/* eslint-disable */
import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** Mongo ObjectId scalar type */
  ObjectId: { input: any; output: any; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

export type AddDealItemsToStorageUnitArgs = {
  dealId: Scalars['ObjectId']['input'];
  itemIds: Array<Scalars['ObjectId']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  setDealToPayedAndStored?: InputMaybe<Scalars['Boolean']['input']>;
  storageDate?: InputMaybe<Scalars['DateTime']['input']>;
  storageFacilityId: Scalars['ObjectId']['input'];
  storageUnits: ItemStorageUnitsArgs;
};

export type AddItemToStorageUnitArgs = {
  itemId: Scalars['ObjectId']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  setDealToPayedAndStored?: InputMaybe<Scalars['Boolean']['input']>;
  storageDate?: InputMaybe<Scalars['DateTime']['input']>;
  storageFacilityId: Scalars['ObjectId']['input'];
  storageUnits: ItemStorageUnitsArgs;
};

export type AdditionalInfoShippingLabel = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  bankInfo?: InputMaybe<Scalars['String']['input']>;
  paymentReference?: InputMaybe<Scalars['String']['input']>;
};

export type AdditionalInformationForCarPawn = {
  __typename?: 'AdditionalInformationForCarPawn';
  appearSerious?: Maybe<Scalars['Boolean']['output']>;
  citizenship?: Maybe<ECountry>;
  employed?: Maybe<Scalars['Boolean']['output']>;
  hasCarPawnRelationshipWithCashy?: Maybe<Scalars['Boolean']['output']>;
  hasSeizureEvident?: Maybe<Scalars['Boolean']['output']>;
  inInsolvencyDatabaseIn3Years?: Maybe<Scalars['Boolean']['output']>;
  lastResidentialAddressSince?: Maybe<Scalars['DateTime']['output']>;
  paySlipsPresented?: Maybe<Scalars['Boolean']['output']>;
  registeredInAustriaSince?: Maybe<Scalars['DateTime']['output']>;
};

export type AdditionalInformationForCarPawnArgs = {
  appearSerious?: InputMaybe<Scalars['Boolean']['input']>;
  citizenship?: InputMaybe<ECountry>;
  employed?: InputMaybe<Scalars['Boolean']['input']>;
  hasCarPawnRelationshipWithCashy?: InputMaybe<Scalars['Boolean']['input']>;
  hasSeizureEvident?: InputMaybe<Scalars['Boolean']['input']>;
  inInsolvencyDatabaseIn3Years?: InputMaybe<Scalars['Boolean']['input']>;
  lastResidentialAddressSince?: InputMaybe<Scalars['DateTime']['input']>;
  paySlipsPresented?: InputMaybe<Scalars['Boolean']['input']>;
  registeredInAustriaSince?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AmountForCategoryArgs = {
  amount: Scalars['Float']['input'];
  categoryId: Scalars['ObjectId']['input'];
};

/** Union of wrappers around EManualPaymentType and EAutomaticPaymentType */
export type AnyPaymentType = AutomaticPaymentWrapper | ManualPaymentWrapper;

export type Auction = {
  __typename?: 'Auction';
  _id: Scalars['ObjectId']['output'];
  auctionAnnouncementLink?: Maybe<FileMetadata>;
  auctionDate: Scalars['DateTime']['output'];
  auctionElements: Array<AuctionElement>;
  closeError?: Maybe<AuctionCloseError>;
  company: Company;
  companyId: Scalars['ObjectId']['output'];
  createdAt: Scalars['DateTime']['output'];
  creationType: EAuctionCreationType;
  internalAuctionAnnouncementLink?: Maybe<FileMetadata>;
  items?: Maybe<Array<AuctionItem>>;
  shopId: Scalars['ObjectId']['output'];
  status: EAuctionStatus;
  withdrawnDeals?: Maybe<Array<WithdrawnDeal>>;
};

export type AuctionCloseError = {
  __typename?: 'AuctionCloseError';
  data?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AuctionCreateArgs = {
  auctionDate: Scalars['DateTime']['input'];
  auctionElementCreateArgs: Array<AuctionElementCreateArgs>;
  companyId: Scalars['ObjectId']['input'];
  createdAt: Scalars['DateTime']['input'];
  creationType: EAuctionCreationType;
  shopId: Scalars['ObjectId']['input'];
};

export type AuctionDeleteArgs = {
  auctionId: Scalars['ObjectId']['input'];
};

export type AuctionElement = {
  __typename?: 'AuctionElement';
  addedToAuctionAt: Scalars['DateTime']['output'];
  addedToAuctionType: EAuctionCreationType;
  bookingNumber: Scalars['Float']['output'];
  dealId: Scalars['ObjectId']['output'];
};

export type AuctionElementCreateArgs = {
  addedToAuctionAt: Scalars['DateTime']['input'];
  addedToAuctionType: EAuctionCreationType;
  bookingNumber: Scalars['Float']['input'];
  dealId: Scalars['ObjectId']['input'];
};

export type AuctionItem = {
  __typename?: 'AuctionItem';
  buyer?: Maybe<AuctionItemBuyer>;
  buyerName?: Maybe<Scalars['String']['output']>;
  dealId: Scalars['ObjectId']['output'];
  finalPrice?: Maybe<Scalars['Float']['output']>;
  item?: Maybe<Item>;
  itemId: Scalars['ObjectId']['output'];
  note?: Maybe<Scalars['String']['output']>;
  notedBy?: Maybe<Scalars['ObjectId']['output']>;
  paymentMethod?: Maybe<EManualPaymentType>;
  startPrice: Scalars['Float']['output'];
  status: EAuctionItemStatus;
  surchargeConfirmationLink?: Maybe<FileMetadata>;
};

export type AuctionItemAnonyBuyer = AuctionItemBuyerBase & {
  __typename?: 'AuctionItemAnonyBuyer';
  type: EAuctionBuyerType;
};

export type AuctionItemArgs = {
  auctionId: Scalars['ObjectId']['input'];
  buyer?: InputMaybe<AuctionItemBuyerArgs>;
  buyerName?: InputMaybe<Scalars['String']['input']>;
  finalPrice?: InputMaybe<Scalars['Float']['input']>;
  itemId: Scalars['ObjectId']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  notedBy?: InputMaybe<Scalars['ObjectId']['input']>;
  paymentMethod?: InputMaybe<EManualPaymentType>;
  shouldBeRemovedFromStorage?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AuctionItemBuyer = AuctionItemAnonyBuyer | AuctionItemExistingCustomer | AuctionItemNewCustomer;

export type AuctionItemBuyerArgs = {
  address?: InputMaybe<IAddress>;
  createCashyAccount?: InputMaybe<Scalars['Boolean']['input']>;
  customerId?: InputMaybe<Scalars['ObjectId']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  type: EAuctionBuyerType;
};

export type AuctionItemBuyerBase = {
  type: EAuctionBuyerType;
};

export type AuctionItemExistingCustomer = AuctionItemBuyerBase & {
  __typename?: 'AuctionItemExistingCustomer';
  customer?: Maybe<Customer>;
  customerId: Scalars['ObjectId']['output'];
  type: EAuctionBuyerType;
};

export type AuctionItemNewCustomer = AuctionItemBuyerBase & {
  __typename?: 'AuctionItemNewCustomer';
  address: OAddress;
  cashyAccountCreated?: Maybe<Scalars['Boolean']['output']>;
  email: Scalars['String']['output'];
  firstname: Scalars['String']['output'];
  lastname: Scalars['String']['output'];
  newCustomer?: Maybe<Customer>;
  newCustomerId?: Maybe<Scalars['ObjectId']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  type: EAuctionBuyerType;
};

export type AuctionUpdateArgs = {
  _id: Scalars['ObjectId']['input'];
  auctionDate?: InputMaybe<Scalars['DateTime']['input']>;
  auctionElementCreateArgs?: InputMaybe<Array<AuctionElementCreateArgs>>;
  companyId: Scalars['ObjectId']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  shopId: Scalars['ObjectId']['input'];
  status?: InputMaybe<EAuctionStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AuctionsFiltersArgs = {
  auctionStatus?: InputMaybe<EAuctionStatus>;
  companyId?: InputMaybe<Scalars['ObjectId']['input']>;
  createdBefore?: InputMaybe<Scalars['DateTime']['input']>;
  paginationArgs: ForwardPaginationSkipLimitArgs;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type AutomaticPaymentWrapper = {
  __typename?: 'AutomaticPaymentWrapper';
  value: EAutomaticPaymentType;
};

export type AvailablePropertyBooleanOption = {
  __typename?: 'AvailablePropertyBooleanOption';
  booleanValue: Scalars['Boolean']['output'];
};

export type AvailablePropertyNumberOption = {
  __typename?: 'AvailablePropertyNumberOption';
  numberValue: Scalars['Float']['output'];
};

export type AvailablePropertyTextOption = {
  __typename?: 'AvailablePropertyTextOption';
  id: Scalars['ObjectId']['output'];
  translation: TranslatedString;
};

export type AvailablePropertyTextOptionArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  translation: Array<MultipleLanguageTextArgs>;
};

export type AvailablePropertyValues = ProductAvailableBooleanProperty | ProductAvailableNumberProperty | ProductAvailableTextProperty;

export type BaseCustomDealFormQuestion = {
  _id: Scalars['ObjectId']['output'];
  info: TranslatedString;
  label: TranslatedString;
  optional?: Maybe<Scalars['Boolean']['output']>;
  showOnIssuanceCertificate: Scalars['Boolean']['output'];
  showOnSalesBill: Scalars['Boolean']['output'];
  titleKey?: Maybe<ECustomDealFormQuestionTitleKey>;
  type: ECustomDealFormQuestionType;
};

export type BaseDealEvent = {
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime']['output'];
};

export type BlacklistInformation = {
  __typename?: 'BlacklistInformation';
  hasCashyAccount?: Maybe<Scalars['Boolean']['output']>;
  isAddedToBlacklist: Scalars['Boolean']['output'];
};

export type BooleanCustomDealFormQuestion = BaseCustomDealFormQuestion & {
  __typename?: 'BooleanCustomDealFormQuestion';
  _id: Scalars['ObjectId']['output'];
  info: TranslatedString;
  initialBooleanAnswer?: Maybe<Scalars['Boolean']['output']>;
  label: TranslatedString;
  optional?: Maybe<Scalars['Boolean']['output']>;
  showOnIssuanceCertificate: Scalars['Boolean']['output'];
  showOnSalesBill: Scalars['Boolean']['output'];
  titleKey?: Maybe<ECustomDealFormQuestionTitleKey>;
  type: ECustomDealFormQuestionType;
};

export type BooleanFilter = {
  condition?: InputMaybe<EBooleanFilterConditions>;
  value: Scalars['Boolean']['input'];
};

export type BuyBackData = {
  __typename?: 'BuyBackData';
  grossProfit?: Maybe<Scalars['Float']['output']>;
  isPawnAgain?: Maybe<Scalars['Boolean']['output']>;
  partialRepayment?: Maybe<Scalars['Float']['output']>;
  repurchaseFee?: Maybe<Scalars['Float']['output']>;
  totalRepurchaseFee?: Maybe<Scalars['Float']['output']>;
};

export type BuyerBillingAddress = {
  __typename?: 'BuyerBillingAddress';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  coordinates?: Maybe<OCoordinates>;
  /** @deprecated Use `countryCode`. */
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<ECountry>;
  door?: Maybe<Scalars['String']['output']>;
  floor?: Maybe<Scalars['String']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  queryString?: Maybe<Scalars['String']['output']>;
  stairway?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  uid?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type BuyerBillingAddressArgs = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  coordinates?: InputMaybe<ICoordinates>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<ECountry>;
  door?: InputMaybe<Scalars['String']['input']>;
  floor?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  stairway?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type BuyerData = {
  __typename?: 'BuyerData';
  name?: Maybe<Scalars['String']['output']>;
  partnerId?: Maybe<Scalars['ObjectId']['output']>;
};

export type BuyerDataArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type CalculatedFeeDefinition = {
  __typename?: 'CalculatedFeeDefinition';
  appliedGrossAmount: Scalars['Float']['output'];
  appliedNetAmount: Scalars['Float']['output'];
  date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  finalGrossAmount: Scalars['Float']['output'];
  finalNetAmount: Scalars['Float']['output'];
  isManual: Scalars['Boolean']['output'];
  storedFeeDefinition: StoredFeeDefinition;
  ust: Scalars['Float']['output'];
};

export type CalculationBase = {
  __typename?: 'CalculationBase';
  loanToValuesEntryId: Scalars['ObjectId']['output'];
  setOfFeesIds: Array<Scalars['ObjectId']['output']>;
};

export type CarDealCalculation = IDealCalculation & {
  __typename?: 'CarDealCalculation';
  appliedUsedFeeDefinitions: Array<UsedFeeDefinition>;
  competitiveVehiclesForSale?: Maybe<Scalars['Float']['output']>;
  date: Scalars['DateTime']['output'];
  dealCalculationId: Scalars['ObjectId']['output'];
  dealValuesEntry: DealValuesEntry;
  itemsValuesEntries: Array<ItemValuesEntry>;
  loanToValuesEntryId: Scalars['ObjectId']['output'];
  noValuation?: Maybe<Scalars['Boolean']['output']>;
  valuation?: Maybe<ViviValuationResponse>;
};

export type CarDealCalculationArgs = {
  answers: Array<ItemAnswerArgs>;
  companyId: Scalars['ObjectId']['input'];
  condition?: InputMaybe<Scalars['Float']['input']>;
  durationInDays: Scalars['Int']['input'];
  href: Scalars['String']['input'];
  itemCategoryId?: InputMaybe<Scalars['ObjectId']['input']>;
  odometer?: InputMaybe<Scalars['Float']['input']>;
  overwrittenPayoutAmount?: InputMaybe<Scalars['Float']['input']>;
  shouldOverwritePayoutAmount?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CarInspectionArgs = {
  currentMileage: Scalars['Float']['input'];
  dealId: Scalars['ObjectId']['input'];
  finalMaxPawnDate: Scalars['DateTime']['input'];
  has57aGutachtenDue: Scalars['DateTime']['input'];
  itemId: Scalars['ObjectId']['input'];
};

export type CarMakeModelsArgs = {
  make: Scalars['String']['input'];
};

export type CashBookCashFlow = {
  __typename?: 'CashBookCashFlow';
  _id: Scalars['ObjectId']['output'];
  accumulatedBalance: Scalars['Float']['output'];
  attachment?: Maybe<FileMetadata>;
  canceledBy?: Maybe<CashBookCashFlow>;
  canceledById?: Maybe<Scalars['ObjectId']['output']>;
  cancels?: Maybe<CashBookCashFlow>;
  cancelsId?: Maybe<Scalars['ObjectId']['output']>;
  cashBookType: ECashBookType;
  cashFlowNumber: Scalars['Float']['output'];
  closedFeesTotalAmount?: Maybe<Scalars['Float']['output']>;
  companyId?: Maybe<Scalars['ObjectId']['output']>;
  createdBy: CashFlowCreator;
  date: Scalars['DateTime']['output'];
  deal?: Maybe<Deal>;
  dealId?: Maybe<Scalars['ObjectId']['output']>;
  employeeId?: Maybe<Scalars['ObjectId']['output']>;
  inflow?: Maybe<Scalars['Float']['output']>;
  itemId?: Maybe<Scalars['ObjectId']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  outflow?: Maybe<Scalars['Float']['output']>;
  paymentReference: ECashBookPaymentReference;
  paymentType: AnyPaymentType;
  ready2OrderInvoices?: Maybe<Array<CashBookCashFlowReady2OrderInvoice>>;
  shopId?: Maybe<Scalars['ObjectId']['output']>;
  storageLabel?: Maybe<Scalars['String']['output']>;
  valorizationEntryId?: Maybe<Scalars['ObjectId']['output']>;
};

export type CashBookCashFlowArgs = {
  attachmentArgs?: InputMaybe<FileTusMetadataArgs>;
  billNumber?: InputMaybe<Scalars['String']['input']>;
  bookingNumber?: InputMaybe<Scalars['Int']['input']>;
  companyId?: InputMaybe<Scalars['ObjectId']['input']>;
  customerNumber?: InputMaybe<Scalars['Int']['input']>;
  date: Scalars['DateTime']['input'];
  inflow?: InputMaybe<Scalars['Float']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  outflow?: InputMaybe<Scalars['Float']['input']>;
  paymentReference: ECashBookPaymentReference;
  paymentType: EManualPaymentType;
  shopId?: InputMaybe<Scalars['ObjectId']['input']>;
  storageLabel?: InputMaybe<Scalars['String']['input']>;
  valorizationEntryId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type CashBookCashFlowCancel = {
  __typename?: 'CashBookCashFlowCancel';
  canceled: CashBookCashFlow;
  cancels: CashBookCashFlow;
};

export type CashBookCashFlowEdge = {
  __typename?: 'CashBookCashFlowEdge';
  cursor: Scalars['String']['output'];
  node: CashBookCashFlow;
};

export type CashBookCashFlowFilterArgs = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  cashBookType?: InputMaybe<ECashBookType>;
  cashFlowNumber?: InputMaybe<Scalars['Float']['input']>;
  companyId?: InputMaybe<IdFilter>;
  date?: InputMaybe<DateFilter>;
  ids?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  paymentType?: InputMaybe<EManualPaymentType>;
  shopId?: InputMaybe<IdFilter>;
  valorizationEntryId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type CashBookCashFlowLatestBalanceFilterArgs = {
  date: DateFilter;
  paymentType: EManualPaymentType;
  shopId: IdFilter;
};

export type CashBookCashFlowOpts = {
  filter?: InputMaybe<CashBookCashFlowFilterArgs>;
  order?: InputMaybe<CashBookCashFlowOrderArgs>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type CashBookCashFlowOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  cashFlowNumber?: InputMaybe<EOrderBy>;
};

export type CashBookCashFlowPaymentReferenceHelper = {
  __typename?: 'CashBookCashFlowPaymentReferenceHelper';
  value: ECashBookPaymentReference;
};

export type CashBookCashFlowReady2OrderInvoice = {
  __typename?: 'CashBookCashFlowReady2OrderInvoice';
  numberFull: Scalars['String']['output'];
};

export type CashBookCount = {
  __typename?: 'CashBookCount';
  _id: Scalars['ObjectId']['output'];
  cashBoxEntries: Array<CashBookCountCashBoxEntry>;
  date: Scalars['DateTime']['output'];
  employee: Employee;
  employeeId: Scalars['ObjectId']['output'];
  paymentType: EManualPaymentType;
  shopId: Scalars['ObjectId']['output'];
  temporary?: Maybe<Scalars['Boolean']['output']>;
};

export type CashBookCountArgs = {
  cashBoxEntries: Array<CashBookCountCashBoxEntryArgs>;
  date: Scalars['DateTime']['input'];
  employeeId: Scalars['ObjectId']['input'];
  paymentType: EManualPaymentType;
  shopId: Scalars['ObjectId']['input'];
  temporary?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CashBookCountCashBoxEntry = {
  __typename?: 'CashBookCountCashBoxEntry';
  cashBoxName: Scalars['String']['output'];
  counts: CashBookCountCounts;
};

export type CashBookCountCashBoxEntryArgs = {
  cashBoxName: Scalars['String']['input'];
  counts: CashBookCountCountsArgs;
};

export type CashBookCountCounts = {
  __typename?: 'CashBookCountCounts';
  EURO_1: Scalars['Float']['output'];
  EURO_2: Scalars['Float']['output'];
  EURO_5: Scalars['Float']['output'];
  EURO_10: Scalars['Float']['output'];
  EURO_20: Scalars['Float']['output'];
  EURO_50: Scalars['Float']['output'];
  EURO_100: Scalars['Float']['output'];
  EURO_200: Scalars['Float']['output'];
  EURO_500: Scalars['Float']['output'];
  EURO_CENT_1: Scalars['Float']['output'];
  EURO_CENT_2: Scalars['Float']['output'];
  EURO_CENT_5: Scalars['Float']['output'];
  EURO_CENT_10: Scalars['Float']['output'];
  EURO_CENT_20: Scalars['Float']['output'];
  EURO_CENT_50: Scalars['Float']['output'];
};

export type CashBookCountCountsArgs = {
  EURO_1: Scalars['Float']['input'];
  EURO_2: Scalars['Float']['input'];
  EURO_5: Scalars['Float']['input'];
  EURO_10: Scalars['Float']['input'];
  EURO_20: Scalars['Float']['input'];
  EURO_50: Scalars['Float']['input'];
  EURO_100: Scalars['Float']['input'];
  EURO_200: Scalars['Float']['input'];
  EURO_500: Scalars['Float']['input'];
  EURO_CENT_1: Scalars['Float']['input'];
  EURO_CENT_2: Scalars['Float']['input'];
  EURO_CENT_5: Scalars['Float']['input'];
  EURO_CENT_10: Scalars['Float']['input'];
  EURO_CENT_20: Scalars['Float']['input'];
  EURO_CENT_50: Scalars['Float']['input'];
};

export type CashBookCountEuroDenominationHelper = {
  __typename?: 'CashBookCountEuroDenominationHelper';
  value: EEuroDenomination;
};

export type CashBookCountFilterArgs = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  date?: InputMaybe<DateFilter>;
  employeeId?: InputMaybe<IdFilter>;
  ids?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  paymentType?: InputMaybe<EManualPaymentType>;
  shopId?: InputMaybe<IdFilter>;
  temporary?: InputMaybe<BooleanFilter>;
};

export type CashBookCountOpts = {
  filter?: InputMaybe<CashBookCountFilterArgs>;
  order?: InputMaybe<CashBookCountOrderArgs>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type CashBookCountOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  date?: InputMaybe<EOrderBy>;
};

export type CashBookCountUpdateArgs = {
  _id: Scalars['ObjectId']['input'];
  cashBoxEntries?: InputMaybe<Array<CashBookCountCashBoxEntryArgs>>;
  employeeId?: InputMaybe<Scalars['ObjectId']['input']>;
  temporary?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Employee | SystemOperation | UnzerTransaction */
export type CashFlowCreator = Employee | SystemOperation | UnzerTransaction;

export type CategorizedUploadedFile = {
  __typename?: 'CategorizedUploadedFile';
  fileCategoryName: Scalars['String']['output'];
  uploadedFiles: Array<FileMetadata>;
};

export type CategoryCountrySpecific = {
  __typename?: 'CategoryCountrySpecific';
  _id: Scalars['ObjectId']['output'];
  bulletComponents: Array<ContentComponent>;
  bulletTitle: Scalars['String']['output'];
  country: EStrapiContentCountry;
  headerComponents: Array<ContentComponent>;
};

export type CategoryPage = {
  __typename?: 'CategoryPage';
  _id: Scalars['ObjectId']['output'];
  categoryImage?: Maybe<UploadFile>;
  categoryImageId?: Maybe<Scalars['ObjectId']['output']>;
  categoryLabel: Scalars['String']['output'];
  countrySpecific?: Maybe<CategoryCountrySpecific>;
  countrySpecificComponents: Array<ContentComponent>;
  customMaxLoanToValue?: Maybe<Scalars['Float']['output']>;
  customRequestLvl0Category?: Maybe<Scalars['String']['output']>;
  fallbackImage?: Maybe<UploadFile>;
  fallbackImageId?: Maybe<Scalars['ObjectId']['output']>;
  faqsIds: Array<Scalars['ObjectId']['output']>;
  inNumbersComponent: Array<ContentComponent>;
  introDescription?: Maybe<Scalars['String']['output']>;
  introTitle?: Maybe<Scalars['String']['output']>;
  isLeaveCategory?: Maybe<Scalars['Boolean']['output']>;
  isSpecialPage?: Maybe<Scalars['Boolean']['output']>;
  itemCategory?: Maybe<ItemCategory>;
  language: Scalars['String']['output'];
  lvl0ContentCategory: Scalars['String']['output'];
  lvl1ContentCategory?: Maybe<Scalars['String']['output']>;
  lvl2ContentCategory?: Maybe<Scalars['String']['output']>;
  lvl3ContentCategory?: Maybe<Scalars['String']['output']>;
  maxLoanToValue?: Maybe<Scalars['Float']['output']>;
  metaDescription: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  pageFaqsComponents: Array<ContentComponent>;
  pageTitle: Scalars['String']['output'];
  path: Scalars['String']['output'];
  published_at?: Maybe<Scalars['DateTime']['output']>;
  selectorHeading: Scalars['String']['output'];
  telephone?: Maybe<Scalars['String']['output']>;
  visibleOnDomain?: Maybe<EVisibleOnDomain>;
  whatsAppDescription?: Maybe<Scalars['String']['output']>;
  whatsappNumber?: Maybe<Scalars['String']['output']>;
};


export type CategoryPageCountrySpecificArgs = {
  country?: InputMaybe<EStrapiContentCountry>;
};

export type CategoryPageContent = {
  __typename?: 'CategoryPageContent';
  availableRegions?: Maybe<Array<ERegionCode>>;
  childPages: Array<CategoryPage>;
  page: CategoryPage;
  parentPages: CategoryPageParents;
};


export type CategoryPageContentChildPagesArgs = {
  includeDrafts?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  visibleOnDomain?: InputMaybe<EStrapiContentCountry>;
};


export type CategoryPageContentParentPagesArgs = {
  includeDrafts?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CategoryPageFilterArgs = {
  ids?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  includeDrafts?: InputMaybe<Scalars['Boolean']['input']>;
  isSpecialPage?: InputMaybe<BooleanFilter>;
  language?: InputMaybe<Scalars['String']['input']>;
  lvl0ContentCategory?: InputMaybe<StringFilter>;
  lvl0ContentCategoryExists?: InputMaybe<Scalars['Boolean']['input']>;
  lvl1ContentCategory?: InputMaybe<StringFilter>;
  lvl1ContentCategoryExists?: InputMaybe<Scalars['Boolean']['input']>;
  lvl2ContentCategory?: InputMaybe<StringFilter>;
  lvl2ContentCategoryExists?: InputMaybe<Scalars['Boolean']['input']>;
  lvl3ContentCategory?: InputMaybe<StringFilter>;
  lvl3ContentCategoryExists?: InputMaybe<Scalars['Boolean']['input']>;
  path?: InputMaybe<StringFilter>;
  visibleOnDomain?: InputMaybe<EStrapiContentCountry>;
};

export type CategoryPageOpts = {
  filter?: InputMaybe<CategoryPageFilterArgs>;
  order?: InputMaybe<CategoryPageOrderArgs>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type CategoryPageOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  categoryLabel?: InputMaybe<EOrderBy>;
  maxLoanToValue?: InputMaybe<EOrderBy>;
  order?: InputMaybe<EOrderBy>;
};

export type CategoryPageParents = {
  __typename?: 'CategoryPageParents';
  lvl0?: Maybe<CategoryPage>;
  lvl1?: Maybe<CategoryPage>;
  lvl2?: Maybe<CategoryPage>;
};

export type CategoryPages = {
  __typename?: 'CategoryPages';
  lvl0?: Maybe<CategoryPage>;
  lvl1?: Maybe<CategoryPage>;
  lvl2?: Maybe<CategoryPage>;
  lvl3?: Maybe<CategoryPage>;
};

export type Company = {
  __typename?: 'Company';
  _id: Scalars['ObjectId']['output'];
  accountOwner?: Maybe<Scalars['String']['output']>;
  automotivesOnly?: Maybe<Scalars['Boolean']['output']>;
  bic?: Maybe<Scalars['String']['output']>;
  carPawnSettings?: Maybe<CompanyCarPawnSettings>;
  companyCounter?: Maybe<CompanyCounter>;
  companyCounterId?: Maybe<Scalars['ObjectId']['output']>;
  configuration: CompanyConfiguration;
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  dpdAccountInfo?: Maybe<DpdAccountInfo>;
  email?: Maybe<Scalars['String']['output']>;
  fibuNumber: Scalars['String']['output'];
  headquarter?: Maybe<OAddress>;
  iban?: Maybe<Scalars['String']['output']>;
  isDeactivated?: Maybe<Scalars['Boolean']['output']>;
  jurisdiction?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  paypalEmail?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  predecessionCompany?: Maybe<Company>;
  primaryShopLocationId: Scalars['ObjectId']['output'];
  saleSupportEmail?: Maybe<Scalars['String']['output']>;
  salesConfiguration: CompanySalesConfiguration;
  successionCompany?: Maybe<Company>;
  successionCompanyId?: Maybe<Scalars['ObjectId']['output']>;
  supportEmail?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
  unzerConfiguration?: Maybe<CompanyUnzerConfiguration>;
  website?: Maybe<Scalars['String']['output']>;
  whatsappNumber?: Maybe<Scalars['String']['output']>;
};

export type CompanyCarPawnSettings = {
  __typename?: 'CompanyCarPawnSettings';
  includeLicensePlate?: Maybe<Scalars['Boolean']['output']>;
  includeSpareTireCount?: Maybe<Scalars['Boolean']['output']>;
};

export type CompanyConfiguration = {
  __typename?: 'CompanyConfiguration';
  differenceTaxRate: Scalars['Float']['output'];
  gracePeriod: Scalars['Int']['output'];
  insuranceFactor: Scalars['Float']['output'];
  liquidationFee: Scalars['Float']['output'];
  minimumPawnDuration: Scalars['Int']['output'];
  payoutConfigurations?: Maybe<OPayoutConfiguration>;
  valorizationFeeRate: Scalars['Float']['output'];
  valueAddedTaxRate: Scalars['Float']['output'];
};

export type CompanyConfigurationArgs = {
  differenceTaxRate: Scalars['Float']['input'];
  gracePeriod: Scalars['Int']['input'];
  insuranceFactor: Scalars['Float']['input'];
  liquidationFee: Scalars['Float']['input'];
  minimumPawnDuration: Scalars['Int']['input'];
  payoutConfigurations?: InputMaybe<PayoutConfigurationsInput>;
  valorizationFeeRate: Scalars['Float']['input'];
  valueAddedTaxRate: Scalars['Float']['input'];
};

export type CompanyCounter = {
  __typename?: 'CompanyCounter';
  billNumbers: Array<YearlyCompanyCounterEntry>;
  bookingNumber?: Maybe<Scalars['Int']['output']>;
  customDealNumber?: Maybe<Scalars['Int']['output']>;
  employeeNumber?: Maybe<Scalars['Int']['output']>;
  isGlobalCounter?: Maybe<Scalars['Boolean']['output']>;
  marketingCreditNoteNumbers: Array<YearlyCompanyCounterEntry>;
  pawnNumber?: Maybe<Scalars['Int']['output']>;
  receiptNumbers: Array<YearlyCompanyCounterEntry>;
  valorizationBillNumbers: Array<YearlyCompanyCounterEntry>;
  valorizationCreditNoteNumbers: Array<YearlyCompanyCounterEntry>;
};

export type CompanyCreateArgs = {
  accountOwner?: InputMaybe<Scalars['String']['input']>;
  bic?: InputMaybe<Scalars['String']['input']>;
  companyCounterId?: InputMaybe<Scalars['ObjectId']['input']>;
  configuration: CompanyConfigurationArgs;
  dpdConfiguration?: InputMaybe<DpdConfigurationArgs>;
  email?: InputMaybe<Scalars['String']['input']>;
  fibuNumber: Scalars['String']['input'];
  headquarter?: InputMaybe<IAddress>;
  iban?: InputMaybe<Scalars['String']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  paypalEmail?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  primaryShopLocation: PrimaryShopLocationArgs;
  saleSupportEmail?: InputMaybe<Scalars['String']['input']>;
  salesConfiguration: CompanySalesConfigurationArgs;
  successionCompanyId?: InputMaybe<Scalars['ObjectId']['input']>;
  supportEmail?: InputMaybe<Scalars['String']['input']>;
  uid: Scalars['String']['input'];
  unzerConfiguration?: InputMaybe<CompanyUnzerConfigurationArgs>;
  website?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyFeesEvaluation = {
  __typename?: 'CompanyFeesEvaluation';
  feeEvaluationItemCategories: Array<FeeEvaluationItemCategory>;
  generalFeesEvaluation: FeeDefinitionEvaluation;
};

export type CompanyFilterArgs = {
  ids?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  isDeactivated?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyOpts = {
  filter?: InputMaybe<CompanyFilterArgs>;
  order?: InputMaybe<CompanyOrderArgs>;
};

export type CompanyOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  name?: InputMaybe<EOrderBy>;
};

export type CompanyRefurbedStaggeredMarginArgs = {
  expectedMargin: Scalars['Float']['input'];
  from: Scalars['Float']['input'];
  minimumMargin: Scalars['Float']['input'];
};

export type CompanySalesConfiguration = {
  __typename?: 'CompanySalesConfiguration';
  refurbedCommission: Scalars['Float']['output'];
  refurbedStaggeredMargins: Array<RefurbedStaggeredMargin>;
};

export type CompanySalesConfigurationArgs = {
  refurbedCommission: Scalars['Float']['input'];
  refurbedStaggeredMargins: Array<CompanyRefurbedStaggeredMarginArgs>;
};

export type CompanyUnzerConfiguration = {
  __typename?: 'CompanyUnzerConfiguration';
  companyCode?: Maybe<Scalars['String']['output']>;
  privateKeyStored?: Maybe<Scalars['Boolean']['output']>;
  publicKey?: Maybe<Scalars['String']['output']>;
  webhookId?: Maybe<Scalars['String']['output']>;
};

export type CompanyUnzerConfigurationArgs = {
  companyCode?: InputMaybe<Scalars['String']['input']>;
  privateKey?: InputMaybe<Scalars['String']['input']>;
  publicKey?: InputMaybe<Scalars['String']['input']>;
};

export type ConditionMaxMarketValues = {
  __typename?: 'ConditionMaxMarketValues';
  excellent: Scalars['Float']['output'];
  good: Scalars['Float']['output'];
  poor: Scalars['Float']['output'];
};

export type ConditionMaxMarketValuesArgs = {
  excellent: Scalars['Float']['input'];
  good: Scalars['Float']['input'];
  poor: Scalars['Float']['input'];
};

export type ConfirmExtensionArgs = {
  dealExtensionCalculationId: Scalars['ObjectId']['input'];
  dealId: Scalars['ObjectId']['input'];
  isChildOverwrittenFees: Scalars['Boolean']['input'];
  isOnlineExtensionPrevented: Scalars['Boolean']['input'];
  onlineExtensionBanNote?: InputMaybe<Scalars['String']['input']>;
  paymentType: EManualPaymentType;
  shopId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type ConfirmPaybackArgs = {
  dealId: Scalars['ObjectId']['input'];
  dealPaybackCalculationId: Scalars['ObjectId']['input'];
  paymentType: EManualPaymentType;
  removeItemsFromStorage: Scalars['Boolean']['input'];
  shopId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type ContentCategories = {
  __typename?: 'ContentCategories';
  lvl0: Scalars['String']['output'];
  lvl1?: Maybe<Scalars['String']['output']>;
  lvl2?: Maybe<Scalars['String']['output']>;
  lvl3?: Maybe<Scalars['String']['output']>;
};

export type ContentCategoriesArgs = {
  lvl0: Scalars['String']['input'];
  lvl1?: InputMaybe<Scalars['String']['input']>;
  lvl2?: InputMaybe<Scalars['String']['input']>;
  lvl3?: InputMaybe<Scalars['String']['input']>;
};

export type ContentComponent = {
  __typename?: 'ContentComponent';
  _id: Scalars['ObjectId']['output'];
  kind: Scalars['String']['output'];
  ref: Scalars['ObjectId']['output'];
};

export type CreateOrUpdateReady2OrderApiKeyArgs = {
  ready2OrderApiKey: Scalars['String']['input'];
  shopId: Scalars['ObjectId']['input'];
};

export type CreateProduct = {
  ean?: InputMaybe<Scalars['String']['input']>;
  gewicht?: InputMaybe<Scalars['Float']['input']>;
  isInactive?: InputMaybe<Scalars['Boolean']['input']>;
  isTaxFree?: InputMaybe<Scalars['Boolean']['input']>;
  karat?: InputMaybe<Scalars['Float']['input']>;
  lvl0Category: Scalars['String']['input'];
  lvl0ContentCategory?: InputMaybe<Scalars['String']['input']>;
  lvl1Category?: InputMaybe<Scalars['String']['input']>;
  lvl1ContentCategory?: InputMaybe<Scalars['String']['input']>;
  lvl2Category?: InputMaybe<Scalars['String']['input']>;
  lvl2ContentCategory?: InputMaybe<Scalars['String']['input']>;
  lvl3ContentCategory?: InputMaybe<Scalars['String']['input']>;
  material?: InputMaybe<Scalars['String']['input']>;
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  objectID: Scalars['String']['input'];
  pictureFilename?: InputMaybe<Scalars['String']['input']>;
  productTags?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreditcardPaymentArgs = {
  paymentId: Scalars['String']['input'];
};

export type CustomDeal = {
  __typename?: 'CustomDeal';
  _id: Scalars['ObjectId']['output'];
  acceptedBy?: Maybe<Employee>;
  availableTransportModes: Array<ETransportMode>;
  company: Company;
  companyId: Scalars['ObjectId']['output'];
  contactData: CustomDealContactData;
  createdAt: Scalars['DateTime']['output'];
  customDealItemsIds: Array<Scalars['ObjectId']['output']>;
  customDealNumber: Scalars['Float']['output'];
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['ObjectId']['output']>;
  deal?: Maybe<Deal>;
  dealId?: Maybe<Scalars['ObjectId']['output']>;
  dealType: EDealType;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  durationInDays: Scalars['Float']['output'];
  employeeId?: Maybe<Scalars['ObjectId']['output']>;
  employeeResponse?: Maybe<CustomDealEmployeeResponse>;
  events: Array<CustomDealEvent>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isPayoutOverwritten?: Maybe<Scalars['Boolean']['output']>;
  isReversedFeeCalculation?: Maybe<Scalars['Boolean']['output']>;
  issuanceCertificate?: Maybe<FileMetadata>;
  items: Array<CustomDealItemDataEntry>;
  link?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Array<Note>>;
  overridePayoutAmount: Scalars['Float']['output'];
  pawnCalculation?: Maybe<CustomDealCalculation>;
  payoutApproverId?: Maybe<Scalars['ObjectId']['output']>;
  pickupTransportMode?: Maybe<ETransportMode>;
  policeNumber?: Maybe<Scalars['String']['output']>;
  purchaseCalculation?: Maybe<CustomDealCalculation>;
  qualified?: Maybe<CustomDealQualification>;
  status?: Maybe<ECustomDealStatusType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CustomDealCalculation = {
  __typename?: 'CustomDealCalculation';
  appliedUsedFeeDefinitions: Array<UsedFeeDefinition>;
  date: Scalars['DateTime']['output'];
  dealType: EDealType;
  dealValuesEntry: DealValuesEntry;
  itemsValuesEntries: Array<ItemValuesEntry>;
  payoutAmount: Scalars['Float']['output'];
  token: Scalars['String']['output'];
};

export type CustomDealCalculationArgs = {
  calculationItems: Array<CustomDealCalculationItem>;
  companyId: Scalars['ObjectId']['input'];
  date?: InputMaybe<Scalars['DateTime']['input']>;
  durationInDays: Scalars['Float']['input'];
  isReversedFeeCalculation: Scalars['Boolean']['input'];
  pickupTransportMode?: InputMaybe<ETransportMode>;
};

export type CustomDealCalculationItem = {
  algoliaReference?: InputMaybe<Scalars['String']['input']>;
  answers: Array<ItemAnswerArgs>;
  customPayoutAmount?: InputMaybe<Scalars['Float']['input']>;
  existingCurrentMarketValue?: InputMaybe<Scalars['Float']['input']>;
  existingPredictedMarketValue?: InputMaybe<Scalars['Float']['input']>;
  foundComparableOffersPrices?: InputMaybe<Array<Scalars['Float']['input']>>;
  foundOffersEvaluationFactor?: InputMaybe<Scalars['Float']['input']>;
  isInvestmentGold?: InputMaybe<Scalars['Boolean']['input']>;
  itemCategoryId: Scalars['ObjectId']['input'];
  material?: InputMaybe<Scalars['String']['input']>;
  overwrittenItemValue?: InputMaybe<Scalars['Float']['input']>;
  overwrittenPawnPayoutAmount?: InputMaybe<Scalars['Float']['input']>;
  overwrittenPurchasePayoutAmount?: InputMaybe<Scalars['Float']['input']>;
  payoutAmount?: InputMaybe<Scalars['Float']['input']>;
  skipPredictionTags?: InputMaybe<Scalars['Boolean']['input']>;
  unconfirmedPropertyIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  useOldValuesOfPrediction?: InputMaybe<Scalars['Boolean']['input']>;
  variantId?: InputMaybe<Scalars['ObjectId']['input']>;
  vehicleData?: InputMaybe<VehicleDataArgs>;
};

export type CustomDealContactData = {
  __typename?: 'CustomDealContactData';
  blacklistInformation?: Maybe<BlacklistInformation>;
  email?: Maybe<Scalars['String']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type CustomDealContactDataArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CustomDealCreateArgs = {
  companyId: Scalars['ObjectId']['input'];
  contactData: CustomDealContactDataArgs;
  customerId?: InputMaybe<Scalars['ObjectId']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dealType: EDealType;
  durationInDays: Scalars['Float']['input'];
  employeeId?: InputMaybe<Scalars['ObjectId']['input']>;
  isItemEvaluationMissing?: InputMaybe<Scalars['Boolean']['input']>;
  items: Array<CustomDealItemCreateArgs>;
  notes?: InputMaybe<Array<NoteCreateArgs>>;
  payoutApprover?: InputMaybe<Scalars['Boolean']['input']>;
  pickupTransportMode?: InputMaybe<ETransportMode>;
};

export type CustomDealCustomerFilterArgs = {
  email?: InputMaybe<StringFilter>;
  firstname?: InputMaybe<StringFilter>;
  lastname?: InputMaybe<StringFilter>;
  phone?: InputMaybe<StringFilter>;
};

export type CustomDealEmployeeResponse = {
  __typename?: 'CustomDealEmployeeResponse';
  closingText: Scalars['String']['output'];
  editableText: Scalars['String']['output'];
  name: Scalars['String']['output'];
  openingText: Scalars['String']['output'];
  subject: Scalars['String']['output'];
};

export type CustomDealEmployeeResponseArgs = {
  closingText: Scalars['String']['input'];
  editableText: Scalars['String']['input'];
  name: Scalars['String']['input'];
  openingText: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

export type CustomDealEvent = {
  __typename?: 'CustomDealEvent';
  createdAt: Scalars['DateTime']['output'];
  creatorId?: Maybe<Scalars['ObjectId']['output']>;
  event: ECustomDealStatusType;
  sentReminderEmailToCustomer?: Maybe<Scalars['Boolean']['output']>;
  timestamp: Scalars['DateTime']['output'];
};

export type CustomDealFilterArgs = {
  _id?: InputMaybe<IdFilter>;
  companyId?: InputMaybe<IdFilter>;
  customDealItem?: InputMaybe<CustomDealItemFilterArgs>;
  customer?: InputMaybe<CustomDealCustomerFilterArgs>;
  customerId?: InputMaybe<IdFilter>;
  customerIds?: InputMaybe<IDsFilter>;
  ids?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  includeClosed?: InputMaybe<BooleanFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  itemIds?: InputMaybe<IDsFilter>;
  status?: InputMaybe<StringFilter>;
};

export type CustomDealForm = {
  __typename?: 'CustomDealForm';
  _id: Scalars['ObjectId']['output'];
  categoryId: Scalars['ObjectId']['output'];
  createdAt: Scalars['DateTime']['output'];
  isUsedForCommissionSale: Scalars['Boolean']['output'];
  questions: Array<CustomDealFormQuestion>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CustomDealFormCreateArgs = {
  categoryId: Scalars['ObjectId']['input'];
  isUsedForCommissionSale: Scalars['Boolean']['input'];
  questions: Array<CustomDealFormQuestionCreateArgs>;
};

export type CustomDealFormOption = {
  __typename?: 'CustomDealFormOption';
  default: Scalars['Boolean']['output'];
  label: TranslatedString;
};

export type CustomDealFormOptionArgs = {
  default: Scalars['Boolean']['input'];
  description?: InputMaybe<Array<MultipleLanguageTextArgs>>;
  label: Array<MultipleLanguageTextArgs>;
};

export type CustomDealFormQuestion = BooleanCustomDealFormQuestion | FileUploadCustomDealFormQuestion | NumberDefaultCustomDealFormQuestion | NumberOptionsCustomDealFormQuestion | TextDefaultCustomDealFormQuestion | TextMultilineCustomDealFormQuestion | TextOptionsCustomDealFormQuestion;

export type CustomDealFormQuestionByCategory = {
  __typename?: 'CustomDealFormQuestionByCategory';
  isAllowedPurchase: Scalars['Boolean']['output'];
  isUsedForCommissionSale: Scalars['Boolean']['output'];
  questions: Array<CustomDealFormQuestion>;
};

export type CustomDealFormQuestionCreateArgs = {
  allowEnterAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  info: Array<MultipleLanguageTextArgs>;
  initialAnswerArgs?: InputMaybe<CustomDealFormQuestionInitialAnswerArgs>;
  label: Array<MultipleLanguageTextArgs>;
  optional?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Array<CustomDealFormOptionArgs>>;
  restrictions?: InputMaybe<Array<CustomDealQuestionNumberRestrictionArgs>>;
  showOnIssuanceCertificate: Scalars['Boolean']['input'];
  showOnSalesBill: Scalars['Boolean']['input'];
  titleKey?: InputMaybe<ECustomDealFormQuestionTitleKey>;
  type: ECustomDealFormQuestionType;
};

export type CustomDealFormQuestionInitialAnswerArgs = {
  booleanAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  numberAnswer?: InputMaybe<Scalars['Float']['input']>;
  optionNumberAnswer?: InputMaybe<Scalars['Float']['input']>;
  optionTextAnswer?: InputMaybe<Scalars['String']['input']>;
  textAnswer?: InputMaybe<Scalars['String']['input']>;
};

export type CustomDealFormQuestionUpdateArgs = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  allowEnterAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  info: Array<MultipleLanguageTextArgs>;
  initialAnswerArgs?: InputMaybe<CustomDealFormQuestionInitialAnswerArgs>;
  label: Array<MultipleLanguageTextArgs>;
  optional?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Array<CustomDealFormOptionArgs>>;
  restrictions?: InputMaybe<Array<CustomDealQuestionNumberRestrictionArgs>>;
  showOnIssuanceCertificate: Scalars['Boolean']['input'];
  showOnSalesBill: Scalars['Boolean']['input'];
  titleKey?: InputMaybe<ECustomDealFormQuestionTitleKey>;
  type: ECustomDealFormQuestionType;
};

export type CustomDealFormTextOption = {
  __typename?: 'CustomDealFormTextOption';
  default: Scalars['Boolean']['output'];
  description?: Maybe<TranslatedString>;
  label: TranslatedString;
};

export type CustomDealFormUpdateArgs = {
  _id: Scalars['ObjectId']['input'];
  categoryId: Scalars['ObjectId']['input'];
  isUsedForCommissionSale: Scalars['Boolean']['input'];
  questions: Array<CustomDealFormQuestionUpdateArgs>;
};

export type CustomDealItemCreateArgs = {
  algoliaReference?: InputMaybe<Scalars['String']['input']>;
  answers: Array<ItemAnswerArgs>;
  condition?: InputMaybe<ECustomDealItemCondition>;
  counterofferPayoutAmount?: InputMaybe<Scalars['Float']['input']>;
  ean?: InputMaybe<Scalars['String']['input']>;
  formAnswers?: InputMaybe<Array<FormAnswerArgs>>;
  foundComparableOffers?: InputMaybe<ECustomItemFoundComparableOffers>;
  foundOffersEvaluationFactor?: InputMaybe<Scalars['Float']['input']>;
  itemCategoryId: Scalars['ObjectId']['input'];
  material?: InputMaybe<Scalars['String']['input']>;
  mediaUploads?: InputMaybe<Array<FileTusMetadataArgs>>;
  note?: InputMaybe<Scalars['String']['input']>;
  overwrittenItemValue?: InputMaybe<Scalars['Float']['input']>;
  overwrittenPawnPayoutAmount?: InputMaybe<Scalars['Float']['input']>;
  overwrittenPurchasePayoutAmount?: InputMaybe<Scalars['Float']['input']>;
  pawnPayoutAmount: Scalars['Float']['input'];
  policeNumber?: InputMaybe<Scalars['String']['input']>;
  priceFindings?: InputMaybe<Array<PriceFindingArgs>>;
  purchasePayoutAmount: Scalars['Float']['input'];
  title: Scalars['String']['input'];
  unconfirmedPropertyIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  variantId?: InputMaybe<Scalars['ObjectId']['input']>;
  vehicleData?: InputMaybe<VehicleDataArgs>;
};

export type CustomDealItemDataEntry = {
  __typename?: 'CustomDealItemDataEntry';
  _id: Scalars['ObjectId']['output'];
  algoliaReference?: Maybe<Scalars['String']['output']>;
  answers?: Maybe<Array<ItemAnswer>>;
  counterofferPayoutAmount?: Maybe<Scalars['Float']['output']>;
  ean?: Maybe<Scalars['String']['output']>;
  formAnswers?: Maybe<Array<FormAnswer>>;
  foundComparableOffers?: Maybe<ECustomItemFoundComparableOffers>;
  foundOffersEvaluationFactor?: Maybe<Scalars['Float']['output']>;
  itemCategory: ItemCategory;
  itemCategoryId: Scalars['ObjectId']['output'];
  itemPawnValueEntry?: Maybe<ItemValuesEntry>;
  itemPurchaseValueEntry?: Maybe<ItemValuesEntry>;
  material?: Maybe<Scalars['String']['output']>;
  media?: Maybe<Array<FileMetadata>>;
  note?: Maybe<Scalars['String']['output']>;
  overwrittenItemValue?: Maybe<Scalars['Float']['output']>;
  overwrittenPawnPayoutAmount?: Maybe<Scalars['Float']['output']>;
  overwrittenPurchasePayoutAmount?: Maybe<Scalars['Float']['output']>;
  pawnPayoutAmount: Scalars['Float']['output'];
  policeNumber?: Maybe<Scalars['String']['output']>;
  priceFindings?: Maybe<Array<PriceFinding>>;
  productVariant?: Maybe<ProductVariant>;
  purchasePayoutAmount: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  unconfirmedPropertyIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
  variantId?: Maybe<Scalars['ObjectId']['output']>;
  vehicleData?: Maybe<VehicleData>;
};

export type CustomDealItemFilterArgs = {
  title?: InputMaybe<StringFilter>;
};

export type CustomDealItemUpdateArgs = {
  _id: Scalars['ObjectId']['input'];
  algoliaReference?: InputMaybe<Scalars['String']['input']>;
  answers?: InputMaybe<Array<ItemAnswerArgs>>;
  condition?: InputMaybe<ECustomDealItemCondition>;
  counterofferPayoutAmount?: InputMaybe<Scalars['Float']['input']>;
  ean?: InputMaybe<Scalars['String']['input']>;
  formAnswers?: InputMaybe<Array<FormAnswerArgs>>;
  foundComparableOffers?: InputMaybe<ECustomItemFoundComparableOffers>;
  foundOffersEvaluationFactor?: InputMaybe<Scalars['Float']['input']>;
  itemCategoryId: Scalars['ObjectId']['input'];
  material?: InputMaybe<Scalars['String']['input']>;
  mediaUploads?: InputMaybe<Array<FileTusMetadataArgs>>;
  note?: InputMaybe<Scalars['String']['input']>;
  overwrittenItemValue?: InputMaybe<Scalars['Float']['input']>;
  overwrittenPawnPayoutAmount?: InputMaybe<Scalars['Float']['input']>;
  overwrittenPurchasePayoutAmount?: InputMaybe<Scalars['Float']['input']>;
  pawnPayoutAmount: Scalars['Float']['input'];
  policeNumber?: InputMaybe<Scalars['String']['input']>;
  priceFindings?: InputMaybe<Array<PriceFindingArgs>>;
  purchasePayoutAmount: Scalars['Float']['input'];
  title: Scalars['String']['input'];
  unconfirmedPropertyIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  variantId?: InputMaybe<Scalars['ObjectId']['input']>;
  vehicleData?: InputMaybe<VehicleDataArgs>;
};

export type CustomDealOpts = {
  filter?: InputMaybe<CustomDealFilterArgs>;
  order?: InputMaybe<CustomDealOrderArgs>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomDealOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  createdAt?: InputMaybe<EOrderBy>;
};

export type CustomDealPawnPurchaseCalculations = {
  __typename?: 'CustomDealPawnPurchaseCalculations';
  pawnCalculation: CustomDealCalculation;
  purchaseCalculation?: Maybe<CustomDealCalculation>;
};

export type CustomDealQualification = {
  __typename?: 'CustomDealQualification';
  at: Scalars['DateTime']['output'];
  by: Employee;
  value: Scalars['Float']['output'];
};

export type CustomDealQuestionNumberRestriction = {
  __typename?: 'CustomDealQuestionNumberRestriction';
  conditionOperator: ENumberFilterConditions;
  conditionValue: Scalars['Float']['output'];
  errorMessage: TranslatedString;
};

export type CustomDealQuestionNumberRestrictionArgs = {
  conditionOperator: ENumberFilterConditions;
  conditionValue: Scalars['Float']['input'];
  errorMessage: Array<MultipleLanguageTextArgs>;
};

export type CustomDealRemoveItemArgs = {
  customDealId: Scalars['ObjectId']['input'];
  customDealItemId: Scalars['ObjectId']['input'];
};

export type CustomDealUpdateArgs = {
  _id: Scalars['ObjectId']['input'];
  companyId?: InputMaybe<Scalars['ObjectId']['input']>;
  contactData?: InputMaybe<CustomDealContactDataArgs>;
  customerId?: InputMaybe<Scalars['ObjectId']['input']>;
  dealType?: InputMaybe<EDealType>;
  durationInDays?: InputMaybe<Scalars['Float']['input']>;
  employeeId?: InputMaybe<Scalars['ObjectId']['input']>;
  employeeResponse?: InputMaybe<CustomDealEmployeeResponseArgs>;
  payoutApproverId?: InputMaybe<Scalars['ObjectId']['input']>;
  pickupTransportMode?: InputMaybe<ETransportMode>;
  priceFindings?: InputMaybe<Array<PriceFindingArgs>>;
  shopId?: InputMaybe<Scalars['ObjectId']['input']>;
  status?: InputMaybe<ECustomDealStatusType>;
};

export type CustomDealsFilterStatus = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  mode: EDateFilterMode;
  names: Array<ECustomDealStatusType>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CustomDealsFiltersArgs = {
  categoryIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  companyId?: InputMaybe<Scalars['ObjectId']['input']>;
  createdBefore?: InputMaybe<Scalars['DateTime']['input']>;
  dealBusinessUnit?: InputMaybe<EBusinessUnit>;
  employeeIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  includeClosedCustomDeals?: InputMaybe<Scalars['Boolean']['input']>;
  paginationArgs: ForwardPaginationSkipLimitArgs;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CustomDealsFilterStatus>;
  type?: InputMaybe<EDealType>;
};

export type CustomDealsWithPagination = {
  __typename?: 'CustomDealsWithPagination';
  records: Array<CustomDeal>;
  totalCount: Scalars['Float']['output'];
  totalPages: Scalars['Float']['output'];
};

export type CustomRequest = {
  __typename?: 'CustomRequest';
  _id: Scalars['ObjectId']['output'];
  acceptedBy?: Maybe<Scalars['String']['output']>;
  appliedUsedFeeDefinitions: Array<UsedFeeDefinition>;
  calculationBase: CalculationBase;
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  customerId: Scalars['ObjectId']['output'];
  dealData: CustomRequestDealData;
  declinedBy?: Maybe<Scalars['String']['output']>;
  events: Array<CustomRequestEvent>;
  itemsData: Array<CustomRequestItemData>;
  note?: Maybe<Scalars['String']['output']>;
  noteToCustomer?: Maybe<Scalars['Boolean']['output']>;
  pawnContinueUsing?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CustomRequestDealData = {
  __typename?: 'CustomRequestDealData';
  selected: CustomRequestDealDataEntry;
  verified: CustomRequestDealDataEntry;
};

export type CustomRequestDealDataEntry = {
  __typename?: 'CustomRequestDealDataEntry';
  dealFeesIds: Array<Scalars['ObjectId']['output']>;
  durationInDays: Scalars['Float']['output'];
  payoutAmount: Scalars['Float']['output'];
};

export type CustomRequestEvent = {
  __typename?: 'CustomRequestEvent';
  createdAt: Scalars['DateTime']['output'];
  event: ECustomRequestEvent;
  responsibleAdminId?: Maybe<Scalars['ObjectId']['output']>;
  timestamp: Scalars['DateTime']['output'];
};

export type CustomRequestFilterArgs = {
  _id?: InputMaybe<IdFilter>;
  createdAt?: InputMaybe<DateFilter>;
  customerId?: InputMaybe<IdFilter>;
  customerIds?: InputMaybe<IdFilter>;
  firstnameOrLastNameOrEmail?: InputMaybe<StringFilter>;
  hasEvents?: InputMaybe<Array<ECustomRequestEvent>>;
  ids?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  itemTitle?: InputMaybe<StringFilter>;
  notHasEvents?: InputMaybe<Array<ECustomRequestEvent>>;
  updatedAt?: InputMaybe<DateFilter>;
};

export type CustomRequestItemData = {
  __typename?: 'CustomRequestItemData';
  selected: CustomRequestItemDataEntry;
  verified: CustomRequestItemDataEntry;
};

export type CustomRequestItemDataEntry = {
  __typename?: 'CustomRequestItemDataEntry';
  condition: ECustomRequestCondition;
  isBulkyGood?: Maybe<Scalars['Boolean']['output']>;
  itemCategory?: Maybe<ItemCategory>;
  itemCategoryId: Scalars['ObjectId']['output'];
  itemFeesIds: Array<Scalars['ObjectId']['output']>;
  itemValuesEntry: ItemValuesEntry;
  media?: Maybe<Array<FileMetadata>>;
  note?: Maybe<Scalars['String']['output']>;
  policeNumber?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  vehicleData?: Maybe<VehicleData>;
};

export type CustomRequestOpts = {
  filter?: InputMaybe<CustomRequestFilterArgs>;
  order?: InputMaybe<CustomRequestOrderArgs>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomRequestOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  createdAt?: InputMaybe<EOrderBy>;
  updatedAt?: InputMaybe<EOrderBy>;
};

export type Customer = {
  __typename?: 'Customer';
  _id: Scalars['ObjectId']['output'];
  acquiredBy?: Maybe<Scalars['String']['output']>;
  activeDeals: Array<Deal>;
  additionalInformationForCarPawn?: Maybe<AdditionalInformationForCarPawn>;
  addresses?: Maybe<Array<OCustomerAddress>>;
  blacklistInformation?: Maybe<BlacklistInformation>;
  closedDeals: Array<Deal>;
  createdAt: Scalars['DateTime']['output'];
  customDeals: Array<CustomDeal>;
  customRequests: Array<CustomRequest>;
  customerNumber: Scalars['Float']['output'];
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  deactivated?: Maybe<Scalars['Boolean']['output']>;
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  dealHistory: CustomerDealHistory;
  deals: Array<Deal>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  firstname: Scalars['String']['output'];
  guestEmail?: Maybe<Scalars['String']['output']>;
  hasAlreadyDeals: Scalars['Boolean']['output'];
  iban?: Maybe<Scalars['String']['output']>;
  identityNumber?: Maybe<Scalars['String']['output']>;
  identityType?: Maybe<ECustomerIdentityType>;
  identityUploadLinks?: Maybe<Array<FileMetadata>>;
  identityUploads?: Maybe<Array<Scalars['Upload']['output']>>;
  identityVerifiedAt?: Maybe<Scalars['DateTime']['output']>;
  identityVerifiedBy?: Maybe<Scalars['ObjectId']['output']>;
  identityVerifiedByEmployee?: Maybe<Employee>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isNotePopup?: Maybe<Scalars['Boolean']['output']>;
  isTestUser?: Maybe<Scalars['Boolean']['output']>;
  lastReminderIdentitySentAt?: Maybe<Scalars['DateTime']['output']>;
  lastname: Scalars['String']['output'];
  mergedCustomers?: Maybe<Array<Maybe<MergedCustomer>>>;
  note?: Maybe<Scalars['String']['output']>;
  paypalAddress?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  registrationCertificate?: Maybe<FileMetadata>;
  roles: Array<ERoles>;
  sex?: Maybe<ESex>;
  token?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uploadedFiles?: Maybe<Array<FileMetadata>>;
  userPermission?: Maybe<UserPermission>;
  userPermissionId: Scalars['ObjectId']['output'];
};


export type CustomerActiveDealsArgs = {
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
};


export type CustomerClosedDealsArgs = {
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
};


export type CustomerCustomRequestsArgs = {
  opts?: InputMaybe<CustomRequestOpts>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
};


export type CustomerDealsArgs = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
};

export type CustomerBlacklist = {
  __typename?: 'CustomerBlacklist';
  _id: Scalars['ObjectId']['output'];
  createdAt: Scalars['DateTime']['output'];
  customers?: Maybe<Array<Customer>>;
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<Employee>;
  firstname: Scalars['String']['output'];
  lastname: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

export type CustomerBlacklistCreateArgs = {
  customerIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employeeId: Scalars['ObjectId']['input'];
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export type CustomerBlacklistDeleteArgs = {
  id: Scalars['ObjectId']['input'];
  reason: Scalars['String']['input'];
};

export type CustomerBlacklistFiltersArgs = {
  customerId?: InputMaybe<Scalars['ObjectId']['input']>;
  dateOfBirth?: InputMaybe<DateFilter>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
};

export type CustomerBlacklistUpdateArgs = {
  customerIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employeeId: Scalars['ObjectId']['input'];
  firstname: Scalars['String']['input'];
  id: Scalars['ObjectId']['input'];
  lastname: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export type CustomerBlacklistsFiltersArgs = {
  createdBefore?: InputMaybe<Scalars['DateTime']['input']>;
  paginationArgs: ForwardPaginationSkipLimitArgs;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerByPersonalDataArgs = {
  dateOfBirth: Scalars['DateTime']['input'];
  email: Scalars['String']['input'];
};

export type CustomerCallRequestArgs = {
  companyId: Scalars['ObjectId']['input'];
  customerEmail: Scalars['String']['input'];
  customerFirstName: Scalars['String']['input'];
  customerTelephoneNumber: Scalars['String']['input'];
};

export type CustomerCategoryArgs = {
  customerCategory: ECustomerCategory;
  dealId: Scalars['ObjectId']['input'];
};

export type CustomerDealHistory = {
  __typename?: 'CustomerDealHistory';
  carPawn: CustomerDealHistoryData;
  normalPawn: CustomerDealHistoryData;
};

export type CustomerDealHistoryData = {
  __typename?: 'CustomerDealHistoryData';
  auctionedDealsCount: Scalars['Float']['output'];
  bookedDealsCount: Scalars['Float']['output'];
  extendedDealsCount: Scalars['Float']['output'];
  paidBackDealsCount: Scalars['Float']['output'];
  verifiedDealsCount: Scalars['Float']['output'];
};

export type CustomerFilterArgs = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  acquiredBy?: InputMaybe<StringFilter>;
  customerNumber?: InputMaybe<NumberFilter>;
  dateOfBirth?: InputMaybe<DateFilter>;
  deactivated?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<StringFilter>;
  firstname?: InputMaybe<StringFilter>;
  firstnameOrLastNameOrEmail?: InputMaybe<StringFilter>;
  ids?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  isDeleted?: InputMaybe<BooleanFilter>;
  isTestUser?: InputMaybe<BooleanFilter>;
  lastname?: InputMaybe<StringFilter>;
  phone?: InputMaybe<StringFilter>;
};

export type CustomerOpts = {
  filter?: InputMaybe<CustomerFilterArgs>;
  order?: InputMaybe<CustomerOrderArgs>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomerOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  customerNumber?: InputMaybe<EOrderBy>;
  firstname?: InputMaybe<EOrderBy>;
  lastname?: InputMaybe<EOrderBy>;
};

export type CustomerSearchOpts = {
  customerNumber?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
};

export type CustomersFiltersArgs = {
  createdBefore?: InputMaybe<Scalars['DateTime']['input']>;
  paginationArgs: ForwardPaginationSkipLimitArgs;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type DpdAccountInfo = {
  __typename?: 'DPDAccountInfo';
  apiEndpoint: Scalars['String']['output'];
  isPasswordStored: Scalars['Boolean']['output'];
  subAccountsInfo?: Maybe<Array<DpdSubAccountInfo>>;
  username?: Maybe<Scalars['String']['output']>;
};

export type DpdConfigurationArgs = {
  accountName: Scalars['String']['input'];
  accountToken?: InputMaybe<Scalars['String']['input']>;
  shopSubAccounts?: InputMaybe<Array<DpdSubAccountArgs>>;
};

export type DpdSubAccountArgs = {
  shopId: Scalars['ObjectId']['input'];
  userId: Scalars['String']['input'];
  userToken?: InputMaybe<Scalars['String']['input']>;
};

export type DpdSubAccountInfo = {
  __typename?: 'DPDSubAccountInfo';
  isPasswordStored: Scalars['Boolean']['output'];
  shopId: Scalars['ObjectId']['output'];
  username: Scalars['String']['output'];
};

export type DateFilter = {
  betweenValues?: InputMaybe<DateFilterBetween>;
  condition?: InputMaybe<EDateFilterConditions>;
  value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DateFilterBetween = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};

export type DateFilterBetweenType = {
  __typename?: 'DateFilterBetweenType';
  from: Scalars['DateTime']['output'];
  to: Scalars['DateTime']['output'];
};

export type DateFilterType = {
  __typename?: 'DateFilterType';
  betweenValues?: Maybe<DateFilterBetweenType>;
  condition?: Maybe<EDateFilterConditions>;
  value?: Maybe<Scalars['DateTime']['output']>;
};

export type Deal = {
  __typename?: 'Deal';
  _id: Scalars['ObjectId']['output'];
  acceptingWithdrawalFeeTermsRequired: Scalars['Boolean']['output'];
  auctionDealCalculation: DealCalculation;
  auctioningSettings?: Maybe<DealAuctioningSettings>;
  bookingNumber: Scalars['Int']['output'];
  businessUnit: EBusinessUnit;
  canDealOnSellBeExtendedOrPaidBack: Scalars['Boolean']['output'];
  chainNotes?: Maybe<Array<Note>>;
  closedBy?: Maybe<Scalars['String']['output']>;
  company: Company;
  companyId: Scalars['ObjectId']['output'];
  createdAt: Scalars['DateTime']['output'];
  customDealId?: Maybe<Scalars['ObjectId']['output']>;
  customer: DealCustomer;
  customerCategory?: Maybe<ECustomerCategory>;
  dealChain?: Maybe<Array<DealChain>>;
  dealFinalValues: DealFinalValues;
  dealPartnerData?: Maybe<ODealPartnerData>;
  dealStartDate: Scalars['DateTime']['output'];
  dealType: EDealType;
  dealValorizationCalculation?: Maybe<DealValorizationCalculation>;
  dropoffData?: Maybe<TransportData>;
  employeeDeclarations?: Maybe<Array<Scalars['String']['output']>>;
  events: Array<DealEvent>;
  extendedBy?: Maybe<Scalars['String']['output']>;
  extensionChain?: Maybe<ExtensionChain>;
  hasCompletedPayment: Scalars['Boolean']['output'];
  initialShopId?: Maybe<Scalars['ObjectId']['output']>;
  insuranceFactor: Scalars['Float']['output'];
  insuredAmount: Scalars['Float']['output'];
  isExtensionPaymentOngoing: Scalars['Boolean']['output'];
  isInOpenAuction?: Maybe<Scalars['Boolean']['output']>;
  isNewCustomer?: Maybe<Scalars['Boolean']['output']>;
  isPaybackPaymentOngoing: Scalars['Boolean']['output'];
  items: Array<DealItem>;
  itemsIds: Array<Scalars['ObjectId']['output']>;
  latestOngoingPaymentRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  notes?: Maybe<Array<Note>>;
  pawnData?: Maybe<PawnData>;
  payoutData: PaymentData;
  persistedExtensionCalculation?: Maybe<PersistedDealExtensionCalculation>;
  persistedPaybackCalculation?: Maybe<PersistedDealPaybackCalculation>;
  pickupData?: Maybe<TransportData>;
  purchaseData?: Maybe<PurchaseData>;
  requestedItems: Array<DealItem>;
  requestedItemsIds: Array<Scalars['ObjectId']['output']>;
  secondaryCustomers?: Maybe<Array<Customer>>;
  secondaryCustomersIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
  secondaryPayoutData?: Maybe<SecondaryPaymentData>;
  shippingLabelPageId?: Maybe<Scalars['String']['output']>;
  shippingLabels?: Maybe<Array<ShippingLabel>>;
  shop?: Maybe<Shop>;
  status?: Maybe<EDealStatusType>;
  surplusPaymentsData?: Maybe<Array<SurplusPaymentData>>;
  updatedAt: Scalars['DateTime']['output'];
  uploadedFiles?: Maybe<Array<FileMetadata>>;
  verifiedBy?: Maybe<Scalars['String']['output']>;
};


export type DealAuctionDealCalculationArgs = {
  auctionDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type DealItemsArgs = {
  omitItemQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  omitItemValorizationCalculation?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DealPersistedExtensionCalculationArgs = {
  args: DealExtensionCalculationArgs;
};


export type DealPersistedPaybackCalculationArgs = {
  args: DealPaybackCalculationArgs;
};

export type DealAuctioningSettings = {
  __typename?: 'DealAuctioningSettings';
  at: Scalars['DateTime']['output'];
  auctioningAllowed: Scalars['Boolean']['output'];
  by: Employee;
};

export type DealBookedEvent = BaseDealEvent & {
  __typename?: 'DealBookedEvent';
  createdAt: Scalars['DateTime']['output'];
  dealCalculation: DealCalculation;
  displayName: Scalars['String']['output'];
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime']['output'];
};

export type DealCalculation = IDealCalculation & {
  __typename?: 'DealCalculation';
  appliedUsedFeeDefinitions: Array<UsedFeeDefinition>;
  date: Scalars['DateTime']['output'];
  dealValuesEntry: DealValuesEntry;
  itemsValuesEntries: Array<ItemValuesEntry>;
  loanToValuesEntryId: Scalars['ObjectId']['output'];
};

export type DealCanceledEvent = BaseDealEvent & {
  __typename?: 'DealCanceledEvent';
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime']['output'];
};

export type DealChain = {
  __typename?: 'DealChain';
  bookingNumber: Scalars['Float']['output'];
  chainType: EDealChainType;
  dealId: Scalars['ObjectId']['output'];
};

export type DealClosedEvent = BaseDealEvent & {
  __typename?: 'DealClosedEvent';
  createdAt: Scalars['DateTime']['output'];
  dealCalculation: DealCalculation;
  displayName: Scalars['String']['output'];
  isClosedByAuctionId?: Maybe<Scalars['ObjectId']['output']>;
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime']['output'];
  valorizationFeeGross?: Maybe<Scalars['Float']['output']>;
  valorizationFeeNet?: Maybe<Scalars['Float']['output']>;
};

export type DealCollectedEvent = BaseDealEvent & {
  __typename?: 'DealCollectedEvent';
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime']['output'];
};

export type DealCreateArgs = {
  companyId: Scalars['ObjectId']['input'];
  creatorId?: InputMaybe<Scalars['ObjectId']['input']>;
  customDealId?: InputMaybe<Scalars['ObjectId']['input']>;
  dealCalculationId: Scalars['ObjectId']['input'];
  dealItemsCreateArgs: Array<DealItemCreateArgs>;
  dealPartnerData?: InputMaybe<DealPartnerDataArgs>;
  employeeDeclarations?: InputMaybe<Array<Scalars['String']['input']>>;
  guestCustomerDataArgs?: InputMaybe<GuestCustomerDataArgs>;
  iban?: InputMaybe<Scalars['String']['input']>;
  initialShopId?: InputMaybe<Scalars['ObjectId']['input']>;
  payoutType: EManualPaymentType;
  paypalAddress?: InputMaybe<Scalars['String']['input']>;
  pickupData?: InputMaybe<TransportDataArgs>;
  registeredCustomerId?: InputMaybe<Scalars['ObjectId']['input']>;
};

/** Customer | GuestCustomerData */
export type DealCustomer = Customer | GuestCustomerData;

export type DealCustomerInCreditEvent = BaseDealEvent & {
  __typename?: 'DealCustomerInCreditEvent';
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime']['output'];
};

export type DealCustomerInDebtEvent = BaseDealEvent & {
  __typename?: 'DealCustomerInDebtEvent';
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime']['output'];
};

export type DealDeclinedEvent = BaseDealEvent & {
  __typename?: 'DealDeclinedEvent';
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime']['output'];
};

export type DealDerecognizedEvent = BaseDealEvent & {
  __typename?: 'DealDerecognizedEvent';
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime']['output'];
};

export type DealEvent = DealBookedEvent | DealCanceledEvent | DealClosedEvent | DealCollectedEvent | DealCustomerInCreditEvent | DealCustomerInDebtEvent | DealDeclinedEvent | DealDerecognizedEvent | DealExcessAmountPayedEvent | DealExtensionConfirmedEvent | DealItemReceivedIdMissingEvent | DealLoanDueEvent | DealLoanDueNotifiedEvent | DealOnSellEvent | DealPaybackConfirmedEvent | DealPayedAndStoredEvent | DealPayedShipmentPendingEvent | DealPickedUpEvent | DealPickedUpUnsuccessfulEvent | DealReviewingEvent | DealSoldExternEvent | DealSoldInternEvent | DealVerifiedEvent;

export type DealEventFilter = {
  event: EDealStatusType;
  when?: InputMaybe<DateFilter>;
};

export type DealEventFilterType = {
  __typename?: 'DealEventFilterType';
  event: EDealStatusType;
  when?: Maybe<DateFilterType>;
};

export type DealExcessAmountPayedEvent = BaseDealEvent & {
  __typename?: 'DealExcessAmountPayedEvent';
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime']['output'];
};

export type DealExtensionCalculation = {
  __typename?: 'DealExtensionCalculation';
  childDealCalculation: DealCalculation;
  dealId: Scalars['ObjectId']['output'];
  dueAmount: Scalars['Float']['output'];
  itemsExtensionAnswers: Array<ItemExtensionAnswers>;
  overwrittenPartialRedemptionAmount?: Maybe<Scalars['Float']['output']>;
  parentDealCalculation: DealCalculation;
  partialRedemptionAmount: Scalars['Float']['output'];
};

export type DealExtensionCalculationArgs = {
  childManualFeeDefinitionsArgs: Array<ManualFeeDefinitionArgs>;
  childShouldOverwriteManualFees: Scalars['Boolean']['input'];
  durationInDays?: InputMaybe<Scalars['Int']['input']>;
  extensionDate?: InputMaybe<Scalars['DateTime']['input']>;
  itemsExtensionAnswersArgs: Array<ItemExtensionAnswersArgs>;
  manualFeeDefinitionsArgs: Array<ManualFeeDefinitionArgs>;
  overwrittenPartialRedemptionAmount?: InputMaybe<Scalars['Float']['input']>;
  shouldOverwriteItemAnswers: Scalars['Boolean']['input'];
  shouldOverwriteManualFees: Scalars['Boolean']['input'];
};

export type DealExtensionConfirmedEvent = BaseDealEvent & {
  __typename?: 'DealExtensionConfirmedEvent';
  childCalculation: DealCalculation;
  createdAt: Scalars['DateTime']['output'];
  dealCalculation: DealCalculation;
  displayName: Scalars['String']['output'];
  dueAmount: Scalars['Float']['output'];
  itemsExtensionAnswers?: Maybe<Array<ItemExtensionAnswers>>;
  overwrittenPartialRedemptionAmount?: Maybe<Scalars['Float']['output']>;
  partialRedemptionAmount: Scalars['Float']['output'];
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime']['output'];
};

export type DealFilterArgs = {
  _id?: InputMaybe<IdFilter>;
  bookingNumber?: InputMaybe<NumberFilter>;
  bookingNumbers?: InputMaybe<Array<Scalars['Int']['input']>>;
  businessUnit?: InputMaybe<EBusinessUnit>;
  companyId?: InputMaybe<IdFilter>;
  customerId?: InputMaybe<IdFilter>;
  customerIds?: InputMaybe<IdFilter>;
  dealEventFilter?: InputMaybe<DealEventFilter>;
  dealType?: InputMaybe<EDealType>;
  firstnameOrLastNameOrEmail?: InputMaybe<StringFilter>;
  hasEvents?: InputMaybe<Array<EDealStatusType>>;
  hasExtension?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrIsExtension?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrIsExtensionBuyBack?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  initialShopId?: InputMaybe<IdFilter>;
  initialShopIds?: InputMaybe<IdFilter>;
  isExtension?: InputMaybe<Scalars['Boolean']['input']>;
  itemsIds?: InputMaybe<IdFilter>;
  noShop?: InputMaybe<Scalars['Boolean']['input']>;
  notHasEvents?: InputMaybe<Array<EDealStatusType>>;
  shopName?: InputMaybe<StringFilter>;
};

export type DealFinalValues = {
  __typename?: 'DealFinalValues';
  dealType: EDealType;
  durationInDays: Scalars['Float']['output'];
  isOnlineExtensionPrevented?: Maybe<Scalars['Boolean']['output']>;
  minPartialRedemptionAmount?: Maybe<Scalars['Float']['output']>;
  partialRedemptionIntervalsCount?: Maybe<Scalars['Float']['output']>;
  partialRedemptionSetUpBy: DealFinalValuesEntryCreator;
  payoutAmount: Scalars['Float']['output'];
  shouldOverwritePayoutAmount: Scalars['Boolean']['output'];
};

export type DealFinalValuesArgs = {
  dealType: EDealType;
  durationInDays: Scalars['Float']['input'];
  payoutAmount: Scalars['Float']['input'];
  shouldOverwritePayoutAmount: Scalars['Boolean']['input'];
};

/** Employee | SystemOperation */
export type DealFinalValuesEntryCreator = Employee | SystemOperation;

export type DealInOpenAuctionArgs = {
  __typename?: 'DealInOpenAuctionArgs';
  auction?: Maybe<Auction>;
  auctionDate?: Maybe<Scalars['DateTime']['output']>;
  isDealExistsInAnOpenAuctions: Scalars['Boolean']['output'];
};

export type DealItem = {
  __typename?: 'DealItem';
  _id: Scalars['ObjectId']['output'];
  _oldItemId?: Maybe<Scalars['String']['output']>;
  algoliaReference?: Maybe<Scalars['String']['output']>;
  answers?: Maybe<Array<ItemAnswer>>;
  categorizedUploadedFiles?: Maybe<Array<CategorizedUploadedFile>>;
  checkedAfterAuction?: Maybe<Scalars['Boolean']['output']>;
  checkedAt?: Maybe<Scalars['DateTime']['output']>;
  checkedBy?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['ObjectId']['output'];
  createdAt: Scalars['DateTime']['output'];
  customDealId?: Maybe<Scalars['ObjectId']['output']>;
  customRequestId?: Maybe<Scalars['ObjectId']['output']>;
  damageCasePeriods?: Maybe<Array<TimePeriod>>;
  dealsHistory?: Maybe<Array<ItemDealsHistoryEntry>>;
  ean?: Maybe<Scalars['String']['output']>;
  entrupyCertificateUrl?: Maybe<Scalars['String']['output']>;
  events?: Maybe<Array<ItemEvent>>;
  formAnswers?: Maybe<Array<FormAnswer>>;
  imei?: Maybe<Scalars['String']['output']>;
  internalSaleData?: Maybe<InternalSaleData>;
  isBulkyItem: Scalars['Boolean']['output'];
  isContinueUsing: Scalars['Boolean']['output'];
  isDamageCase?: Maybe<Scalars['Boolean']['output']>;
  isForPersonalUse?: Maybe<Scalars['Boolean']['output']>;
  isInvestmentGold?: Maybe<Scalars['Boolean']['output']>;
  itemCategory: ItemCategory;
  itemCategoryId: Scalars['ObjectId']['output'];
  itemSpecification?: Maybe<Scalars['String']['output']>;
  itemValorizationCalculation?: Maybe<ItemValorizationCalculation>;
  lastBookingNumber?: Maybe<Scalars['String']['output']>;
  loanToValuesEntryId: Scalars['ObjectId']['output'];
  manualTest?: Maybe<PiceaTest>;
  material?: Maybe<Scalars['String']['output']>;
  media?: Maybe<Array<FileMetadata>>;
  note?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Array<Note>>;
  personalUsePeriods?: Maybe<Array<TimePeriod>>;
  piceaTest?: Maybe<PiceaTest>;
  piceaUpload?: Maybe<Scalars['Upload']['output']>;
  piceaUploadLink?: Maybe<FileMetadata>;
  policeNumber?: Maybe<Scalars['String']['output']>;
  product?: Maybe<ProductLegacy>;
  productLegacy?: Maybe<ProductLegacy>;
  productVariant?: Maybe<ProductVariant>;
  questionIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
  questions?: Maybe<Array<ItemQuestion>>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  shippingLabels?: Maybe<Array<ShippingLabel>>;
  status?: Maybe<EItemStatusType>;
  storageFacility?: Maybe<StorageFacility>;
  storageFacilityId?: Maybe<Scalars['ObjectId']['output']>;
  storageHistory?: Maybe<Array<ItemStorageHistoryEntry>>;
  storageLabel?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  unconfirmedPropertyIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
  updatedAt: Scalars['DateTime']['output'];
  uploadedFiles?: Maybe<Array<FileMetadata>>;
  usedGrade?: Maybe<EUsedGrade>;
  valorizationHistoryIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
  values: ItemValues;
  variantId?: Maybe<Scalars['ObjectId']['output']>;
  vehicleData?: Maybe<VehicleData>;
};

export type DealItemCalculationArgs = {
  algoliaReference?: InputMaybe<Scalars['String']['input']>;
  answers: Array<ItemAnswerArgs>;
  customPayoutAmount?: InputMaybe<Scalars['Float']['input']>;
  existingCurrentMarketValue?: InputMaybe<Scalars['Float']['input']>;
  existingPredictedMarketValue?: InputMaybe<Scalars['Float']['input']>;
  isInvestmentGold?: InputMaybe<Scalars['Boolean']['input']>;
  itemCategoryId: Scalars['ObjectId']['input'];
  material?: InputMaybe<Scalars['String']['input']>;
  skipPredictionTags?: InputMaybe<Scalars['Boolean']['input']>;
  unconfirmedPropertyIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  useOldValuesOfPrediction?: InputMaybe<Scalars['Boolean']['input']>;
  variantId?: InputMaybe<Scalars['ObjectId']['input']>;
  vehicleData?: InputMaybe<VehicleDataArgs>;
};

export type DealItemCategorizedUploadFiles = {
  fileCategoryName: Scalars['String']['input'];
  uploads: Array<FileTusMetadataArgs>;
};

export type DealItemCreateArgs = {
  algoliaReference?: InputMaybe<Scalars['String']['input']>;
  answers: Array<ItemAnswerArgs>;
  categorizedUploads?: InputMaybe<Array<DealItemCategorizedUploadFiles>>;
  customPayoutAmount?: InputMaybe<Scalars['Float']['input']>;
  ean?: InputMaybe<Scalars['String']['input']>;
  existingCurrentMarketValue?: InputMaybe<Scalars['Float']['input']>;
  existingPredictedMarketValue?: InputMaybe<Scalars['Float']['input']>;
  formAnswers?: InputMaybe<Array<DealItemFormAnswer>>;
  isInvestmentGold?: InputMaybe<Scalars['Boolean']['input']>;
  itemCategoryId: Scalars['ObjectId']['input'];
  material?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Array<FileMetadataArgs>>;
  note?: InputMaybe<Scalars['String']['input']>;
  policeNumber?: InputMaybe<Scalars['String']['input']>;
  skipPredictionTags?: InputMaybe<Scalars['Boolean']['input']>;
  storageFacilityId?: InputMaybe<Scalars['ObjectId']['input']>;
  title: Scalars['String']['input'];
  unconfirmedPropertyIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  uploads?: InputMaybe<Array<FileTusMetadataArgs>>;
  useOldValuesOfPrediction?: InputMaybe<Scalars['Boolean']['input']>;
  variantId?: InputMaybe<Scalars['ObjectId']['input']>;
  vehicleData?: InputMaybe<VehicleDataArgs>;
};

export type DealItemFormAnswer = {
  questionId: Scalars['ObjectId']['input'];
  value: DealItemFormAnswerValue;
};

export type DealItemFormAnswerValue = {
  booleanValue?: InputMaybe<Scalars['Boolean']['input']>;
  numberValue?: InputMaybe<Scalars['Float']['input']>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
};

export type DealItemReceivedIdMissingEvent = BaseDealEvent & {
  __typename?: 'DealItemReceivedIdMissingEvent';
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime']['output'];
};

export type DealItemUpdateArgs = {
  _id: Scalars['ObjectId']['input'];
  checkedAfterAuction?: InputMaybe<Scalars['Boolean']['input']>;
  checkedAt?: InputMaybe<Scalars['DateTime']['input']>;
  checkedBy?: InputMaybe<Scalars['String']['input']>;
  disableCheckPiceaTest?: InputMaybe<Scalars['Boolean']['input']>;
  entrupyCertificateUrl?: InputMaybe<Scalars['String']['input']>;
  formAnswers?: InputMaybe<Array<UpdateFormAnswerArgs>>;
  imei?: InputMaybe<Scalars['String']['input']>;
  isBulkyGood?: InputMaybe<Scalars['Boolean']['input']>;
  isInvestmentGold?: InputMaybe<Scalars['Boolean']['input']>;
  itemSpecification?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  storageFacilityId?: InputMaybe<Scalars['ObjectId']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unconfirmedPropertyIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  usedGrade?: InputMaybe<EUsedGrade>;
  variantId?: InputMaybe<Scalars['ObjectId']['input']>;
  vehicleData?: InputMaybe<UpdateVehicleDataArgs>;
};

export type DealLoanDueEvent = BaseDealEvent & {
  __typename?: 'DealLoanDueEvent';
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime']['output'];
};

export type DealLoanDueNotifiedEvent = BaseDealEvent & {
  __typename?: 'DealLoanDueNotifiedEvent';
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime']['output'];
};

export type DealOnSellEvent = BaseDealEvent & {
  __typename?: 'DealOnSellEvent';
  createdAt: Scalars['DateTime']['output'];
  differenceTaxRate: Scalars['Float']['output'];
  displayName: Scalars['String']['output'];
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime']['output'];
  valorizationFeeRate: Scalars['Float']['output'];
  valueAddedTaxRate: Scalars['Float']['output'];
};

export type DealOpts = {
  filter?: InputMaybe<DealFilterArgs>;
  order?: InputMaybe<DealOrderArgs>;
  query?: InputMaybe<Array<QueryFieldFilter>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type DealOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  bookingNumber?: InputMaybe<EOrderBy>;
  createdAt?: InputMaybe<EOrderBy>;
};

export type DealPartnerDataArgs = {
  knp?: InputMaybe<DealPartnerDataKnpArgs>;
  type: EDealPartnerType;
};

export type DealPartnerDataKnpArgs = {
  debtAmount?: InputMaybe<Scalars['Float']['input']>;
  fileReferenceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DealPawnDurationsArgs = {
  companyId: Scalars['ObjectId']['input'];
  itemCategoryIds: Array<Scalars['ObjectId']['input']>;
};

export type DealPaybackCalculationArgs = {
  dropoffData?: InputMaybe<TransportDataArgs>;
  durationInDays?: InputMaybe<Scalars['Int']['input']>;
  manualFeeDefinitionsArgs: Array<ManualFeeDefinitionArgs>;
  shouldOverwriteManualFees: Scalars['Boolean']['input'];
};

export type DealPaybackConfirmedEvent = BaseDealEvent & {
  __typename?: 'DealPaybackConfirmedEvent';
  createdAt: Scalars['DateTime']['output'];
  dealCalculation: DealCalculation;
  displayName: Scalars['String']['output'];
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime']['output'];
};

export type DealPayedAndStoredEvent = BaseDealEvent & {
  __typename?: 'DealPayedAndStoredEvent';
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime']['output'];
};

export type DealPayedShipmentPendingEvent = BaseDealEvent & {
  __typename?: 'DealPayedShipmentPendingEvent';
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime']['output'];
};

export type DealPickedUpEvent = BaseDealEvent & {
  __typename?: 'DealPickedUpEvent';
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime']['output'];
};

export type DealPickedUpUnsuccessfulEvent = BaseDealEvent & {
  __typename?: 'DealPickedUpUnsuccessfulEvent';
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime']['output'];
};

export type DealReviewingEvent = BaseDealEvent & {
  __typename?: 'DealReviewingEvent';
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  issuanceCertificate: FileMetadata;
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime']['output'];
};

export type DealSoldExternEvent = BaseDealEvent & {
  __typename?: 'DealSoldExternEvent';
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime']['output'];
};

export type DealSoldInternEvent = BaseDealEvent & {
  __typename?: 'DealSoldInternEvent';
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime']['output'];
};

export type DealSurplusPaymentArgs = {
  amount: Scalars['Float']['input'];
  createNewCashbook: Scalars['Boolean']['input'];
  dealId: Scalars['ObjectId']['input'];
  existingCashbookId?: InputMaybe<Scalars['ObjectId']['input']>;
  paymentDate: Scalars['DateTime']['input'];
  paymentType: EManualPaymentType;
  shopId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type DealTransportUpdateArgs = {
  dealId: Scalars['ObjectId']['input'];
  notifyCustomer: Scalars['Boolean']['input'];
  shippingLabelCreateArgs?: InputMaybe<ShippingLabelCreateArgs>;
  transportMode: ETransportMode;
  transportType: ETransportType;
};

export type DealValorizationCalculation = {
  __typename?: 'DealValorizationCalculation';
  auctionRevenues: Array<ItemAuctionRevenue>;
  customerDebt: Scalars['Float']['output'];
  paybackCosts: Array<DealValorizationCalculationPaybackCost>;
  payoutAmount: Scalars['Float']['output'];
  surplusAmount: Scalars['Float']['output'];
  valorizationFeeGross: Scalars['Float']['output'];
  valorizationFeeNet: Scalars['Float']['output'];
  valorizationFeeRate: Scalars['Float']['output'];
};

export type DealValorizationCalculationPaybackCost = {
  __typename?: 'DealValorizationCalculationPaybackCost';
  description?: Maybe<Scalars['String']['output']>;
  grossAmount: Scalars['Float']['output'];
  netAmount: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};

export type DealValuesEntry = {
  __typename?: 'DealValuesEntry';
  calculationPaybackAmount: Scalars['Float']['output'];
  calculationPayoutAmount: Scalars['Float']['output'];
  durationInDays: Scalars['Float']['output'];
  overwrittenPayoutAmount: Scalars['Float']['output'];
  paybackAmount: Scalars['Float']['output'];
  payoutAmount: Scalars['Float']['output'];
  shouldOverwritePayoutAmount: Scalars['Boolean']['output'];
};

export type DealVerifiedEvent = BaseDealEvent & {
  __typename?: 'DealVerifiedEvent';
  createdAt: Scalars['DateTime']['output'];
  dealCalculation: DealCalculation;
  displayName: Scalars['String']['output'];
  isOverwrittenFees?: Maybe<Scalars['Boolean']['output']>;
  paymentType: AnyPaymentType;
  timestamp: Scalars['DateTime']['output'];
};

export type DealsFilterStatus = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  mode: EDateFilterMode;
  names: Array<EDealStatusType>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DealsFiltersArgs = {
  businessUnit?: InputMaybe<EBusinessUnit>;
  companyId?: InputMaybe<Scalars['ObjectId']['input']>;
  createdBefore?: InputMaybe<Scalars['DateTime']['input']>;
  initialShopId?: InputMaybe<Scalars['ObjectId']['input']>;
  paginationArgs: ForwardPaginationSkipLimitArgs;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DealsFilterStatus>;
  transportType?: InputMaybe<ETransportMode>;
  type?: InputMaybe<EDealType>;
};

export enum EAuctionBuyerType {
  Anonym = 'ANONYM',
  ExistingCustomer = 'EXISTING_CUSTOMER',
  NewCustomer = 'NEW_CUSTOMER',
  OtherRevenue = 'OTHER_REVENUE',
  SurplusPayout = 'SURPLUS_PAYOUT'
}

export enum EAuctionCreationType {
  Auto = 'AUTO',
  Manual = 'MANUAL'
}

export enum EAuctionItemStatus {
  ReadyForAuction = 'READY_FOR_AUCTION',
  Sold = 'SOLD'
}

export enum EAuctionStatus {
  Closed = 'CLOSED',
  CloseError = 'CLOSE_ERROR',
  ClosingInProgress = 'CLOSING_IN_PROGRESS',
  Open = 'OPEN',
  Started = 'STARTED'
}

export enum EAutomaticPaymentType {
  CreditcardAutomatic = 'CREDITCARD_AUTOMATIC',
  EpsAutomatic = 'EPS_AUTOMATIC',
  /** @deprecated Discontinued */
  GiropayAutomatic = 'GIROPAY_AUTOMATIC',
  PaypalAutomatic = 'PAYPAL_AUTOMATIC',
  /** @deprecated Discontinued by Klarna */
  SofortAutomatic = 'SOFORT_AUTOMATIC',
  UnzerDirectBankTransferAutomatic = 'UNZER_DIRECT_BANK_TRANSFER_AUTOMATIC'
}

export enum EBillingPeriodType {
  Day = 'DAY',
  HalfMonth = 'HALF_MONTH',
  Month = 'MONTH',
  OneTime = 'ONE_TIME'
}

export enum EBooleanFilterConditions {
  Equals = 'EQUALS',
  NotEquals = 'NOT_EQUALS'
}

export enum EBusinessUnit {
  Car = 'CAR',
  General = 'GENERAL'
}

export enum ECashBookPaymentReference {
  AuctionProceeds = 'AUCTION_PROCEEDS',
  BankWithdrawal = 'BANK_WITHDRAWAL',
  Bill = 'BILL',
  Extension = 'EXTENSION',
  ExtensionPayout = 'EXTENSION_PAYOUT',
  MarketingCreditNote = 'MARKETING_CREDIT_NOTE',
  MiscellaneousBooking = 'MISCELLANEOUS_BOOKING',
  OtherRevenue = 'OTHER_REVENUE',
  Payback = 'PAYBACK',
  Payout = 'PAYOUT',
  PrivateSale = 'PRIVATE_SALE',
  SurplusPayout = 'SURPLUS_PAYOUT',
  Tipico = 'TIPICO',
  ValorizationCreditNote = 'VALORIZATION_CREDIT_NOTE',
  ValorizationSale = 'VALORIZATION_SALE'
}

export enum ECashBookType {
  Bank = 'BANK',
  Card = 'CARD',
  Cash = 'CASH',
  Paypal = 'PAYPAL',
  Unzer = 'UNZER'
}

export enum ECountry {
  Ad = 'AD',
  Ae = 'AE',
  Af = 'AF',
  Ag = 'AG',
  Ai = 'AI',
  Al = 'AL',
  Am = 'AM',
  Ao = 'AO',
  Aq = 'AQ',
  Ar = 'AR',
  As = 'AS',
  At = 'AT',
  Au = 'AU',
  Aw = 'AW',
  Ax = 'AX',
  Az = 'AZ',
  Ba = 'BA',
  Bb = 'BB',
  Bd = 'BD',
  Be = 'BE',
  Bf = 'BF',
  Bg = 'BG',
  Bh = 'BH',
  Bi = 'BI',
  Bj = 'BJ',
  Bl = 'BL',
  Bm = 'BM',
  Bn = 'BN',
  Bo = 'BO',
  Bq = 'BQ',
  Br = 'BR',
  Bs = 'BS',
  Bt = 'BT',
  Bv = 'BV',
  Bw = 'BW',
  By = 'BY',
  Bz = 'BZ',
  Ca = 'CA',
  Cc = 'CC',
  Cd = 'CD',
  Cf = 'CF',
  Cg = 'CG',
  Ch = 'CH',
  Ci = 'CI',
  Ck = 'CK',
  Cl = 'CL',
  Cm = 'CM',
  Cn = 'CN',
  Co = 'CO',
  Cr = 'CR',
  Cu = 'CU',
  Cv = 'CV',
  Cw = 'CW',
  Cx = 'CX',
  Cy = 'CY',
  Cz = 'CZ',
  De = 'DE',
  Dj = 'DJ',
  Dk = 'DK',
  Dm = 'DM',
  Do = 'DO',
  Dz = 'DZ',
  Ec = 'EC',
  Ee = 'EE',
  Eg = 'EG',
  Eh = 'EH',
  Er = 'ER',
  Es = 'ES',
  Et = 'ET',
  Fi = 'FI',
  Fj = 'FJ',
  Fk = 'FK',
  Fm = 'FM',
  Fo = 'FO',
  Fr = 'FR',
  Ga = 'GA',
  Gb = 'GB',
  Gd = 'GD',
  Ge = 'GE',
  Gf = 'GF',
  Gg = 'GG',
  Gh = 'GH',
  Gi = 'GI',
  Gl = 'GL',
  Gm = 'GM',
  Gn = 'GN',
  Gp = 'GP',
  Gq = 'GQ',
  Gr = 'GR',
  Gs = 'GS',
  Gt = 'GT',
  Gu = 'GU',
  Gw = 'GW',
  Gy = 'GY',
  Hk = 'HK',
  Hm = 'HM',
  Hn = 'HN',
  Hr = 'HR',
  Ht = 'HT',
  Hu = 'HU',
  Id = 'ID',
  Ie = 'IE',
  Il = 'IL',
  Im = 'IM',
  In = 'IN',
  Io = 'IO',
  Iq = 'IQ',
  Ir = 'IR',
  Is = 'IS',
  It = 'IT',
  Je = 'JE',
  Jm = 'JM',
  Jo = 'JO',
  Jp = 'JP',
  Ke = 'KE',
  Kg = 'KG',
  Kh = 'KH',
  Ki = 'KI',
  Km = 'KM',
  Kn = 'KN',
  Kp = 'KP',
  Kr = 'KR',
  Kw = 'KW',
  Ky = 'KY',
  Kz = 'KZ',
  La = 'LA',
  Lb = 'LB',
  Lc = 'LC',
  Li = 'LI',
  Lk = 'LK',
  Lr = 'LR',
  Ls = 'LS',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Ly = 'LY',
  Ma = 'MA',
  Mc = 'MC',
  Md = 'MD',
  Me = 'ME',
  Mf = 'MF',
  Mg = 'MG',
  Mh = 'MH',
  Mk = 'MK',
  Ml = 'ML',
  Mm = 'MM',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Mq = 'MQ',
  Mr = 'MR',
  Ms = 'MS',
  Mt = 'MT',
  Mu = 'MU',
  Mv = 'MV',
  Mw = 'MW',
  Mx = 'MX',
  My = 'MY',
  Mz = 'MZ',
  Na = 'NA',
  Nc = 'NC',
  Ne = 'NE',
  Nf = 'NF',
  Ng = 'NG',
  Ni = 'NI',
  Nl = 'NL',
  No = 'NO',
  Np = 'NP',
  Nr = 'NR',
  Nu = 'NU',
  Nz = 'NZ',
  Om = 'OM',
  Pa = 'PA',
  Pe = 'PE',
  Pf = 'PF',
  Pg = 'PG',
  Ph = 'PH',
  Pk = 'PK',
  Pl = 'PL',
  Pm = 'PM',
  Pn = 'PN',
  Pr = 'PR',
  Ps = 'PS',
  Pt = 'PT',
  Pw = 'PW',
  Py = 'PY',
  Qa = 'QA',
  Re = 'RE',
  Ro = 'RO',
  Rs = 'RS',
  Ru = 'RU',
  Rw = 'RW',
  Sa = 'SA',
  Sb = 'SB',
  Sc = 'SC',
  Sd = 'SD',
  Se = 'SE',
  Sg = 'SG',
  Sh = 'SH',
  Si = 'SI',
  Sj = 'SJ',
  Sk = 'SK',
  Sl = 'SL',
  Sm = 'SM',
  Sn = 'SN',
  So = 'SO',
  Sr = 'SR',
  Ss = 'SS',
  St = 'ST',
  Sv = 'SV',
  Sx = 'SX',
  Sy = 'SY',
  Sz = 'SZ',
  Tc = 'TC',
  Td = 'TD',
  Tf = 'TF',
  Tg = 'TG',
  Th = 'TH',
  Tj = 'TJ',
  Tk = 'TK',
  Tl = 'TL',
  Tm = 'TM',
  Tn = 'TN',
  To = 'TO',
  Tr = 'TR',
  Tt = 'TT',
  Tv = 'TV',
  Tw = 'TW',
  Tz = 'TZ',
  Ua = 'UA',
  Ug = 'UG',
  Um = 'UM',
  Us = 'US',
  Uy = 'UY',
  Uz = 'UZ',
  Va = 'VA',
  Vc = 'VC',
  Ve = 'VE',
  Vg = 'VG',
  Vi = 'VI',
  Vn = 'VN',
  Vu = 'VU',
  Wf = 'WF',
  Ws = 'WS',
  Ye = 'YE',
  Yt = 'YT',
  Za = 'ZA',
  Zm = 'ZM',
  Zw = 'ZW'
}

export enum ECurrencyCode {
  Eur = 'EUR'
}

export enum ECustomDealFormQuestionTitleKey {
  AdditionalInfo = 'ADDITIONAL_INFO',
  Condition = 'CONDITION',
  Price = 'PRICE',
  ProductName = 'PRODUCT_NAME'
}

export enum ECustomDealFormQuestionType {
  Boolean = 'Boolean',
  FileUpload = 'FileUpload',
  NumberDefault = 'NumberDefault',
  NumberOptions = 'NumberOptions',
  TextDefault = 'TextDefault',
  TextMultiline = 'TextMultiline',
  TextOptions = 'TextOptions'
}

export enum ECustomDealItemCondition {
  Good = 'GOOD',
  LikeNew = 'LIKE_NEW',
  New = 'NEW',
  Used = 'USED'
}

export enum ECustomDealStatusType {
  Accepted = 'ACCEPTED',
  Canceled = 'CANCELED',
  Closed = 'CLOSED',
  Counteroffer = 'COUNTEROFFER',
  Created = 'CREATED',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  InProgress = 'IN_PROGRESS',
  Reviewing = 'REVIEWING'
}

export enum ECustomItemFoundComparableOffers {
  LessThanTen = 'LESS_THAN_TEN',
  MoreThanTen = 'MORE_THAN_TEN',
  NoOffersFound = 'NO_OFFERS_FOUND',
  OneOrTwo = 'ONE_OR_TWO'
}

export enum ECustomRequestCondition {
  Good = 'GOOD',
  LikeNew = 'LIKE_NEW',
  New = 'NEW',
  Used = 'USED'
}

export enum ECustomRequestEvent {
  Accepted = 'ACCEPTED',
  Counteroffer = 'COUNTEROFFER',
  Declined = 'DECLINED',
  Deleted = 'DELETED',
  Requested = 'REQUESTED'
}

export enum ECustomerCategory {
  A = 'A',
  B = 'B',
  C = 'C'
}

export enum ECustomerIdentityType {
  DrivingLicense = 'DRIVING_LICENSE',
  IdentityCard = 'IDENTITY_CARD',
  Passport = 'PASSPORT'
}

export enum EDateFilterConditions {
  Equals = 'EQUALS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  LessThan = 'LESS_THAN',
  LessThanOrEqual = 'LESS_THAN_OR_EQUAL',
  NotEquals = 'NOT_EQUALS'
}

export enum EDateFilterMode {
  Current = 'CURRENT',
  Was = 'WAS'
}

export enum EDealChainType {
  Buyback = 'BUYBACK',
  Extension = 'EXTENSION',
  None = 'NONE'
}

export enum EDealItemCondition {
  Good = 'GOOD',
  LikeNew = 'LIKE_NEW',
  New = 'NEW',
  Used = 'USED'
}

export enum EDealPartnerType {
  Knp = 'KNP'
}

export enum EDealStatusType {
  Booked = 'BOOKED',
  Canceled = 'CANCELED',
  Closed = 'CLOSED',
  Collected = 'COLLECTED',
  CustomerInCredit = 'CUSTOMER_IN_CREDIT',
  CustomerInDebt = 'CUSTOMER_IN_DEBT',
  Declined = 'DECLINED',
  Derecognized = 'DERECOGNIZED',
  ExcessAmountPayed = 'EXCESS_AMOUNT_PAYED',
  ExtensionConfirmed = 'EXTENSION_CONFIRMED',
  ItemReceivedIdMissing = 'ITEM_RECEIVED_ID_MISSING',
  LoanDue = 'LOAN_DUE',
  LoanDueNotified = 'LOAN_DUE_NOTIFIED',
  OnSell = 'ON_SELL',
  PaybackConfirmed = 'PAYBACK_CONFIRMED',
  PayedAndStored = 'PAYED_AND_STORED',
  PayedShipmentPending = 'PAYED_SHIPMENT_PENDING',
  PickedUp = 'PICKED_UP',
  PickupUnsuccessful = 'PICKUP_UNSUCCESSFUL',
  Reviewing = 'REVIEWING',
  SoldExtern = 'SOLD_EXTERN',
  SoldIntern = 'SOLD_INTERN',
  Verified = 'VERIFIED'
}

export enum EDealType {
  Pawn = 'PAWN',
  Purchase = 'PURCHASE'
}

export enum EEuroDenomination {
  Euro_1 = 'EURO_1',
  Euro_2 = 'EURO_2',
  Euro_5 = 'EURO_5',
  Euro_10 = 'EURO_10',
  Euro_20 = 'EURO_20',
  Euro_50 = 'EURO_50',
  Euro_100 = 'EURO_100',
  Euro_200 = 'EURO_200',
  Euro_500 = 'EURO_500',
  EuroCent_1 = 'EURO_CENT_1',
  EuroCent_2 = 'EURO_CENT_2',
  EuroCent_5 = 'EURO_CENT_5',
  EuroCent_10 = 'EURO_CENT_10',
  EuroCent_20 = 'EURO_CENT_20',
  EuroCent_50 = 'EURO_CENT_50'
}

export enum EExportStatusType {
  Cancelled = 'CANCELLED',
  Error = 'ERROR',
  Finished = 'FINISHED',
  InProgress = 'IN_PROGRESS',
  Scheduled = 'SCHEDULED'
}

export enum EFeeIntervalType {
  Fixed = 'FIXED',
  Percentage = 'PERCENTAGE'
}

export enum EFeeLevel {
  Deal = 'DEAL',
  Item = 'ITEM',
  Valorization = 'VALORIZATION'
}

export enum EFeeMode {
  Constant = 'CONSTANT',
  Custome = 'CUSTOME',
  MultiplierPayout = 'MULTIPLIER_PAYOUT',
  TaxRate = 'TAX_RATE'
}

export enum EFeeType {
  CashExpenditures = 'CASH_EXPENDITURES',
  Cleaning = 'CLEANING',
  Discount = 'DISCOUNT',
  DiscountFirstMonth = 'DISCOUNT_FIRST_MONTH',
  DropoffTransport = 'DROPOFF_TRANSPORT',
  Initial = 'INITIAL',
  InitialStaggered = 'INITIAL_STAGGERED',
  Interest = 'INTEREST',
  LiquidationFee = 'LIQUIDATION_FEE',
  Manipulation = 'MANIPULATION',
  Other = 'OTHER',
  PickupTransport = 'PICKUP_TRANSPORT',
  Storage = 'STORAGE',
  ThirdPartyCosts = 'THIRD_PARTY_COSTS',
  Verification = 'VERIFICATION',
  Withdrawal = 'WITHDRAWAL'
}

export enum EIdFilterConditions {
  Equals = 'EQUALS',
  NotEquals = 'NOT_EQUALS'
}

export enum EItemCategorySearchIcon {
  Car = 'CAR',
  Pawn = 'PAWN',
  Purchase = 'PURCHASE'
}

export enum EItemDerecognizedReason {
  Damage = 'DAMAGE',
  Fraud = 'FRAUD',
  Valuation = 'VALUATION'
}

export enum EItemManualTestAssessment {
  Audio = 'AUDIO',
  Camera = 'CAMERA',
  Touchscreen = 'TOUCHSCREEN',
  Video = 'VIDEO'
}

export enum EItemNotSellablePermanentlyReason {
  DamageCase = 'DAMAGE_CASE',
  ItemLost = 'ITEM_LOST',
  PersonalUse = 'PERSONAL_USE'
}

export enum EItemNotSellableTemporaryReason {
  Repairing = 'REPAIRING',
  Seasonal = 'SEASONAL'
}

export enum EItemNotSellableType {
  Permanently = 'PERMANENTLY',
  Temporary = 'TEMPORARY'
}

export enum EItemNotification {
  TemporaryNotSellableRepairingDue = 'TEMPORARY_NOT_SELLABLE_REPAIRING_DUE',
  TemporaryNotSellableSeasonalDue = 'TEMPORARY_NOT_SELLABLE_SEASONAL_DUE'
}

export enum EItemReturnType {
  ReturnedInShop = 'RETURNED_IN_SHOP',
  ReturnedViaShipment = 'RETURNED_VIA_SHIPMENT'
}

export enum EItemSituation {
  InconsistentData = 'INCONSISTENT_DATA',
  ItemInStore = 'ITEM_IN_STORE',
  ItemNotInStore = 'ITEM_NOT_IN_STORE'
}

export enum EItemStatusType {
  Auctioned = 'AUCTIONED',
  CarCollected = 'CAR_COLLECTED',
  CarSold = 'CAR_SOLD',
  CollectCar = 'COLLECT_CAR',
  Derecognized = 'DERECOGNIZED',
  InLiquidation = 'IN_LIQUIDATION',
  NotRelevant = 'NOT_RELEVANT',
  NotSellable = 'NOT_SELLABLE',
  OfferedKg = 'OFFERED_KG',
  OfferedToSell = 'OFFERED_TO_SELL',
  PaidAndCollected = 'PAID_AND_COLLECTED',
  PaidAndShipped = 'PAID_AND_SHIPPED',
  Pawned = 'PAWNED',
  PrivateSale = 'PRIVATE_SALE',
  ReadyToSell = 'READY_TO_SELL',
  Returned = 'RETURNED',
  ReturnArrived = 'RETURN_ARRIVED',
  ReturnRequested = 'RETURN_REQUESTED',
  Securing = 'SECURING',
  ShipBetweenShops = 'SHIP_BETWEEN_SHOPS',
  Sold = 'SOLD',
  VoluntarySelfDelivery = 'VOLUNTARY_SELF_DELIVERY'
}

export enum EksvRequestType {
  AddAsset = 'ADD_ASSET',
  ChangeAsset = 'CHANGE_ASSET',
  FindAssets = 'FIND_ASSETS',
  RemoveAsset = 'REMOVE_ASSET'
}

export enum ELanguageCode {
  De = 'de',
  En = 'en',
  Ro = 'ro',
  Sr = 'sr',
  Tr = 'tr'
}

export enum ELogisticsPartnerType {
  Cashy = 'CASHY',
  Logsta = 'LOGSTA'
}

export enum EManualPaymentType {
  Bank = 'BANK',
  Card = 'CARD',
  Cash = 'CASH',
  CashOnDelivery = 'CASH_ON_DELIVERY',
  Dummy = 'DUMMY',
  Paypal = 'PAYPAL'
}

export enum EMaximumPawnDuration {
  Inherited = 'INHERITED',
  In_30Days = 'IN_30_DAYS',
  In_60Days = 'IN_60_DAYS',
  In_90Days = 'IN_90_DAYS'
}

export enum EMergingCustomerReason {
  Duplicated = 'DUPLICATED',
  Request = 'REQUEST'
}

export enum ENumberFilterConditions {
  Equals = 'EQUALS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  LessThan = 'LESS_THAN',
  LessThanOrEqual = 'LESS_THAN_OR_EQUAL',
  NotEquals = 'NOT_EQUALS'
}

export enum EOrderBy {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum EPrivateSaleCreationType {
  Auto = 'AUTO',
  Manual = 'MANUAL'
}

export enum EProductImageMode {
  ImagePerVariant = 'IMAGE_PER_VARIANT',
  OneImageForAllProducts = 'ONE_IMAGE_FOR_ALL_PRODUCTS'
}

export enum EProductMaterial {
  Gold = 'GOLD',
  Platin = 'PLATIN',
  Silver = 'SILVER'
}

export enum EProductPriceAdjustmentType {
  AbsoluteMarkup = 'ABSOLUTE_MARKUP',
  FixedPrice = 'FIXED_PRICE',
  PercentageMarkup = 'PERCENTAGE_MARKUP'
}

export enum EProductPriceMode {
  Crawled = 'CRAWLED',
  ManualPreciousMetal = 'MANUAL_PRECIOUS_METAL',
  ManualProperty = 'MANUAL_PROPERTY',
  ManualVariant = 'MANUAL_VARIANT'
}

export enum EProductPropertyType {
  Boolean = 'BOOLEAN',
  Number = 'NUMBER',
  Translation = 'TRANSLATION'
}

export enum EQuestionConditionValue {
  Excellent = 'excellent',
  Good = 'good',
  Poor = 'poor'
}

export enum EQuestionPredictionTag {
  Alloy = 'alloy',
  Condition = 'condition',
  Weight = 'weight'
}

export enum EQuestionType {
  Range = 'RANGE',
  SingleChoice = 'SINGLE_CHOICE'
}

export enum EQuestionValueMode {
  Constant = 'CONSTANT',
  Percentage = 'PERCENTAGE',
  UnitPriceMultiplier = 'UNIT_PRICE_MULTIPLIER'
}

export enum ERefurbedBuyBoxState {
  Eligible = 'ELIGIBLE',
  Ineligible = 'INELIGIBLE',
  ShouldWin = 'SHOULD_WIN',
  Won = 'WON',
  WonElsewhere = 'WON_ELSEWHERE'
}

export enum ERefurbedProductsImportStatus {
  Completed = 'COMPLETED',
  Running = 'RUNNING'
}

export enum ERefurbedTaxation {
  Gross = 'GROSS',
  Marginal = 'MARGINAL'
}

export enum ERegionCode {
  At = 'AT',
  De = 'DE'
}

export enum ERemindUploadIdType {
  InvalidId = 'INVALID_ID',
  MissingId = 'MISSING_ID'
}

export enum EReturnReasons {
  AccountLock = 'ACCOUNT_LOCK',
  Cancelled = 'CANCELLED',
  Fake = 'FAKE',
  OpticalError = 'OPTICAL_ERROR',
  Other = 'OTHER',
  ReturnForNoReason = 'RETURN_FOR_NO_REASON',
  TechnicalError = 'TECHNICAL_ERROR',
  WrongProduct = 'WRONG_PRODUCT'
}

export enum ERoles {
  Admin = 'ADMIN',
  Customer = 'CUSTOMER',
  Guest = 'GUEST',
  Locationadmin = 'LOCATIONADMIN',
  Locationstaff = 'LOCATIONSTAFF',
  Superadmin = 'SUPERADMIN'
}

export enum ESalesPartnerType {
  Baggyluxe = 'BAGGYLUXE',
  BlitzMobile = 'BLITZ_MOBILE',
  Cashy = 'CASHY',
  Chrono24 = 'CHRONO24',
  Ebay = 'EBAY',
  EbayKleinanzeigen = 'EBAY_KLEINANZEIGEN',
  Others = 'OTHERS',
  Rebelle = 'REBELLE',
  Refurbed = 'REFURBED',
  VestiaireCollective = 'VESTIAIRE_COLLECTIVE',
  Willhaben = 'WILLHABEN'
}

export enum ESex {
  Diverse = 'DIVERSE',
  Female = 'FEMALE',
  Male = 'MALE'
}

export enum EShippingLabelDirection {
  Receive = 'RECEIVE',
  Send = 'SEND'
}

export enum EShippingLabelEntity {
  Deal = 'DEAL',
  Item = 'ITEM'
}

export enum EShippingLabelFileSource {
  Generate = 'GENERATE',
  History = 'HISTORY',
  Upload = 'UPLOAD'
}

export enum EStandardShipmentType {
  Cashy = 'CASHY',
  Dhl = 'DHL',
  DpdStandard = 'DPD_STANDARD',
  Post = 'POST'
}

export enum EStatusFilterType {
  Contain = 'CONTAIN',
  Latest = 'LATEST'
}

export enum EStorageStatus {
  AddedToStorage = 'ADDED_TO_STORAGE',
  RemovedFromStorage = 'REMOVED_FROM_STORAGE'
}

export enum EStrapiContentCountry {
  All = 'ALL',
  At = 'AT',
  De = 'DE'
}

export enum EStringFilterConditions {
  Contains = 'CONTAINS',
  EndsWith = 'ENDS_WITH',
  Equals = 'EQUALS',
  NotContains = 'NOT_CONTAINS',
  NotEquals = 'NOT_EQUALS',
  StartsWith = 'STARTS_WITH'
}

export enum ETransactionType {
  CashExpenditures = 'CASH_EXPENDITURES',
  CustomerPaymentAfterSale = 'CUSTOMER_PAYMENT_AFTER_SALE',
  Derecognization = 'DERECOGNIZATION',
  LiquidationFee = 'LIQUIDATION_FEE',
  OtherFees = 'OTHER_FEES',
  PaybackFees = 'PAYBACK_FEES',
  Payout = 'PAYOUT',
  PayoutExcessAmount = 'PAYOUT_EXCESS_AMOUNT',
  SellingCar = 'SELLING_CAR',
  ThirdPartyCosts = 'THIRD_PARTY_COSTS'
}

export enum ETransportMode {
  Auction = 'AUCTION',
  Courier = 'COURIER',
  Extension = 'EXTENSION',
  ExtensionAuction = 'EXTENSION_AUCTION',
  PremiumShipment = 'PREMIUM_SHIPMENT',
  PrivateSale = 'PRIVATE_SALE',
  Shop = 'SHOP',
  StandardShipment = 'STANDARD_SHIPMENT',
  Storebox = 'STOREBOX'
}

export enum ETransportType {
  Dropoff = 'DROPOFF',
  Pickup = 'PICKUP'
}

export enum EUnzerFailedPaymentErrorCode {
  MaxLimitExceeded = 'MAX_LIMIT_EXCEEDED',
  Unknown = 'UNKNOWN'
}

export enum EUsedGrade {
  Grade_01 = 'GRADE_01',
  Grade_02 = 'GRADE_02',
  Grade_03 = 'GRADE_03'
}

export enum EVisibleOnDomain {
  All = 'ALL',
  At = 'AT',
  De = 'DE',
  None = 'NONE'
}

export type Employee = {
  __typename?: 'Employee';
  _id: Scalars['ObjectId']['output'];
  company: Company;
  companyId: Scalars['ObjectId']['output'];
  createdAt: Scalars['DateTime']['output'];
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  employeeNumber: Scalars['Int']['output'];
  firstname: Scalars['String']['output'];
  isDeactivated?: Maybe<Scalars['Boolean']['output']>;
  isNotePopup?: Maybe<Scalars['Boolean']['output']>;
  lastname: Scalars['String']['output'];
  locations?: Maybe<Array<Shop>>;
  note?: Maybe<Scalars['String']['output']>;
  payoutConfigurations?: Maybe<OPayoutConfiguration>;
  phone: Scalars['String']['output'];
  preferences?: Maybe<EmployeePreferences>;
  roles: Array<ERoles>;
  scheduledDeactivationAt?: Maybe<Scalars['DateTime']['output']>;
  sex?: Maybe<ESex>;
  shopIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
  token?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userPermission?: Maybe<UserPermission>;
  userPermissionId: Scalars['ObjectId']['output'];
};

export type EmployeeActivationArgs = {
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

export type EmployeeFilterArgs = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  companyId?: InputMaybe<IdFilter>;
  defaultShopId?: InputMaybe<IdFilter>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  isDeactivated?: InputMaybe<BooleanFilter>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<ERoles>;
};

export type EmployeeOpts = {
  filter?: InputMaybe<EmployeeFilterArgs>;
  order?: InputMaybe<EmployeeOrderArgs>;
};

export type EmployeeOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  firstname?: InputMaybe<EOrderBy>;
  lastname?: InputMaybe<EOrderBy>;
};

export type EmployeePreferences = {
  __typename?: 'EmployeePreferences';
  defaultShopId?: Maybe<Scalars['ObjectId']['output']>;
};

export type EmployeePreferencesInput = {
  defaultShopId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type ExportEntriesWithPagination = {
  __typename?: 'ExportEntriesWithPagination';
  records: Array<ExportEntry>;
  totalCount: Scalars['Float']['output'];
  totalPages: Scalars['Float']['output'];
};

export type ExportEntry = {
  __typename?: 'ExportEntry';
  _id: Scalars['ObjectId']['output'];
  createdAt: Scalars['DateTime']['output'];
  employeeId?: Maybe<Scalars['ObjectId']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  exportStatus: EExportStatusType;
  fileUrl: Scalars['String']['output'];
  items: Array<ExportEntryItem>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ExportEntryItem = {
  __typename?: 'ExportEntryItem';
  currentChunkInProgress: Scalars['Float']['output'];
  status: EExportStatusType;
  viewName: Scalars['String']['output'];
};

export type ExportEntryOpts = {
  order?: InputMaybe<ExportEntryOrderArgs>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ExportEntryOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  createdAt?: InputMaybe<EOrderBy>;
};

export type ExportHistoryFilter = {
  __typename?: 'ExportHistoryFilter';
  companyId?: Maybe<Scalars['ObjectId']['output']>;
  date?: Maybe<DateFilterType>;
  dealEventFilter?: Maybe<DealEventFilterType>;
  exportName?: Maybe<Scalars['String']['output']>;
  includeTestUsers?: Maybe<Scalars['Boolean']['output']>;
  shopId?: Maybe<Scalars['ObjectId']['output']>;
};

export type ExtensionChain = {
  __typename?: 'ExtensionChain';
  extensionBookingNumbers: Array<Scalars['Float']['output']>;
  extensionDealIds: Array<Scalars['ObjectId']['output']>;
};

export type FailedPayment = {
  __typename?: 'FailedPayment';
  errors: Array<FailedPaymentError>;
  id: Scalars['String']['output'];
};

export type FailedPaymentError = {
  __typename?: 'FailedPaymentError';
  code: EUnzerFailedPaymentErrorCode;
  message: Scalars['String']['output'];
};

export type FeeAmountForCategory = {
  __typename?: 'FeeAmountForCategory';
  amount: Scalars['Float']['output'];
  categoryId: Scalars['ObjectId']['output'];
};

export type FeeCreateArgs = {
  amount: Scalars['Float']['input'];
  amountForCategories?: InputMaybe<Array<AmountForCategoryArgs>>;
  billingPeriodType: EBillingPeriodType;
  businessUnit: EBusinessUnit;
  companyId: Scalars['ObjectId']['input'];
  dealTypes: Array<EDealType>;
  feeIntervals?: InputMaybe<Array<FeeIntervalArgs>>;
  feeType: EFeeType;
  includedOnExtensions: Scalars['Boolean']['input'];
  isActive: Scalars['Boolean']['input'];
  itemQuestionTitle?: InputMaybe<Scalars['String']['input']>;
  itemQuestionValidAnswer?: InputMaybe<Scalars['String']['input']>;
  level: EFeeLevel;
  mode: EFeeMode;
  onlyWhenInAuction?: InputMaybe<Scalars['Boolean']['input']>;
  priority: Scalars['Float']['input'];
  restrictToCategories?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  restrictToItemQuestion?: InputMaybe<Scalars['ObjectId']['input']>;
  transportMode?: InputMaybe<ETransportMode>;
  withdrawalFeeIntervals?: InputMaybe<Array<WithdrawalFeeIntervalArgs>>;
};

export type FeeDefinition = {
  __typename?: 'FeeDefinition';
  _id: Scalars['ObjectId']['output'];
  amount: Scalars['Float']['output'];
  amountForCategories?: Maybe<Array<FeeAmountForCategory>>;
  billingPeriodType: EBillingPeriodType;
  businessUnit: EBusinessUnit;
  company?: Maybe<Company>;
  companyId: Scalars['ObjectId']['output'];
  dealTypes: Array<EDealType>;
  feeIntervals?: Maybe<Array<FeeInterval>>;
  feeType: EFeeType;
  includedOnExtensions: Scalars['Boolean']['output'];
  intervalSelectedIndex?: Maybe<Scalars['Float']['output']>;
  isActive: Scalars['Boolean']['output'];
  itemQuestionTitle?: Maybe<Scalars['String']['output']>;
  itemQuestionValidAnswer?: Maybe<Scalars['String']['output']>;
  level: EFeeLevel;
  mode: EFeeMode;
  onlyWhenInAuction?: Maybe<Scalars['Boolean']['output']>;
  priority: Scalars['Float']['output'];
  restrictToCategories?: Maybe<Array<Scalars['ObjectId']['output']>>;
  restrictToItemQuestion?: Maybe<Scalars['ObjectId']['output']>;
  transportMode?: Maybe<ETransportMode>;
  withdrawalFeeIntervals?: Maybe<Array<WithdrawalFeeInterval>>;
};

export type FeeDefinitionEvaluation = {
  __typename?: 'FeeDefinitionEvaluation';
  dailyPawnFeeEvaluation: Array<FeeDefinition>;
  dailyPurchaseFeeEvaluation: Array<FeeDefinition>;
  fullMonthPawnFeeEvaluation: Array<FeeDefinition>;
  fullMonthPurchaseFeeEvaluation: Array<FeeDefinition>;
  halfMonthPawnFeeEvaluation: Array<FeeDefinition>;
  halfMonthPurchaseFeeEvaluation: Array<FeeDefinition>;
  oneTimePawnFeeEvaluation: Array<FeeDefinition>;
  oneTimePurchaseFeeEvaluation: Array<FeeDefinition>;
};

export type FeeEvaluationItemCategory = {
  __typename?: 'FeeEvaluationItemCategory';
  feeDefinitionEvaluations: FeeDefinitionEvaluation;
  itemCategoryId: Scalars['ObjectId']['output'];
};

export type FeeFilterArgs = {
  _id?: InputMaybe<IdFilter>;
  businessUnit?: InputMaybe<StringFilter>;
  companyId?: InputMaybe<IdFilter>;
  dealType?: InputMaybe<StringFilter>;
  ids?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  includedOnExtensions?: InputMaybe<BooleanFilter>;
  isActive?: InputMaybe<BooleanFilter>;
  level?: InputMaybe<StringFilter>;
};

export type FeeInterval = {
  __typename?: 'FeeInterval';
  diffAmount: Scalars['Float']['output'];
  finalGrossAmount: Scalars['Float']['output'];
  finalNetAmount: Scalars['Float']['output'];
  from: Scalars['Float']['output'];
  type: EFeeIntervalType;
};

export type FeeIntervalArgs = {
  diffAmount: Scalars['Float']['input'];
  from: Scalars['Float']['input'];
  type: EFeeIntervalType;
};

export type FeeOpts = {
  filter?: InputMaybe<FeeFilterArgs>;
  order?: InputMaybe<FeeOrderArgs>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type FeeOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  amount?: InputMaybe<EOrderBy>;
  billingPeriodType?: InputMaybe<EOrderBy>;
  feeType?: InputMaybe<EOrderBy>;
  level?: InputMaybe<EOrderBy>;
  mode?: InputMaybe<EOrderBy>;
};

export type FeeUpdateArgs = {
  _id: Scalars['ObjectId']['input'];
  amount: Scalars['Float']['input'];
  amountForCategories?: InputMaybe<Array<AmountForCategoryArgs>>;
  billingPeriodType: EBillingPeriodType;
  businessUnit: EBusinessUnit;
  companyId: Scalars['ObjectId']['input'];
  dealTypes: Array<EDealType>;
  feeIntervals?: InputMaybe<Array<FeeIntervalArgs>>;
  feeType: EFeeType;
  includedOnExtensions: Scalars['Boolean']['input'];
  isActive: Scalars['Boolean']['input'];
  itemQuestionTitle?: InputMaybe<Scalars['String']['input']>;
  itemQuestionValidAnswer?: InputMaybe<Scalars['String']['input']>;
  level: EFeeLevel;
  mode: EFeeMode;
  onlyWhenInAuction?: InputMaybe<Scalars['Boolean']['input']>;
  priority: Scalars['Float']['input'];
  restrictToCategories?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  restrictToItemQuestion?: InputMaybe<Scalars['ObjectId']['input']>;
  transportMode?: InputMaybe<ETransportMode>;
  withdrawalFeeIntervals?: InputMaybe<Array<WithdrawalFeeIntervalArgs>>;
};

export type FileMetadata = {
  __typename?: 'FileMetadata';
  contentType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  url: Scalars['String']['output'];
};

export type FileMetadataArgs = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type FileTusMetadataArgs = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  fileId?: InputMaybe<Scalars['String']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type FileUploadCustomDealFormQuestion = BaseCustomDealFormQuestion & {
  __typename?: 'FileUploadCustomDealFormQuestion';
  _id: Scalars['ObjectId']['output'];
  info: TranslatedString;
  initialFileUploadAnswer?: Maybe<Scalars['String']['output']>;
  label: TranslatedString;
  optional?: Maybe<Scalars['Boolean']['output']>;
  showOnIssuanceCertificate: Scalars['Boolean']['output'];
  showOnSalesBill: Scalars['Boolean']['output'];
  titleKey?: Maybe<ECustomDealFormQuestionTitleKey>;
  type: ECustomDealFormQuestionType;
};

export type FindItemCategoryArgs = {
  name: Scalars['String']['input'];
  parentId?: InputMaybe<IdFilter>;
  visibleOnDomain?: InputMaybe<EVisibleOnDomain>;
};

export type FormAnswer = FormBooleanAnswer | FormFileUploadAnswer | FormMultilineTextAnswer | FormNumberAnswer | FormOptionNumberAnswer | FormOptionTextAnswer | FormTextAnswer;

export type FormAnswerArgs = {
  booleanAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  numberAnswer?: InputMaybe<Scalars['Float']['input']>;
  optionNumberAnswer?: InputMaybe<Scalars['Float']['input']>;
  optionTextAnswer?: InputMaybe<Scalars['String']['input']>;
  question: CustomDealFormQuestionUpdateArgs;
  textAnswer?: InputMaybe<Scalars['String']['input']>;
  textMultilineAnswer?: InputMaybe<Scalars['String']['input']>;
};

export type FormAnswerBase = {
  question: CustomDealFormQuestion;
};

export type FormBooleanAnswer = FormAnswerBase & {
  __typename?: 'FormBooleanAnswer';
  booleanAnswer?: Maybe<Scalars['Boolean']['output']>;
  question: BooleanCustomDealFormQuestion;
};

export type FormFileUploadAnswer = FormAnswerBase & {
  __typename?: 'FormFileUploadAnswer';
  question: FileUploadCustomDealFormQuestion;
};

export type FormMultilineTextAnswer = FormAnswerBase & {
  __typename?: 'FormMultilineTextAnswer';
  question: TextMultilineCustomDealFormQuestion;
  textMultilineAnswer?: Maybe<Scalars['String']['output']>;
};

export type FormNumberAnswer = FormAnswerBase & {
  __typename?: 'FormNumberAnswer';
  numberAnswer?: Maybe<Scalars['Float']['output']>;
  question: NumberDefaultCustomDealFormQuestion;
};

export type FormOptionNumberAnswer = FormAnswerBase & {
  __typename?: 'FormOptionNumberAnswer';
  optionNumberAnswer?: Maybe<Scalars['Float']['output']>;
  question: NumberOptionsCustomDealFormQuestion;
};

export type FormOptionTextAnswer = FormAnswerBase & {
  __typename?: 'FormOptionTextAnswer';
  optionTextAnswer?: Maybe<Scalars['String']['output']>;
  question: TextOptionsCustomDealFormQuestion;
};

export type FormTextAnswer = FormAnswerBase & {
  __typename?: 'FormTextAnswer';
  question: TextDefaultCustomDealFormQuestion;
  textAnswer?: Maybe<Scalars['String']['output']>;
};

export type ForwardPaginationSkipLimitArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type GeneratePowerOfAttorneyArgs = {
  customerId: Scalars['ObjectId']['input'];
  dealId: Scalars['ObjectId']['input'];
  shopId: Scalars['ObjectId']['input'];
};

export type GenerateUserAgreementArgs = {
  customerId: Scalars['ObjectId']['input'];
  dealId: Scalars['ObjectId']['input'];
  note: Scalars['String']['input'];
  shopId: Scalars['ObjectId']['input'];
  uses: Scalars['String']['input'];
};

export type GetExistingDealCalculationArgs = {
  dealType: EDealType;
  dropoffTransportMode: ETransportMode;
  durationInDays: Scalars['Int']['input'];
  /** This should be set to true if the calculation result need to be shown to customer. Currently we decide if the Withdrawal fee should be charged or not if the deal is ON_SELL */
  isForCustomer: Scalars['Boolean']['input'];
  manualFeeDefinitionsArgs: Array<ManualFeeDefinitionArgs>;
  overwrittenPayoutAmount?: InputMaybe<Scalars['Float']['input']>;
  shouldOverwriteManualFees: Scalars['Boolean']['input'];
  shouldOverwritePayoutAmount?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetProductVariantArgs = {
  productVariantId: Scalars['ObjectId']['input'];
};

export type GetProductVariantsArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GuestCustomerData = {
  __typename?: 'GuestCustomerData';
  blacklistInformation?: Maybe<BlacklistInformation>;
  email: Scalars['String']['output'];
  iban?: Maybe<Scalars['String']['output']>;
  paypalAddress?: Maybe<Scalars['String']['output']>;
};

export type GuestCustomerDataArgs = {
  email: Scalars['String']['input'];
};

export type IAddress = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  coordinates?: InputMaybe<ICoordinates>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<ECountry>;
  door?: InputMaybe<Scalars['String']['input']>;
  floor?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  stairway?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type ICoordinates = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

export type ICustomerAddress = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  coordinates?: InputMaybe<ICoordinates>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<ECountry>;
  door?: InputMaybe<Scalars['String']['input']>;
  floor?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  isBillingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveryAddress?: InputMaybe<Scalars['Boolean']['input']>;
  isRegistrationAddress?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  stairway?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type IdFilter = {
  condition?: InputMaybe<EIdFilterConditions>;
  value?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type IDealCalculation = {
  appliedUsedFeeDefinitions: Array<UsedFeeDefinition>;
  date: Scalars['DateTime']['output'];
  dealValuesEntry: DealValuesEntry;
  itemsValuesEntries: Array<ItemValuesEntry>;
  loanToValuesEntryId: Scalars['ObjectId']['output'];
};

export type IDsFilter = {
  condition?: InputMaybe<EIdFilterConditions>;
  value?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type IStoreboxPickupAddress = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  companyName?: InputMaybe<Scalars['String']['input']>;
  coordinates?: InputMaybe<ICoordinates>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryCode: ECountry;
  door?: InputMaybe<Scalars['String']['input']>;
  floor?: InputMaybe<Scalars['String']['input']>;
  houseNumber: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  stairway?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type ImportItemNewInternalPricesArgs = {
  updateItemNewInternalPricesArgs: Array<UpdateItemNewInternalPriceArgs>;
};

export type ImportNewProductsResult = {
  __typename?: 'ImportNewProductsResult';
  addedProductsCount: Scalars['Float']['output'];
  status?: Maybe<ERefurbedProductsImportStatus>;
};

export type ImportProductsArgs = {
  createdProducts: Array<CreateProduct>;
  updatedProducts: Array<UpdateProduct>;
};

export type InternalPriceHistory = {
  __typename?: 'InternalPriceHistory';
  date: Scalars['DateTime']['output'];
  price: Scalars['Float']['output'];
};

export type InternalSaleData = {
  __typename?: 'InternalSaleData';
  buyerData?: Maybe<BuyerData>;
  date?: Maybe<Scalars['DateTime']['output']>;
  isAuctioned?: Maybe<Scalars['Boolean']['output']>;
  isCashyPrice?: Maybe<Scalars['Boolean']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  priceHistories?: Maybe<Array<InternalPriceHistory>>;
  purchasedDirectly?: Maybe<Scalars['Boolean']['output']>;
};

export type InternalSaleDataArgs = {
  buyerData?: InputMaybe<BuyerDataArgs>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  isAuctioned?: InputMaybe<Scalars['Boolean']['input']>;
  isCashyPrice?: InputMaybe<Scalars['Boolean']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  purchasedDirectly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Item = {
  __typename?: 'Item';
  _id: Scalars['ObjectId']['output'];
  _oldItemId?: Maybe<Scalars['String']['output']>;
  advertiserPlatform?: Maybe<ESalesPartnerType>;
  bookingNumbers: Array<Scalars['Float']['output']>;
  categorizedUploadedFiles?: Maybe<Array<CategorizedUploadedFile>>;
  checkedAfterAuction?: Maybe<Scalars['Boolean']['output']>;
  checkedAt?: Maybe<Scalars['DateTime']['output']>;
  checkedBy?: Maybe<Scalars['String']['output']>;
  company: Company;
  companyId: Scalars['ObjectId']['output'];
  createdAt: Scalars['DateTime']['output'];
  customDealId?: Maybe<Scalars['ObjectId']['output']>;
  customRequestId?: Maybe<Scalars['ObjectId']['output']>;
  damageCasePeriods?: Maybe<Array<TimePeriod>>;
  dealsHistory: Array<ItemDealsHistoryEntry>;
  ean?: Maybe<Scalars['String']['output']>;
  entrupyCertificateUrl?: Maybe<Scalars['String']['output']>;
  events?: Maybe<Array<ItemEvent>>;
  formAnswers?: Maybe<Array<FormAnswer>>;
  imei?: Maybe<Scalars['String']['output']>;
  internalSaleData?: Maybe<InternalSaleData>;
  isContinueUsing: Scalars['Boolean']['output'];
  isDamageCase?: Maybe<Scalars['Boolean']['output']>;
  isForPersonalUse?: Maybe<Scalars['Boolean']['output']>;
  isInStore: EItemSituation;
  isInvestmentGold?: Maybe<Scalars['Boolean']['output']>;
  isItemBulky: Scalars['Boolean']['output'];
  isValuable: Scalars['Boolean']['output'];
  itemCategory?: Maybe<ItemCategory>;
  itemInAuctionShop: Scalars['Boolean']['output'];
  itemNotifications: Array<EItemNotification>;
  itemSpecification?: Maybe<Scalars['String']['output']>;
  itemValorizationCalculation?: Maybe<ItemValorizationCalculation>;
  lastBookingNumber?: Maybe<Scalars['String']['output']>;
  manualTest?: Maybe<ItemManualTest>;
  media?: Maybe<Array<FileMetadata>>;
  note?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Array<Note>>;
  personalUsePeriods?: Maybe<Array<TimePeriod>>;
  piceaTest?: Maybe<PiceaTest>;
  piceaUpload?: Maybe<Scalars['Upload']['output']>;
  piceaUploadLink?: Maybe<FileMetadata>;
  policeNumber?: Maybe<Scalars['String']['output']>;
  product?: Maybe<ProductLegacy>;
  productVariant?: Maybe<ProductVariant>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  shippingLabels?: Maybe<Array<ShippingLabel>>;
  status?: Maybe<EItemStatusType>;
  storageFacility?: Maybe<StorageFacility>;
  storageFacilityId?: Maybe<Scalars['ObjectId']['output']>;
  storageHistory?: Maybe<Array<ItemStorageHistoryEntry>>;
  storageLabel?: Maybe<Scalars['String']['output']>;
  unconfirmedPropertyIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
  updatedAt: Scalars['DateTime']['output'];
  uploadedFiles?: Maybe<Array<FileMetadata>>;
  usedGrade?: Maybe<EUsedGrade>;
  valorizationHistoryIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
  variantId?: Maybe<Scalars['ObjectId']['output']>;
  vehicleData?: Maybe<VehicleData>;
};

export type ItemAnswer = {
  __typename?: 'ItemAnswer';
  questionId: Scalars['ObjectId']['output'];
  rangeValue?: Maybe<Scalars['Float']['output']>;
  selectedOptionIndex?: Maybe<Scalars['Float']['output']>;
};

export type ItemAnswerArgs = {
  questionId: Scalars['ObjectId']['input'];
  rangeValue?: InputMaybe<Scalars['Float']['input']>;
  selectedOptionIndex?: InputMaybe<Scalars['Float']['input']>;
};

export type ItemAuctionRevenue = {
  __typename?: 'ItemAuctionRevenue';
  finalPrice: Scalars['Float']['output'];
  itemId: Scalars['ObjectId']['output'];
  storageLabel: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ItemCalculation = {
  __typename?: 'ItemCalculation';
  itemValuesEntry: ItemValuesEntry;
};

export type ItemCategory = {
  __typename?: 'ItemCategory';
  _id: Scalars['ObjectId']['output'];
  algoliaCategorySlug?: Maybe<Scalars['String']['output']>;
  availableTransportModes: Array<ETransportMode>;
  categoryPageIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
  categoryPages?: Maybe<Array<CategoryPage>>;
  createdAt: Scalars['DateTime']['output'];
  expectedTurnOverTime?: Maybe<Scalars['Float']['output']>;
  helpLink?: Maybe<Scalars['String']['output']>;
  idealoId?: Maybe<Scalars['String']['output']>;
  isValuable?: Maybe<Scalars['Boolean']['output']>;
  maximumPawnDuration: EMaximumPawnDuration;
  minimumItemValue?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  parent?: Maybe<ItemCategory>;
  parentCategories: Array<ItemCategory>;
  parentId?: Maybe<Scalars['ObjectId']['output']>;
  recursiveMinimumItemValue?: Maybe<Scalars['Float']['output']>;
  slug: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  visibleOnDomain: EVisibleOnDomain;
  warningPossiblyStolenItems?: Maybe<Scalars['Boolean']['output']>;
};

export type ItemCategoryFilterArgs = {
  _id?: InputMaybe<IdFilter>;
  algoliaCategorySlug?: InputMaybe<StringFilter>;
  categoryPageIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  ids?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  includeHided?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<StringFilter>;
  parentId?: InputMaybe<IdFilter>;
  slug?: InputMaybe<StringFilter>;
  visibleOnDomain?: InputMaybe<EVisibleOnDomain>;
};

export type ItemCategoryFiltersArgs = {
  createdBefore: Scalars['DateTime']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ItemCategoryIdealoIdMapArgs = {
  idealoId?: InputMaybe<Scalars['String']['input']>;
  itemCategoryId: Scalars['ObjectId']['input'];
};

export type ItemCategoryOpts = {
  filter?: InputMaybe<ItemCategoryFilterArgs>;
  order?: InputMaybe<ItemCategoryOrderArgs>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ItemCategoryOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  name?: InputMaybe<EOrderBy>;
};

export type ItemCategorySearchResult = {
  __typename?: 'ItemCategorySearchResult';
  fullSlug: Scalars['String']['output'];
  icon: EItemCategorySearchIcon;
  matchedKeyword?: Maybe<Scalars['String']['output']>;
  text: TranslatedString;
};

export type ItemDealsHistoryEntry = {
  __typename?: 'ItemDealsHistoryEntry';
  algoliaReference?: Maybe<Scalars['String']['output']>;
  answers?: Maybe<Array<ItemAnswer>>;
  deal: Deal;
  dealId: Scalars['ObjectId']['output'];
  itemCategory?: Maybe<ItemCategory>;
  itemCategoryId: Scalars['ObjectId']['output'];
  loanToValuesEntryId: Scalars['ObjectId']['output'];
  material?: Maybe<Scalars['String']['output']>;
  parentCategoryIds: Array<Scalars['ObjectId']['output']>;
  questionIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
  questions?: Maybe<Array<ItemQuestion>>;
  title: Scalars['String']['output'];
  unconfirmedPropertyIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
  values: ItemValues;
  variantId?: Maybe<Scalars['ObjectId']['output']>;
};

export type ItemEvent = {
  __typename?: 'ItemEvent';
  createdAt: Scalars['DateTime']['output'];
  event: EItemStatusType;
  meta?: Maybe<ItemEventMeta>;
  timestamp: Scalars['DateTime']['output'];
};

export type ItemEventCreateArgs = {
  createdAt: Scalars['DateTime']['input'];
  event: EItemStatusType;
  meta?: InputMaybe<ItemEventMetaArgs>;
  timestamp: Scalars['DateTime']['input'];
};

export type ItemEventMeta = {
  __typename?: 'ItemEventMeta';
  advertisementLink?: Maybe<Array<Scalars['String']['output']>>;
  advertiserPlatformName?: Maybe<Array<Scalars['String']['output']>>;
  cashyEmployee?: Maybe<Employee>;
  cashyEmployeeId?: Maybe<Scalars['ObjectId']['output']>;
  creatorId?: Maybe<Scalars['ObjectId']['output']>;
  derecognizedReason?: Maybe<EItemDerecognizedReason>;
  description?: Maybe<Scalars['String']['output']>;
  destinationShopId?: Maybe<Scalars['ObjectId']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  isPrerequisites?: Maybe<Scalars['Boolean']['output']>;
  logisticPartnerLabelFile?: Maybe<Scalars['Upload']['output']>;
  logisticPartnerLabelFileLink?: Maybe<FileMetadata>;
  logisticPartnerName?: Maybe<Scalars['String']['output']>;
  logisticPartnerTrackingCode?: Maybe<Scalars['String']['output']>;
  logisticPartnerTrackingLink?: Maybe<Scalars['String']['output']>;
  metaHistories?: Maybe<Array<ItemEventMeta>>;
  notSellableType?: Maybe<EItemNotSellableType>;
  notificationEvents?: Maybe<ItemMetaNotificationEvents>;
  offeredPrice?: Maybe<Scalars['Float']['output']>;
  offeredPriceAt?: Maybe<Scalars['DateTime']['output']>;
  opticalCondition?: Maybe<Scalars['String']['output']>;
  permanentlyNotSellableReason?: Maybe<EItemNotSellablePermanentlyReason>;
  refurbedOffer?: Maybe<RefurbedOffer>;
  returnType?: Maybe<EItemReturnType>;
  salesPartnerId?: Maybe<Scalars['String']['output']>;
  salesPartnerName?: Maybe<Scalars['String']['output']>;
  salesPartnerTrackingLink?: Maybe<Scalars['String']['output']>;
  sendNotification?: Maybe<Scalars['Boolean']['output']>;
  statusReason?: Maybe<Scalars['String']['output']>;
  temporaryNotSellableReason?: Maybe<EItemNotSellableTemporaryReason>;
  validFrom?: Maybe<Scalars['DateTime']['output']>;
  validUntil?: Maybe<Scalars['DateTime']['output']>;
  valorizationEntryId?: Maybe<Scalars['ObjectId']['output']>;
  voluntarySelfDelivery?: Maybe<VoluntarySelfDeliveryMetadata>;
};

export type ItemEventMetaArgs = {
  advertisementLink?: InputMaybe<Array<Scalars['String']['input']>>;
  advertiserPlatformName?: InputMaybe<Array<Scalars['String']['input']>>;
  cashyEmployeeId?: InputMaybe<Scalars['ObjectId']['input']>;
  creatorId?: InputMaybe<Scalars['ObjectId']['input']>;
  derecognizedReason?: InputMaybe<EItemDerecognizedReason>;
  description?: InputMaybe<Scalars['String']['input']>;
  destinationShopId?: InputMaybe<Scalars['ObjectId']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  isPrerequisites?: InputMaybe<Scalars['Boolean']['input']>;
  logisticPartnerLabelFile?: InputMaybe<FileTusMetadataArgs>;
  logisticPartnerName?: InputMaybe<Scalars['String']['input']>;
  logisticPartnerTrackingCode?: InputMaybe<Scalars['String']['input']>;
  logisticPartnerTrackingLink?: InputMaybe<Scalars['String']['input']>;
  notSellableType?: InputMaybe<EItemNotSellableType>;
  offeredPrice?: InputMaybe<Scalars['Float']['input']>;
  offeredPriceAt?: InputMaybe<Scalars['DateTime']['input']>;
  permanentlyNotSellableReason?: InputMaybe<EItemNotSellablePermanentlyReason>;
  refurbedOffer?: InputMaybe<RefurbedOfferArgs>;
  returnType?: InputMaybe<EItemReturnType>;
  salesPartnerId?: InputMaybe<Scalars['String']['input']>;
  salesPartnerName?: InputMaybe<Scalars['String']['input']>;
  salesPartnerTrackingLink?: InputMaybe<Scalars['String']['input']>;
  sendNotification?: InputMaybe<Scalars['Boolean']['input']>;
  statusReason?: InputMaybe<Scalars['String']['input']>;
  temporaryNotSellableReason?: InputMaybe<EItemNotSellableTemporaryReason>;
  validFrom?: InputMaybe<Scalars['DateTime']['input']>;
  validUntil?: InputMaybe<Scalars['DateTime']['input']>;
  valorizationEntryId?: InputMaybe<Scalars['ObjectId']['input']>;
  voluntarySelfDelivery?: InputMaybe<ItemVoluntarySelfDeliveryArgs>;
};

export type ItemEventUpdateArgs = {
  event: EItemStatusType;
  meta?: InputMaybe<ItemEventMetaArgs>;
};

export type ItemExtensionAnswers = {
  __typename?: 'ItemExtensionAnswers';
  answers: Array<ItemAnswer>;
  storageLabel: Scalars['String']['output'];
};

export type ItemExtensionAnswersArgs = {
  answers: Array<ItemAnswerArgs>;
  storageLabel: Scalars['String']['input'];
};

export type ItemFilterArgs = {
  _id?: InputMaybe<IdFilter>;
  _oldItemId?: InputMaybe<IdFilter>;
  _oldItemIds?: InputMaybe<Array<Scalars['String']['input']>>;
  bookingNumber?: InputMaybe<NumberFilter>;
  bookingNumbers?: InputMaybe<Array<Scalars['Int']['input']>>;
  companyId?: InputMaybe<IdFilter>;
  ids?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  itemStatusFilter?: InputMaybe<ItemStatusFilter>;
  storageFacilityId?: InputMaybe<IdFilter>;
  storageLabel?: InputMaybe<StringFilter>;
  storageLabels?: InputMaybe<Array<Scalars['String']['input']>>;
  storageLvl1?: InputMaybe<IdFilter>;
  storageLvl2?: InputMaybe<IdFilter>;
  storageLvl3?: InputMaybe<IdFilter>;
  storageLvl4?: InputMaybe<IdFilter>;
  storageStatusFilter?: InputMaybe<StorageStatusFilter>;
  title?: InputMaybe<StringFilter>;
};

export type ItemManualTest = {
  __typename?: 'ItemManualTest';
  assessments: Array<ItemManualTestAssessment>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Employee;
};

export type ItemManualTestArgs = {
  assessments: Array<ItemManualTestAssessmentArgs>;
};

export type ItemManualTestAssessment = {
  __typename?: 'ItemManualTestAssessment';
  assessment: EItemManualTestAssessment;
  passed: Scalars['Boolean']['output'];
};

export type ItemManualTestAssessmentArgs = {
  assessment: EItemManualTestAssessment;
  passed: Scalars['Boolean']['input'];
};

export type ItemMetaNotificationEvents = {
  __typename?: 'ItemMetaNotificationEvents';
  overtimeReadyToSell?: Maybe<Scalars['Boolean']['output']>;
  overtimeShipBetweenShops?: Maybe<Scalars['Boolean']['output']>;
};

export type ItemOpts = {
  filter?: InputMaybe<ItemFilterArgs>;
  order?: InputMaybe<ItemOrderArgs>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ItemOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  bookingNumber?: InputMaybe<EOrderBy>;
  updatedAt?: InputMaybe<EOrderBy>;
};

export type ItemPage = {
  __typename?: 'ItemPage';
  _id: Scalars['ObjectId']['output'];
  faqKeyword: Scalars['String']['output'];
  faqsIds: Array<Scalars['ObjectId']['output']>;
  language: Scalars['String']['output'];
  lvl0ContentCategory?: Maybe<Scalars['String']['output']>;
  lvl1ContentCategory?: Maybe<Scalars['String']['output']>;
  lvl2ContentCategory?: Maybe<Scalars['String']['output']>;
  lvl3ContentCategory?: Maybe<Scalars['String']['output']>;
  pageFaqsComponents: Array<ContentComponent>;
  published_at?: Maybe<Scalars['DateTime']['output']>;
};

export type ItemPageContent = {
  __typename?: 'ItemPageContent';
  availableRegions?: Maybe<Array<ERegionCode>>;
  categoryPages: CategoryPages;
  id: Scalars['ID']['output'];
  itemPages: ItemPages;
  itemQuestions: Array<ItemQuestion>;
  product: ProductLegacy;
};


export type ItemPageContentCategoryPagesArgs = {
  includeDrafts: Scalars['Boolean']['input'];
  language: Scalars['String']['input'];
};


export type ItemPageContentItemPagesArgs = {
  includeDrafts: Scalars['Boolean']['input'];
  language: Scalars['String']['input'];
};


export type ItemPageContentItemQuestionsArgs = {
  date: Scalars['DateTime']['input'];
  omitInternalQuestions?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemPageFilterArgs = {
  includeDrafts?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lvl0ContentCategory?: InputMaybe<StringFilter>;
  lvl0ContentCategoryExists?: InputMaybe<Scalars['Boolean']['input']>;
  lvl1ContentCategory?: InputMaybe<StringFilter>;
  lvl1ContentCategoryExists?: InputMaybe<Scalars['Boolean']['input']>;
  lvl2ContentCategory?: InputMaybe<StringFilter>;
  lvl2ContentCategoryExists?: InputMaybe<Scalars['Boolean']['input']>;
  lvl3ContentCategory?: InputMaybe<StringFilter>;
  lvl3ContentCategoryExists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemPageOpts = {
  filter?: InputMaybe<ItemPageFilterArgs>;
  order?: InputMaybe<ItemPageOrderArgs>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ItemPageOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
};

export type ItemPages = {
  __typename?: 'ItemPages';
  lvl0?: Maybe<ItemPage>;
  lvl1?: Maybe<ItemPage>;
  lvl2?: Maybe<ItemPage>;
  lvl3?: Maybe<ItemPage>;
  root?: Maybe<ItemPage>;
};

export type ItemQuestion = {
  __typename?: 'ItemQuestion';
  _id: Scalars['ObjectId']['output'];
  _oldItemQuestionIds?: Maybe<Array<Scalars['String']['output']>>;
  infoKey?: Maybe<Scalars['String']['output']>;
  isDeactivatedForNewProducts?: Maybe<Scalars['Boolean']['output']>;
  isInternal?: Maybe<Scalars['Boolean']['output']>;
  itemCategories?: Maybe<Array<ItemCategory>>;
  itemCategoryIds: Array<Scalars['ObjectId']['output']>;
  order: Scalars['Float']['output'];
  predictionTag?: Maybe<EQuestionPredictionTag>;
  questionType: EQuestionType;
  rangeData?: Maybe<ItemQuestionRangeData>;
  singleChoiceOptions?: Maybe<Array<ItemQuestionOption>>;
  titleKey: Scalars['String']['output'];
  validFrom: Scalars['DateTime']['output'];
  validTo: Scalars['DateTime']['output'];
  valueMode: EQuestionValueMode;
};

export type ItemQuestionFilterArgs = {
  _id?: InputMaybe<IdFilter>;
  ids?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  itemCategoryIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  omitDeactivatedQuestionsForNewProducts?: InputMaybe<Scalars['Boolean']['input']>;
  omitInternalQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  titleKey?: InputMaybe<Scalars['String']['input']>;
  validFrom?: InputMaybe<DateFilter>;
  validTo?: InputMaybe<DateFilter>;
  valueMode?: InputMaybe<EQuestionValueMode>;
};

export type ItemQuestionOption = {
  __typename?: 'ItemQuestionOption';
  categoryValues?: Maybe<Scalars['JSON']['output']>;
  conditionValue?: Maybe<EQuestionConditionValue>;
  infoKey?: Maybe<Scalars['String']['output']>;
  isDefaultValue?: Maybe<Scalars['Boolean']['output']>;
  isInternal?: Maybe<Scalars['Boolean']['output']>;
  labelKey: Scalars['String']['output'];
};

export type ItemQuestionOptionArgs = {
  categoryValues?: InputMaybe<Scalars['JSON']['input']>;
  conditionValue?: InputMaybe<EQuestionConditionValue>;
  infoKey?: InputMaybe<Scalars['String']['input']>;
  isDefaultValue?: InputMaybe<Scalars['Boolean']['input']>;
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  labelKey?: InputMaybe<Scalars['String']['input']>;
};

export type ItemQuestionOpts = {
  filter?: InputMaybe<ItemQuestionFilterArgs>;
  order?: InputMaybe<ItemQuestionOrderArgs>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ItemQuestionOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  order?: InputMaybe<EOrderBy>;
  validFrom?: InputMaybe<EOrderBy>;
  validTo?: InputMaybe<EOrderBy>;
};

export type ItemQuestionRangeData = {
  __typename?: 'ItemQuestionRangeData';
  defaultValue: Scalars['Float']['output'];
  maxValue: Scalars['Float']['output'];
  minValue: Scalars['Float']['output'];
  unitKey: Scalars['String']['output'];
  unitPrice: Scalars['Float']['output'];
};

export type ItemQuestionRangeDataArgs = {
  defaultValue: Scalars['Float']['input'];
  maxValue: Scalars['Float']['input'];
  minValue: Scalars['Float']['input'];
  unitKey: Scalars['String']['input'];
  unitPrice: Scalars['Float']['input'];
};

export type ItemStatusFilter = {
  itemStatus: EItemStatusType;
  statusFilterType: EStatusFilterType;
  when?: InputMaybe<DateFilter>;
};

export type ItemStorageHistoryEntry = {
  __typename?: 'ItemStorageHistoryEntry';
  createdAt: Scalars['DateTime']['output'];
  employeeId: Scalars['ObjectId']['output'];
  note?: Maybe<Scalars['String']['output']>;
  storageStatus: EStorageStatus;
  storageUnits: ItemStorageUnits;
  timestamp: Scalars['DateTime']['output'];
};

export type ItemStorageUnits = {
  __typename?: 'ItemStorageUnits';
  lvl1: Scalars['ObjectId']['output'];
  lvl2?: Maybe<Scalars['ObjectId']['output']>;
  lvl3?: Maybe<Scalars['ObjectId']['output']>;
  lvl4?: Maybe<Scalars['ObjectId']['output']>;
};

export type ItemStorageUnitsArgs = {
  lvl1: Scalars['ObjectId']['input'];
  lvl2?: InputMaybe<Scalars['ObjectId']['input']>;
  lvl3?: InputMaybe<Scalars['ObjectId']['input']>;
  lvl4?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type ItemUpdateArgs = {
  _id: Scalars['ObjectId']['input'];
  checkedAfterAuction?: InputMaybe<Scalars['Boolean']['input']>;
  checkedAt?: InputMaybe<Scalars['DateTime']['input']>;
  checkedBy?: InputMaybe<Scalars['String']['input']>;
  disableCheckPiceaTest?: InputMaybe<Scalars['Boolean']['input']>;
  entrupyCertificateUrl?: InputMaybe<Scalars['String']['input']>;
  formAnswers?: InputMaybe<Array<UpdateFormAnswerArgs>>;
  imei?: InputMaybe<Scalars['String']['input']>;
  isBulkyGood?: InputMaybe<Scalars['Boolean']['input']>;
  isInvestmentGold?: InputMaybe<Scalars['Boolean']['input']>;
  itemSpecification?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  storageFacilityId?: InputMaybe<Scalars['ObjectId']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unconfirmedPropertyIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  usedGrade?: InputMaybe<EUsedGrade>;
  variantId?: InputMaybe<Scalars['ObjectId']['input']>;
  vehicleData?: InputMaybe<UpdateVehicleDataArgs>;
};

export type ItemValorizationCalculation = {
  __typename?: 'ItemValorizationCalculation';
  itemValorizationValues: ItemValorizationValues;
  valorizationHistory: Array<ValorizationHistoryEntry>;
};

export type ItemValorizationValues = {
  __typename?: 'ItemValorizationValues';
  salePrice: Scalars['Float']['output'];
  valorizationDeviation: Scalars['Float']['output'];
  valorizationDifferenceGross: Scalars['Float']['output'];
  valorizationDifferenceNet: Scalars['Float']['output'];
  valorizationDifferenceTax: Scalars['Float']['output'];
};

export type ItemValues = {
  __typename?: 'ItemValues';
  closed?: Maybe<ItemValuesEntry>;
  selected?: Maybe<ItemValuesEntry>;
  verified?: Maybe<ItemValuesEntry>;
};

export type ItemValuesEntry = {
  __typename?: 'ItemValuesEntry';
  adjustedMarketValue: Scalars['Float']['output'];
  conditionMaxMarketValues?: Maybe<ConditionMaxMarketValues>;
  creatorId?: Maybe<Scalars['ObjectId']['output']>;
  currentMarketValue?: Maybe<Scalars['Float']['output']>;
  date: Scalars['DateTime']['output'];
  durationInDays: Scalars['Float']['output'];
  loanToValue: Scalars['Float']['output'];
  maxMarketValue?: Maybe<Scalars['Float']['output']>;
  payoutAmount?: Maybe<Scalars['Float']['output']>;
  predictedMarketValue?: Maybe<Scalars['Float']['output']>;
};

export type ItemVoluntarySelfDeliveryArgs = {
  appointment?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ItemsFilterOpticalCondition = {
  conditionAnswer: EDealItemCondition;
  usedGrade?: InputMaybe<EUsedGrade>;
};

export type ItemsFilterSalePartnerType = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  mode: EDateFilterMode;
  names: Array<ESalesPartnerType>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ItemsFilterStatus = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  mode: EDateFilterMode;
  names: Array<EItemStatusType>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ItemsFiltersArgs = {
  companyId?: InputMaybe<Scalars['ObjectId']['input']>;
  createdBefore?: InputMaybe<Scalars['DateTime']['input']>;
  itemCategoryId?: InputMaybe<Scalars['ObjectId']['input']>;
  opticalCondition?: InputMaybe<ItemsFilterOpticalCondition>;
  paginationArgs: ForwardPaginationSkipLimitArgs;
  salePartnerType?: InputMaybe<ItemsFilterSalePartnerType>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ItemsFilterStatus>;
  storageFacilityId?: InputMaybe<Scalars['ObjectId']['input']>;
  storageUnitIdLv0?: InputMaybe<Scalars['ObjectId']['input']>;
  storageUnitIdLv1?: InputMaybe<Scalars['ObjectId']['input']>;
  storageUnitIdLv2?: InputMaybe<Scalars['ObjectId']['input']>;
  storageUnitIdLv3?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type KsvAssetRecord = {
  __typename?: 'KSVAssetRecord';
  owner?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
};

export type KsvQueryHistory = {
  __typename?: 'KSVQueryHistory';
  meta?: Maybe<Scalars['JSON']['output']>;
  queryAt: Scalars['DateTime']['output'];
  type: EksvRequestType;
  vin: Scalars['String']['output'];
};

export type KnpDebt = {
  __typename?: 'KnpDebt';
  amount: Scalars['Float']['output'];
};

export type KnpOpts = {
  filenumber: Scalars['String']['input'];
};

export type LoanToValueFilterArgs = {
  _id?: InputMaybe<IdFilter>;
  companyId?: InputMaybe<IdFilter>;
  ids?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  validFrom?: InputMaybe<DateFilter>;
  validTo?: InputMaybe<DateFilter>;
};

export type LoanToValueOpts = {
  filter?: InputMaybe<LoanToValueFilterArgs>;
  order?: InputMaybe<LoanToValueOrderArgs>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type LoanToValueOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  validFrom?: InputMaybe<EOrderBy>;
  validTo?: InputMaybe<EOrderBy>;
};

export type LoanToValuesEntry = {
  __typename?: 'LoanToValuesEntry';
  _id: Scalars['ObjectId']['output'];
  categoryValues: Scalars['JSON']['output'];
  company: Company;
  validFrom: Scalars['DateTime']['output'];
};

export type LocationDistance = {
  __typename?: 'LocationDistance';
  distance: Scalars['Float']['output'];
  location: Shop;
};

export type LogisticsPartnerDataArgs = {
  cashy?: InputMaybe<LogisticsPartnerDataCashyArgs>;
  logsta?: InputMaybe<LogisticsPartnerDataLogstaArgs>;
  trackingLink?: InputMaybe<Scalars['String']['input']>;
  type: ELogisticsPartnerType;
};

export type LogisticsPartnerDataCashyArgs = {
  _placeHolder?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LogisticsPartnerDataLogstaArgs = {
  logstaNumber?: InputMaybe<Scalars['String']['input']>;
};

export type MaintenanceWindow = {
  __typename?: 'MaintenanceWindow';
  _id: Scalars['ObjectId']['output'];
  duration: Scalars['Float']['output'];
  scheduledStartTime: Scalars['DateTime']['output'];
};

export type ManualFeeDefinitionArgs = {
  amount: Scalars['Float']['input'];
  billingPeriodType: EBillingPeriodType;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dealType: EDealType;
  description?: InputMaybe<Scalars['String']['input']>;
  feeType: EFeeType;
  isActive: Scalars['Boolean']['input'];
  isManual: Scalars['Boolean']['input'];
  level: EFeeLevel;
  mode: EFeeMode;
  storageLabel?: InputMaybe<Scalars['String']['input']>;
  ust: Scalars['Float']['input'];
};

export type ManualPaymentWrapper = {
  __typename?: 'ManualPaymentWrapper';
  value: EManualPaymentType;
};

export type MaterialMetric = {
  __typename?: 'MaterialMetric';
  alloy: Scalars['Float']['output'];
  weight: Scalars['Float']['output'];
};

export type MaterialMetricArgs = {
  alloy: Scalars['Float']['input'];
  weight: Scalars['Float']['input'];
};

export type MaterialPrice = {
  __typename?: 'MaterialPrice';
  _id: Scalars['ObjectId']['output'];
  date: Scalars['DateTime']['output'];
  material: Scalars['String']['output'];
  mu: Scalars['Float']['output'];
  price: Scalars['Float']['output'];
  sigma: Scalars['Float']['output'];
};

export type MaterialPriceFilterArgs = {
  _id?: InputMaybe<IdFilter>;
  date?: InputMaybe<DateFilter>;
  ids?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  material?: InputMaybe<StringFilter>;
  price?: InputMaybe<NumberFilter>;
};

export type MaterialPriceOpts = {
  filter?: InputMaybe<MaterialPriceFilterArgs>;
  order?: InputMaybe<MaterialPriceOrderArgs>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type MaterialPriceOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  date?: InputMaybe<EOrderBy>;
  material?: InputMaybe<EOrderBy>;
  mu?: InputMaybe<EOrderBy>;
  price?: InputMaybe<EOrderBy>;
  sigma?: InputMaybe<EOrderBy>;
};

export type MemorySize = {
  __typename?: 'MemorySize';
  gb?: Maybe<Array<Scalars['Float']['output']>>;
  mb?: Maybe<Array<Scalars['Float']['output']>>;
  tb?: Maybe<Array<Scalars['Float']['output']>>;
};

export type MenuItem = {
  __typename?: 'MenuItem';
  _id: Scalars['ObjectId']['output'];
  label: Scalars['String']['output'];
  url: Scalars['String']['output'];
  visibleOnDomain: EStrapiContentCountry;
};

export type MenuPanel = {
  __typename?: 'MenuPanel';
  _id: Scalars['ObjectId']['output'];
  allCategoriesLabel: Scalars['String']['output'];
  categories: Array<MenuItem>;
};


export type MenuPanelCategoriesArgs = {
  country?: InputMaybe<EStrapiContentCountry>;
};

export type MergeCustomersInput = {
  mergedCustomerId: Scalars['ObjectId']['input'];
  primaryCustomerId: Scalars['ObjectId']['input'];
  reason: EMergingCustomerReason;
};

export type MergedCustomer = {
  __typename?: 'MergedCustomer';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customDealIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
  customRequestIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
  customerId?: Maybe<Scalars['ObjectId']['output']>;
  dealIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
  reason?: Maybe<EMergingCustomerReason>;
};

export type MergedCustomerArgs = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customDealIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  customRequestIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  customerId?: InputMaybe<Scalars['ObjectId']['input']>;
  dealIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  reason?: InputMaybe<EMergingCustomerReason>;
};

export type MultipleLanguageTextArgs = {
  languageCode: ELanguageCode;
  text: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  activateEmployee: Employee;
  addCompanyId: Employee;
  addCustomDealItem: CustomDealItemDataEntry;
  addCustomDealNote: CustomDeal;
  addDealItem: Deal;
  addDealItemsToStorageUnit: Deal;
  addDealNote: Deal;
  addDealRating: Scalars['Boolean']['output'];
  addItemCategoryId: Shop;
  addItemNote: Item;
  addItemToStorageUnit: Item;
  addKSVAsset: Scalars['Boolean']['output'];
  addSecondaryCustomerToDeal: Deal;
  addStorageFacilityId: Shop;
  addValorizationHistoryEntryToDealItem: Deal;
  callViviVinEndpoint: ViviSequenceResponse;
  cancelCashBookCashFlow: CashBookCashFlowCancel;
  cancelDeal: Deal;
  cancelPaybackExtension: Deal;
  cancelPickupAndUpdateDeal: Deal;
  changeAuctionItemStatus: Auction;
  changeCustomerPasswordFromToken: Customer;
  changeItemStatus: Item;
  changeKSVAsset: Scalars['Boolean']['output'];
  changeMainCustomerOfDeal: Deal;
  closeAuctionById: Auction;
  closeDeal: Deal;
  confirmExtension: Deal;
  confirmPayback: Deal;
  connectCustomerToDeal: Deal;
  convertToDeal: Scalars['Boolean']['output'];
  createAuction: Auction;
  createCarDeal: Deal;
  createCashBookCashFlow: CashBookCashFlow;
  createCashBookCount: CashBookCount;
  createChildUnit: StorageUnit;
  createCompany: Company;
  createCustomDeal: CustomDeal;
  createCustomDealForm: CustomDealForm;
  createCustomerBlacklist: CustomerBlacklist;
  createCustomerCallRequest: Scalars['Boolean']['output'];
  createDeal: Deal;
  createDealForCustomer: Deal;
  createEmployee: Employee;
  createExportEntry: Scalars['Boolean']['output'];
  createFee: Array<FeeDefinition>;
  createItemCategory: ItemCategory;
  createItemQuestion: ItemQuestion;
  createLoanToValuesEntry: LoanToValuesEntry;
  createMaintenanceWindow: MaintenanceWindow;
  createMaterialPrice: MaterialPrice;
  createOrUpdateReady2OrderApiKey: Scalars['Boolean']['output'];
  createPartner: Partner;
  createPrivateSale: PrivateSale;
  createPrivateSaleTransaction: PrivateSale;
  createProduct: Product;
  createProductLegacy: ProductLegacy;
  createProductPropertyDefinition: ProductPropertyDefinition;
  createReceiptWithoutIdentity: Deal;
  createResponseTemplate: ResponseTemplate;
  createShippingLabel: ShippingLabel;
  createShippingLabelByPageId: Deal;
  createShop: Shop;
  createStorageFacility: StorageFacility;
  createStorageUnit: StorageUnit;
  createValorizationEntry: ValorizationEntry;
  deactivateCompany: Company;
  deactivateCustomer: Scalars['Boolean']['output'];
  deactivateEmployee: Scalars['Boolean']['output'];
  deactivatePartner: Partner;
  deactivateStorageFacility: StorageFacility;
  declineDeal: Deal;
  deleteAuction: Auction;
  deleteCustomDeal: CustomDeal;
  deleteCustomDealForm: Scalars['Boolean']['output'];
  deleteCustomer: Scalars['Boolean']['output'];
  deleteCustomerBlacklist: Scalars['Boolean']['output'];
  deleteFee: Array<FeeDefinition>;
  deleteItemCategory: Scalars['String']['output'];
  deleteItemQuestion: Scalars['String']['output'];
  deleteLoanToValuesEntry: Scalars['String']['output'];
  deleteMaterialPrice: Scalars['String']['output'];
  deletePrivateSaleTransaction: PrivateSale;
  deleteResponseTemplate: Scalars['String']['output'];
  deleteStorageUnit: StorageUnit;
  deleteValorizationEntry: Scalars['String']['output'];
  disablePostalCode: Scalars['Boolean']['output'];
  employeeChangePassword: Scalars['Boolean']['output'];
  enablePostalCodes: Array<StoreboxEnabledPostalCode>;
  exchangeDealItem: Deal;
  findKSVAssets: Scalars['Boolean']['output'];
  generateAuctionAnnouncementPdf: Auction;
  generatePowerOfAttorney: Deal;
  generateUserAgreement: Deal;
  importItemNewInternalPrices: Scalars['Boolean']['output'];
  importNewRefurbedProducts: Scalars['Boolean']['output'];
  importProducts: Scalars['Boolean']['output'];
  loginCustomer: Customer;
  loginEmployee: Employee;
  mergeCustomer?: Maybe<Customer>;
  overwriteCustomDealPayoutAmountToCustomerRequested: CustomDeal;
  parsePiceaTest: Item;
  payDealSurplusAmount: Deal;
  payExtensionOnline: OnlinePaymentResult;
  qualifyLead: CustomDeal;
  reevaluateFinalPrivateSaleFinalState: Deal;
  refetchAndUpdateCarMarketValue: Deal;
  refreshAuction: Auction;
  refreshDealInAuction: Deal;
  refreshItem: Item;
  refreshItemValorizations: Deal;
  refreshShippingProfileList: Array<RefurbedShippingProfile>;
  refreshValorizationCalculationForDealItem: Deal;
  regenerateBillForDeal: Deal;
  regeneratePawnTicketForDeal: Deal;
  regenerateReceiptForDeal: Deal;
  regenerateValorizationReceipts: Array<ValorizationEntry>;
  registerCustomer: Customer;
  rejectCustomDealCounteroffer: CustomDeal;
  removeCustomDealItem: Scalars['Boolean']['output'];
  removeDealItem: Deal;
  removeItemCategoryId: Shop;
  removeItemFromStorageUnit: Item;
  removeKSVAsset: Scalars['Boolean']['output'];
  removeLastItemEvent: Item;
  removeSecondaryCustomerToDeal: Deal;
  removeStorageFacilityId: Array<Shop>;
  removeValorizationEntry: Scalars['Boolean']['output'];
  reserveExtension: Deal;
  reservePayback: Deal;
  resetCustomerPasswordMail: Scalars['Boolean']['output'];
  saveReady2OrderProductMaps: Scalars['Boolean']['output'];
  sendReminderEmailForUploadingID?: Maybe<Customer>;
  setAllDealItemsToPurchasedDirectly: Array<Item>;
  setAuctionItemsBuyersAndGenerateSurchargeCertificate: Auction;
  setDealReceivedIdMissing: Deal;
  setDealReviewing: Deal;
  setMainStorageFacilityId: Shop;
  setOnSell: Deal;
  setPayedAndStored: Deal;
  setSoldExtern: Deal;
  startAuction: Auction;
  updateAuction: Auction;
  updateAuctionItem: Auction;
  updateCarInspection: Deal;
  updateCashBookCount: CashBookCount;
  updateCompany: Company;
  updateCurrentEmployeePreferences: Employee;
  updateCustomDeal: CustomDeal;
  updateCustomDealForm: CustomDealForm;
  updateCustomDealItem: CustomDealItemDataEntry;
  updateCustomDealNote: CustomDeal;
  updateCustomer: Customer;
  updateCustomerBlacklist: CustomerBlacklist;
  updateCustomerCategory: Deal;
  updateCustomerPassword: Customer;
  updateDealAuctioningSettings: Deal;
  updateDealItem: DealItem;
  updateDealItemAnswers: Deal;
  updateDealItemAnswersWithoutRecalculation: Deal;
  updateDealItemInternalSaleData: Deal;
  updateDealNote: Deal;
  updateDealOnlineExtensionPrevention: Deal;
  updateDealTransport: Deal;
  updateDealUploadedFiles: Deal;
  updateEmployee: Employee;
  updateEmployeePassword: Employee;
  updateEmployeeProfile: Employee;
  updateFee: Array<FeeDefinition>;
  updateInsuredAmount: Deal;
  updateInternalSaleDataForDirectlyPurchasedItems: Deal;
  updateItem: Item;
  updateItemCategorizedUploadedFiles: Item;
  updateItemCategory: ItemCategory;
  updateItemCategoryId: Item;
  updateItemCategoryIdealoIdMaps: Scalars['Boolean']['output'];
  updateItemEvent: Item;
  updateItemManualTest: Item;
  updateItemMedia: Item;
  updateItemNote: Item;
  updateItemQuestion: ItemQuestion;
  updateItemUploadedFiles: Item;
  updateMaintenanceWindow: Scalars['Boolean']['output'];
  updateMaterialPrice: MaterialPrice;
  updatePartialRedemption: Deal;
  updatePartner: Partner;
  updatePaybackData: Deal;
  updatePayoutData: Deal;
  updatePiceaUploadLink: Item;
  updatePreviewCalculation: Deal;
  updatePrivateSaleTransaction: PrivateSale;
  updateProduct: Product;
  updateProductLegacy: ProductLegacy;
  updateProductPrice: Product;
  updateProductPropertyDefinition: ProductPropertyDefinition;
  updateProductPublication: Product;
  updateResponseTemplate: ResponseTemplate;
  updateSavedValorizationHistoryEntry: Array<ValorizationEntry>;
  updateSecondaryPayoutData: Deal;
  updateShop: Shop;
  updateShopId: Deal;
  updateStorageFacility: StorageFacility;
  updateStorageLabelForCashBookCashFlow: CashBookCashFlow;
  updateStorageUnit: StorageUnit;
  validatePaybackOrExtendDealPersistanceCalculation: Scalars['Boolean']['output'];
  verifyActivationEmployeeToken: VerifiedActivationEmployee;
  verifyDeal: Deal;
};


export type MutationActivateEmployeeArgs = {
  args: EmployeeActivationArgs;
};


export type MutationAddCompanyIdArgs = {
  companyId: Scalars['ObjectId']['input'];
  employeeId: Scalars['ObjectId']['input'];
};


export type MutationAddCustomDealItemArgs = {
  customDealId: Scalars['ObjectId']['input'];
  customDealItemCreateArgs: CustomDealItemCreateArgs;
};


export type MutationAddCustomDealNoteArgs = {
  customDealId: Scalars['ObjectId']['input'];
  noteCreateArgs: NoteCreateArgs;
};


export type MutationAddDealItemArgs = {
  args: DealItemCreateArgs;
  dealId: Scalars['ObjectId']['input'];
};


export type MutationAddDealItemsToStorageUnitArgs = {
  args: AddDealItemsToStorageUnitArgs;
};


export type MutationAddDealNoteArgs = {
  dealId: Scalars['ObjectId']['input'];
  noteCreateArgs: NoteCreateArgs;
};


export type MutationAddDealRatingArgs = {
  dealId: Scalars['ObjectId']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  rating: Scalars['Int']['input'];
};


export type MutationAddItemCategoryIdArgs = {
  itemCategoryId: Scalars['ObjectId']['input'];
  shopId: Scalars['ObjectId']['input'];
};


export type MutationAddItemNoteArgs = {
  itemId: Scalars['ObjectId']['input'];
  noteCreateArgs: NoteCreateArgs;
};


export type MutationAddItemToStorageUnitArgs = {
  itemId: Scalars['ObjectId']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  setDealToPayedAndStored?: InputMaybe<Scalars['Boolean']['input']>;
  storageDate?: InputMaybe<Scalars['DateTime']['input']>;
  storageUnits: ItemStorageUnitsArgs;
};


export type MutationAddKsvAssetArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  itemId: Scalars['ObjectId']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationAddSecondaryCustomerToDealArgs = {
  dealId: Scalars['ObjectId']['input'];
  selectedCustomerId: Scalars['ObjectId']['input'];
};


export type MutationAddStorageFacilityIdArgs = {
  shopId: Scalars['ObjectId']['input'];
  storageFacilityId: Scalars['ObjectId']['input'];
};


export type MutationAddValorizationHistoryEntryToDealItemArgs = {
  args: ValorizationEntryCreateArgs;
  dealId: Scalars['ObjectId']['input'];
  itemId: Scalars['ObjectId']['input'];
  shopId: Scalars['ObjectId']['input'];
};


export type MutationCallViviVinEndpointArgs = {
  args: ViviVinRequestArgs;
};


export type MutationCancelCashBookCashFlowArgs = {
  cashBookCashFlowId: Scalars['ObjectId']['input'];
};


export type MutationCancelDealArgs = {
  dealId: Scalars['ObjectId']['input'];
};


export type MutationCancelPaybackExtensionArgs = {
  dealId: Scalars['ObjectId']['input'];
};


export type MutationCancelPickupAndUpdateDealArgs = {
  dealId: Scalars['ObjectId']['input'];
};


export type MutationChangeAuctionItemStatusArgs = {
  args: AuctionItemArgs;
  newItemStatus: EAuctionItemStatus;
};


export type MutationChangeCustomerPasswordFromTokenArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationChangeItemStatusArgs = {
  addItemToStorageUnitArgs?: InputMaybe<AddItemToStorageUnitArgs>;
  isStatusAddedManually: Scalars['Boolean']['input'];
  itemId: Scalars['ObjectId']['input'];
  newEvent: ItemEventCreateArgs;
  relocateItem?: InputMaybe<Scalars['Boolean']['input']>;
  relocateNote?: InputMaybe<Scalars['String']['input']>;
  shippingLabelCreateArgs?: InputMaybe<ShippingLabelCreateArgs>;
};


export type MutationChangeKsvAssetArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  itemId: Scalars['ObjectId']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationChangeMainCustomerOfDealArgs = {
  dealId: Scalars['ObjectId']['input'];
  selectedCustomerId: Scalars['ObjectId']['input'];
};


export type MutationCloseAuctionByIdArgs = {
  openAuctionId: Scalars['ObjectId']['input'];
};


export type MutationCloseDealArgs = {
  dealId: Scalars['ObjectId']['input'];
  removeItemsFromStorage: Scalars['Boolean']['input'];
};


export type MutationConfirmExtensionArgs = {
  args: ConfirmExtensionArgs;
};


export type MutationConfirmPaybackArgs = {
  args: ConfirmPaybackArgs;
};


export type MutationConnectCustomerToDealArgs = {
  customerId: Scalars['ObjectId']['input'];
  dealId: Scalars['ObjectId']['input'];
};


export type MutationConvertToDealArgs = {
  customDealId: Scalars['ObjectId']['input'];
  customDealUpdateArgs?: InputMaybe<CustomDealUpdateArgs>;
};


export type MutationCreateAuctionArgs = {
  args: AuctionCreateArgs;
  shouldNotifyCustomers: Scalars['Boolean']['input'];
};


export type MutationCreateCarDealArgs = {
  companyId: Scalars['ObjectId']['input'];
  creatorId?: InputMaybe<Scalars['ObjectId']['input']>;
  customDealId?: InputMaybe<Scalars['ObjectId']['input']>;
  dealCalculationId: Scalars['ObjectId']['input'];
  dealItemsCreateArgs: Array<DealItemCreateArgs>;
  dealPartnerData?: InputMaybe<DealPartnerDataArgs>;
  employeeDeclarations?: InputMaybe<Array<Scalars['String']['input']>>;
  guestCustomerDataArgs?: InputMaybe<GuestCustomerDataArgs>;
  iban?: InputMaybe<Scalars['String']['input']>;
  initialShopId?: InputMaybe<Scalars['ObjectId']['input']>;
  payoutType: EManualPaymentType;
  paypalAddress?: InputMaybe<Scalars['String']['input']>;
  pickupData?: InputMaybe<TransportDataArgs>;
  registeredCustomerId?: InputMaybe<Scalars['ObjectId']['input']>;
};


export type MutationCreateCashBookCashFlowArgs = {
  cashBookCashFlowArgs: CashBookCashFlowArgs;
};


export type MutationCreateCashBookCountArgs = {
  cashBookCountArgs: CashBookCountArgs;
};


export type MutationCreateChildUnitArgs = {
  capacity?: InputMaybe<Scalars['Float']['input']>;
  isSecureLocation?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ObjectId']['input']>;
  storageFacilityId?: InputMaybe<Scalars['ObjectId']['input']>;
};


export type MutationCreateCompanyArgs = {
  company: CompanyCreateArgs;
};


export type MutationCreateCustomDealArgs = {
  customDealCreateArgs: CustomDealCreateArgs;
};


export type MutationCreateCustomDealFormArgs = {
  customDealFormCreateArgs: CustomDealFormCreateArgs;
};


export type MutationCreateCustomerBlacklistArgs = {
  args: CustomerBlacklistCreateArgs;
};


export type MutationCreateCustomerCallRequestArgs = {
  args: CustomerCallRequestArgs;
};


export type MutationCreateDealArgs = {
  companyId: Scalars['ObjectId']['input'];
  creatorId?: InputMaybe<Scalars['ObjectId']['input']>;
  customDealId?: InputMaybe<Scalars['ObjectId']['input']>;
  dealCalculationId: Scalars['ObjectId']['input'];
  dealItemsCreateArgs: Array<DealItemCreateArgs>;
  dealPartnerData?: InputMaybe<DealPartnerDataArgs>;
  employeeDeclarations?: InputMaybe<Array<Scalars['String']['input']>>;
  guestCustomerDataArgs?: InputMaybe<GuestCustomerDataArgs>;
  iban?: InputMaybe<Scalars['String']['input']>;
  initialShopId?: InputMaybe<Scalars['ObjectId']['input']>;
  payoutType: EManualPaymentType;
  paypalAddress?: InputMaybe<Scalars['String']['input']>;
  pickupData?: InputMaybe<TransportDataArgs>;
  registeredCustomerId?: InputMaybe<Scalars['ObjectId']['input']>;
};


export type MutationCreateDealForCustomerArgs = {
  customerEmail: Scalars['String']['input'];
  dealCreateArgs: DealCreateArgs;
};


export type MutationCreateEmployeeArgs = {
  companyId: Scalars['ObjectId']['input'];
  email: Scalars['String']['input'];
  roles: Array<ERoles>;
};


export type MutationCreateExportEntryArgs = {
  employeeId: Scalars['ObjectId']['input'];
};


export type MutationCreateFeeArgs = {
  feeCreateArgs: FeeCreateArgs;
};


export type MutationCreateItemCategoryArgs = {
  algoliaCategorySlug?: InputMaybe<Scalars['String']['input']>;
  categoryPageIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  expectedTurnOverTime?: InputMaybe<Scalars['Float']['input']>;
  helpLink?: InputMaybe<Scalars['String']['input']>;
  maximumPawnDuration?: InputMaybe<EMaximumPawnDuration>;
  minimumItemValue?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ObjectId']['input']>;
  storageFeeIds: Array<Scalars['ObjectId']['input']>;
  visibleOnDomain?: InputMaybe<EVisibleOnDomain>;
};


export type MutationCreateItemQuestionArgs = {
  _oldItemQuestionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  infoKey?: InputMaybe<Scalars['String']['input']>;
  isDeactivatedForNewProducts?: InputMaybe<Scalars['Boolean']['input']>;
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  itemCategoryIds: Array<Scalars['ObjectId']['input']>;
  order: Scalars['Float']['input'];
  predictionTag?: InputMaybe<EQuestionPredictionTag>;
  questionType: EQuestionType;
  rangeData?: InputMaybe<ItemQuestionRangeDataArgs>;
  singleChoiceOptions?: InputMaybe<Array<ItemQuestionOptionArgs>>;
  titleKey: Scalars['String']['input'];
  validFrom: Scalars['DateTime']['input'];
  validTo: Scalars['DateTime']['input'];
  valueMode: EQuestionValueMode;
};


export type MutationCreateLoanToValuesEntryArgs = {
  categoryValues: Scalars['JSON']['input'];
  companyId: Scalars['ObjectId']['input'];
  validFrom: Scalars['DateTime']['input'];
};


export type MutationCreateMaintenanceWindowArgs = {
  duration: Scalars['Float']['input'];
  scheduledStartTime: Scalars['DateTime']['input'];
};


export type MutationCreateMaterialPriceArgs = {
  date: Scalars['DateTime']['input'];
  material: Scalars['String']['input'];
  mu: Scalars['Float']['input'];
  price: Scalars['Float']['input'];
  sigma: Scalars['Float']['input'];
};


export type MutationCreateOrUpdateReady2OrderApiKeyArgs = {
  args: CreateOrUpdateReady2OrderApiKeyArgs;
};


export type MutationCreatePartnerArgs = {
  partner: PartnerCreateArgs;
};


export type MutationCreatePrivateSaleArgs = {
  args: PrivateSaleCreateArgs;
};


export type MutationCreatePrivateSaleTransactionArgs = {
  args: PrivateSaleTransactionArgs;
  needToHandleCashbook: Scalars['Boolean']['input'];
  privateSaleId: Scalars['ObjectId']['input'];
};


export type MutationCreateProductArgs = {
  args: ProductCreateArgs;
};


export type MutationCreateProductLegacyArgs = {
  class?: InputMaybe<Scalars['String']['input']>;
  conditionMaxValues?: InputMaybe<ConditionMaxMarketValuesArgs>;
  contentCategories?: InputMaybe<ContentCategoriesArgs>;
  ean?: InputMaybe<Scalars['String']['input']>;
  gewicht?: InputMaybe<Scalars['Float']['input']>;
  isInactive?: InputMaybe<Scalars['Boolean']['input']>;
  isTaxFree?: InputMaybe<Scalars['Boolean']['input']>;
  itemCategoryIds: Array<Scalars['ObjectId']['input']>;
  karat?: InputMaybe<Scalars['Float']['input']>;
  material?: InputMaybe<Scalars['String']['input']>;
  maxLoanToValue?: InputMaybe<Scalars['Float']['input']>;
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  objectID: Scalars['String']['input'];
  pictureFilename?: InputMaybe<Scalars['String']['input']>;
  releaseDate?: InputMaybe<Scalars['DateTime']['input']>;
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
};


export type MutationCreateProductPropertyDefinitionArgs = {
  args: ProductPropertyDefinitionCreateArgs;
};


export type MutationCreateReceiptWithoutIdentityArgs = {
  dealId: Scalars['ObjectId']['input'];
};


export type MutationCreateResponseTemplateArgs = {
  responseTemplate: ResponseTemplateCreateArgs;
};


export type MutationCreateShippingLabelArgs = {
  createArgs: ShippingLabelCreateArgs;
};


export type MutationCreateShippingLabelByPageIdArgs = {
  shippingLabelPageId: Scalars['String']['input'];
};


export type MutationCreateShopArgs = {
  address: IAddress;
  cashBoxNames?: InputMaybe<Array<Scalars['String']['input']>>;
  companyId: Scalars['ObjectId']['input'];
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  disabledAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  googleMapsLink: Scalars['String']['input'];
  hideLocationOnWebsite?: InputMaybe<Scalars['Boolean']['input']>;
  itemCategoryIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  name: Scalars['String']['input'];
  openingHours: Scalars['String']['input'];
  partnerId?: InputMaybe<Scalars['ObjectId']['input']>;
  phone: Scalars['String']['input'];
  r2oProductMaps?: InputMaybe<Array<R2OProductMapArgs>>;
  ready2OrderApiKey?: InputMaybe<Scalars['String']['input']>;
  successionShopId?: InputMaybe<Scalars['ObjectId']['input']>;
};


export type MutationCreateStorageFacilityArgs = {
  address: IAddress;
  external: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateStorageUnitArgs = {
  capacity?: InputMaybe<Scalars['Float']['input']>;
  isSecureLocation?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ObjectId']['input']>;
  storageFacilityId?: InputMaybe<Scalars['ObjectId']['input']>;
};


export type MutationCreateValorizationEntryArgs = {
  buyerBillingAddress?: InputMaybe<BuyerBillingAddressArgs>;
  buyerEmail?: InputMaybe<Scalars['String']['input']>;
  buyerName?: InputMaybe<Scalars['String']['input']>;
  buyerPhone?: InputMaybe<Scalars['String']['input']>;
  buyerShippingAddress?: InputMaybe<IAddress>;
  cashflow: Scalars['Float']['input'];
  customLabel?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['DateTime']['input'];
  descriptionForItemStatus?: InputMaybe<Scalars['String']['input']>;
  isItemReturned?: InputMaybe<Scalars['Boolean']['input']>;
  isTaxFreeTransaction?: InputMaybe<Scalars['Boolean']['input']>;
  itemsIds: Array<Scalars['ObjectId']['input']>;
  logisticsPartnerData?: InputMaybe<LogisticsPartnerDataArgs>;
  order?: InputMaybe<Scalars['Float']['input']>;
  paymentData?: InputMaybe<PaymentDataArgs>;
  relatedBillId?: InputMaybe<Scalars['ObjectId']['input']>;
  returnReason?: InputMaybe<EReturnReasons>;
  returnReasonDetails?: InputMaybe<Scalars['String']['input']>;
  salesPartnerData?: InputMaybe<SalesPartnerDataArgs>;
  sendBill?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationDeactivateCompanyArgs = {
  companyId: Scalars['ObjectId']['input'];
};


export type MutationDeactivateCustomerArgs = {
  customerId: Scalars['ObjectId']['input'];
};


export type MutationDeactivateEmployeeArgs = {
  employeeId: Scalars['ObjectId']['input'];
};


export type MutationDeactivatePartnerArgs = {
  partnerId: Scalars['ObjectId']['input'];
};


export type MutationDeactivateStorageFacilityArgs = {
  storageFacilityId: Scalars['ObjectId']['input'];
};


export type MutationDeclineDealArgs = {
  dealId: Scalars['ObjectId']['input'];
};


export type MutationDeleteAuctionArgs = {
  args: AuctionDeleteArgs;
};


export type MutationDeleteCustomDealArgs = {
  customDealId: Scalars['ObjectId']['input'];
};


export type MutationDeleteCustomDealFormArgs = {
  customDealFormId: Scalars['ObjectId']['input'];
};


export type MutationDeleteCustomerArgs = {
  customerId: Scalars['ObjectId']['input'];
};


export type MutationDeleteCustomerBlacklistArgs = {
  args: CustomerBlacklistDeleteArgs;
};


export type MutationDeleteFeeArgs = {
  feeId: Scalars['ObjectId']['input'];
};


export type MutationDeleteItemCategoryArgs = {
  itemCategoryId: Scalars['ObjectId']['input'];
};


export type MutationDeleteItemQuestionArgs = {
  itemQuestionId: Scalars['ObjectId']['input'];
};


export type MutationDeleteLoanToValuesEntryArgs = {
  loanToValuesEntryId: Scalars['ObjectId']['input'];
};


export type MutationDeleteMaterialPriceArgs = {
  materialPriceId: Scalars['ObjectId']['input'];
};


export type MutationDeletePrivateSaleTransactionArgs = {
  privateSaleId: Scalars['ObjectId']['input'];
  transactionOrder: Scalars['Float']['input'];
};


export type MutationDeleteResponseTemplateArgs = {
  responseTemplateId: Scalars['ObjectId']['input'];
};


export type MutationDeleteStorageUnitArgs = {
  storageUnitId: Scalars['ObjectId']['input'];
};


export type MutationDeleteValorizationEntryArgs = {
  valorizationEntryId: Scalars['ObjectId']['input'];
};


export type MutationDisablePostalCodeArgs = {
  id: Scalars['ObjectId']['input'];
};


export type MutationEmployeeChangePasswordArgs = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};


export type MutationEnablePostalCodesArgs = {
  companyId: Scalars['ObjectId']['input'];
  postalCodes: Array<Scalars['String']['input']>;
};


export type MutationExchangeDealItemArgs = {
  dealId: Scalars['ObjectId']['input'];
  newItemArgs: DealItemCreateArgs;
  oldItemId: Scalars['ObjectId']['input'];
};


export type MutationFindKsvAssetsArgs = {
  itemId: Scalars['ObjectId']['input'];
};


export type MutationGenerateAuctionAnnouncementPdfArgs = {
  auctionId: Scalars['ObjectId']['input'];
};


export type MutationGeneratePowerOfAttorneyArgs = {
  generatePowerOfAttorneyArgs: GeneratePowerOfAttorneyArgs;
};


export type MutationGenerateUserAgreementArgs = {
  generateUserAgreementArgs: GenerateUserAgreementArgs;
};


export type MutationImportItemNewInternalPricesArgs = {
  args: ImportItemNewInternalPricesArgs;
};


export type MutationImportProductsArgs = {
  args: ImportProductsArgs;
};


export type MutationLoginCustomerArgs = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationLoginEmployeeArgs = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationMergeCustomerArgs = {
  input: MergeCustomersInput;
};


export type MutationOverwriteCustomDealPayoutAmountToCustomerRequestedArgs = {
  customDealId: Scalars['ObjectId']['input'];
};


export type MutationParsePiceaTestArgs = {
  itemId: Scalars['ObjectId']['input'];
};


export type MutationPayDealSurplusAmountArgs = {
  dealSurplusPaymentArgs: DealSurplusPaymentArgs;
};


export type MutationPayExtensionOnlineArgs = {
  onlinePaymentArgs: OnlinePaymentArgs;
};


export type MutationQualifyLeadArgs = {
  args: QualifyLeadArgs;
};


export type MutationReevaluateFinalPrivateSaleFinalStateArgs = {
  privateSaleId: Scalars['ObjectId']['input'];
};


export type MutationRefetchAndUpdateCarMarketValueArgs = {
  itemId: Scalars['ObjectId']['input'];
};


export type MutationRefreshAuctionArgs = {
  auctionId: Scalars['ObjectId']['input'];
};


export type MutationRefreshDealInAuctionArgs = {
  dealId: Scalars['ObjectId']['input'];
};


export type MutationRefreshItemArgs = {
  itemId: Scalars['ObjectId']['input'];
};


export type MutationRefreshItemValorizationsArgs = {
  itemId: Scalars['ObjectId']['input'];
};


export type MutationRefreshValorizationCalculationForDealItemArgs = {
  dealId: Scalars['ObjectId']['input'];
};


export type MutationRegenerateBillForDealArgs = {
  dealId: Scalars['ObjectId']['input'];
};


export type MutationRegeneratePawnTicketForDealArgs = {
  dealId: Scalars['ObjectId']['input'];
};


export type MutationRegenerateReceiptForDealArgs = {
  dealId: Scalars['ObjectId']['input'];
};


export type MutationRegenerateValorizationReceiptsArgs = {
  valorizationEntryId: Scalars['ObjectId']['input'];
};


export type MutationRegisterCustomerArgs = {
  acquiredBy?: InputMaybe<Scalars['String']['input']>;
  additionalInformationForCarPawn?: InputMaybe<AdditionalInformationForCarPawnArgs>;
  address?: InputMaybe<ICustomerAddress>;
  dateOfBirth: Scalars['DateTime']['input'];
  deactivated?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  guestEmail?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  identityNumber?: InputMaybe<Scalars['String']['input']>;
  identityType?: InputMaybe<ECustomerIdentityType>;
  identityUploadLinks?: InputMaybe<Array<FileTusMetadataArgs>>;
  isNotePopup?: InputMaybe<Scalars['Boolean']['input']>;
  isTestUser?: InputMaybe<Scalars['Boolean']['input']>;
  lastname: Scalars['String']['input'];
  mergedCustomers?: InputMaybe<Array<InputMaybe<MergedCustomerArgs>>>;
  note?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  paypalAddress?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  registrationId?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<ESex>;
};


export type MutationRejectCustomDealCounterofferArgs = {
  rejectCustomDealCounterofferArgs: RejectCustomDealCounterofferArgs;
};


export type MutationRemoveCustomDealItemArgs = {
  customDealRemoveItemArgs: CustomDealRemoveItemArgs;
};


export type MutationRemoveDealItemArgs = {
  dealId: Scalars['ObjectId']['input'];
  itemId: Scalars['ObjectId']['input'];
};


export type MutationRemoveItemCategoryIdArgs = {
  itemCategoryId: Scalars['ObjectId']['input'];
  shopId: Scalars['ObjectId']['input'];
};


export type MutationRemoveItemFromStorageUnitArgs = {
  itemId: Scalars['ObjectId']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  storageDate?: InputMaybe<Scalars['DateTime']['input']>;
  storageUnits: ItemStorageUnitsArgs;
};


export type MutationRemoveKsvAssetArgs = {
  itemId: Scalars['ObjectId']['input'];
};


export type MutationRemoveLastItemEventArgs = {
  isNeededToRemoveRelatedValorizationEntry: Scalars['Boolean']['input'];
  itemId: Scalars['ObjectId']['input'];
};


export type MutationRemoveSecondaryCustomerToDealArgs = {
  dealId: Scalars['ObjectId']['input'];
  selectedCustomerId: Scalars['ObjectId']['input'];
};


export type MutationRemoveStorageFacilityIdArgs = {
  shopId: Scalars['ObjectId']['input'];
  storageFacilityId: Scalars['ObjectId']['input'];
};


export type MutationRemoveValorizationEntryArgs = {
  valorizationHistoryId: Scalars['ObjectId']['input'];
};


export type MutationReserveExtensionArgs = {
  args: ReserveExtensionArgs;
};


export type MutationReservePaybackArgs = {
  args: ReservePaybackArgs;
};


export type MutationResetCustomerPasswordMailArgs = {
  email: Scalars['String']['input'];
};


export type MutationSaveReady2OrderProductMapsArgs = {
  args: SaveReady2OrderProductMapsArgs;
};


export type MutationSendReminderEmailForUploadingIdArgs = {
  customerId: Scalars['ObjectId']['input'];
  type: ERemindUploadIdType;
};


export type MutationSetAllDealItemsToPurchasedDirectlyArgs = {
  dealId: Scalars['ObjectId']['input'];
};


export type MutationSetAuctionItemsBuyersAndGenerateSurchargeCertificateArgs = {
  args: SetAuctionItemsBuyersAndGenerateSurchargeCertificateArgs;
};


export type MutationSetDealReceivedIdMissingArgs = {
  dealId: Scalars['ObjectId']['input'];
};


export type MutationSetDealReviewingArgs = {
  dealId: Scalars['ObjectId']['input'];
};


export type MutationSetMainStorageFacilityIdArgs = {
  shopId: Scalars['ObjectId']['input'];
  storageFacilityId?: InputMaybe<Scalars['ObjectId']['input']>;
};


export type MutationSetOnSellArgs = {
  dealId: Scalars['ObjectId']['input'];
};


export type MutationSetPayedAndStoredArgs = {
  dealId: Scalars['ObjectId']['input'];
};


export type MutationSetSoldExternArgs = {
  dealId: Scalars['ObjectId']['input'];
};


export type MutationStartAuctionArgs = {
  auctionId: Scalars['ObjectId']['input'];
};


export type MutationUpdateAuctionArgs = {
  args: AuctionUpdateArgs;
  shouldNotifyCustomers: Scalars['Boolean']['input'];
};


export type MutationUpdateAuctionItemArgs = {
  auctionItemArgs: AuctionItemArgs;
};


export type MutationUpdateCarInspectionArgs = {
  args: CarInspectionArgs;
};


export type MutationUpdateCashBookCountArgs = {
  cashBookCountUpdateArgs: CashBookCountUpdateArgs;
};


export type MutationUpdateCompanyArgs = {
  _id: Scalars['ObjectId']['input'];
  accountOwner?: InputMaybe<Scalars['String']['input']>;
  bic?: InputMaybe<Scalars['String']['input']>;
  configuration?: InputMaybe<CompanyConfigurationArgs>;
  dpdConfiguration?: InputMaybe<DpdConfigurationArgs>;
  email?: InputMaybe<Scalars['String']['input']>;
  fibuNumber: Scalars['String']['input'];
  headquarter?: InputMaybe<IAddress>;
  iban?: InputMaybe<Scalars['String']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  paypalEmail?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  primaryShopLocationId: Scalars['ObjectId']['input'];
  saleSupportEmail?: InputMaybe<Scalars['String']['input']>;
  salesConfiguration?: InputMaybe<CompanySalesConfigurationArgs>;
  successionCompanyId?: InputMaybe<Scalars['ObjectId']['input']>;
  supportEmail?: InputMaybe<Scalars['String']['input']>;
  uid: Scalars['String']['input'];
  unzerConfiguration?: InputMaybe<CompanyUnzerConfigurationArgs>;
  website?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateCurrentEmployeePreferencesArgs = {
  preferences: EmployeePreferencesInput;
};


export type MutationUpdateCustomDealArgs = {
  customDealUpdateArgs: CustomDealUpdateArgs;
};


export type MutationUpdateCustomDealFormArgs = {
  customDealFormUpdateArgs: CustomDealFormUpdateArgs;
};


export type MutationUpdateCustomDealItemArgs = {
  customDealId: Scalars['ObjectId']['input'];
  customDealItemUpdateArgs: CustomDealItemUpdateArgs;
};


export type MutationUpdateCustomDealNoteArgs = {
  customDealId: Scalars['ObjectId']['input'];
  noteId: Scalars['ObjectId']['input'];
  noteUpdateArgs: NoteUpdateArgs;
};


export type MutationUpdateCustomerArgs = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  acquiredBy?: InputMaybe<Scalars['String']['input']>;
  additionalInformationForCarPawn?: InputMaybe<AdditionalInformationForCarPawnArgs>;
  addresses?: InputMaybe<Array<ICustomerAddress>>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  deactivated?: InputMaybe<Scalars['Boolean']['input']>;
  deactivatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  guestEmail?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  identityNumber?: InputMaybe<Scalars['String']['input']>;
  identityType?: InputMaybe<ECustomerIdentityType>;
  identityUploadLinks?: InputMaybe<Array<FileTusMetadataArgs>>;
  identityVerifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  identityVerifiedBy?: InputMaybe<Scalars['ObjectId']['input']>;
  isNotePopup?: InputMaybe<Scalars['Boolean']['input']>;
  isTestUser?: InputMaybe<Scalars['Boolean']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  mergedCustomers?: InputMaybe<Array<InputMaybe<MergedCustomerArgs>>>;
  note?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  paypalAddress?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  registrationCertificate?: InputMaybe<FileTusMetadataArgs>;
  sex?: InputMaybe<ESex>;
  uploadedFiles?: InputMaybe<Array<FileTusMetadataArgs>>;
};


export type MutationUpdateCustomerBlacklistArgs = {
  args: CustomerBlacklistUpdateArgs;
};


export type MutationUpdateCustomerCategoryArgs = {
  customerCategoryArgs: CustomerCategoryArgs;
};


export type MutationUpdateCustomerPasswordArgs = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};


export type MutationUpdateDealAuctioningSettingsArgs = {
  args: UpdateDealAuctioningSettingsArgs;
};


export type MutationUpdateDealItemArgs = {
  args: DealItemUpdateArgs;
  dealId: Scalars['ObjectId']['input'];
};


export type MutationUpdateDealItemAnswersArgs = {
  args: UpdateDealItemAnswersArgs;
  dealId: Scalars['ObjectId']['input'];
};


export type MutationUpdateDealItemAnswersWithoutRecalculationArgs = {
  args: UpdateDealItemAnswersArgs;
  dealId: Scalars['ObjectId']['input'];
};


export type MutationUpdateDealItemInternalSaleDataArgs = {
  args: InternalSaleDataArgs;
  dealId: Scalars['ObjectId']['input'];
  itemId: Scalars['ObjectId']['input'];
};


export type MutationUpdateDealNoteArgs = {
  dealId: Scalars['ObjectId']['input'];
  noteId: Scalars['ObjectId']['input'];
  noteUpdateArgs: NoteUpdateArgs;
};


export type MutationUpdateDealOnlineExtensionPreventionArgs = {
  dealId: Scalars['ObjectId']['input'];
  isOnlineExtensionPrevented: Scalars['Boolean']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateDealTransportArgs = {
  args: DealTransportUpdateArgs;
};


export type MutationUpdateDealUploadedFilesArgs = {
  dealId: Scalars['ObjectId']['input'];
  uploadedFilesArgs: Array<FileTusMetadataArgs>;
};


export type MutationUpdateEmployeeArgs = {
  _id: Scalars['ObjectId']['input'];
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  isNotePopup?: InputMaybe<Scalars['Boolean']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  payoutConfigurations?: InputMaybe<PayoutConfigurationsInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  preferences?: InputMaybe<EmployeePreferencesInput>;
  roles?: InputMaybe<Array<ERoles>>;
  scheduledDeactivationAt?: InputMaybe<Scalars['DateTime']['input']>;
  sex?: InputMaybe<ESex>;
  shopIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
};


export type MutationUpdateEmployeePasswordArgs = {
  employeeId: Scalars['ObjectId']['input'];
  password: Scalars['String']['input'];
};


export type MutationUpdateEmployeeProfileArgs = {
  _id: Scalars['ObjectId']['input'];
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<ESex>;
};


export type MutationUpdateFeeArgs = {
  feeUpdateArgs: FeeUpdateArgs;
};


export type MutationUpdateInsuredAmountArgs = {
  dealId: Scalars['ObjectId']['input'];
  insuredAmount: Scalars['Float']['input'];
};


export type MutationUpdateInternalSaleDataForDirectlyPurchasedItemsArgs = {
  dealId: Scalars['ObjectId']['input'];
};


export type MutationUpdateItemArgs = {
  args: ItemUpdateArgs;
};


export type MutationUpdateItemCategorizedUploadedFilesArgs = {
  fileCategoryName: Scalars['String']['input'];
  itemId: Scalars['ObjectId']['input'];
  uploadedFilesArgs: Array<FileTusMetadataArgs>;
};


export type MutationUpdateItemCategoryArgs = {
  _id: Scalars['ObjectId']['input'];
  algoliaCategorySlug?: InputMaybe<Scalars['String']['input']>;
  categoryPageIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  expectedTurnOverTime?: InputMaybe<Scalars['Float']['input']>;
  helpLink?: InputMaybe<Scalars['String']['input']>;
  maximumPawnDuration?: InputMaybe<EMaximumPawnDuration>;
  minimumItemValue?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['ObjectId']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  storageFeeIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  visibleOnDomain?: InputMaybe<EVisibleOnDomain>;
};


export type MutationUpdateItemCategoryIdArgs = {
  dealId: Scalars['ObjectId']['input'];
  itemCategoryId: Scalars['ObjectId']['input'];
  itemId: Scalars['ObjectId']['input'];
};


export type MutationUpdateItemCategoryIdealoIdMapsArgs = {
  args: Array<ItemCategoryIdealoIdMapArgs>;
};


export type MutationUpdateItemEventArgs = {
  itemEventUpdateArgs: ItemEventUpdateArgs;
  itemId: Scalars['ObjectId']['input'];
};


export type MutationUpdateItemManualTestArgs = {
  args: ItemManualTestArgs;
  itemId: Scalars['ObjectId']['input'];
};


export type MutationUpdateItemMediaArgs = {
  itemId: Scalars['ObjectId']['input'];
  mediaArgs: Array<FileTusMetadataArgs>;
};


export type MutationUpdateItemNoteArgs = {
  itemId: Scalars['ObjectId']['input'];
  noteId: Scalars['ObjectId']['input'];
  noteUpdateArgs: NoteUpdateArgs;
};


export type MutationUpdateItemQuestionArgs = {
  _id: Scalars['ObjectId']['input'];
  _oldItemQuestionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  infoKey?: InputMaybe<Scalars['String']['input']>;
  isDeactivatedForNewProducts?: InputMaybe<Scalars['Boolean']['input']>;
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  itemCategoryIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  order?: InputMaybe<Scalars['Float']['input']>;
  predictionTag?: InputMaybe<EQuestionPredictionTag>;
  questionType?: InputMaybe<EQuestionType>;
  rangeData?: InputMaybe<ItemQuestionRangeDataArgs>;
  singleChoiceOptions?: InputMaybe<Array<ItemQuestionOptionArgs>>;
  titleKey?: InputMaybe<Scalars['String']['input']>;
  validFrom?: InputMaybe<Scalars['DateTime']['input']>;
  validTo?: InputMaybe<Scalars['DateTime']['input']>;
  valueMode?: InputMaybe<EQuestionValueMode>;
};


export type MutationUpdateItemUploadedFilesArgs = {
  itemId: Scalars['ObjectId']['input'];
  uploadedFilesArgs: Array<FileTusMetadataArgs>;
};


export type MutationUpdateMaintenanceWindowArgs = {
  duration?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ObjectId']['input'];
  isFinished?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledStartTime?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationUpdateMaterialPriceArgs = {
  _id: Scalars['ObjectId']['input'];
  date?: InputMaybe<Scalars['DateTime']['input']>;
  material?: InputMaybe<Scalars['String']['input']>;
  mu?: InputMaybe<Scalars['Float']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  sigma?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationUpdatePartialRedemptionArgs = {
  args: PartialRedemptionArgs;
};


export type MutationUpdatePartnerArgs = {
  _id: Scalars['ObjectId']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  partnershipTypes?: InputMaybe<PartnershipTypeArgs>;
};


export type MutationUpdatePaybackDataArgs = {
  args: PaymentDataArgs;
  dealId: Scalars['ObjectId']['input'];
};


export type MutationUpdatePayoutDataArgs = {
  args: PaymentDataArgs;
  dealId: Scalars['ObjectId']['input'];
};


export type MutationUpdatePiceaUploadLinkArgs = {
  itemId: Scalars['ObjectId']['input'];
  piceaUploadLinkArgs?: InputMaybe<FileTusMetadataArgs>;
};


export type MutationUpdatePreviewCalculationArgs = {
  dealFinalValuesArgs: DealFinalValuesArgs;
  dealId: Scalars['ObjectId']['input'];
};


export type MutationUpdatePrivateSaleTransactionArgs = {
  args: PrivateSaleTransactionArgs;
  privateSaleId: Scalars['ObjectId']['input'];
  transactionOrder: Scalars['Float']['input'];
};


export type MutationUpdateProductArgs = {
  args: ProductUpdateArgs;
};


export type MutationUpdateProductLegacyArgs = {
  _id: Scalars['ObjectId']['input'];
  class?: InputMaybe<Scalars['String']['input']>;
  conditionMaxValues?: InputMaybe<ConditionMaxMarketValuesArgs>;
  contentCategories?: InputMaybe<ContentCategoriesArgs>;
  ean?: InputMaybe<Scalars['String']['input']>;
  gewicht?: InputMaybe<Scalars['Float']['input']>;
  isInactive?: InputMaybe<Scalars['Boolean']['input']>;
  isTaxFree?: InputMaybe<Scalars['Boolean']['input']>;
  itemCategoryIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  karat?: InputMaybe<Scalars['Float']['input']>;
  material?: InputMaybe<Scalars['String']['input']>;
  maxLoanToValue?: InputMaybe<Scalars['Float']['input']>;
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  objectID?: InputMaybe<Scalars['String']['input']>;
  pictureFilename?: InputMaybe<Scalars['String']['input']>;
  releaseDate?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateProductPriceArgs = {
  args: ProductUpdatePriceArgs;
};


export type MutationUpdateProductPropertyDefinitionArgs = {
  args: ProductPropertyDefinitionUpdateArgs;
};


export type MutationUpdateProductPublicationArgs = {
  isPublished: Scalars['Boolean']['input'];
  productId: Scalars['ObjectId']['input'];
};


export type MutationUpdateResponseTemplateArgs = {
  responseTemplate: ResponseTemplateUpdateArgs;
};


export type MutationUpdateSavedValorizationHistoryEntryArgs = {
  args: ValorizationEntryUpdateArgs;
  shopId?: InputMaybe<Scalars['ObjectId']['input']>;
};


export type MutationUpdateSecondaryPayoutDataArgs = {
  args?: InputMaybe<SecondaryPaymentDataArgs>;
  dealId: Scalars['ObjectId']['input'];
};


export type MutationUpdateShopArgs = {
  _id: Scalars['ObjectId']['input'];
  address?: InputMaybe<IAddress>;
  cashBoxNames?: InputMaybe<Array<Scalars['String']['input']>>;
  companyId?: InputMaybe<Scalars['ObjectId']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  disabledAt?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  googleMapsLink?: InputMaybe<Scalars['String']['input']>;
  hideLocationOnWebsite?: InputMaybe<Scalars['Boolean']['input']>;
  itemCategoryIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  openingHours?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['ObjectId']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  r2oProductMaps?: InputMaybe<Array<R2OProductMapArgs>>;
  ready2OrderApiKey?: InputMaybe<Scalars['String']['input']>;
  successionShopId?: InputMaybe<Scalars['ObjectId']['input']>;
};


export type MutationUpdateShopIdArgs = {
  dealId: Scalars['ObjectId']['input'];
  initialShopId: Scalars['ObjectId']['input'];
};


export type MutationUpdateStorageFacilityArgs = {
  _id: Scalars['ObjectId']['input'];
  address?: InputMaybe<IAddress>;
  external?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateStorageLabelForCashBookCashFlowArgs = {
  cashBookCashFlowId: Scalars['ObjectId']['input'];
  storageLabel: Scalars['String']['input'];
};


export type MutationUpdateStorageUnitArgs = {
  _id: Scalars['ObjectId']['input'];
  capacity?: InputMaybe<Scalars['Float']['input']>;
  childIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  isSecureLocation?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['ObjectId']['input']>;
  storageFacilityId?: InputMaybe<Scalars['ObjectId']['input']>;
};


export type MutationValidatePaybackOrExtendDealPersistanceCalculationArgs = {
  args: ValidatePaybackOrExtendDealPersistanceCalculationArgs;
};


export type MutationVerifyActivationEmployeeTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationVerifyDealArgs = {
  verifyDealArgs: VerifyDealArgs;
};

export type Note = {
  __typename?: 'Note';
  _id: Scalars['ObjectId']['output'];
  bookingNumber?: Maybe<Scalars['Float']['output']>;
  content: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['ObjectId']['output']>;
  dealId?: Maybe<Scalars['ObjectId']['output']>;
  employee?: Maybe<Employee>;
  isPopup?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type NoteCreateArgs = {
  content: Scalars['String']['input'];
  isPopup?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NoteUpdateArgs = {
  content?: InputMaybe<Scalars['String']['input']>;
  isPopup?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NumberDefaultCustomDealFormQuestion = BaseCustomDealFormQuestion & {
  __typename?: 'NumberDefaultCustomDealFormQuestion';
  _id: Scalars['ObjectId']['output'];
  info: TranslatedString;
  initialNumberAnswer?: Maybe<Scalars['Float']['output']>;
  label: TranslatedString;
  optional?: Maybe<Scalars['Boolean']['output']>;
  showOnIssuanceCertificate: Scalars['Boolean']['output'];
  showOnSalesBill: Scalars['Boolean']['output'];
  titleKey?: Maybe<ECustomDealFormQuestionTitleKey>;
  type: ECustomDealFormQuestionType;
};

export type NumberFilter = {
  betweenValues?: InputMaybe<NumberFilterBetween>;
  condition?: InputMaybe<ENumberFilterConditions>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type NumberFilterBetween = {
  from: Scalars['Float']['input'];
  to: Scalars['Float']['input'];
};

export type NumberOptionsCustomDealFormQuestion = BaseCustomDealFormQuestion & {
  __typename?: 'NumberOptionsCustomDealFormQuestion';
  _id: Scalars['ObjectId']['output'];
  allowEnterAnswer: Scalars['Boolean']['output'];
  info: TranslatedString;
  initialOptionNumberAnswer?: Maybe<Scalars['Float']['output']>;
  label: TranslatedString;
  optional?: Maybe<Scalars['Boolean']['output']>;
  options: Array<CustomDealFormOption>;
  restrictions: Array<CustomDealQuestionNumberRestriction>;
  showOnIssuanceCertificate: Scalars['Boolean']['output'];
  showOnSalesBill: Scalars['Boolean']['output'];
  titleKey?: Maybe<ECustomDealFormQuestionTitleKey>;
  type: ECustomDealFormQuestionType;
};


export type NumberOptionsCustomDealFormQuestionRestrictionsArgs = {
  categoryId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type OAddress = {
  __typename?: 'OAddress';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  coordinates?: Maybe<OCoordinates>;
  /** @deprecated Use `countryCode`. */
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<ECountry>;
  door?: Maybe<Scalars['String']['output']>;
  floor?: Maybe<Scalars['String']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  queryString?: Maybe<Scalars['String']['output']>;
  stairway?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type OCoordinates = {
  __typename?: 'OCoordinates';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type OCustomerAddress = {
  __typename?: 'OCustomerAddress';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  coordinates?: Maybe<OCoordinates>;
  /** @deprecated Use `countryCode`. */
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<ECountry>;
  door?: Maybe<Scalars['String']['output']>;
  floor?: Maybe<Scalars['String']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  isBillingAddress?: Maybe<Scalars['Boolean']['output']>;
  isDeliveryAddress?: Maybe<Scalars['Boolean']['output']>;
  isRegistrationAddress?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  queryString?: Maybe<Scalars['String']['output']>;
  stairway?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type ODealPartnerData = {
  __typename?: 'ODealPartnerData';
  knp?: Maybe<ODealPartnerDataKnp>;
  type: EDealPartnerType;
};

export type ODealPartnerDataKnp = {
  __typename?: 'ODealPartnerDataKnp';
  debtAmount: Scalars['Float']['output'];
  fileReferenceNumber: Scalars['String']['output'];
};

export type OLogisticsPartnerData = {
  __typename?: 'OLogisticsPartnerData';
  cashy?: Maybe<OLogisticsPartnerDataCashy>;
  logsta?: Maybe<OLogisticsPartnerDataLogsta>;
  trackingLink?: Maybe<Scalars['String']['output']>;
  type: ELogisticsPartnerType;
};

export type OLogisticsPartnerDataCashy = {
  __typename?: 'OLogisticsPartnerDataCashy';
  _placeHolder?: Maybe<Scalars['Boolean']['output']>;
};

export type OLogisticsPartnerDataLogsta = {
  __typename?: 'OLogisticsPartnerDataLogsta';
  logstaNumber?: Maybe<Scalars['String']['output']>;
};

export type OOpeningHoursEntry = {
  __typename?: 'OOpeningHoursEntry';
  from: Scalars['Float']['output'];
  to: Scalars['Float']['output'];
};

export type OPayoutConfiguration = {
  __typename?: 'OPayoutConfiguration';
  carPayoutLimit?: Maybe<Scalars['Float']['output']>;
  noLimit?: Maybe<Scalars['Boolean']['output']>;
  payoutLimit?: Maybe<Scalars['Float']['output']>;
};

export type OSalesPartnerData = {
  __typename?: 'OSalesPartnerData';
  baggyluxe?: Maybe<OSalesPartnerDataBaggyluxe>;
  blitzmobile?: Maybe<OSalesPartnerDataBlitzMobile>;
  cashy?: Maybe<OSalesPartnerDataCashy>;
  chrono24?: Maybe<OSalesPartnerDataChrono24>;
  ebay?: Maybe<OSalesPartnerDataEbay>;
  ebaykleinanzeigen?: Maybe<OSalesPartnerDataEbayKleinanzeigen>;
  others?: Maybe<OSalesPartnerDataOthers>;
  rebelle?: Maybe<OSalesPartnerDataRebelle>;
  refurbed?: Maybe<OSalesPartnerDataRefurbed>;
  type: ESalesPartnerType;
  vestiairecollective?: Maybe<OSalesPartnerDataVestiaireCollective>;
  willhaben?: Maybe<OSalesPartnerDataWillhaben>;
};

export type OSalesPartnerDataBaggyluxe = {
  __typename?: 'OSalesPartnerDataBaggyluxe';
  saleId?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type OSalesPartnerDataBlitzMobile = {
  __typename?: 'OSalesPartnerDataBlitzMobile';
  saleId?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type OSalesPartnerDataCashy = {
  __typename?: 'OSalesPartnerDataCashy';
  _placeHolder?: Maybe<Scalars['Boolean']['output']>;
};

export type OSalesPartnerDataChrono24 = {
  __typename?: 'OSalesPartnerDataChrono24';
  saleId?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type OSalesPartnerDataEbay = {
  __typename?: 'OSalesPartnerDataEbay';
  articleDescription?: Maybe<Scalars['String']['output']>;
  ebayArticleNumber?: Maybe<Scalars['String']['output']>;
  numberOfItems?: Maybe<Scalars['Float']['output']>;
  paidDate?: Maybe<Scalars['DateTime']['output']>;
  purchaseProcessingDate?: Maybe<Scalars['String']['output']>;
  saleProtocolNumber?: Maybe<Scalars['Float']['output']>;
  shippingCosts?: Maybe<Scalars['Float']['output']>;
  shippingDate?: Maybe<Scalars['DateTime']['output']>;
  shippingService?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type OSalesPartnerDataEbayKleinanzeigen = {
  __typename?: 'OSalesPartnerDataEbayKleinanzeigen';
  kleinanzeigenArticleNumber?: Maybe<Scalars['String']['output']>;
  shippingDate?: Maybe<Scalars['DateTime']['output']>;
};

export type OSalesPartnerDataOthers = {
  __typename?: 'OSalesPartnerDataOthers';
  saleId?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type OSalesPartnerDataRebelle = {
  __typename?: 'OSalesPartnerDataRebelle';
  saleId?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type OSalesPartnerDataRefurbed = {
  __typename?: 'OSalesPartnerDataRefurbed';
  ID: Scalars['Float']['output'];
  quantity: Scalars['Float']['output'];
  settlementBaseCommission?: Maybe<Scalars['Float']['output']>;
  settlementDynamicCommission?: Maybe<Scalars['Float']['output']>;
  settlementPaymentCommission?: Maybe<Scalars['Float']['output']>;
  settlementPayoutCommission?: Maybe<Scalars['Float']['output']>;
  settlementTotalCommission?: Maybe<Scalars['Float']['output']>;
  settlementTotalRefunded?: Maybe<Scalars['Float']['output']>;
  shippingCosts: Scalars['Float']['output'];
  warranty: Scalars['String']['output'];
};

export type OSalesPartnerDataVestiaireCollective = {
  __typename?: 'OSalesPartnerDataVestiaireCollective';
  refId?: Maybe<Scalars['String']['output']>;
};

export type OSalesPartnerDataWillhaben = {
  __typename?: 'OSalesPartnerDataWillhaben';
  articleDescription?: Maybe<Scalars['String']['output']>;
  numberOfItems?: Maybe<Scalars['Float']['output']>;
  paidDate?: Maybe<Scalars['DateTime']['output']>;
  purchaseProcessingDate?: Maybe<Scalars['String']['output']>;
  saleProtocolNumber?: Maybe<Scalars['Float']['output']>;
  shippingCosts?: Maybe<Scalars['Float']['output']>;
  shippingDate?: Maybe<Scalars['DateTime']['output']>;
  shippingService?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  willhabenArticleNumber?: Maybe<Scalars['String']['output']>;
};

export type OnlinePaymentArgs = {
  calculationId: Scalars['ObjectId']['input'];
  dealId: Scalars['ObjectId']['input'];
  dropoffDataArgs: TransportDataArgs;
  language: ELanguageCode;
  unzerPaymentArgs?: InputMaybe<UnzerPaymentArgs>;
};

export type OnlinePaymentResult = {
  __typename?: 'OnlinePaymentResult';
  deal: Deal;
  paymentResult: PaymentResult;
};

export type OtherCarProperty = {
  __typename?: 'OtherCarProperty';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type OtherVehiclePropertiesArgs = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>;
  startCursor?: Maybe<Scalars['String']['output']>;
  total: Scalars['Float']['output'];
};

export type PageInfoSkipLimit = {
  __typename?: 'PageInfoSkipLimit';
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>;
  limit?: Maybe<Scalars['Float']['output']>;
  skip?: Maybe<Scalars['Float']['output']>;
  total: Scalars['Float']['output'];
};

export type PaginatedAuctions = {
  __typename?: 'PaginatedAuctions';
  nodes: Array<Auction>;
  pageInfo: PageInfoSkipLimit;
};

export type PaginatedCustomDeals = {
  __typename?: 'PaginatedCustomDeals';
  nodes: Array<CustomDeal>;
  pageInfo: PageInfoSkipLimit;
};

export type PaginatedDeals = {
  __typename?: 'PaginatedDeals';
  nodes: Array<Deal>;
  pageInfo: PageInfoSkipLimit;
};

export type PaginatedItems = {
  __typename?: 'PaginatedItems';
  nodes: Array<Item>;
  pageInfo: PageInfoSkipLimit;
};

export type PaginatedPrivateSales = {
  __typename?: 'PaginatedPrivateSales';
  nodes: Array<PrivateSale>;
  pageInfo: PageInfoSkipLimit;
};

export type PaginatedProductExport = {
  __typename?: 'PaginatedProductExport';
  edges: Array<ProductExportEdge>;
  pageInfo: PageInfo;
};

export type PaginatedProducts = {
  __typename?: 'PaginatedProducts';
  nodes: Array<Product>;
  pageInfo: PageInfoSkipLimit;
};

export type PaginatedSkipLimitCustomerBlacklist = {
  __typename?: 'PaginatedSkipLimitCustomerBlacklist';
  nodes: Array<CustomerBlacklist>;
  pageInfo: PageInfoSkipLimit;
};

export type PaginatedSkipLimitCustomers = {
  __typename?: 'PaginatedSkipLimitCustomers';
  nodes: Array<Customer>;
  pageInfo: PageInfoSkipLimit;
};

export type PartialRedemptionArgs = {
  dealId: Scalars['ObjectId']['input'];
  itemId: Scalars['ObjectId']['input'];
  minPartialRedemptionAmount?: InputMaybe<Scalars['Float']['input']>;
  partialRedemptionIntervalsCount?: InputMaybe<Scalars['Float']['input']>;
};

export type Partner = {
  __typename?: 'Partner';
  _id: Scalars['ObjectId']['output'];
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  isDeactivated?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  partnershipTypes?: Maybe<PartnershipType>;
};

export type PartnerCreateArgs = {
  name: Scalars['String']['input'];
  partnershipTypes?: InputMaybe<PartnershipTypeArgs>;
};

export type PartnerFilterArgs = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  ids?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  isDeactivated?: InputMaybe<BooleanFilter>;
  isInternalSalesPartner?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
};

export type PartnerOpts = {
  filter?: InputMaybe<PartnerFilterArgs>;
  order?: InputMaybe<PartnerOrderArgs>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type PartnerOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  name?: InputMaybe<EOrderBy>;
};

export type PartnershipType = {
  __typename?: 'PartnershipType';
  isInternalSalesPartner?: Maybe<Scalars['Boolean']['output']>;
};

export type PartnershipTypeArgs = {
  isInternalSalesPartner?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PawnData = {
  __typename?: 'PawnData';
  billLink?: Maybe<FileMetadata>;
  billNumber?: Maybe<Scalars['String']['output']>;
  buyBackChildId?: Maybe<Scalars['ObjectId']['output']>;
  buyBackData?: Maybe<BuyBackData>;
  buyBackParentId?: Maybe<Scalars['ObjectId']['output']>;
  extensionChildId?: Maybe<Scalars['ObjectId']['output']>;
  extensionParentId?: Maybe<Scalars['ObjectId']['output']>;
  finalMaxPawnDate?: Maybe<Scalars['DateTime']['output']>;
  pawnNumber?: Maybe<Scalars['Float']['output']>;
  pawnTicketLink?: Maybe<FileMetadata>;
  paybackData?: Maybe<PaymentData>;
  powerOfAttorneyDocuments?: Maybe<Array<PawnDocument>>;
  reservedPaybackData?: Maybe<ReservedPaybackData>;
  surplusCashBookCashFlowIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
  userAgreementDocuments?: Maybe<Array<PawnDocument>>;
};

export type PawnDocument = {
  __typename?: 'PawnDocument';
  customerId: Scalars['ObjectId']['output'];
  fileMetadata: FileMetadata;
};

export type PaymentData = {
  __typename?: 'PaymentData';
  iban?: Maybe<Scalars['String']['output']>;
  paymentType: AnyPaymentType;
  paypalAddress?: Maybe<Scalars['String']['output']>;
  paypalTransactionId?: Maybe<Scalars['String']['output']>;
};

export type PaymentDataArgs = {
  iban?: InputMaybe<Scalars['String']['input']>;
  paymentType: EManualPaymentType;
  paypalAddress?: InputMaybe<Scalars['String']['input']>;
  paypalTransactionId?: InputMaybe<Scalars['String']['input']>;
  shopId?: InputMaybe<Scalars['ObjectId']['input']>;
};

/** SuccessfulPayment | PendingPayment | FailedPayment */
export type PaymentResult = FailedPayment | PendingPayment | SuccessfulPayment;

export type PayoutConfigurationsInput = {
  carPayoutLimit?: InputMaybe<Scalars['Float']['input']>;
  noLimit?: InputMaybe<Scalars['Boolean']['input']>;
  payoutLimit?: InputMaybe<Scalars['Float']['input']>;
};

export type PendingPayment = {
  __typename?: 'PendingPayment';
  id: Scalars['String']['output'];
  redirectUrl: Scalars['String']['output'];
};

export type PersistedDealCalculation = IDealCalculation & {
  __typename?: 'PersistedDealCalculation';
  appliedUsedFeeDefinitions: Array<UsedFeeDefinition>;
  date: Scalars['DateTime']['output'];
  dealCalculationId: Scalars['ObjectId']['output'];
  dealValuesEntry: DealValuesEntry;
  itemsValuesEntries: Array<ItemValuesEntry>;
  loanToValuesEntryId: Scalars['ObjectId']['output'];
};

export type PersistedDealExtensionCalculation = {
  __typename?: 'PersistedDealExtensionCalculation';
  childDealCalculation: DealCalculation;
  dealExtensionCalculationId: Scalars['ObjectId']['output'];
  dealId: Scalars['ObjectId']['output'];
  dueAmount: Scalars['Float']['output'];
  itemsExtensionAnswers: Array<ItemExtensionAnswers>;
  overwrittenPartialRedemptionAmount?: Maybe<Scalars['Float']['output']>;
  parentDealCalculation: DealCalculation;
  partialRedemptionAmount: Scalars['Float']['output'];
};

export type PersistedDealPaybackCalculation = {
  __typename?: 'PersistedDealPaybackCalculation';
  dealCalculation: DealCalculation;
  dealId: Scalars['ObjectId']['output'];
  dealPaybackCalculationId: Scalars['ObjectId']['output'];
};

export type PiceaTest = {
  __typename?: 'PiceaTest';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  data?: Maybe<Array<PiceaTestData>>;
  disable?: Maybe<Scalars['Boolean']['output']>;
  error?: Maybe<Scalars['Boolean']['output']>;
};

export type PiceaTestData = {
  __typename?: 'PiceaTestData';
  label: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type PremiumShippingData = {
  __typename?: 'PremiumShippingData';
  address: OAddress;
  date: Scalars['DateTime']['output'];
  fromHourUTC: Scalars['Float']['output'];
  toHourUTC: Scalars['Float']['output'];
};

export type PremiumShippingDataArgs = {
  address: IAddress;
  date: Scalars['DateTime']['input'];
  fromHourUTC: Scalars['Int']['input'];
  toHourUTC: Scalars['Int']['input'];
};

export type PriceFinding = {
  __typename?: 'PriceFinding';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Employee>;
  creatorId?: Maybe<Scalars['ObjectId']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type PriceFindingArgs = {
  price?: InputMaybe<Scalars['Float']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type PrimaryShopLocationArgs = {
  address: IAddress;
  cashBoxNames?: InputMaybe<Array<Scalars['String']['input']>>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  disabledAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  googleMapsLink: Scalars['String']['input'];
  hideLocationOnWebsite?: InputMaybe<Scalars['Boolean']['input']>;
  itemCategoryIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  name: Scalars['String']['input'];
  openingHours: Scalars['String']['input'];
  partnerId?: InputMaybe<Scalars['ObjectId']['input']>;
  phone: Scalars['String']['input'];
  successionShopId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type PrivateSale = {
  __typename?: 'PrivateSale';
  _id: Scalars['ObjectId']['output'];
  bookingNumber: Scalars['Float']['output'];
  carTitle?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['ObjectId']['output'];
  createdAt: Scalars['DateTime']['output'];
  creationType: EPrivateSaleCreationType;
  customerFullName?: Maybe<Scalars['String']['output']>;
  dealFinalBalance?: Maybe<Scalars['Float']['output']>;
  dealId: Scalars['ObjectId']['output'];
  itemId: Scalars['ObjectId']['output'];
  privateSaleDate: Scalars['DateTime']['output'];
  privateSaleTransactions?: Maybe<Array<PrivateSaleTransaction>>;
  status?: Maybe<EDealStatusType>;
};

export type PrivateSaleCreateArgs = {
  creationType: EPrivateSaleCreationType;
  dealId: Scalars['ObjectId']['input'];
  itemId: Scalars['ObjectId']['input'];
  manualFeeDefinitionsArgs: Array<ManualFeeDefinitionArgs>;
  privateSaleDate: Scalars['DateTime']['input'];
  transactionArgs?: InputMaybe<Array<PrivateSaleTransactionArgs>>;
};

export type PrivateSaleTransaction = {
  __typename?: 'PrivateSaleTransaction';
  amount: Scalars['Float']['output'];
  balance?: Maybe<Scalars['Float']['output']>;
  buyerName?: Maybe<Scalars['String']['output']>;
  cashFlowId?: Maybe<Scalars['ObjectId']['output']>;
  costName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  employeeId?: Maybe<Scalars['ObjectId']['output']>;
  employeeName?: Maybe<Scalars['String']['output']>;
  grossAmount?: Maybe<Scalars['Float']['output']>;
  order: Scalars['Float']['output'];
  paymentType: AnyPaymentType;
  shopId?: Maybe<Scalars['ObjectId']['output']>;
  sortingOrder: Scalars['Float']['output'];
  transactionFileLink?: Maybe<FileMetadata>;
  transactionType: ETransactionType;
  ust?: Maybe<Scalars['Float']['output']>;
};

export type PrivateSaleTransactionArgs = {
  amount: Scalars['Float']['input'];
  buyerName?: InputMaybe<Scalars['String']['input']>;
  costName?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  grossAmount?: InputMaybe<Scalars['Float']['input']>;
  order: Scalars['Float']['input'];
  paymentType?: InputMaybe<EManualPaymentType>;
  regenerateBill?: InputMaybe<Scalars['Boolean']['input']>;
  shopId?: InputMaybe<Scalars['ObjectId']['input']>;
  transactionFileLink?: InputMaybe<FileTusMetadataArgs>;
  transactionType: ETransactionType;
  ust?: InputMaybe<Scalars['Float']['input']>;
};

export type PrivateSalesFiltersArgs = {
  companyId?: InputMaybe<Scalars['ObjectId']['input']>;
  createdBefore?: InputMaybe<Scalars['DateTime']['input']>;
  paginationArgs: ForwardPaginationSkipLimitArgs;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type Product = {
  __typename?: 'Product';
  _id: Scalars['ObjectId']['output'];
  availableProperties?: Maybe<Array<AvailablePropertyValues>>;
  category: ItemCategory;
  categoryId: Scalars['ObjectId']['output'];
  createdAt: Scalars['DateTime']['output'];
  image?: Maybe<ProductImage>;
  imageId?: Maybe<Scalars['String']['output']>;
  imageMode: EProductImageMode;
  isCrawled: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  itemQuestions: Array<ItemQuestion>;
  keywords?: Maybe<Array<Scalars['String']['output']>>;
  manufacturer: Scalars['String']['output'];
  name: Scalars['String']['output'];
  overviewImage?: Maybe<ProductImage>;
  overviewImageId?: Maybe<Scalars['String']['output']>;
  price?: Maybe<ProductPriceUnion>;
  slug: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  variants: Array<ProductVariant>;
};


export type ProductImageArgs = {
  size?: InputMaybe<Scalars['String']['input']>;
};


export type ProductItemQuestionsArgs = {
  date: Scalars['DateTime']['input'];
  omitDeactivatedQuestionsForNewProducts: Scalars['Boolean']['input'];
  omitInternalQuestions?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductOverviewImageArgs = {
  size?: InputMaybe<Scalars['String']['input']>;
};


export type ProductVariantsArgs = {
  args?: InputMaybe<GetProductVariantsArgs>;
};

export type ProductAvailableBooleanProperty = ProductAvailableProperty & {
  __typename?: 'ProductAvailableBooleanProperty';
  propertyDefinition: ProductPropertyDefinition;
  propertyDefinitionId: Scalars['ObjectId']['output'];
  propertyDefinitionType: EProductPropertyType;
};

export type ProductAvailableNumberProperty = ProductAvailableProperty & {
  __typename?: 'ProductAvailableNumberProperty';
  propertyDefinition: ProductPropertyDefinition;
  propertyDefinitionId: Scalars['ObjectId']['output'];
  propertyDefinitionType: EProductPropertyType;
  values: Array<AvailablePropertyNumberOption>;
};

export type ProductAvailableProperty = {
  propertyDefinition: ProductPropertyDefinition;
  propertyDefinitionId: Scalars['ObjectId']['output'];
  propertyDefinitionType: EProductPropertyType;
};

export type ProductAvailablePropertyArgs = {
  propertyDefinitionId: Scalars['ObjectId']['input'];
  sortPriority: Scalars['Float']['input'];
  values?: InputMaybe<ProductAvailablePropertyValuesArgs>;
};

export type ProductAvailablePropertyValuesArgs = {
  numberOptions?: InputMaybe<Array<Scalars['Float']['input']>>;
  textOptions?: InputMaybe<Array<AvailablePropertyTextOptionArgs>>;
};

export type ProductAvailableTextProperty = ProductAvailableProperty & {
  __typename?: 'ProductAvailableTextProperty';
  propertyDefinition: ProductPropertyDefinition;
  propertyDefinitionId: Scalars['ObjectId']['output'];
  propertyDefinitionType: EProductPropertyType;
  values: Array<AvailablePropertyTextOption>;
};

export type ProductCreateArgs = {
  availableProperties: Array<ProductAvailablePropertyArgs>;
  categoryId: Scalars['ObjectId']['input'];
  ephemeralImageId?: InputMaybe<Scalars['String']['input']>;
  ephemeralOverviewImageId?: InputMaybe<Scalars['String']['input']>;
  imageId?: InputMaybe<Scalars['String']['input']>;
  imageMode: EProductImageMode;
  isPublished: Scalars['Boolean']['input'];
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  manufacturer: Scalars['String']['input'];
  name: Scalars['String']['input'];
  overviewImageId?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<ProductPriceArgs>;
  variants: Array<ProductVariantArgs>;
};

export type ProductExport = {
  __typename?: 'ProductExport';
  _id: Scalars['ObjectId']['output'];
  collectionName?: Maybe<Scalars['String']['output']>;
  crawledPrice?: Maybe<Scalars['Float']['output']>;
  crawledTimestamp?: Maybe<Scalars['Float']['output']>;
  currentMarketValue?: Maybe<Scalars['Float']['output']>;
  ean?: Maybe<Scalars['String']['output']>;
  gewicht?: Maybe<Scalars['Float']['output']>;
  isInactive: Scalars['Boolean']['output'];
  isTaxFree?: Maybe<Scalars['Boolean']['output']>;
  karat?: Maybe<Scalars['Float']['output']>;
  lastPrice_id?: Maybe<Scalars['ObjectId']['output']>;
  lowestMarketValue?: Maybe<Scalars['Float']['output']>;
  lvl0Category?: Maybe<Scalars['String']['output']>;
  lvl0ContentCategory?: Maybe<Scalars['String']['output']>;
  lvl1Category?: Maybe<Scalars['String']['output']>;
  lvl1ContentCategory?: Maybe<Scalars['String']['output']>;
  lvl2Category?: Maybe<Scalars['String']['output']>;
  lvl2ContentCategory?: Maybe<Scalars['String']['output']>;
  lvl3ContentCategory?: Maybe<Scalars['String']['output']>;
  material?: Maybe<Scalars['String']['output']>;
  maxValue?: Maybe<Scalars['Float']['output']>;
  objectID: Scalars['String']['output'];
  pictureFilename?: Maybe<Scalars['String']['output']>;
  predictionFactor?: Maybe<Scalars['Float']['output']>;
  previouslyOverwrittenPrice?: Maybe<Scalars['Float']['output']>;
  previouslyOverwrittenTimestamp?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  productTags: Scalars['String']['output'];
  releaseDate: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ProductExportEdge = {
  __typename?: 'ProductExportEdge';
  cursor: Scalars['String']['output'];
  node: ProductExport;
};

export type ProductExportOpts = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  shouldCreateSlug?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductFilterArgs = {
  _id?: InputMaybe<IdFilter>;
  categoryIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  excludeIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  ids?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductImage = {
  __typename?: 'ProductImage';
  id: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ProductLegacy = {
  __typename?: 'ProductLegacy';
  _id: Scalars['ObjectId']['output'];
  class?: Maybe<Scalars['String']['output']>;
  conditionMaxValues?: Maybe<ConditionMaxMarketValues>;
  contentCategories?: Maybe<ContentCategories>;
  ean?: Maybe<Scalars['String']['output']>;
  gewicht?: Maybe<Scalars['Float']['output']>;
  isInactive?: Maybe<Scalars['Boolean']['output']>;
  isTaxFree?: Maybe<Scalars['Boolean']['output']>;
  itemCategory?: Maybe<ItemCategory>;
  itemCategoryId: Scalars['ObjectId']['output'];
  karat?: Maybe<Scalars['Float']['output']>;
  material?: Maybe<Scalars['String']['output']>;
  maxLoanToValue?: Maybe<Scalars['Float']['output']>;
  maxValue?: Maybe<Scalars['Float']['output']>;
  objectID: Scalars['String']['output'];
  picture?: Maybe<UploadFile>;
  pictureFilename?: Maybe<Scalars['String']['output']>;
  productTags?: Maybe<Array<Scalars['String']['output']>>;
  releaseDate?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ProductLegacyFilterArgs = {
  _id?: InputMaybe<IdFilter>;
  contentCategories?: InputMaybe<ContentCategoriesArgs>;
  excludeInactiveProducts?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  objectID?: InputMaybe<Scalars['String']['input']>;
  objectIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ProductLegacyOpts = {
  filter?: InputMaybe<ProductLegacyFilterArgs>;
  order?: InputMaybe<ProductLegacyOrderArgs>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductLegacyOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  maxLoanToValue?: InputMaybe<EOrderBy>;
  title?: InputMaybe<EOrderBy>;
};

export type ProductOpts = {
  filter?: InputMaybe<ProductFilterArgs>;
  order?: InputMaybe<ProductOrderArgs>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductOrderArgs = {
  name?: InputMaybe<EOrderBy>;
};

export type ProductPrice = {
  mode: EProductPriceMode;
};

export type ProductPriceAdjustment = {
  __typename?: 'ProductPriceAdjustment';
  type: EProductPriceAdjustmentType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['ObjectId']['output']>;
  value: Scalars['Float']['output'];
};

export type ProductPriceAdjustmentArgs = {
  type: EProductPriceAdjustmentType;
  value: Scalars['Float']['input'];
};

export type ProductPriceArgs = {
  basePrice?: InputMaybe<Scalars['Float']['input']>;
  isInvestmentGold?: InputMaybe<Scalars['Boolean']['input']>;
  material?: InputMaybe<EProductMaterial>;
  mode: EProductPriceMode;
  properties?: InputMaybe<Array<ProductVariantPricePropertyArgs>>;
  variants?: InputMaybe<Array<ProductVariantPriceArgs>>;
};

export type ProductPriceCrawledMode = ProductPrice & {
  __typename?: 'ProductPriceCrawledMode';
  mode: EProductPriceMode;
  variants: Array<ProductVariantPrice>;
};

export type ProductPriceManualPreciousMetalMode = ProductPrice & {
  __typename?: 'ProductPriceManualPreciousMetalMode';
  isInvestmentGold: Scalars['Boolean']['output'];
  material: EProductMaterial;
  mode: EProductPriceMode;
  variants: Array<ProductVariantPrice>;
};

export type ProductPriceManualPropertyMode = ProductPrice & {
  __typename?: 'ProductPriceManualPropertyMode';
  basePrice: Scalars['Float']['output'];
  mode: EProductPriceMode;
  properties: Array<ProductVariantPriceProperty>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  variants: Array<ProductVariantPrice>;
};

export type ProductPriceManualVariantMode = ProductPrice & {
  __typename?: 'ProductPriceManualVariantMode';
  mode: EProductPriceMode;
  variants: Array<ProductVariantPrice>;
};

export type ProductPriceUnion = ProductPriceCrawledMode | ProductPriceManualPreciousMetalMode | ProductPriceManualPropertyMode | ProductPriceManualVariantMode;

export type ProductPropertyDefinition = {
  __typename?: 'ProductPropertyDefinition';
  _id: Scalars['ObjectId']['output'];
  categories: Array<ItemCategory>;
  categoryIds: Array<Scalars['ObjectId']['output']>;
  description?: Maybe<TranslatedString>;
  idealoName?: Maybe<Scalars['String']['output']>;
  impactsLook: Scalars['Boolean']['output'];
  info?: Maybe<TranslatedString>;
  isInUse: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  name: TranslatedString;
  showOnWebsite: Scalars['Boolean']['output'];
  sortPriority: Scalars['Float']['output'];
  type: EProductPropertyType;
  valueFormatting?: Maybe<PropertyDefinitionValueFormatting>;
};

export type ProductPropertyDefinitionCreateArgs = {
  categoryIds: Array<Scalars['ObjectId']['input']>;
  description?: InputMaybe<Array<MultipleLanguageTextArgs>>;
  idealoName?: InputMaybe<Scalars['String']['input']>;
  impactsLook: Scalars['Boolean']['input'];
  info?: InputMaybe<Array<MultipleLanguageTextArgs>>;
  key: Scalars['String']['input'];
  name: Array<MultipleLanguageTextArgs>;
  showOnWebsite: Scalars['Boolean']['input'];
  sortPriority: Scalars['Float']['input'];
  type: EProductPropertyType;
  valueFormatting?: InputMaybe<PropertyDefinitionValueFormattingArgs>;
};

export type ProductPropertyDefinitionFilterArgs = {
  _id?: InputMaybe<IdFilter>;
  categoryId?: InputMaybe<Scalars['ObjectId']['input']>;
  ids?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ProductPropertyDefinitionOpts = {
  filter?: InputMaybe<ProductPropertyDefinitionFilterArgs>;
  order?: InputMaybe<ProductPropertyDefinitionOrderArgs>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductPropertyDefinitionOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  createdAt?: InputMaybe<EOrderBy>;
};

export type ProductPropertyDefinitionUpdateArgs = {
  _id: Scalars['ObjectId']['input'];
  categoryIds: Array<Scalars['ObjectId']['input']>;
  description?: InputMaybe<Array<MultipleLanguageTextArgs>>;
  idealoName?: InputMaybe<Scalars['String']['input']>;
  impactsLook: Scalars['Boolean']['input'];
  info?: InputMaybe<Array<MultipleLanguageTextArgs>>;
  key: Scalars['String']['input'];
  name: Array<MultipleLanguageTextArgs>;
  showOnWebsite: Scalars['Boolean']['input'];
  sortPriority: Scalars['Float']['input'];
  type: EProductPropertyType;
  valueFormatting?: InputMaybe<PropertyDefinitionValueFormattingArgs>;
};

export type ProductUpdateArgs = {
  _id: Scalars['ObjectId']['input'];
  availableProperties: Array<ProductAvailablePropertyArgs>;
  categoryId: Scalars['ObjectId']['input'];
  ephemeralImageId?: InputMaybe<Scalars['String']['input']>;
  ephemeralOverviewImageId?: InputMaybe<Scalars['String']['input']>;
  imageId?: InputMaybe<Scalars['String']['input']>;
  imageMode: EProductImageMode;
  isPublished: Scalars['Boolean']['input'];
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  manufacturer: Scalars['String']['input'];
  name: Scalars['String']['input'];
  overviewImageId?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<ProductPriceArgs>;
  variants: Array<ProductVariantArgs>;
};

export type ProductUpdatePriceArgs = {
  _id: Scalars['ObjectId']['input'];
  price: ProductPriceArgs;
};

export type ProductVariant = {
  __typename?: 'ProductVariant';
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ObjectId']['output'];
  image?: Maybe<ProductImage>;
  imageId?: Maybe<Scalars['String']['output']>;
  isPriceValid: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  product: Product;
  propertiesValues: Array<ProductVariantValue>;
  releasedAt: Scalars['DateTime']['output'];
  unconfirmedPropertyIds: Array<Scalars['ObjectId']['output']>;
};


export type ProductVariantImageArgs = {
  size?: InputMaybe<Scalars['String']['input']>;
};

export type ProductVariantArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  ephemeralImageId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  imageId?: InputMaybe<Scalars['String']['input']>;
  propertiesValues: Array<ProductVariantValueArgs>;
  releasedAt: Scalars['DateTime']['input'];
};

export type ProductVariantPrice = {
  __typename?: 'ProductVariantPrice';
  adjustment?: Maybe<ProductPriceAdjustment>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  materialMetric?: Maybe<MaterialMetric>;
  price?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  variantId: Scalars['ObjectId']['output'];
};

export type ProductVariantPriceArgs = {
  adjustment?: InputMaybe<ProductPriceAdjustmentArgs>;
  materialMetric?: InputMaybe<MaterialMetricArgs>;
  price?: InputMaybe<Scalars['Float']['input']>;
  variantId: Scalars['ObjectId']['input'];
};

export type ProductVariantPriceProperty = {
  __typename?: 'ProductVariantPriceProperty';
  adjustment?: Maybe<ProductPriceAdjustment>;
  propertyDefinitionId: Scalars['ObjectId']['output'];
  propertyValue: Scalars['String']['output'];
};

export type ProductVariantPricePropertyArgs = {
  adjustment?: InputMaybe<ProductPriceAdjustmentArgs>;
  propertyDefinitionId: Scalars['ObjectId']['input'];
  propertyValue: Scalars['String']['input'];
};

export type ProductVariantPropertyBooleanValue = ProductVariantPropertyValue & {
  __typename?: 'ProductVariantPropertyBooleanValue';
  propertyDefinition: ProductPropertyDefinition;
  propertyDefinitionId: Scalars['ObjectId']['output'];
  propertyDefinitionType: EProductPropertyType;
  value: AvailablePropertyBooleanOption;
};

export type ProductVariantPropertyNumberValue = ProductVariantPropertyValue & {
  __typename?: 'ProductVariantPropertyNumberValue';
  propertyDefinition: ProductPropertyDefinition;
  propertyDefinitionId: Scalars['ObjectId']['output'];
  propertyDefinitionType: EProductPropertyType;
  value: AvailablePropertyNumberOption;
};

export type ProductVariantPropertyTextValue = ProductVariantPropertyValue & {
  __typename?: 'ProductVariantPropertyTextValue';
  propertyDefinition: ProductPropertyDefinition;
  propertyDefinitionId: Scalars['ObjectId']['output'];
  propertyDefinitionType: EProductPropertyType;
  value: AvailablePropertyTextOption;
};

export type ProductVariantPropertyValue = {
  propertyDefinition: ProductPropertyDefinition;
  propertyDefinitionId: Scalars['ObjectId']['output'];
  propertyDefinitionType: EProductPropertyType;
};

export type ProductVariantValue = ProductVariantPropertyBooleanValue | ProductVariantPropertyNumberValue | ProductVariantPropertyTextValue;

export type ProductVariantValueArgs = {
  propertyDefinitionId: Scalars['ObjectId']['input'];
  value: ProductVariantValueOptionArgs;
};

export type ProductVariantValueOptionArgs = {
  booleanOption?: InputMaybe<Scalars['Boolean']['input']>;
  numberOption?: InputMaybe<Scalars['Float']['input']>;
  textOption?: InputMaybe<AvailablePropertyTextOptionArgs>;
};

export type ProductsFiltersArgs = {
  categoryIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  createdBefore: Scalars['DateTime']['input'];
  isCrawled?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  paginationArgs: ForwardPaginationSkipLimitArgs;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ProductsWithPagination = {
  __typename?: 'ProductsWithPagination';
  count: Scalars['Float']['output'];
  products: Array<ProductLegacy>;
  skip?: Maybe<Scalars['Float']['output']>;
  take?: Maybe<Scalars['Float']['output']>;
};

export type PropertyDefinitionValueFormatting = {
  __typename?: 'PropertyDefinitionValueFormatting';
  orderBy?: Maybe<EOrderBy>;
  suffix?: Maybe<Scalars['String']['output']>;
};

export type PropertyDefinitionValueFormattingArgs = {
  orderBy?: InputMaybe<EOrderBy>;
  suffix?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseData = {
  __typename?: 'PurchaseData';
  receiptLink?: Maybe<FileMetadata>;
  receiptLinkWithoutIdentity?: Maybe<FileMetadata>;
  receiptNumber?: Maybe<Scalars['String']['output']>;
};

export type QualifyLeadArgs = {
  customDealId: Scalars['ObjectId']['input'];
  estimatedPayoutAmount: Scalars['Float']['input'];
};

export type Query = {
  __typename?: 'Query';
  callViviEndpoint: ViviSequenceResponse;
  callViviValuation: ViviValuationResponse;
  carDealCalculation: CarDealCalculation;
  carMakeModels?: Maybe<Array<Scalars['String']['output']>>;
  checkCustomDealItemsPossiblyStolen: Scalars['Boolean']['output'];
  checkDealItemsPossiblyStolen: Scalars['Boolean']['output'];
  customDealCalculation: CustomDealCalculation;
  customDealPawnPurchaseCalculations: CustomDealPawnPurchaseCalculations;
  customerByPersonalData?: Maybe<Customer>;
  dealCalculation: PersistedDealCalculation;
  dealExtensionCalculation?: Maybe<PersistedDealExtensionCalculation>;
  dealPawnDurations: Array<Scalars['Float']['output']>;
  dealPaybackCalculation?: Maybe<PersistedDealPaybackCalculation>;
  findItemCategory: ItemCategory;
  getActiveCompanies: Array<Company>;
  getActiveCustomers: Array<Customer>;
  getActiveEmployees: Array<Employee>;
  getActiveKSVAssetRecords: Array<KsvAssetRecord>;
  getActivePartners: Array<Partner>;
  getActiveStorageFacilities: Array<StorageFacility>;
  getAllShopPages: Array<ShopPage>;
  getAssignedStorageFeesByCategory: Array<FeeDefinition>;
  getAuctionById: Auction;
  getAuctionByItemId?: Maybe<Auction>;
  getAuctionSuggestedDeals: Array<Deal>;
  getAvailableRegions: RegionData;
  getCashBookCashFlows: Array<CashBookCashFlow>;
  getCashBookCashFlowsExport: FileMetadata;
  getCashBookCount?: Maybe<CashBookCount>;
  getCashBookCounts: Array<CashBookCount>;
  getCategoryPageContent: CategoryPageContent;
  getCategoryPages: Array<CategoryPage>;
  getCompanies: Array<Company>;
  getCompany: Company;
  getCompanyByRegion: Company;
  getCompanyFeesEvaluation: CompanyFeesEvaluation;
  getCurrentCustomer: Customer;
  getCurrentEmployee: Employee;
  getCustomDealById: CustomDeal;
  getCustomDealFormByCategory?: Maybe<CustomDealFormQuestionByCategory>;
  getCustomDealFormById: CustomDealForm;
  getCustomDealForms: Array<CustomDealForm>;
  getCustomDeals: CustomDealsWithPagination;
  getCustomDealsCount: Scalars['Float']['output'];
  getCustomRequest: CustomRequest;
  getCustomRequests: Array<CustomRequest>;
  getCustomRequestsFromCustomer: Array<CustomRequest>;
  getCustomer: Customer;
  getCustomerBlacklistById: CustomerBlacklist;
  getDealById: Deal;
  getDealByShippingLabelPageId: Deal;
  getDealItem: DealItem;
  getDeals: Array<Deal>;
  getDealsCount: Scalars['Float']['output'];
  getEmployee: Employee;
  getEnabledPostalCodes: Array<StoreboxEnabledPostalCode>;
  getExistingCustomerBlacklists: Array<CustomerBlacklist>;
  getExistingDealCalculation: DealCalculation;
  getExportEntries: ExportEntriesWithPagination;
  getExportEntry: ExportEntry;
  getFee: FeeDefinition;
  getFees: Array<FeeDefinition>;
  getItemById: Item;
  getItemCategories: Array<ItemCategory>;
  getItemCategory: ItemCategory;
  getItemPage: ItemPage;
  getItemPageContent: ItemPageContent;
  getItemQuestion: ItemQuestion;
  getItemQuestionByTitle?: Maybe<ItemQuestion>;
  getItemQuestions: Array<ItemQuestion>;
  getItemQuestionsByCategory: Array<ItemQuestion>;
  getItemQuestionsByCategoryV2: Array<ItemQuestion>;
  getItems: Array<Item>;
  getItemsCount: Scalars['Float']['output'];
  getKnpDebt: KnpDebt;
  getLatestCashFlowBalanceForDate: Scalars['Float']['output'];
  getLoanToValuesEntries: Array<LoanToValuesEntry>;
  getLoanToValuesEntry: LoanToValuesEntry;
  getMaintenanceWindow?: Maybe<MaintenanceWindow>;
  getMarketingCreditNoteCashBookCashFlowsInTimeRange: Array<CashBookCashFlow>;
  getMaterialPrice: MaterialPrice;
  getMaterialPriceForDate: MaterialPrice;
  getMaterialPrices: Array<MaterialPrice>;
  getMenuPanel: MenuPanel;
  getNearestLocations: Array<LocationDistance>;
  getOpenAuction: DealInOpenAuctionArgs;
  getOtherRevenuesInTimeRange: Array<CashBookCashFlow>;
  getParentCategories: Array<ItemCategory>;
  getPartner: Partner;
  getPawnsInTimeRange: Array<Deal>;
  getPrivateSaleByDealId?: Maybe<PrivateSale>;
  getPrivateSaleById: PrivateSale;
  getPrivateSaleSuggestedDeals: Array<Deal>;
  getProduct: Product;
  getProductBySlug: Product;
  getProductLegacy: ProductLegacy;
  getProductPropertyDefinition: ProductPropertyDefinition;
  getProductPropertyDefinitions: Array<ProductPropertyDefinition>;
  getProducts: Array<Product>;
  getProductsExport: PaginatedProductExport;
  getProductsLegacy: Array<ProductLegacy>;
  getProductsLegacyWithPagination: ProductsWithPagination;
  getPurchasesInTimeRange: Array<Deal>;
  getReady2OrderProductNames: Array<Scalars['String']['output']>;
  getRefurbedProductsByInstanceId: Array<RefurbedProduct>;
  getRefurbedProductsImportStatus: ImportNewProductsResult;
  getResponseTemplate: ResponseTemplate;
  getResponseTemplates: Array<ResponseTemplate>;
  getSearchedCustomers: Array<Customer>;
  getShipmentAddress: OAddress;
  getShippingLabels: Array<ShippingLabel>;
  getShippingProfileList: Array<RefurbedShippingProfile>;
  getShop: Shop;
  getShops: Array<Shop>;
  getShopsActiveOnWebsite: Array<Shop>;
  getShopsForCategories: Array<Shop>;
  getSimilarRefurbedProducts: Array<RefurbedProduct>;
  getStorageFacility: StorageFacility;
  getStorageUnit: StorageUnit;
  getStorageUnits: Array<StorageUnit>;
  getUpcomingPickupSlots: Array<StoreboxPickupSlot>;
  getValorizationEntries: Array<ValorizationEntry>;
  getValorizationEntriesInTimeRange: Array<ValorizationEntry>;
  getValorizationEntry: ValorizationEntry;
  getViviEntryPoint: ViviSequenceResponse;
  getViviSequenceForVin?: Maybe<ViviSequenceResponse>;
  handleCheckLoanDue: Scalars['Boolean']['output'];
  handleCheckLoanDueNotified: Scalars['Boolean']['output'];
  handleCheckValorizationStart: Scalars['Boolean']['output'];
  handleTemporaryNotSellableItems: Scalars['Boolean']['output'];
  isGuestCheckoutRegistrationTokenValid: Scalars['Boolean']['output'];
  itemCalculation: ItemCalculation;
  productVariant: ProductVariant;
  searchAuctions: PaginatedAuctions;
  searchCashBookCashFlows: Array<CashBookCashFlow>;
  searchCustomDeals: PaginatedCustomDeals;
  searchCustomerBlacklists: PaginatedSkipLimitCustomerBlacklist;
  searchCustomers: PaginatedSkipLimitCustomers;
  searchDeals: PaginatedDeals;
  searchItemCategories: Array<ItemCategorySearchResult>;
  searchItems: PaginatedItems;
  searchPrivateSales: PaginatedPrivateSales;
  searchProducts: PaginatedProducts;
  storeboxAvailableForZipCode: Scalars['Boolean']['output'];
  validateInitialPasswordLink: Scalars['Boolean']['output'];
};


export type QueryCallViviEndpointArgs = {
  args: ViviRequestArgs;
};


export type QueryCallViviValuationArgs = {
  args: ViviValuationArgs;
};


export type QueryCarDealCalculationArgs = {
  args: CarDealCalculationArgs;
};


export type QueryCarMakeModelsArgs = {
  args: CarMakeModelsArgs;
};


export type QueryCheckCustomDealItemsPossiblyStolenArgs = {
  customDealId: Scalars['ObjectId']['input'];
};


export type QueryCheckDealItemsPossiblyStolenArgs = {
  dealId: Scalars['ObjectId']['input'];
};


export type QueryCustomDealCalculationArgs = {
  customDealCalculationArgs: CustomDealCalculationArgs;
};


export type QueryCustomDealPawnPurchaseCalculationsArgs = {
  customDealCalculationArgs: CustomDealCalculationArgs;
};


export type QueryCustomerByPersonalDataArgs = {
  args: CustomerByPersonalDataArgs;
};


export type QueryDealCalculationArgs = {
  companyId: Scalars['ObjectId']['input'];
  customDealId?: InputMaybe<Scalars['ObjectId']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dealItemsCalculationArgs: Array<DealItemCalculationArgs>;
  dealType: EDealType;
  dropoffTransportMode: ETransportMode;
  durationInDays: Scalars['Int']['input'];
  isReversedCalculation: Scalars['Boolean']['input'];
  manualFeeDefinitionsArgs: Array<ManualFeeDefinitionArgs>;
  overwrittenPayoutAmount: Scalars['Float']['input'];
  pickupTransportMode: ETransportMode;
  shouldOverwriteManualFees: Scalars['Boolean']['input'];
  shouldOverwritePayoutAmount: Scalars['Boolean']['input'];
};


export type QueryDealExtensionCalculationArgs = {
  args: DealExtensionCalculationArgs;
  dealId: Scalars['ObjectId']['input'];
};


export type QueryDealPawnDurationsArgs = {
  args: DealPawnDurationsArgs;
};


export type QueryDealPaybackCalculationArgs = {
  args: DealPaybackCalculationArgs;
  dealId: Scalars['ObjectId']['input'];
};


export type QueryFindItemCategoryArgs = {
  args: FindItemCategoryArgs;
};


export type QueryGetActiveCompaniesArgs = {
  opts?: InputMaybe<CompanyOpts>;
};


export type QueryGetActiveCustomersArgs = {
  opts?: InputMaybe<CustomerOpts>;
};


export type QueryGetActiveEmployeesArgs = {
  opts?: InputMaybe<EmployeeOpts>;
};


export type QueryGetActiveKsvAssetRecordsArgs = {
  vin: Scalars['String']['input'];
};


export type QueryGetActivePartnersArgs = {
  opts?: InputMaybe<PartnerOpts>;
};


export type QueryGetActiveStorageFacilitiesArgs = {
  opts?: InputMaybe<StorageFacilityOpts>;
};


export type QueryGetAllShopPagesArgs = {
  opts?: InputMaybe<ShopPageOpts>;
};


export type QueryGetAssignedStorageFeesByCategoryArgs = {
  itemCategoryId: Scalars['ObjectId']['input'];
};


export type QueryGetAuctionByIdArgs = {
  auctionId: Scalars['ObjectId']['input'];
};


export type QueryGetAuctionByItemIdArgs = {
  itemId: Scalars['ObjectId']['input'];
};


export type QueryGetAuctionSuggestedDealsArgs = {
  companyId: Scalars['ObjectId']['input'];
};


export type QueryGetCashBookCashFlowsArgs = {
  opts?: InputMaybe<CashBookCashFlowOpts>;
};


export type QueryGetCashBookCashFlowsExportArgs = {
  opts?: InputMaybe<CashBookCashFlowOpts>;
};


export type QueryGetCashBookCountArgs = {
  opts?: InputMaybe<CashBookCountOpts>;
};


export type QueryGetCashBookCountsArgs = {
  opts?: InputMaybe<CashBookCountOpts>;
};


export type QueryGetCategoryPageContentArgs = {
  includeDrafts?: InputMaybe<Scalars['Boolean']['input']>;
  path: Scalars['String']['input'];
};


export type QueryGetCategoryPagesArgs = {
  opts?: InputMaybe<CategoryPageOpts>;
};


export type QueryGetCompaniesArgs = {
  opts?: InputMaybe<CompanyOpts>;
};


export type QueryGetCompanyArgs = {
  companyId: Scalars['ObjectId']['input'];
};


export type QueryGetCompanyByRegionArgs = {
  region: ERegionCode;
};


export type QueryGetCompanyFeesEvaluationArgs = {
  businessUnit: EBusinessUnit;
  companyId: Scalars['ObjectId']['input'];
};


export type QueryGetCustomDealByIdArgs = {
  customDealId: Scalars['ObjectId']['input'];
};


export type QueryGetCustomDealFormByCategoryArgs = {
  categoryId: Scalars['ObjectId']['input'];
};


export type QueryGetCustomDealFormByIdArgs = {
  id: Scalars['ObjectId']['input'];
};


export type QueryGetCustomDealsArgs = {
  opts?: InputMaybe<CustomDealOpts>;
};


export type QueryGetCustomDealsCountArgs = {
  opts?: InputMaybe<CustomDealOpts>;
};


export type QueryGetCustomRequestArgs = {
  customRequestId: Scalars['ObjectId']['input'];
};


export type QueryGetCustomRequestsArgs = {
  opts?: InputMaybe<CustomRequestOpts>;
};


export type QueryGetCustomRequestsFromCustomerArgs = {
  customerId: Scalars['ObjectId']['input'];
};


export type QueryGetCustomerArgs = {
  customerId: Scalars['ObjectId']['input'];
};


export type QueryGetCustomerBlacklistByIdArgs = {
  id: Scalars['ObjectId']['input'];
};


export type QueryGetDealByIdArgs = {
  dealId: Scalars['ObjectId']['input'];
};


export type QueryGetDealByShippingLabelPageIdArgs = {
  shippingLabelPageId: Scalars['String']['input'];
};


export type QueryGetDealItemArgs = {
  dealId: Scalars['ObjectId']['input'];
  itemId: Scalars['ObjectId']['input'];
};


export type QueryGetDealsArgs = {
  opts?: InputMaybe<DealOpts>;
};


export type QueryGetDealsCountArgs = {
  opts?: InputMaybe<DealOpts>;
};


export type QueryGetEmployeeArgs = {
  employeeId: Scalars['ObjectId']['input'];
};


export type QueryGetEnabledPostalCodesArgs = {
  companyId: Scalars['ObjectId']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetExistingCustomerBlacklistsArgs = {
  args: CustomerBlacklistFiltersArgs;
};


export type QueryGetExistingDealCalculationArgs = {
  args: GetExistingDealCalculationArgs;
  dealId: Scalars['ObjectId']['input'];
};


export type QueryGetExportEntriesArgs = {
  opts?: InputMaybe<ExportEntryOpts>;
};


export type QueryGetExportEntryArgs = {
  exportId: Scalars['ObjectId']['input'];
};


export type QueryGetFeeArgs = {
  feeId: Scalars['ObjectId']['input'];
};


export type QueryGetFeesArgs = {
  opts?: InputMaybe<FeeOpts>;
};


export type QueryGetItemByIdArgs = {
  itemId: Scalars['ObjectId']['input'];
};


export type QueryGetItemCategoriesArgs = {
  opts?: InputMaybe<ItemCategoryOpts>;
};


export type QueryGetItemCategoryArgs = {
  itemCategoryId: Scalars['ObjectId']['input'];
};


export type QueryGetItemPageArgs = {
  opts: ItemPageOpts;
};


export type QueryGetItemPageContentArgs = {
  slug: Scalars['String']['input'];
};


export type QueryGetItemQuestionArgs = {
  itemQuestionId: Scalars['ObjectId']['input'];
};


export type QueryGetItemQuestionByTitleArgs = {
  itemCategoryId?: InputMaybe<Scalars['ObjectId']['input']>;
  titleKey: Scalars['String']['input'];
};


export type QueryGetItemQuestionsArgs = {
  opts?: InputMaybe<ItemQuestionOpts>;
};


export type QueryGetItemQuestionsByCategoryArgs = {
  date: Scalars['DateTime']['input'];
  isCustomItem: Scalars['Boolean']['input'];
  itemCategoryId: Scalars['ObjectId']['input'];
  omitDeactivatedQuestionsForNewProducts: Scalars['Boolean']['input'];
};


export type QueryGetItemQuestionsByCategoryV2Args = {
  date: Scalars['DateTime']['input'];
  itemCategoryId: Scalars['ObjectId']['input'];
  omitDeactivatedQuestionsForNewProducts: Scalars['Boolean']['input'];
  omitInternalQuestions?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetItemsArgs = {
  opts?: InputMaybe<ItemOpts>;
};


export type QueryGetItemsCountArgs = {
  opts?: InputMaybe<ItemOpts>;
};


export type QueryGetKnpDebtArgs = {
  opts: KnpOpts;
};


export type QueryGetLatestCashFlowBalanceForDateArgs = {
  filterArgs?: InputMaybe<CashBookCashFlowLatestBalanceFilterArgs>;
};


export type QueryGetLoanToValuesEntriesArgs = {
  opts?: InputMaybe<LoanToValueOpts>;
};


export type QueryGetLoanToValuesEntryArgs = {
  loanToValuesEntryId: Scalars['ObjectId']['input'];
};


export type QueryGetMarketingCreditNoteCashBookCashFlowsInTimeRangeArgs = {
  month: Scalars['Int']['input'];
  shopId?: InputMaybe<Scalars['ObjectId']['input']>;
  year: Scalars['Int']['input'];
};


export type QueryGetMaterialPriceArgs = {
  materialPriceId: Scalars['ObjectId']['input'];
};


export type QueryGetMaterialPriceForDateArgs = {
  date: Scalars['DateTime']['input'];
  material: Scalars['String']['input'];
};


export type QueryGetMaterialPricesArgs = {
  opts?: InputMaybe<MaterialPriceOpts>;
};


export type QueryGetNearestLocationsArgs = {
  lat: Scalars['Float']['input'];
  limit: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};


export type QueryGetOpenAuctionArgs = {
  dealId: Scalars['ObjectId']['input'];
};


export type QueryGetOtherRevenuesInTimeRangeArgs = {
  companyId?: InputMaybe<Scalars['ObjectId']['input']>;
  month: Scalars['Int']['input'];
  shopId?: InputMaybe<Scalars['ObjectId']['input']>;
  year: Scalars['Int']['input'];
};


export type QueryGetParentCategoriesArgs = {
  itemCategoryId: Scalars['ObjectId']['input'];
};


export type QueryGetPartnerArgs = {
  partnerId: Scalars['ObjectId']['input'];
};


export type QueryGetPawnsInTimeRangeArgs = {
  companyId?: InputMaybe<Scalars['ObjectId']['input']>;
  events: Array<EDealStatusType>;
  month: Scalars['Int']['input'];
  shopId?: InputMaybe<Scalars['ObjectId']['input']>;
  year: Scalars['Int']['input'];
};


export type QueryGetPrivateSaleByDealIdArgs = {
  dealId: Scalars['ObjectId']['input'];
};


export type QueryGetPrivateSaleByIdArgs = {
  privateSaleId: Scalars['ObjectId']['input'];
};


export type QueryGetProductArgs = {
  productId: Scalars['ObjectId']['input'];
};


export type QueryGetProductBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryGetProductLegacyArgs = {
  opts: ProductLegacyOpts;
};


export type QueryGetProductPropertyDefinitionArgs = {
  productPropertyDefinitionId: Scalars['ObjectId']['input'];
};


export type QueryGetProductPropertyDefinitionsArgs = {
  opts?: InputMaybe<ProductPropertyDefinitionOpts>;
};


export type QueryGetProductsArgs = {
  opts?: InputMaybe<ProductOpts>;
};


export type QueryGetProductsExportArgs = {
  opts: ProductExportOpts;
};


export type QueryGetProductsLegacyArgs = {
  opts: ProductLegacyOpts;
};


export type QueryGetProductsLegacyWithPaginationArgs = {
  opts: ProductLegacyOpts;
};


export type QueryGetPurchasesInTimeRangeArgs = {
  companyId?: InputMaybe<Scalars['ObjectId']['input']>;
  events: Array<EDealStatusType>;
  month: Scalars['Int']['input'];
  shopId?: InputMaybe<Scalars['ObjectId']['input']>;
  year: Scalars['Int']['input'];
};


export type QueryGetReady2OrderProductNamesArgs = {
  shopId: Scalars['ObjectId']['input'];
};


export type QueryGetRefurbedProductsByInstanceIdArgs = {
  instanceId: Scalars['String']['input'];
};


export type QueryGetResponseTemplateArgs = {
  responseTemplateId: Scalars['ObjectId']['input'];
};


export type QueryGetResponseTemplatesArgs = {
  opts?: InputMaybe<ResponseTemplateOpts>;
};


export type QueryGetSearchedCustomersArgs = {
  opts: CustomerSearchOpts;
};


export type QueryGetShipmentAddressArgs = {
  companyId: Scalars['ObjectId']['input'];
};


export type QueryGetShippingLabelsArgs = {
  args: ShippingLabelFilterArgs;
};


export type QueryGetShopArgs = {
  shopId: Scalars['ObjectId']['input'];
};


export type QueryGetShopsArgs = {
  opts?: InputMaybe<ShopOpts>;
};


export type QueryGetShopsActiveOnWebsiteArgs = {
  opts?: InputMaybe<ShopOpts>;
};


export type QueryGetShopsForCategoriesArgs = {
  itemCategoryIds: Array<Scalars['ObjectId']['input']>;
  opts?: InputMaybe<ShopOpts>;
};


export type QueryGetSimilarRefurbedProductsArgs = {
  opts: RefurbedProductSearchArgs;
};


export type QueryGetStorageFacilityArgs = {
  storageFacilityId: Scalars['ObjectId']['input'];
};


export type QueryGetStorageUnitArgs = {
  storageUnitId: Scalars['ObjectId']['input'];
};


export type QueryGetStorageUnitsArgs = {
  opts?: InputMaybe<StorageUnitOpts>;
};


export type QueryGetUpcomingPickupSlotsArgs = {
  args: StoreboxUpcomingPickupSlotsArgs;
};


export type QueryGetValorizationEntriesArgs = {
  opts?: InputMaybe<ValorizationEntryOpts>;
};


export type QueryGetValorizationEntriesInTimeRangeArgs = {
  companyId?: InputMaybe<Scalars['ObjectId']['input']>;
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type QueryGetValorizationEntryArgs = {
  valorizationEntryId: Scalars['ObjectId']['input'];
};


export type QueryGetViviSequenceForVinArgs = {
  vin: Scalars['String']['input'];
};


export type QueryIsGuestCheckoutRegistrationTokenValidArgs = {
  token: Scalars['String']['input'];
};


export type QueryItemCalculationArgs = {
  algoliaReference?: InputMaybe<Scalars['String']['input']>;
  answers: Array<ItemAnswerArgs>;
  companyId: Scalars['ObjectId']['input'];
  customPayoutAmount?: InputMaybe<Scalars['Float']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  durationInDays: Scalars['Int']['input'];
  existingCurrentMarketValue?: InputMaybe<Scalars['Float']['input']>;
  existingPredictedMarketValue?: InputMaybe<Scalars['Float']['input']>;
  isInvestmentGold?: InputMaybe<Scalars['Boolean']['input']>;
  itemCategoryId: Scalars['ObjectId']['input'];
  material?: InputMaybe<Scalars['String']['input']>;
  skipPredictionTags?: InputMaybe<Scalars['Boolean']['input']>;
  unconfirmedPropertyIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  useOldValuesOfPrediction?: InputMaybe<Scalars['Boolean']['input']>;
  variantId?: InputMaybe<Scalars['ObjectId']['input']>;
  vehicleData?: InputMaybe<VehicleDataArgs>;
};


export type QueryProductVariantArgs = {
  args: GetProductVariantArgs;
};


export type QuerySearchAuctionsArgs = {
  args: AuctionsFiltersArgs;
};


export type QuerySearchCashBookCashFlowsArgs = {
  cashFlowNumber: Scalars['String']['input'];
};


export type QuerySearchCustomDealsArgs = {
  args: CustomDealsFiltersArgs;
};


export type QuerySearchCustomerBlacklistsArgs = {
  args: CustomerBlacklistsFiltersArgs;
};


export type QuerySearchCustomersArgs = {
  args?: InputMaybe<CustomersFiltersArgs>;
};


export type QuerySearchDealsArgs = {
  args: DealsFiltersArgs;
};


export type QuerySearchItemCategoriesArgs = {
  args: ItemCategoryFiltersArgs;
};


export type QuerySearchItemsArgs = {
  args?: InputMaybe<ItemsFiltersArgs>;
};


export type QuerySearchPrivateSalesArgs = {
  args: PrivateSalesFiltersArgs;
};


export type QuerySearchProductsArgs = {
  args: ProductsFiltersArgs;
};


export type QueryStoreboxAvailableForZipCodeArgs = {
  companyId: Scalars['ObjectId']['input'];
  zipCode: Scalars['String']['input'];
};


export type QueryValidateInitialPasswordLinkArgs = {
  token: Scalars['String']['input'];
};

export type QueryFieldFilter = {
  betweenValues?: InputMaybe<NumberFilterBetween>;
  condition?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<StringFilterOptions>;
  path: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type R2OProductMap = {
  __typename?: 'R2OProductMap';
  paymentReference: Scalars['String']['output'];
  productName?: Maybe<Scalars['String']['output']>;
};

export type R2OProductMapArgs = {
  paymentReference: Scalars['String']['input'];
  productName?: InputMaybe<Scalars['String']['input']>;
};

export type RefurbedBuyBox = {
  __typename?: 'RefurbedBuyBox';
  marketCode?: Maybe<ECountry>;
  sitePrice?: Maybe<Scalars['String']['output']>;
  state?: Maybe<ERefurbedBuyBoxState>;
};

export type RefurbedBuyBoxArgs = {
  marketCode?: InputMaybe<ECountry>;
  sitePrice?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<ERefurbedBuyBoxState>;
};

export type RefurbedOffer = {
  __typename?: 'RefurbedOffer';
  bestBuyBox?: Maybe<RefurbedBuyBox>;
  currencyCode?: Maybe<ECurrencyCode>;
  grading?: Maybe<Scalars['String']['output']>;
  instanceId?: Maybe<Scalars['String']['output']>;
  lowestPrice?: Maybe<Scalars['Float']['output']>;
  offeredPrice?: Maybe<Scalars['Float']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  shippingProfileId?: Maybe<Scalars['String']['output']>;
  shippingProfileName?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  stock?: Maybe<Scalars['Float']['output']>;
  taxation?: Maybe<ERefurbedTaxation>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  warranty?: Maybe<Scalars['String']['output']>;
};

export type RefurbedOfferArgs = {
  bestBuyBox?: InputMaybe<RefurbedBuyBoxArgs>;
  currencyCode?: InputMaybe<ECurrencyCode>;
  grading?: InputMaybe<Scalars['String']['input']>;
  instanceId?: InputMaybe<Scalars['String']['input']>;
  lowestPrice?: InputMaybe<Scalars['Float']['input']>;
  offeredPrice?: InputMaybe<Scalars['Float']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  shippingProfileId?: InputMaybe<Scalars['String']['input']>;
  shippingProfileName?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  stock?: InputMaybe<Scalars['Float']['input']>;
  taxation?: InputMaybe<ERefurbedTaxation>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  warranty?: InputMaybe<Scalars['String']['input']>;
};

export type RefurbedProduct = {
  __typename?: 'RefurbedProduct';
  _id: Scalars['ObjectId']['output'];
  instanceId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nameDe: Scalars['String']['output'];
  searchTags: Array<Scalars['String']['output']>;
  storageSizes?: Maybe<MemorySize>;
};

export type RefurbedProductSearchArgs = {
  keyword: Scalars['String']['input'];
};

export type RefurbedShippingProfile = {
  __typename?: 'RefurbedShippingProfile';
  _id: Scalars['ObjectId']['output'];
  destinations: Array<ShippingDestination>;
  name: Scalars['String']['output'];
  profileId: Scalars['String']['output'];
  sourceCountryMarketCode: Scalars['String']['output'];
  sourceCountryMarketName: Scalars['String']['output'];
};

export type RefurbedStaggeredMargin = {
  __typename?: 'RefurbedStaggeredMargin';
  expectedMargin: Scalars['Float']['output'];
  from: Scalars['Float']['output'];
  minimumMargin: Scalars['Float']['output'];
};

export type Region = {
  __typename?: 'Region';
  code: ECountry;
  domain: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type RegionData = {
  __typename?: 'RegionData';
  availableRegions: Array<Region>;
  currentRegion?: Maybe<Region>;
};

export type RejectCustomDealCounterofferArgs = {
  _id: Scalars['ObjectId']['input'];
};

export type ReserveExtensionArgs = {
  dealExtensionCalculationId: Scalars['ObjectId']['input'];
  dealId: Scalars['ObjectId']['input'];
  paymentType: EManualPaymentType;
};

export type ReservePaybackArgs = {
  dealId: Scalars['ObjectId']['input'];
  dealPaybackCalculationId: Scalars['ObjectId']['input'];
  paymentType: EManualPaymentType;
};

export type ReservedPaybackData = {
  __typename?: 'ReservedPaybackData';
  date: Scalars['DateTime']['output'];
  dueAmount: Scalars['Float']['output'];
  feeAmount: Scalars['Float']['output'];
  isExtension: Scalars['Boolean']['output'];
  partialRedemptionAmount: Scalars['Float']['output'];
  paymentType: EManualPaymentType;
};

export type ResponseTemplate = {
  __typename?: 'ResponseTemplate';
  _id: Scalars['ObjectId']['output'];
  closingText: Scalars['String']['output'];
  editableText: Scalars['String']['output'];
  name: Scalars['String']['output'];
  openingText: Scalars['String']['output'];
  subject: Scalars['String']['output'];
};

export type ResponseTemplateCreateArgs = {
  closingText: Scalars['String']['input'];
  editableText: Scalars['String']['input'];
  name: Scalars['String']['input'];
  openingText: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

export type ResponseTemplateFilterArgs = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  ids?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  name?: InputMaybe<StringFilter>;
};

export type ResponseTemplateOpts = {
  filter?: InputMaybe<ResponseTemplateFilterArgs>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ResponseTemplateUpdateArgs = {
  _id: Scalars['ObjectId']['input'];
  closingText?: InputMaybe<Scalars['String']['input']>;
  editableText?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  openingText?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type SalesPartnerDataArgs = {
  baggyluxe?: InputMaybe<SalesPartnerDataBaggyluxeArgs>;
  blitzmobile?: InputMaybe<SalesPartnerDataBlitzMobileArgs>;
  cashy?: InputMaybe<SalesPartnerDataCashyArgs>;
  chrono24?: InputMaybe<SalesPartnerDataChrono24Args>;
  ebay?: InputMaybe<SalesPartnerDataEbayArgs>;
  ebaykleinanzeigen?: InputMaybe<SalesPartnerDataEbayKleinanzeigenArgs>;
  others?: InputMaybe<SalesPartnerDataOthersArgs>;
  rebelle?: InputMaybe<SalesPartnerDataRebelleArgs>;
  refurbed?: InputMaybe<SalesPartnerDataRefurbedArgs>;
  type: ESalesPartnerType;
  vestiairecollective?: InputMaybe<SalesPartnerDataVestiaireCollectiveArgs>;
  willhaben?: InputMaybe<SalesPartnerDataWillhabenArgs>;
};

export type SalesPartnerDataBaggyluxeArgs = {
  saleId?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type SalesPartnerDataBlitzMobileArgs = {
  saleId?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type SalesPartnerDataCashyArgs = {
  _placeHolder?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SalesPartnerDataChrono24Args = {
  saleId?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type SalesPartnerDataEbayArgs = {
  articleDescription?: InputMaybe<Scalars['String']['input']>;
  ebayArticleNumber?: InputMaybe<Scalars['String']['input']>;
  numberOfItems?: InputMaybe<Scalars['Float']['input']>;
  paidDate?: InputMaybe<Scalars['DateTime']['input']>;
  purchaseProcessingDate?: InputMaybe<Scalars['String']['input']>;
  saleProtocolNumber?: InputMaybe<Scalars['Float']['input']>;
  shippingCosts?: InputMaybe<Scalars['Float']['input']>;
  shippingDate?: InputMaybe<Scalars['DateTime']['input']>;
  shippingService?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type SalesPartnerDataEbayKleinanzeigenArgs = {
  kleinanzeigenArticleNumber?: InputMaybe<Scalars['String']['input']>;
  shippingDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SalesPartnerDataOthersArgs = {
  saleId?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type SalesPartnerDataRebelleArgs = {
  saleId?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type SalesPartnerDataRefurbedArgs = {
  ID: Scalars['Float']['input'];
  quantity: Scalars['Float']['input'];
  shippingCosts: Scalars['Float']['input'];
  warranty: Scalars['String']['input'];
};

export type SalesPartnerDataVestiaireCollectiveArgs = {
  refId?: InputMaybe<Scalars['String']['input']>;
};

export type SalesPartnerDataWillhabenArgs = {
  articleDescription?: InputMaybe<Scalars['String']['input']>;
  numberOfItems?: InputMaybe<Scalars['Float']['input']>;
  paidDate?: InputMaybe<Scalars['DateTime']['input']>;
  purchaseProcessingDate?: InputMaybe<Scalars['String']['input']>;
  saleProtocolNumber?: InputMaybe<Scalars['Float']['input']>;
  shippingCosts?: InputMaybe<Scalars['Float']['input']>;
  shippingDate?: InputMaybe<Scalars['DateTime']['input']>;
  shippingService?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
  willhabenArticleNumber?: InputMaybe<Scalars['String']['input']>;
};

export type SaveReady2OrderProductMapsArgs = {
  r2oProductMaps: Array<R2OProductMapArgs>;
  shopId: Scalars['ObjectId']['input'];
};

export type SecondaryPaymentData = {
  __typename?: 'SecondaryPaymentData';
  amount: Scalars['Float']['output'];
  iban?: Maybe<Scalars['String']['output']>;
  paymentType: AnyPaymentType;
  paypalAddress?: Maybe<Scalars['String']['output']>;
  paypalTransactionId?: Maybe<Scalars['String']['output']>;
};

export type SecondaryPaymentDataArgs = {
  amount: Scalars['Float']['input'];
  iban?: InputMaybe<Scalars['String']['input']>;
  paymentType: EManualPaymentType;
  paypalAddress?: InputMaybe<Scalars['String']['input']>;
  paypalTransactionId?: InputMaybe<Scalars['String']['input']>;
  shopId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type SetAuctionItemsBuyersAndGenerateSurchargeCertificateArgs = {
  auctionId: Scalars['ObjectId']['input'];
  employeeId: Scalars['ObjectId']['input'];
  items: Array<AuctionItemArgs>;
};

export type ShippingDestination = {
  __typename?: 'ShippingDestination';
  currencyCode: Scalars['String']['output'];
  isSiteMarket: Scalars['String']['output'];
  marketCode: Scalars['String']['output'];
  marketName: Scalars['String']['output'];
  maxDeliveryDays: Scalars['Float']['output'];
  minDeliveryDays: Scalars['Float']['output'];
  shippingCosts: Scalars['String']['output'];
  siteMarketCurrencyCode: Scalars['String']['output'];
  siteMarketShippingCosts: Scalars['String']['output'];
};

export type ShippingLabel = {
  __typename?: 'ShippingLabel';
  direction: EShippingLabelDirection;
  isCODPayment?: Maybe<Scalars['Boolean']['output']>;
  labelCreateDate: Scalars['DateTime']['output'];
  labelFile: FileMetadata;
  receiverAddress: OAddress;
  receiverCompanyName: Scalars['String']['output'];
  receiverName: Scalars['String']['output'];
  senderAddress: OAddress;
  senderCompanyName: Scalars['String']['output'];
  senderName: Scalars['String']['output'];
  shippingPartner: EStandardShipmentType;
  trackingCode: Scalars['String']['output'];
  trackingLink: Scalars['String']['output'];
};

export type ShippingLabelCreateArgs = {
  additionalInfo?: InputMaybe<AdditionalInfoShippingLabel>;
  customerEmailAddress?: InputMaybe<Scalars['String']['input']>;
  dealId?: InputMaybe<Scalars['ObjectId']['input']>;
  direction: EShippingLabelDirection;
  entity: EShippingLabelEntity;
  isCODPayment?: InputMaybe<Scalars['Boolean']['input']>;
  itemId?: InputMaybe<Scalars['ObjectId']['input']>;
  labelFile?: InputMaybe<FileTusMetadataArgs>;
  /** Either receiverAddress or receiverShopId should be available */
  receiverAddress?: InputMaybe<IAddress>;
  receiverCompanyName?: InputMaybe<Scalars['String']['input']>;
  receiverName: Scalars['String']['input'];
  /** Either receiverAddress or receiverShopId should be available */
  receiverShopId?: InputMaybe<Scalars['ObjectId']['input']>;
  /** Either senderAddress or senderShopId should be available */
  senderAddress?: InputMaybe<IAddress>;
  senderCompanyName?: InputMaybe<Scalars['String']['input']>;
  senderName: Scalars['String']['input'];
  /** Either senderAddress or senderShopId should be available */
  senderShopId?: InputMaybe<Scalars['ObjectId']['input']>;
  shippingLabelFileSource: EShippingLabelFileSource;
  shippingPartner: EStandardShipmentType;
  trackingCode?: InputMaybe<Scalars['String']['input']>;
  trackingLink?: InputMaybe<Scalars['String']['input']>;
};

export type ShippingLabelFilterArgs = {
  dealId?: InputMaybe<Scalars['ObjectId']['input']>;
  itemId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type Shop = {
  __typename?: 'Shop';
  _id: Scalars['ObjectId']['output'];
  address: OAddress;
  cashBoxNames?: Maybe<Array<Scalars['String']['output']>>;
  company: Company;
  companyId: Scalars['ObjectId']['output'];
  disabled?: Maybe<Scalars['Boolean']['output']>;
  disabledAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  googleMapsLink: Scalars['String']['output'];
  hideLocationOnWebsite?: Maybe<Scalars['Boolean']['output']>;
  itemCategories?: Maybe<Array<ItemCategory>>;
  itemCategoryIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
  mainStorageFacility?: Maybe<StorageFacility>;
  mainStorageFacilityId?: Maybe<Scalars['ObjectId']['output']>;
  name: Scalars['String']['output'];
  openingHours: Scalars['String']['output'];
  partnerId?: Maybe<Scalars['ObjectId']['output']>;
  phone: Scalars['String']['output'];
  r2oProductMaps?: Maybe<Array<R2OProductMap>>;
  ready2OrderApiKey?: Maybe<Scalars['String']['output']>;
  ready2OrderApiKeyStored?: Maybe<Scalars['Boolean']['output']>;
  shopPagePath?: Maybe<Scalars['String']['output']>;
  storageFacilities: Array<StorageFacility>;
  storageFacilityIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
  successionShop?: Maybe<Shop>;
  successionShopId?: Maybe<Scalars['ObjectId']['output']>;
};


export type ShopItemCategoriesArgs = {
  opts?: InputMaybe<ItemCategoryOpts>;
};


export type ShopStorageFacilitiesArgs = {
  opts?: InputMaybe<StorageFacilityOpts>;
};

export type ShopFilterArgs = {
  activeOnWebsite?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<IdFilter>;
  disabled?: InputMaybe<BooleanFilter>;
  ids?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  regionCode?: InputMaybe<ERegionCode>;
  storageFacilityIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  successionShopId?: InputMaybe<IdFilter>;
};

export type ShopOpts = {
  filter?: InputMaybe<ShopFilterArgs>;
  order?: InputMaybe<ShopOrderArgs>;
};

export type ShopOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  name?: InputMaybe<EOrderBy>;
};

export type ShopPage = {
  __typename?: 'ShopPage';
  _id: Scalars['ObjectId']['output'];
  country?: Maybe<EStrapiContentCountry>;
  detailedContentComponents: Array<ContentComponent>;
  headerComponents: Array<ContentComponent>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pageTitle?: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
};

export type ShopPageFilterArgs = {
  country?: InputMaybe<EStrapiContentCountry>;
  name?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
};

export type ShopPageOpts = {
  filter?: InputMaybe<ShopPageFilterArgs>;
  order?: InputMaybe<ShopPageOrderArgs>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ShopPageOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
};

export type StandardShippingData = {
  __typename?: 'StandardShippingData';
  address: OAddress;
  sentShippingLabels?: Maybe<Array<ShippingLabel>>;
  shippingType?: Maybe<EStandardShipmentType>;
};

export type StandardShippingDataArgs = {
  address: IAddress;
};

export type StorageFacility = {
  __typename?: 'StorageFacility';
  _id: Scalars['ObjectId']['output'];
  address: OAddress;
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  external: Scalars['Boolean']['output'];
  isDeactivated?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  shopIds: Array<Scalars['ObjectId']['output']>;
  shops: Array<Shop>;
  storageUnitIds: Array<Scalars['ObjectId']['output']>;
  storageUnits: Array<StorageUnit>;
};


export type StorageFacilityShopsArgs = {
  opts?: InputMaybe<ShopOpts>;
};


export type StorageFacilityStorageUnitsArgs = {
  opts?: InputMaybe<StorageUnitOpts>;
};

export type StorageFacilityFilterArgs = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  ids?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  isDeactivated?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  shopIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
};

export type StorageFacilityOpts = {
  filter?: InputMaybe<StorageFacilityFilterArgs>;
  order?: InputMaybe<StorageFacilityOrderArgs>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type StorageFacilityOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  name?: InputMaybe<EOrderBy>;
};

export type StorageStatusFilter = {
  status: EStorageStatus;
  when?: InputMaybe<DateFilter>;
};

export type StorageUnit = {
  __typename?: 'StorageUnit';
  _id: Scalars['ObjectId']['output'];
  capacity?: Maybe<Scalars['Float']['output']>;
  childIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
  childUnits?: Maybe<Array<StorageUnit>>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isSecureLocation: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['ObjectId']['output']>;
  storageFacilityId: Scalars['ObjectId']['output'];
};


export type StorageUnitChildUnitsArgs = {
  opts?: InputMaybe<StorageUnitOpts>;
};

export type StorageUnitFilterArgs = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  ids?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  isDeleted?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
};

export type StorageUnitOpts = {
  filter?: InputMaybe<StorageUnitFilterArgs>;
  order?: InputMaybe<StorageUnitOrderArgs>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type StorageUnitOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  name?: InputMaybe<EOrderBy>;
};

export type StoreboxData = {
  __typename?: 'StoreboxData';
  address: StoreboxPickupAddress;
  bookedAt?: Maybe<Scalars['DateTime']['output']>;
  slot: StoreboxPickupSlot;
};

export type StoreboxDataArgs = {
  address: IStoreboxPickupAddress;
  slot: StoreboxPickupSlotArgs;
};

export type StoreboxEnabledPostalCode = {
  __typename?: 'StoreboxEnabledPostalCode';
  _id: Scalars['ObjectId']['output'];
  companyId: Scalars['ObjectId']['output'];
  country: ECountry;
  postalCode: Scalars['String']['output'];
  postalName: Scalars['String']['output'];
};

export type StoreboxPickupAddress = {
  __typename?: 'StoreboxPickupAddress';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  companyName?: Maybe<Scalars['String']['output']>;
  coordinates?: Maybe<OCoordinates>;
  /** @deprecated Use `countryCode`. */
  country?: Maybe<Scalars['String']['output']>;
  countryCode: ECountry;
  door?: Maybe<Scalars['String']['output']>;
  floor?: Maybe<Scalars['String']['output']>;
  houseNumber: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  queryString?: Maybe<Scalars['String']['output']>;
  stairway?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type StoreboxPickupSlot = {
  __typename?: 'StoreboxPickupSlot';
  end: Scalars['DateTime']['output'];
  start: Scalars['DateTime']['output'];
};

export type StoreboxPickupSlotArgs = {
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
};

export type StoreboxUpcomingPickupSlotsArgs = {
  country: ECountry;
};

export type StoredFeeDefinition = {
  __typename?: 'StoredFeeDefinition';
  amount: Scalars['Float']['output'];
  billingPeriodType: EBillingPeriodType;
  companyId: Scalars['ObjectId']['output'];
  dealTypes: Array<EDealType>;
  feeIntervals?: Maybe<Array<FeeInterval>>;
  feeType: EFeeType;
  intervalSelectedIndex?: Maybe<Scalars['Float']['output']>;
  isActive: Scalars['Boolean']['output'];
  itemQuestionTitle?: Maybe<Scalars['String']['output']>;
  itemQuestionValidAnswer?: Maybe<Scalars['String']['output']>;
  level: EFeeLevel;
  mode: EFeeMode;
  onlyWhenInAuction?: Maybe<Scalars['Boolean']['output']>;
  priority: Scalars['Float']['output'];
  transportMode?: Maybe<ETransportMode>;
  withdrawalFeeIntervals?: Maybe<Array<WithdrawalFeeInterval>>;
};

export type StringFilter = {
  condition?: InputMaybe<EStringFilterConditions>;
  options?: InputMaybe<StringFilterOptions>;
  value: Scalars['String']['input'];
};

export type StringFilterOptions = {
  caseSensitive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  customDealAdded: CustomDeal;
  dealAdded: Deal;
  onlinePaymentSucceeded: Deal;
};

export type SuccessfulPayment = {
  __typename?: 'SuccessfulPayment';
  id: Scalars['String']['output'];
};

export type SurplusPaymentData = {
  __typename?: 'SurplusPaymentData';
  cashBookCashFlowId: Scalars['ObjectId']['output'];
  cashBookLocation: Scalars['String']['output'];
  cashBookType: ECashBookType;
  cashFlowNumber: Scalars['Float']['output'];
  date: Scalars['DateTime']['output'];
  employee: Employee;
  outFlow: Scalars['Float']['output'];
  paymentReference: ECashBookPaymentReference;
};

export type SystemOperation = {
  __typename?: 'SystemOperation';
  name: Scalars['String']['output'];
};

export type TextDefaultCustomDealFormQuestion = BaseCustomDealFormQuestion & {
  __typename?: 'TextDefaultCustomDealFormQuestion';
  _id: Scalars['ObjectId']['output'];
  info: TranslatedString;
  initialTextAnswer?: Maybe<Scalars['String']['output']>;
  label: TranslatedString;
  optional?: Maybe<Scalars['Boolean']['output']>;
  showOnIssuanceCertificate: Scalars['Boolean']['output'];
  showOnSalesBill: Scalars['Boolean']['output'];
  titleKey?: Maybe<ECustomDealFormQuestionTitleKey>;
  type: ECustomDealFormQuestionType;
};

export type TextMultilineCustomDealFormQuestion = BaseCustomDealFormQuestion & {
  __typename?: 'TextMultilineCustomDealFormQuestion';
  _id: Scalars['ObjectId']['output'];
  info: TranslatedString;
  initialMultilineTextAnswer?: Maybe<Scalars['String']['output']>;
  label: TranslatedString;
  optional?: Maybe<Scalars['Boolean']['output']>;
  showOnIssuanceCertificate: Scalars['Boolean']['output'];
  showOnSalesBill: Scalars['Boolean']['output'];
  titleKey?: Maybe<ECustomDealFormQuestionTitleKey>;
  type: ECustomDealFormQuestionType;
};

export type TextOptionsCustomDealFormQuestion = BaseCustomDealFormQuestion & {
  __typename?: 'TextOptionsCustomDealFormQuestion';
  _id: Scalars['ObjectId']['output'];
  allowEnterAnswer: Scalars['Boolean']['output'];
  info: TranslatedString;
  initialOptionTextAnswer?: Maybe<Scalars['String']['output']>;
  label: TranslatedString;
  optional?: Maybe<Scalars['Boolean']['output']>;
  options: Array<CustomDealFormTextOption>;
  showOnIssuanceCertificate: Scalars['Boolean']['output'];
  showOnSalesBill: Scalars['Boolean']['output'];
  titleKey?: Maybe<ECustomDealFormQuestionTitleKey>;
  type: ECustomDealFormQuestionType;
};

export type TimePeriod = {
  __typename?: 'TimePeriod';
  from: Scalars['DateTime']['output'];
  to?: Maybe<Scalars['DateTime']['output']>;
};

export type TranslatedString = {
  __typename?: 'TranslatedString';
  allTranslations: Array<TranslationItem>;
  text: Scalars['String']['output'];
};


export type TranslatedStringTextArgs = {
  languageCode: ELanguageCode;
};

export type TranslationItem = {
  __typename?: 'TranslationItem';
  languageCode: ELanguageCode;
  text: Scalars['String']['output'];
};

export type TransportData = {
  __typename?: 'TransportData';
  premiumShippingData?: Maybe<PremiumShippingData>;
  standardShippingData?: Maybe<StandardShippingData>;
  storeboxData?: Maybe<StoreboxData>;
  transportMode: ETransportMode;
};

export type TransportDataArgs = {
  note?: InputMaybe<Scalars['String']['input']>;
  premiumShippingDataArgs?: InputMaybe<PremiumShippingDataArgs>;
  standardShippingDataArgs?: InputMaybe<StandardShippingDataArgs>;
  storeboxDataArgs?: InputMaybe<StoreboxDataArgs>;
  transportMode: ETransportMode;
};

export type UnzerPaymentArgs = {
  creditcardPaymentData?: InputMaybe<CreditcardPaymentArgs>;
  paymentType: EAutomaticPaymentType;
};

export type UnzerTransaction = {
  __typename?: 'UnzerTransaction';
  paymentId: Scalars['String']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  typeId: Scalars['String']['output'];
};

export type UpdateDealAuctioningSettingsArgs = {
  auctioningAllowed: Scalars['Boolean']['input'];
  dealId: Scalars['ObjectId']['input'];
};

export type UpdateDealItemAnswersArgs = {
  answers: Array<ItemAnswerArgs>;
  itemId: Scalars['ObjectId']['input'];
};

export type UpdateFormAnswerArgs = {
  booleanAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  numberAnswer?: InputMaybe<Scalars['Float']['input']>;
  optionNumberAnswer?: InputMaybe<Scalars['Float']['input']>;
  optionTextAnswer?: InputMaybe<Scalars['String']['input']>;
  textAnswer?: InputMaybe<Scalars['String']['input']>;
  textMultilineAnswer?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateItemNewInternalPriceArgs = {
  itemId: Scalars['ObjectId']['input'];
  price: Scalars['Float']['input'];
};

export type UpdateProduct = {
  _id: Scalars['ObjectId']['input'];
  collectionName?: InputMaybe<Scalars['String']['input']>;
  ean?: InputMaybe<Scalars['String']['input']>;
  gewicht?: InputMaybe<Scalars['Float']['input']>;
  isInactive?: InputMaybe<Scalars['Boolean']['input']>;
  isTaxFree?: InputMaybe<Scalars['Boolean']['input']>;
  karat?: InputMaybe<Scalars['Float']['input']>;
  lastPrice_id?: InputMaybe<Scalars['ObjectId']['input']>;
  lvl0Category?: InputMaybe<Scalars['String']['input']>;
  lvl0ContentCategory?: InputMaybe<Scalars['String']['input']>;
  lvl1Category?: InputMaybe<Scalars['String']['input']>;
  lvl1ContentCategory?: InputMaybe<Scalars['String']['input']>;
  lvl2Category?: InputMaybe<Scalars['String']['input']>;
  lvl2ContentCategory?: InputMaybe<Scalars['String']['input']>;
  lvl3ContentCategory?: InputMaybe<Scalars['String']['input']>;
  material?: InputMaybe<Scalars['String']['input']>;
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  pictureFilename?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  productTags?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVehicleDataArgs = {
  carPriceLastFetched?: InputMaybe<Scalars['DateTime']['input']>;
  has57aGutachten?: InputMaybe<Scalars['Boolean']['input']>;
  has57aGutachtenDue?: InputMaybe<Scalars['DateTime']['input']>;
  hasApprovalCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  hasSaleContract?: InputMaybe<Scalars['Boolean']['input']>;
  hasSecondKey?: InputMaybe<Scalars['Boolean']['input']>;
  hasTypeCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  indicataId?: InputMaybe<Scalars['String']['input']>;
  licensePlate?: InputMaybe<Scalars['String']['input']>;
  spareTireCount?: InputMaybe<Scalars['Float']['input']>;
  vehicleProperties?: InputMaybe<UpdateVehiclePropertiesArgs>;
  vin?: InputMaybe<Scalars['String']['input']>;
  vinLastFetched?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateVehiclePropertiesArgs = {
  body?: InputMaybe<Scalars['String']['input']>;
  engine?: InputMaybe<Scalars['String']['input']>;
  facelift?: InputMaybe<Scalars['String']['input']>;
  fuel?: InputMaybe<Scalars['String']['input']>;
  horsePower?: InputMaybe<Scalars['String']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  odometer?: InputMaybe<Scalars['Float']['input']>;
  regdate?: InputMaybe<Scalars['String']['input']>;
  seats?: InputMaybe<Scalars['String']['input']>;
  transmission?: InputMaybe<Scalars['String']['input']>;
  trim?: InputMaybe<Scalars['String']['input']>;
};

export type UploadFile = {
  __typename?: 'UploadFile';
  _id: Scalars['ObjectId']['output'];
  alternativeText: Scalars['String']['output'];
  caption: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  ext: Scalars['String']['output'];
  formats?: Maybe<UploadFileFormats>;
  hash: Scalars['String']['output'];
  height: Scalars['Int']['output'];
  mime: Scalars['String']['output'];
  name: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  size: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type UploadFileFormat = {
  __typename?: 'UploadFileFormat';
  ext: Scalars['String']['output'];
  hash: Scalars['String']['output'];
  height: Scalars['Int']['output'];
  mime: Scalars['String']['output'];
  path?: Maybe<Scalars['String']['output']>;
  size: Scalars['Float']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type UploadFileFormats = {
  __typename?: 'UploadFileFormats';
  large?: Maybe<UploadFileFormat>;
  medium?: Maybe<UploadFileFormat>;
  product_small?: Maybe<UploadFileFormat>;
  product_thumbnail?: Maybe<UploadFileFormat>;
  small?: Maybe<UploadFileFormat>;
  thumbnail: UploadFileFormat;
};

export type UsedFeeDefinition = {
  __typename?: 'UsedFeeDefinition';
  calculatedFeeDefinitions: Array<CalculatedFeeDefinition>;
  feeWeight: Scalars['Float']['output'];
  itemCategoryId: Scalars['ObjectId']['output'];
  storageLabel?: Maybe<Scalars['String']['output']>;
};

export type UserPermission = {
  __typename?: 'UserPermission';
  _id: Scalars['ObjectId']['output'];
  userPermissions?: Maybe<Array<Scalars['String']['output']>>;
};

export type ValidatePaybackOrExtendDealPersistanceCalculationArgs = {
  dealExtensionCalculationId?: InputMaybe<Scalars['ObjectId']['input']>;
  dealId: Scalars['ObjectId']['input'];
  dealPaybackCalculationId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type ValorizationEntry = {
  __typename?: 'ValorizationEntry';
  _id: Scalars['ObjectId']['output'];
  buyerBillingAddress?: Maybe<BuyerBillingAddress>;
  buyerEmail?: Maybe<Scalars['String']['output']>;
  buyerName?: Maybe<Scalars['String']['output']>;
  buyerPhone?: Maybe<Scalars['String']['output']>;
  buyerShippingAddress?: Maybe<OAddress>;
  canBeFinalized?: Maybe<Scalars['Boolean']['output']>;
  cashFlowId?: Maybe<Scalars['ObjectId']['output']>;
  cashflow: Scalars['Float']['output'];
  companyId: Scalars['ObjectId']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: ValorizationEntryCreator;
  customLabel?: Maybe<Scalars['String']['output']>;
  date: Scalars['DateTime']['output'];
  isItemReturned?: Maybe<Scalars['Boolean']['output']>;
  isTaxFreeTransaction?: Maybe<Scalars['Boolean']['output']>;
  itemsIds: Array<Scalars['ObjectId']['output']>;
  logisticsPartnerData?: Maybe<OLogisticsPartnerData>;
  order?: Maybe<Scalars['Float']['output']>;
  paymentData?: Maybe<PaymentData>;
  relatedBillId?: Maybe<Scalars['ObjectId']['output']>;
  returnReason?: Maybe<EReturnReasons>;
  returnReasonDetails?: Maybe<Scalars['String']['output']>;
  salesPartnerData?: Maybe<OSalesPartnerData>;
  sendBill?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  valorizationBillLink?: Maybe<FileMetadata>;
  valorizationBillNumber?: Maybe<Scalars['String']['output']>;
  valorizationCreditNoteLink?: Maybe<FileMetadata>;
  valorizationCreditNoteNumber?: Maybe<Scalars['String']['output']>;
};

export type ValorizationEntryCreateArgs = {
  buyerBillingAddress?: InputMaybe<BuyerBillingAddressArgs>;
  buyerEmail?: InputMaybe<Scalars['String']['input']>;
  buyerName?: InputMaybe<Scalars['String']['input']>;
  buyerPhone?: InputMaybe<Scalars['String']['input']>;
  buyerShippingAddress?: InputMaybe<IAddress>;
  cashflow: Scalars['Float']['input'];
  customLabel?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['DateTime']['input'];
  descriptionForItemStatus?: InputMaybe<Scalars['String']['input']>;
  isItemReturned?: InputMaybe<Scalars['Boolean']['input']>;
  isTaxFreeTransaction?: InputMaybe<Scalars['Boolean']['input']>;
  itemsIds: Array<Scalars['ObjectId']['input']>;
  logisticsPartnerData?: InputMaybe<LogisticsPartnerDataArgs>;
  order?: InputMaybe<Scalars['Float']['input']>;
  paymentData?: InputMaybe<PaymentDataArgs>;
  relatedBillId?: InputMaybe<Scalars['ObjectId']['input']>;
  returnReason?: InputMaybe<EReturnReasons>;
  returnReasonDetails?: InputMaybe<Scalars['String']['input']>;
  salesPartnerData?: InputMaybe<SalesPartnerDataArgs>;
  sendBill?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Employee | SystemOperation */
export type ValorizationEntryCreator = Employee | SystemOperation;

export type ValorizationEntryFilterArgs = {
  _id?: InputMaybe<IdFilter>;
  buyerName?: InputMaybe<StringFilter>;
  cashflow?: InputMaybe<NumberFilter>;
  date?: InputMaybe<DateFilter>;
  ids?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  itemsIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  valorizationBillNumber?: InputMaybe<StringFilter>;
  valorizationCreditNoteNumber?: InputMaybe<StringFilter>;
};

export type ValorizationEntryOpts = {
  filter?: InputMaybe<ValorizationEntryFilterArgs>;
  order?: InputMaybe<ValorizationEntryOrderArgs>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ValorizationEntryOrderArgs = {
  _id?: InputMaybe<EOrderBy>;
  buyerName?: InputMaybe<EOrderBy>;
  cashflow?: InputMaybe<EOrderBy>;
  date?: InputMaybe<EOrderBy>;
};

export type ValorizationEntryUpdateArgs = {
  _id: Scalars['ObjectId']['input'];
  paymentData?: InputMaybe<PaymentDataArgs>;
};

export type ValorizationHistoryEntry = {
  __typename?: 'ValorizationHistoryEntry';
  _id: Scalars['ObjectId']['output'];
  buyerBillingAddress?: Maybe<BuyerBillingAddress>;
  buyerEmail?: Maybe<Scalars['String']['output']>;
  buyerName?: Maybe<Scalars['String']['output']>;
  buyerPhone?: Maybe<Scalars['String']['output']>;
  buyerShippingAddress?: Maybe<OAddress>;
  canBeFinalized?: Maybe<Scalars['Boolean']['output']>;
  cashFlowId?: Maybe<Scalars['ObjectId']['output']>;
  cashflow: Scalars['Float']['output'];
  companyId: Scalars['ObjectId']['output'];
  costOfGoodsSold: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: ValorizationEntryCreator;
  cumulatedCashflow: Scalars['Float']['output'];
  customLabel?: Maybe<Scalars['String']['output']>;
  date: Scalars['DateTime']['output'];
  deltaDifferenceTax: Scalars['Float']['output'];
  deviation: Scalars['Float']['output'];
  differenceGross: Scalars['Float']['output'];
  differenceNet: Scalars['Float']['output'];
  differenceTax: Scalars['Float']['output'];
  externalSalePriceGross: Scalars['Float']['output'];
  externalSalePriceGrossDeduction: Scalars['Float']['output'];
  externalSalePriceNet: Scalars['Float']['output'];
  externalSalePriceNetDeduction: Scalars['Float']['output'];
  grossProfit: Scalars['Float']['output'];
  isItemReturned?: Maybe<Scalars['Boolean']['output']>;
  isTaxFreeTransaction?: Maybe<Scalars['Boolean']['output']>;
  itemsIds: Array<Scalars['ObjectId']['output']>;
  logisticsPartnerData?: Maybe<OLogisticsPartnerData>;
  order?: Maybe<Scalars['Float']['output']>;
  paymentData?: Maybe<PaymentData>;
  relatedBillId?: Maybe<Scalars['ObjectId']['output']>;
  returnReason?: Maybe<EReturnReasons>;
  returnReasonDetails?: Maybe<Scalars['String']['output']>;
  salesPartnerData?: Maybe<OSalesPartnerData>;
  sendBill?: Maybe<Scalars['Boolean']['output']>;
  taxableAmount: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  valorizationBillLink?: Maybe<FileMetadata>;
  valorizationBillNumber?: Maybe<Scalars['String']['output']>;
  valorizationCreditNoteLink?: Maybe<FileMetadata>;
  valorizationCreditNoteNumber?: Maybe<Scalars['String']['output']>;
  valorizationResult: Scalars['Float']['output'];
};

export type VehicleData = {
  __typename?: 'VehicleData';
  carPriceLastFetched?: Maybe<Scalars['DateTime']['output']>;
  has57aGutachten?: Maybe<Scalars['Boolean']['output']>;
  has57aGutachtenDue?: Maybe<Scalars['DateTime']['output']>;
  hasApprovalCertificate?: Maybe<Scalars['Boolean']['output']>;
  hasSaleContract?: Maybe<Scalars['Boolean']['output']>;
  hasSecondKey?: Maybe<Scalars['Boolean']['output']>;
  hasTypeCertificate?: Maybe<Scalars['Boolean']['output']>;
  indicataId?: Maybe<Scalars['String']['output']>;
  ksvQueryHistories?: Maybe<Array<KsvQueryHistory>>;
  licensePlate?: Maybe<Scalars['String']['output']>;
  spareTireCount?: Maybe<Scalars['Float']['output']>;
  vehicleProperties: VehicleProperties;
  vin?: Maybe<Scalars['String']['output']>;
  vinLastFetched?: Maybe<Scalars['DateTime']['output']>;
};

export type VehicleDataArgs = {
  carPriceLastFetched?: InputMaybe<Scalars['DateTime']['input']>;
  has57aGutachtenDue?: InputMaybe<Scalars['DateTime']['input']>;
  hasSecondKey?: InputMaybe<Scalars['Boolean']['input']>;
  indicataId?: InputMaybe<Scalars['String']['input']>;
  vehicleProperties: VehiclePropertiesArgs;
  vin?: InputMaybe<Scalars['String']['input']>;
  vinLastFetched?: InputMaybe<Scalars['DateTime']['input']>;
};

export type VehicleProperties = {
  __typename?: 'VehicleProperties';
  body?: Maybe<Scalars['String']['output']>;
  engine?: Maybe<Scalars['String']['output']>;
  facelift?: Maybe<Scalars['String']['output']>;
  fuel?: Maybe<Scalars['String']['output']>;
  horsePower?: Maybe<Scalars['String']['output']>;
  make: Scalars['String']['output'];
  model?: Maybe<Scalars['String']['output']>;
  odometer?: Maybe<Scalars['Float']['output']>;
  otherVehicleProperties?: Maybe<Array<OtherCarProperty>>;
  regdate?: Maybe<Scalars['String']['output']>;
  seats?: Maybe<Scalars['String']['output']>;
  transmission?: Maybe<Scalars['String']['output']>;
  trim?: Maybe<Scalars['String']['output']>;
};

export type VehiclePropertiesArgs = {
  body?: InputMaybe<Scalars['String']['input']>;
  engine?: InputMaybe<Scalars['String']['input']>;
  facelift?: InputMaybe<Scalars['String']['input']>;
  fuel?: InputMaybe<Scalars['String']['input']>;
  horsePower?: InputMaybe<Scalars['String']['input']>;
  make: Scalars['String']['input'];
  model?: InputMaybe<Scalars['String']['input']>;
  odometer?: InputMaybe<Scalars['Float']['input']>;
  otherVehicleProperties?: InputMaybe<Array<OtherVehiclePropertiesArgs>>;
  regdate?: InputMaybe<Scalars['String']['input']>;
  seats?: InputMaybe<Scalars['String']['input']>;
  transmission?: InputMaybe<Scalars['String']['input']>;
  trim?: InputMaybe<Scalars['String']['input']>;
};

export type VerifiedActivationEmployee = {
  __typename?: 'VerifiedActivationEmployee';
  email: Scalars['String']['output'];
};

export type VerifyDealArgs = {
  dealId: Scalars['ObjectId']['input'];
  finalMaxPawnDate?: InputMaybe<Scalars['DateTime']['input']>;
  isOnlineExtensionPrevented: Scalars['Boolean']['input'];
  manualFeeDefinitionsArgs: Array<ManualFeeDefinitionArgs>;
  onlineExtensionBanNote?: InputMaybe<Scalars['String']['input']>;
  shopId?: InputMaybe<Scalars['ObjectId']['input']>;
  shouldOverwriteManualFees: Scalars['Boolean']['input'];
};

export type ViviDescription = {
  __typename?: 'ViviDescription';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ViviRequestArgs = {
  href: Scalars['String']['input'];
};

export type ViviSequenceOption = {
  __typename?: 'ViviSequenceOption';
  description: Array<ViviDescription>;
  href: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  rel: Scalars['String']['output'];
  summary: Scalars['String']['output'];
  templated: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

export type ViviSequenceResponse = {
  __typename?: 'ViviSequenceResponse';
  lastStepHref?: Maybe<Scalars['String']['output']>;
  nextStep: Array<ViviSequenceOption>;
  valuation?: Maybe<Scalars['Float']['output']>;
  vehicleProperties: Array<OtherCarProperty>;
};


export type ViviSequenceResponseValuationArgs = {
  odometer?: InputMaybe<Scalars['Int']['input']>;
};

export type ViviValuationArgs = {
  condition?: InputMaybe<Scalars['Float']['input']>;
  href: Scalars['String']['input'];
  odometer?: InputMaybe<Scalars['Float']['input']>;
};

export type ViviValuationResponse = {
  __typename?: 'ViviValuationResponse';
  amount: Scalars['Float']['output'];
  competitiveVehiclesForSale: Scalars['Float']['output'];
  vehicleProperties: Array<OtherCarProperty>;
};

export type ViviVinRequestArgs = {
  condition?: InputMaybe<Scalars['Float']['input']>;
  odometer?: InputMaybe<Scalars['Float']['input']>;
  vin: Scalars['String']['input'];
};

export type VoluntarySelfDeliveryMetadata = {
  __typename?: 'VoluntarySelfDeliveryMetadata';
  appointment?: Maybe<Scalars['DateTime']['output']>;
  notifiedToEmployee?: Maybe<Scalars['Boolean']['output']>;
};

export type WithdrawalFeeInterval = {
  __typename?: 'WithdrawalFeeInterval';
  factor: Scalars['Float']['output'];
  from: Scalars['Float']['output'];
};

export type WithdrawalFeeIntervalArgs = {
  factor: Scalars['Float']['input'];
  from: Scalars['Float']['input'];
};

export type WithdrawnDeal = {
  __typename?: 'WithdrawnDeal';
  deal: Deal;
  dealId: Scalars['ObjectId']['output'];
  paymentType: AnyPaymentType;
  shop: Shop;
  shopId: Scalars['ObjectId']['output'];
  withdrawalDate: Scalars['DateTime']['output'];
  withdrawalReason: Scalars['String']['output'];
};

export type YearlyCompanyCounterEntry = {
  __typename?: 'YearlyCompanyCounterEntry';
  counter: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type GetCurrentCustomerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentCustomerQuery = { __typename?: 'Query', getCurrentCustomer: { __typename?: 'Customer', _id: any, firstname: string, lastname: string, email: string, phone: string, dateOfBirth?: any | null, iban?: string | null, paypalAddress?: string | null, hasAlreadyDeals: boolean, addresses?: Array<{ __typename?: 'OCustomerAddress', countryCode?: ECountry | null, street?: string | null, zipCode?: string | null }> | null } };

export type LoginCustomerMutationVariables = Exact<{
  username: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginCustomerMutation = { __typename?: 'Mutation', loginCustomer: { __typename?: 'Customer', token?: string | null, _id: any, firstname: string, lastname: string, email: string, phone: string, dateOfBirth?: any | null, iban?: string | null, paypalAddress?: string | null, deals: Array<{ __typename?: 'Deal', _id: any }>, addresses?: Array<{ __typename?: 'OCustomerAddress', countryCode?: ECountry | null, street?: string | null, zipCode?: string | null }> | null } };

export type RegisterCustomerMutationVariables = Exact<{
  email: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  password: Scalars['String']['input'];
  dateOfBirth: Scalars['DateTime']['input'];
  phone: Scalars['String']['input'];
  acquiredBy?: InputMaybe<Scalars['String']['input']>;
  registrationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type RegisterCustomerMutation = { __typename?: 'Mutation', registerCustomer: { __typename?: 'Customer', token?: string | null, _id: any, firstname: string, lastname: string, email: string, phone: string, dateOfBirth?: any | null, iban?: string | null, paypalAddress?: string | null } };

export type ResetCustomerPasswordMailMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ResetCustomerPasswordMailMutation = { __typename?: 'Mutation', resetCustomerPasswordMail: boolean };

export type ChangeCustomerPasswordFromTokenMutationVariables = Exact<{
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type ChangeCustomerPasswordFromTokenMutation = { __typename?: 'Mutation', changeCustomerPasswordFromToken: { __typename?: 'Customer', token?: string | null, _id: any, firstname: string, lastname: string, email: string, phone: string, dateOfBirth?: any | null, iban?: string | null, paypalAddress?: string | null } };

export type ValidateInitialPasswordLinkQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type ValidateInitialPasswordLinkQuery = { __typename?: 'Query', validateInitialPasswordLink: boolean };

export type IsGuestCheckoutRegistrationTokenValidQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type IsGuestCheckoutRegistrationTokenValidQuery = { __typename?: 'Query', isGuestCheckoutRegistrationTokenValid: boolean };

export type UploadFileFormatFragmentFragment = { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string };

export type UploadFileFragmentFragment = { __typename?: 'UploadFile', _id: any, name: string, alternativeText: string, caption: string, hash: string, ext: string, mime: string, width: number, height: number, size: number, url: string, provider: string, createdAt: any, updatedAt: any, formats?: { __typename?: 'UploadFileFormats', thumbnail: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string }, small?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, medium?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, large?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, product_thumbnail?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, product_small?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null } | null };

export type FeeFragmentFragment = { __typename?: 'FeeDefinition', _id: any, companyId: any, priority: number, amount: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, mode: EFeeMode, feeType: EFeeType, dealTypes: Array<EDealType>, restrictToCategories?: Array<any> | null, restrictToItemQuestion?: any | null, transportMode?: ETransportMode | null, isActive: boolean, company?: { __typename?: 'Company', name: string } | null, feeIntervals?: Array<{ __typename?: 'FeeInterval', from: number, diffAmount: number, type: EFeeIntervalType }> | null };

export type DealValuesEntryFragmentFragment = { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number };

export type ItemValuesEntryFragmentFragment = { __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null };

export type CalculatedFeeDefinitionFragmentFragment = { __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } };

export type AppliedUsedFeeDefinitionsFragmentFragment = { __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> };

export type DealCalculationFragmentFragment = { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> };

export type PersistedDealExtensionCalculationFragmentFragment = { __typename?: 'PersistedDealExtensionCalculation', dealId: any, dueAmount: number, partialRedemptionAmount: number, overwrittenPartialRedemptionAmount?: number | null, dealExtensionCalculationId: any, itemsExtensionAnswers: Array<{ __typename?: 'ItemExtensionAnswers', storageLabel: string, answers: Array<{ __typename?: 'ItemAnswer', questionId: any, selectedOptionIndex?: number | null, rangeValue?: number | null }> }>, childDealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> }, parentDealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } };

export type PersistedDealPaybackCalculationFragmentFragment = { __typename?: 'PersistedDealPaybackCalculation', dealId: any, dealPaybackCalculationId: any, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } };

export type CarDealCalculationFragmentFragment = { __typename?: 'CarDealCalculation', dealCalculationId: any, date: any, noValuation?: boolean | null, loanToValuesEntryId: any, competitiveVehiclesForSale?: number | null, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> };

export type AddressFragmentFragment = { __typename?: 'OAddress', houseNumber?: string | null, stairway?: string | null, door?: string | null, floor?: string | null, street?: string | null, city?: string | null, state?: string | null, countryCode?: ECountry | null, country?: string | null, zipCode?: string | null, queryString?: string | null, address1?: string | null, address2?: string | null, note?: string | null, name?: string | null, companyName?: string | null, coordinates?: { __typename?: 'OCoordinates', lat: number, lng: number } | null };

export type CustomDealFragmentFragment = { __typename?: 'CustomDeal', _id: any, customDealNumber: number, status?: ECustomDealStatusType | null, createdAt: any, updatedAt: any, durationInDays: number, isPayoutOverwritten?: boolean | null, isReversedFeeCalculation?: boolean | null, dealType: EDealType, overridePayoutAmount: number, availableTransportModes: Array<ETransportMode>, contactData: { __typename?: 'CustomDealContactData', email?: string | null, phone?: string | null }, company: { __typename?: 'Company', _id: any, configuration: { __typename?: 'CompanyConfiguration', minimumPawnDuration: number, gracePeriod: number } }, items: Array<{ __typename?: 'CustomDealItemDataEntry', itemCategoryId: any, title: string, note?: string | null, algoliaReference?: string | null, policeNumber?: string | null, pawnPayoutAmount: number, purchasePayoutAmount: number, overwrittenPawnPayoutAmount?: number | null, overwrittenPurchasePayoutAmount?: number | null, ean?: string | null, material?: string | null, counterofferPayoutAmount?: number | null, foundComparableOffers?: ECustomItemFoundComparableOffers | null, overwrittenItemValue?: number | null, foundOffersEvaluationFactor?: number | null, variantId?: any | null, productVariant?: { __typename?: 'ProductVariant', id: any, isPriceValid: boolean, name: string, image?: { __typename?: 'ProductImage', id: string, url: string } | null, product: { __typename?: 'Product', name: string, category: { __typename?: 'ItemCategory', name: string, parentCategories: Array<{ __typename?: 'ItemCategory', name: string }> } }, propertiesValues: Array<{ __typename?: 'ProductVariantPropertyBooleanValue', propertyDefinitionId: any, propertyDefinition: { __typename?: 'ProductPropertyDefinition', _id: any, type: EProductPropertyType, impactsLook: boolean, showOnWebsite: boolean, key: string, name: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> }, valueFormatting?: { __typename?: 'PropertyDefinitionValueFormatting', suffix?: string | null } | null }, value: { __typename?: 'AvailablePropertyBooleanOption', booleanValue: boolean } } | { __typename?: 'ProductVariantPropertyNumberValue', propertyDefinitionId: any, propertyDefinition: { __typename?: 'ProductPropertyDefinition', _id: any, type: EProductPropertyType, impactsLook: boolean, showOnWebsite: boolean, key: string, name: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> }, valueFormatting?: { __typename?: 'PropertyDefinitionValueFormatting', suffix?: string | null } | null }, value: { __typename?: 'AvailablePropertyNumberOption', numberValue: number } } | { __typename?: 'ProductVariantPropertyTextValue', propertyDefinitionId: any, propertyDefinition: { __typename?: 'ProductPropertyDefinition', _id: any, type: EProductPropertyType, impactsLook: boolean, showOnWebsite: boolean, key: string, name: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> }, valueFormatting?: { __typename?: 'PropertyDefinitionValueFormatting', suffix?: string | null } | null }, value: { __typename?: 'AvailablePropertyTextOption', translation: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> } } }> } | null, priceFindings?: Array<{ __typename?: 'PriceFinding', price?: number | null }> | null, media?: Array<{ __typename?: 'FileMetadata', url: string, contentType?: string | null }> | null, answers?: Array<{ __typename?: 'ItemAnswer', questionId: any, selectedOptionIndex?: number | null, rangeValue?: number | null }> | null, itemPawnValueEntry?: { __typename?: 'ItemValuesEntry', adjustedMarketValue: number, payoutAmount?: number | null } | null, itemPurchaseValueEntry?: { __typename?: 'ItemValuesEntry', adjustedMarketValue: number, payoutAmount?: number | null } | null }>, events: Array<{ __typename?: 'CustomDealEvent', event: ECustomDealStatusType, createdAt: any, timestamp: any }>, pawnCalculation?: { __typename?: 'CustomDealCalculation', payoutAmount: number } | null, purchaseCalculation?: { __typename?: 'CustomDealCalculation', payoutAmount: number } | null };

export type CustomRequestFragmentFragment = { __typename?: 'CustomRequest', _id: any, createdAt: any, updatedAt: any, events: Array<{ __typename?: 'CustomRequestEvent', createdAt: any, event: ECustomRequestEvent, timestamp: any }>, dealData: { __typename?: 'CustomRequestDealData', selected: { __typename?: 'CustomRequestDealDataEntry', durationInDays: number, payoutAmount: number }, verified: { __typename?: 'CustomRequestDealDataEntry', durationInDays: number, payoutAmount: number } }, itemsData: Array<{ __typename?: 'CustomRequestItemData', selected: { __typename?: 'CustomRequestItemDataEntry', title: string, itemCategoryId: any, condition: ECustomRequestCondition, note?: string | null, itemCategory?: { __typename?: 'ItemCategory', _id: any, name: string, parentId?: any | null } | null, media?: Array<{ __typename?: 'FileMetadata', url: string, contentType?: string | null }> | null, itemValuesEntry: { __typename?: 'ItemValuesEntry', adjustedMarketValue: number, loanToValue: number, durationInDays: number, date: any } }, verified: { __typename?: 'CustomRequestItemDataEntry', title: string, itemCategoryId: any, condition: ECustomRequestCondition, note?: string | null, itemCategory?: { __typename?: 'ItemCategory', _id: any, name: string, parentId?: any | null } | null, media?: Array<{ __typename?: 'FileMetadata', url: string, contentType?: string | null }> | null, itemValuesEntry: { __typename?: 'ItemValuesEntry', adjustedMarketValue: number, loanToValue: number, durationInDays: number, date: any } } }> };

export type RegionFragmentFragment = { __typename?: 'Region', name: string, code: ECountry, domain: string };

export type ShopFragmentFragment = { __typename?: 'Shop', _id: any, name: string, phone: string, email: string, googleMapsLink: string, shopPagePath?: string | null, openingHours: string, address: { __typename?: 'OAddress', houseNumber?: string | null, stairway?: string | null, door?: string | null, floor?: string | null, street?: string | null, city?: string | null, state?: string | null, countryCode?: ECountry | null, country?: string | null, zipCode?: string | null, queryString?: string | null, address1?: string | null, address2?: string | null, coordinates?: { __typename?: 'OCoordinates', lat: number, lng: number } | null } };

export type PaymentDataFragmentFragment = { __typename?: 'PaymentData', paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType } };

export type GetCompanyByRegionQueryVariables = Exact<{
  region: ERegionCode;
}>;


export type GetCompanyByRegionQuery = { __typename?: 'Query', getCompanyByRegion: { __typename?: 'Company', _id: any, name: string, uid: string, fibuNumber: string, paypalEmail?: string | null, email?: string | null, supportEmail?: string | null, phoneNumber?: string | null, whatsappNumber?: string | null, website?: string | null, jurisdiction?: string | null, headquarter?: { __typename?: 'OAddress', houseNumber?: string | null, stairway?: string | null, floor?: string | null, door?: string | null, street?: string | null, address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, state?: string | null, country?: string | null, countryCode?: ECountry | null } | null, configuration: { __typename?: 'CompanyConfiguration', minimumPawnDuration: number, gracePeriod: number } } };

export type GetAvailableAndCurrentUserRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableAndCurrentUserRegionsQuery = { __typename?: 'Query', getAvailableRegions: { __typename?: 'RegionData', currentRegion?: { __typename?: 'Region', name: string, code: ECountry, domain: string } | null, availableRegions: Array<{ __typename?: 'Region', name: string, code: ECountry, domain: string }> } };

export type GetMaintenanceWindowQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMaintenanceWindowQuery = { __typename?: 'Query', getMaintenanceWindow?: { __typename?: 'MaintenanceWindow', scheduledStartTime: any, duration: number } | null };

export type CreateShippingLabelByPageIdMutationVariables = Exact<{
  shippingLabelPageId: Scalars['String']['input'];
}>;


export type CreateShippingLabelByPageIdMutation = { __typename?: 'Mutation', createShippingLabelByPageId: { __typename?: 'Deal', pickupData?: { __typename?: 'TransportData', transportMode: ETransportMode, standardShippingData?: { __typename?: 'StandardShippingData', sentShippingLabels?: Array<{ __typename?: 'ShippingLabel', shippingPartner: EStandardShipmentType, labelFile: { __typename?: 'FileMetadata', filename?: string | null } }> | null } | null } | null } };

export type SearchPageProductFragmentFragment = { __typename?: 'Product', _id: any, name: string, slug: string, isPublished: boolean };

export type SearchPageItemCategoryFragmentFragment = { __typename?: 'ItemCategorySearchResult', icon: EItemCategorySearchIcon, matchedKeyword?: string | null, fullSlug: string, text: { __typename?: 'TranslatedString', text: string } };

export type SearchPageQueryQueryVariables = Exact<{
  searchProductArgs: ProductsFiltersArgs;
  searchItemCategoryArgs: ItemCategoryFiltersArgs;
  languageCode: ELanguageCode;
}>;


export type SearchPageQueryQuery = { __typename?: 'Query', searchProducts: { __typename?: 'PaginatedProducts', nodes: Array<{ __typename?: 'Product', _id: any, name: string, slug: string, isPublished: boolean }> }, searchItemCategories: Array<{ __typename?: 'ItemCategorySearchResult', icon: EItemCategorySearchIcon, matchedKeyword?: string | null, fullSlug: string, text: { __typename?: 'TranslatedString', text: string } }> };

export type ProductSelectorMainProductsQueryQueryVariables = Exact<{
  productIds: Array<Scalars['ObjectId']['input']> | Scalars['ObjectId']['input'];
  categoryIds: Array<Scalars['ObjectId']['input']> | Scalars['ObjectId']['input'];
}>;


export type ProductSelectorMainProductsQueryQuery = { __typename?: 'Query', products: Array<{ __typename?: 'Product', _id: any, slug: string, name: string, overviewImage?: { __typename?: 'ProductImage', url: string } | null, image?: { __typename?: 'ProductImage', url: string } | null }>, otherProducts: Array<{ __typename?: 'Product', _id: any }> };

export type ProductSelectorOtherProductsQueryQueryVariables = Exact<{
  opts: ProductOpts;
}>;


export type ProductSelectorOtherProductsQueryQuery = { __typename?: 'Query', products: Array<{ __typename?: 'Product', _id: any, slug: string, name: string, overviewImage?: { __typename?: 'ProductImage', url: string } | null, image?: { __typename?: 'ProductImage', url: string } | null }> };

export type ProductSelectorProducts_ProductsFragmentFragment = { __typename?: 'Product', _id: any, slug: string, name: string, overviewImage?: { __typename?: 'ProductImage', url: string } | null, image?: { __typename?: 'ProductImage', url: string } | null };

export type GetViviEntryPointQueryVariables = Exact<{ [key: string]: never; }>;


export type GetViviEntryPointQuery = { __typename?: 'Query', getViviEntryPoint: { __typename?: 'ViviSequenceResponse', nextStep: Array<{ __typename?: 'ViviSequenceOption', summary: string, name?: string | null, href: string, type: string, rel: string, templated: boolean, description: Array<{ __typename?: 'ViviDescription', value: string, label: string }> }> } };

export type CallViviEndpointQueryVariables = Exact<{
  args: ViviRequestArgs;
}>;


export type CallViviEndpointQuery = { __typename?: 'Query', callViviEndpoint: { __typename?: 'ViviSequenceResponse', lastStepHref?: string | null, nextStep: Array<{ __typename?: 'ViviSequenceOption', summary: string, name?: string | null, href: string, type: string, rel: string, templated: boolean, description: Array<{ __typename?: 'ViviDescription', value: string, label: string }> }> } };

export type CarDealCalculationQueryVariables = Exact<{
  args: CarDealCalculationArgs;
}>;


export type CarDealCalculationQuery = { __typename?: 'Query', carDealCalculation: { __typename?: 'CarDealCalculation', dealCalculationId: any, date: any, noValuation?: boolean | null, loanToValuesEntryId: any, competitiveVehiclesForSale?: number | null, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } };

export type CreateCustomerCallRequestMutationVariables = Exact<{
  args: CustomerCallRequestArgs;
}>;


export type CreateCustomerCallRequestMutation = { __typename?: 'Mutation', createCustomerCallRequest: boolean };

export type CreateCarDealMutationVariables = Exact<{
  dealCalculationId: Scalars['ObjectId']['input'];
  companyId: Scalars['ObjectId']['input'];
  payoutType: EManualPaymentType;
  iban?: InputMaybe<Scalars['String']['input']>;
  paypalAddress?: InputMaybe<Scalars['String']['input']>;
  dealItemsCreateArgs: Array<DealItemCreateArgs> | DealItemCreateArgs;
  pickupData?: InputMaybe<TransportDataArgs>;
  dealPartnerData?: InputMaybe<DealPartnerDataArgs>;
  initialShopId?: InputMaybe<Scalars['ObjectId']['input']>;
  registeredCustomerId?: InputMaybe<Scalars['ObjectId']['input']>;
  guestCustomerDataArgs?: InputMaybe<GuestCustomerDataArgs>;
}>;


export type CreateCarDealMutation = { __typename?: 'Mutation', createCarDeal: { __typename?: 'Deal', _id: any, createdAt: any, updatedAt: any, dealType: EDealType, bookingNumber: number, initialShopId?: any | null, itemsIds: Array<any>, dealFinalValues: { __typename?: 'DealFinalValues', dealType: EDealType, durationInDays: number, shouldOverwritePayoutAmount: boolean, payoutAmount: number, isOnlineExtensionPrevented?: boolean | null }, pawnData?: { __typename?: 'PawnData', pawnNumber?: number | null, billNumber?: string | null, extensionChildId?: any | null, extensionParentId?: any | null, pawnTicketLink?: { __typename?: 'FileMetadata', url: string, contentType?: string | null } | null, billLink?: { __typename?: 'FileMetadata', url: string, contentType?: string | null } | null, paybackData?: { __typename?: 'PaymentData', iban?: string | null, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType } } | null } | null, purchaseData?: { __typename?: 'PurchaseData', receiptNumber?: string | null, receiptLink?: { __typename?: 'FileMetadata', url: string, contentType?: string | null } | null } | null, events: Array<{ __typename: 'DealBookedEvent', createdAt: any, timestamp: any, displayName: string, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | { __typename: 'DealCanceledEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealClosedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealCollectedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealCustomerInCreditEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealCustomerInDebtEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealDeclinedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealDerecognizedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealExcessAmountPayedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealExtensionConfirmedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealItemReceivedIdMissingEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealLoanDueEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealLoanDueNotifiedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealOnSellEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPaybackConfirmedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPayedAndStoredEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPayedShipmentPendingEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPickedUpEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPickedUpUnsuccessfulEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealReviewingEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealSoldExternEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealSoldInternEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealVerifiedEvent', createdAt: any, timestamp: any, displayName: string }>, payoutData: { __typename?: 'PaymentData', iban?: string | null, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType } }, pickupData?: { __typename?: 'TransportData', transportMode: ETransportMode } | null, dropoffData?: { __typename?: 'TransportData', transportMode: ETransportMode } | null, dealPartnerData?: { __typename?: 'ODealPartnerData', type: EDealPartnerType, knp?: { __typename?: 'ODealPartnerDataKnp', fileReferenceNumber: string, debtAmount: number } | null } | null, items: Array<{ __typename?: 'DealItem', _id: any, title: string, itemCategoryId: any, algoliaReference?: string | null, material?: string | null, ean?: string | null, note?: string | null, itemCategory: { __typename?: 'ItemCategory', _id: any, name: string, parentId?: any | null, createdAt: any, updatedAt: any, slug: string, parentCategories: Array<{ __typename?: 'ItemCategory', _id: any }> }, media?: Array<{ __typename?: 'FileMetadata', url: string, contentType?: string | null }> | null, values: { __typename?: 'ItemValues', verified?: { __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, loanToValue: number, payoutAmount?: number | null } | null } }> } };

export type GetCarMakeModelsQueryVariables = Exact<{
  args: CarMakeModelsArgs;
}>;


export type GetCarMakeModelsQuery = { __typename?: 'Query', carMakeModels?: Array<string> | null };

export type GetShopsActiveOnWebsiteQueryVariables = Exact<{
  opts?: InputMaybe<ShopOpts>;
}>;


export type GetShopsActiveOnWebsiteQuery = { __typename?: 'Query', getShopsActiveOnWebsite: Array<{ __typename?: 'Shop', _id: any, name: string, phone: string, email: string, googleMapsLink: string, shopPagePath?: string | null, openingHours: string, address: { __typename?: 'OAddress', houseNumber?: string | null, stairway?: string | null, door?: string | null, floor?: string | null, street?: string | null, city?: string | null, state?: string | null, countryCode?: ECountry | null, country?: string | null, zipCode?: string | null, queryString?: string | null, address1?: string | null, address2?: string | null, coordinates?: { __typename?: 'OCoordinates', lat: number, lng: number } | null } }> };

export type GetShopsForCategoriesQueryVariables = Exact<{
  opts?: InputMaybe<ShopOpts>;
  itemCategoryIds: Array<Scalars['ObjectId']['input']> | Scalars['ObjectId']['input'];
}>;


export type GetShopsForCategoriesQuery = { __typename?: 'Query', getShopsForCategories: Array<{ __typename?: 'Shop', _id: any, name: string, phone: string, email: string, googleMapsLink: string, shopPagePath?: string | null, openingHours: string, address: { __typename?: 'OAddress', houseNumber?: string | null, stairway?: string | null, door?: string | null, floor?: string | null, street?: string | null, city?: string | null, state?: string | null, countryCode?: ECountry | null, country?: string | null, zipCode?: string | null, queryString?: string | null, address1?: string | null, address2?: string | null, coordinates?: { __typename?: 'OCoordinates', lat: number, lng: number } | null } }> };

export type AddDealRatingMutationVariables = Exact<{
  rating: Scalars['Int']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  dealId: Scalars['ObjectId']['input'];
}>;


export type AddDealRatingMutation = { __typename?: 'Mutation', addDealRating: boolean };

export type DealCalculationQueryVariables = Exact<{
  companyId: Scalars['ObjectId']['input'];
  durationInDays: Scalars['Int']['input'];
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dealType: EDealType;
  dealItemsCalculationArgs: Array<DealItemCalculationArgs> | DealItemCalculationArgs;
  pickupTransportMode: ETransportMode;
  dropoffTransportMode: ETransportMode;
  shouldOverwritePayoutAmount: Scalars['Boolean']['input'];
  overwrittenPayoutAmount: Scalars['Float']['input'];
  shouldOverwriteManualFees: Scalars['Boolean']['input'];
  manualFeeDefinitionsArgs: Array<ManualFeeDefinitionArgs> | ManualFeeDefinitionArgs;
  customDealId?: InputMaybe<Scalars['ObjectId']['input']>;
  isReversedCalculation: Scalars['Boolean']['input'];
}>;


export type DealCalculationQuery = { __typename?: 'Query', dealCalculation: { __typename?: 'PersistedDealCalculation', dealCalculationId: any, date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } };

export type CreateDealMutationVariables = Exact<{
  dealCalculationId: Scalars['ObjectId']['input'];
  companyId: Scalars['ObjectId']['input'];
  payoutType: EManualPaymentType;
  iban?: InputMaybe<Scalars['String']['input']>;
  paypalAddress?: InputMaybe<Scalars['String']['input']>;
  dealItemsCreateArgs: Array<DealItemCreateArgs> | DealItemCreateArgs;
  pickupData?: InputMaybe<TransportDataArgs>;
  dealPartnerData?: InputMaybe<DealPartnerDataArgs>;
  customDealId?: InputMaybe<Scalars['ObjectId']['input']>;
  initialShopId?: InputMaybe<Scalars['ObjectId']['input']>;
  registeredCustomerId?: InputMaybe<Scalars['ObjectId']['input']>;
  guestCustomerDataArgs?: InputMaybe<GuestCustomerDataArgs>;
}>;


export type CreateDealMutation = { __typename?: 'Mutation', createDeal: { __typename?: 'Deal', _id: any, createdAt: any, updatedAt: any, dealType: EDealType, bookingNumber: number, initialShopId?: any | null, itemsIds: Array<any>, dealFinalValues: { __typename?: 'DealFinalValues', dealType: EDealType, durationInDays: number, shouldOverwritePayoutAmount: boolean, payoutAmount: number }, pawnData?: { __typename?: 'PawnData', pawnNumber?: number | null, billNumber?: string | null, extensionChildId?: any | null, extensionParentId?: any | null, pawnTicketLink?: { __typename?: 'FileMetadata', url: string, contentType?: string | null } | null, billLink?: { __typename?: 'FileMetadata', url: string, contentType?: string | null } | null, paybackData?: { __typename?: 'PaymentData', iban?: string | null, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType } } | null } | null, purchaseData?: { __typename?: 'PurchaseData', receiptNumber?: string | null, receiptLink?: { __typename?: 'FileMetadata', url: string, contentType?: string | null } | null } | null, events: Array<{ __typename: 'DealBookedEvent', createdAt: any, timestamp: any, displayName: string, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | { __typename: 'DealCanceledEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealClosedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealCollectedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealCustomerInCreditEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealCustomerInDebtEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealDeclinedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealDerecognizedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealExcessAmountPayedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealExtensionConfirmedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealItemReceivedIdMissingEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealLoanDueEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealLoanDueNotifiedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealOnSellEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPaybackConfirmedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPayedAndStoredEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPayedShipmentPendingEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPickedUpEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPickedUpUnsuccessfulEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealReviewingEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealSoldExternEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealSoldInternEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealVerifiedEvent', createdAt: any, timestamp: any, displayName: string }>, payoutData: { __typename?: 'PaymentData', iban?: string | null, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType } }, pickupData?: { __typename?: 'TransportData', transportMode: ETransportMode } | null, dropoffData?: { __typename?: 'TransportData', transportMode: ETransportMode } | null, dealPartnerData?: { __typename?: 'ODealPartnerData', type: EDealPartnerType, knp?: { __typename?: 'ODealPartnerDataKnp', fileReferenceNumber: string, debtAmount: number } | null } | null, items: Array<{ __typename?: 'DealItem', _id: any, title: string, itemCategoryId: any, algoliaReference?: string | null, material?: string | null, ean?: string | null, note?: string | null, itemCategory: { __typename?: 'ItemCategory', _id: any, name: string, parentId?: any | null, createdAt: any, updatedAt: any, slug: string, parentCategories: Array<{ __typename?: 'ItemCategory', _id: any }> }, media?: Array<{ __typename?: 'FileMetadata', url: string, contentType?: string | null }> | null, values: { __typename?: 'ItemValues', verified?: { __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, loanToValue: number, payoutAmount?: number | null } | null } }> } };

export type CreateDealForCustomerMutationVariables = Exact<{
  dealCreateArgs: DealCreateArgs;
  customerEmail: Scalars['String']['input'];
}>;


export type CreateDealForCustomerMutation = { __typename?: 'Mutation', createDealForCustomer: { __typename?: 'Deal', _id: any, createdAt: any, updatedAt: any, dealType: EDealType, bookingNumber: number, initialShopId?: any | null, itemsIds: Array<any>, dealFinalValues: { __typename?: 'DealFinalValues', dealType: EDealType, durationInDays: number, shouldOverwritePayoutAmount: boolean, payoutAmount: number }, pawnData?: { __typename?: 'PawnData', pawnNumber?: number | null, billNumber?: string | null, extensionChildId?: any | null, extensionParentId?: any | null, pawnTicketLink?: { __typename?: 'FileMetadata', url: string, contentType?: string | null } | null, billLink?: { __typename?: 'FileMetadata', url: string, contentType?: string | null } | null, paybackData?: { __typename?: 'PaymentData', iban?: string | null, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType } } | null } | null, purchaseData?: { __typename?: 'PurchaseData', receiptNumber?: string | null, receiptLink?: { __typename?: 'FileMetadata', url: string, contentType?: string | null } | null } | null, events: Array<{ __typename: 'DealBookedEvent', createdAt: any, timestamp: any, displayName: string, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | { __typename: 'DealCanceledEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealClosedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealCollectedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealCustomerInCreditEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealCustomerInDebtEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealDeclinedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealDerecognizedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealExcessAmountPayedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealExtensionConfirmedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealItemReceivedIdMissingEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealLoanDueEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealLoanDueNotifiedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealOnSellEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPaybackConfirmedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPayedAndStoredEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPayedShipmentPendingEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPickedUpEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPickedUpUnsuccessfulEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealReviewingEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealSoldExternEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealSoldInternEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealVerifiedEvent', createdAt: any, timestamp: any, displayName: string }>, payoutData: { __typename?: 'PaymentData', iban?: string | null, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType } }, pickupData?: { __typename?: 'TransportData', transportMode: ETransportMode } | null, dropoffData?: { __typename?: 'TransportData', transportMode: ETransportMode } | null, dealPartnerData?: { __typename?: 'ODealPartnerData', type: EDealPartnerType, knp?: { __typename?: 'ODealPartnerDataKnp', fileReferenceNumber: string, debtAmount: number } | null } | null, items: Array<{ __typename?: 'DealItem', _id: any, title: string, itemCategoryId: any, algoliaReference?: string | null, material?: string | null, ean?: string | null, note?: string | null, itemCategory: { __typename?: 'ItemCategory', _id: any, name: string, parentId?: any | null, createdAt: any, updatedAt: any, slug: string }, media?: Array<{ __typename?: 'FileMetadata', url: string, contentType?: string | null }> | null, values: { __typename?: 'ItemValues', verified?: { __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, loanToValue: number } | null } }> } };

export type GetCurrentCustomerAddressesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentCustomerAddressesQuery = { __typename?: 'Query', getCurrentCustomer: { __typename?: 'Customer', addresses?: Array<{ __typename?: 'OCustomerAddress', street?: string | null, countryCode?: ECountry | null, zipCode?: string | null, houseNumber?: string | null, floor?: string | null, door?: string | null, city?: string | null, state?: string | null, country?: string | null, stairway?: string | null, queryString?: string | null, note?: string | null, isDeliveryAddress?: boolean | null, isBillingAddress?: boolean | null, coordinates?: { __typename?: 'OCoordinates', lat: number, lng: number } | null }> | null } };

export type GetUpcomingPickupSlotsQueryVariables = Exact<{
  args: StoreboxUpcomingPickupSlotsArgs;
}>;


export type GetUpcomingPickupSlotsQuery = { __typename?: 'Query', getUpcomingPickupSlots: Array<{ __typename?: 'StoreboxPickupSlot', start: any, end: any }> };

export type StoreboxAvailableForZipCodeQueryVariables = Exact<{
  zipCode: Scalars['String']['input'];
  companyId: Scalars['ObjectId']['input'];
}>;


export type StoreboxAvailableForZipCodeQuery = { __typename?: 'Query', storeboxAvailableForZipCode: boolean };

export type CreateCustomDealMutationVariables = Exact<{
  customDealCreateArgs: CustomDealCreateArgs;
}>;


export type CreateCustomDealMutation = { __typename?: 'Mutation', createCustomDeal: { __typename?: 'CustomDeal', _id: any, items: Array<{ __typename?: 'CustomDealItemDataEntry', itemCategory: { __typename?: 'ItemCategory', parentCategories: Array<{ __typename?: 'ItemCategory', _id: any }> } }> } };

export type RejectCustomDealCounterofferMutationVariables = Exact<{
  rejectCustomDealCounterofferArgs: RejectCustomDealCounterofferArgs;
}>;


export type RejectCustomDealCounterofferMutation = { __typename?: 'Mutation', rejectCustomDealCounteroffer: { __typename?: 'CustomDeal', _id: any } };

export type GetCustomDealByIdQueryVariables = Exact<{
  customDealId: Scalars['ObjectId']['input'];
}>;


export type GetCustomDealByIdQuery = { __typename?: 'Query', getCustomDealById: { __typename?: 'CustomDeal', _id: any, customDealNumber: number, status?: ECustomDealStatusType | null, createdAt: any, updatedAt: any, durationInDays: number, isPayoutOverwritten?: boolean | null, isReversedFeeCalculation?: boolean | null, dealType: EDealType, overridePayoutAmount: number, availableTransportModes: Array<ETransportMode>, contactData: { __typename?: 'CustomDealContactData', email?: string | null, phone?: string | null }, company: { __typename?: 'Company', _id: any, configuration: { __typename?: 'CompanyConfiguration', minimumPawnDuration: number, gracePeriod: number } }, items: Array<{ __typename?: 'CustomDealItemDataEntry', itemCategoryId: any, title: string, note?: string | null, algoliaReference?: string | null, policeNumber?: string | null, pawnPayoutAmount: number, purchasePayoutAmount: number, overwrittenPawnPayoutAmount?: number | null, overwrittenPurchasePayoutAmount?: number | null, ean?: string | null, material?: string | null, counterofferPayoutAmount?: number | null, foundComparableOffers?: ECustomItemFoundComparableOffers | null, overwrittenItemValue?: number | null, foundOffersEvaluationFactor?: number | null, variantId?: any | null, productVariant?: { __typename?: 'ProductVariant', id: any, isPriceValid: boolean, name: string, image?: { __typename?: 'ProductImage', id: string, url: string } | null, product: { __typename?: 'Product', name: string, category: { __typename?: 'ItemCategory', name: string, parentCategories: Array<{ __typename?: 'ItemCategory', name: string }> } }, propertiesValues: Array<{ __typename?: 'ProductVariantPropertyBooleanValue', propertyDefinitionId: any, propertyDefinition: { __typename?: 'ProductPropertyDefinition', _id: any, type: EProductPropertyType, impactsLook: boolean, showOnWebsite: boolean, key: string, name: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> }, valueFormatting?: { __typename?: 'PropertyDefinitionValueFormatting', suffix?: string | null } | null }, value: { __typename?: 'AvailablePropertyBooleanOption', booleanValue: boolean } } | { __typename?: 'ProductVariantPropertyNumberValue', propertyDefinitionId: any, propertyDefinition: { __typename?: 'ProductPropertyDefinition', _id: any, type: EProductPropertyType, impactsLook: boolean, showOnWebsite: boolean, key: string, name: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> }, valueFormatting?: { __typename?: 'PropertyDefinitionValueFormatting', suffix?: string | null } | null }, value: { __typename?: 'AvailablePropertyNumberOption', numberValue: number } } | { __typename?: 'ProductVariantPropertyTextValue', propertyDefinitionId: any, propertyDefinition: { __typename?: 'ProductPropertyDefinition', _id: any, type: EProductPropertyType, impactsLook: boolean, showOnWebsite: boolean, key: string, name: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> }, valueFormatting?: { __typename?: 'PropertyDefinitionValueFormatting', suffix?: string | null } | null }, value: { __typename?: 'AvailablePropertyTextOption', translation: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> } } }> } | null, priceFindings?: Array<{ __typename?: 'PriceFinding', price?: number | null }> | null, media?: Array<{ __typename?: 'FileMetadata', url: string, contentType?: string | null }> | null, answers?: Array<{ __typename?: 'ItemAnswer', questionId: any, selectedOptionIndex?: number | null, rangeValue?: number | null }> | null, itemPawnValueEntry?: { __typename?: 'ItemValuesEntry', adjustedMarketValue: number, payoutAmount?: number | null } | null, itemPurchaseValueEntry?: { __typename?: 'ItemValuesEntry', adjustedMarketValue: number, payoutAmount?: number | null } | null }>, events: Array<{ __typename?: 'CustomDealEvent', event: ECustomDealStatusType, createdAt: any, timestamp: any }>, pawnCalculation?: { __typename?: 'CustomDealCalculation', payoutAmount: number } | null, purchaseCalculation?: { __typename?: 'CustomDealCalculation', payoutAmount: number } | null } };

export type DealPawnDurationsQueryVariables = Exact<{
  args: DealPawnDurationsArgs;
}>;


export type DealPawnDurationsQuery = { __typename?: 'Query', dealPawnDurations: Array<number> };

export type CustomDealCalculationQueryVariables = Exact<{
  customDealCalculationArgs: CustomDealCalculationArgs;
}>;


export type CustomDealCalculationQuery = { __typename?: 'Query', customDealCalculation: { __typename?: 'CustomDealCalculation', payoutAmount: number, dealType: EDealType, token: string, date: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } };

export type GetCustomDealFormByCategoryQueryVariables = Exact<{
  categoryId: Scalars['ObjectId']['input'];
  languageCode: ELanguageCode;
}>;


export type GetCustomDealFormByCategoryQuery = { __typename?: 'Query', getCustomDealFormByCategory?: { __typename?: 'CustomDealFormQuestionByCategory', isAllowedPurchase: boolean, isUsedForCommissionSale: boolean, questions: Array<{ __typename: 'BooleanCustomDealFormQuestion', _id: any, type: ECustomDealFormQuestionType, titleKey?: ECustomDealFormQuestionTitleKey | null, optional?: boolean | null, showOnIssuanceCertificate: boolean, showOnSalesBill: boolean, initialBooleanAnswer?: boolean | null, label: { __typename?: 'TranslatedString', text: string, allTranslations: Array<{ __typename?: 'TranslationItem', languageCode: ELanguageCode, text: string }> }, info: { __typename?: 'TranslatedString', text: string, allTranslations: Array<{ __typename?: 'TranslationItem', languageCode: ELanguageCode, text: string }> } } | { __typename: 'FileUploadCustomDealFormQuestion', _id: any, type: ECustomDealFormQuestionType, titleKey?: ECustomDealFormQuestionTitleKey | null, optional?: boolean | null, showOnIssuanceCertificate: boolean, showOnSalesBill: boolean, initialFileUploadAnswer?: string | null, label: { __typename?: 'TranslatedString', text: string, allTranslations: Array<{ __typename?: 'TranslationItem', languageCode: ELanguageCode, text: string }> }, info: { __typename?: 'TranslatedString', text: string, allTranslations: Array<{ __typename?: 'TranslationItem', languageCode: ELanguageCode, text: string }> } } | { __typename: 'NumberDefaultCustomDealFormQuestion', _id: any, type: ECustomDealFormQuestionType, titleKey?: ECustomDealFormQuestionTitleKey | null, optional?: boolean | null, showOnIssuanceCertificate: boolean, showOnSalesBill: boolean, initialNumberAnswer?: number | null, label: { __typename?: 'TranslatedString', text: string, allTranslations: Array<{ __typename?: 'TranslationItem', languageCode: ELanguageCode, text: string }> }, info: { __typename?: 'TranslatedString', text: string, allTranslations: Array<{ __typename?: 'TranslationItem', languageCode: ELanguageCode, text: string }> } } | { __typename: 'NumberOptionsCustomDealFormQuestion', _id: any, type: ECustomDealFormQuestionType, titleKey?: ECustomDealFormQuestionTitleKey | null, optional?: boolean | null, showOnIssuanceCertificate: boolean, showOnSalesBill: boolean, initialOptionNumberAnswer?: number | null, allowEnterAnswer: boolean, label: { __typename?: 'TranslatedString', text: string, allTranslations: Array<{ __typename?: 'TranslationItem', languageCode: ELanguageCode, text: string }> }, info: { __typename?: 'TranslatedString', text: string, allTranslations: Array<{ __typename?: 'TranslationItem', languageCode: ELanguageCode, text: string }> }, options: Array<{ __typename?: 'CustomDealFormOption', default: boolean, label: { __typename?: 'TranslatedString', text: string, allTranslations: Array<{ __typename?: 'TranslationItem', languageCode: ELanguageCode, text: string }> } }>, restrictions: Array<{ __typename?: 'CustomDealQuestionNumberRestriction', conditionOperator: ENumberFilterConditions, conditionValue: number, errorMessage: { __typename?: 'TranslatedString', text: string } }> } | { __typename: 'TextDefaultCustomDealFormQuestion', _id: any, type: ECustomDealFormQuestionType, titleKey?: ECustomDealFormQuestionTitleKey | null, optional?: boolean | null, showOnIssuanceCertificate: boolean, showOnSalesBill: boolean, initialTextAnswer?: string | null, label: { __typename?: 'TranslatedString', text: string, allTranslations: Array<{ __typename?: 'TranslationItem', languageCode: ELanguageCode, text: string }> }, info: { __typename?: 'TranslatedString', text: string, allTranslations: Array<{ __typename?: 'TranslationItem', languageCode: ELanguageCode, text: string }> } } | { __typename: 'TextMultilineCustomDealFormQuestion', _id: any, type: ECustomDealFormQuestionType, titleKey?: ECustomDealFormQuestionTitleKey | null, optional?: boolean | null, showOnIssuanceCertificate: boolean, showOnSalesBill: boolean, initialMultilineTextAnswer?: string | null, label: { __typename?: 'TranslatedString', text: string, allTranslations: Array<{ __typename?: 'TranslationItem', languageCode: ELanguageCode, text: string }> }, info: { __typename?: 'TranslatedString', text: string, allTranslations: Array<{ __typename?: 'TranslationItem', languageCode: ELanguageCode, text: string }> } } | { __typename: 'TextOptionsCustomDealFormQuestion', _id: any, type: ECustomDealFormQuestionType, titleKey?: ECustomDealFormQuestionTitleKey | null, optional?: boolean | null, showOnIssuanceCertificate: boolean, showOnSalesBill: boolean, initialOptionTextAnswer?: string | null, allowEnterAnswer: boolean, label: { __typename?: 'TranslatedString', text: string, allTranslations: Array<{ __typename?: 'TranslationItem', languageCode: ELanguageCode, text: string }> }, info: { __typename?: 'TranslatedString', text: string, allTranslations: Array<{ __typename?: 'TranslationItem', languageCode: ELanguageCode, text: string }> }, options: Array<{ __typename?: 'CustomDealFormTextOption', default: boolean, description?: { __typename?: 'TranslatedString', text: string, allTranslations: Array<{ __typename?: 'TranslationItem', languageCode: ELanguageCode, text: string }> } | null, label: { __typename?: 'TranslatedString', text: string, allTranslations: Array<{ __typename?: 'TranslationItem', languageCode: ELanguageCode, text: string }> } }> }> } | null };

export type GetItemCategoriesQueryVariables = Exact<{
  opts?: InputMaybe<ItemCategoryOpts>;
}>;


export type GetItemCategoriesQuery = { __typename?: 'Query', getItemCategories: Array<{ __typename?: 'ItemCategory', _id: any, name: string, parentId?: any | null, createdAt: any, updatedAt: any, slug: string, categoryPageIds?: Array<any> | null, visibleOnDomain: EVisibleOnDomain }> };

export type CategoryPageFragmentFragment = { __typename?: 'CategoryPage', _id: any, fallbackImage?: { __typename?: 'UploadFile', _id: any, name: string, alternativeText: string, caption: string, hash: string, ext: string, mime: string, width: number, height: number, size: number, url: string, provider: string, createdAt: any, updatedAt: any, formats?: { __typename?: 'UploadFileFormats', thumbnail: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string }, small?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, medium?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, large?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, product_thumbnail?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, product_small?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null } | null } | null };

export type ItemQuestionFragmentFragment = { __typename?: 'ItemQuestion', _id: any, order: number, questionType: EQuestionType, valueMode: EQuestionValueMode, titleKey: string, infoKey?: string | null, isInternal?: boolean | null, predictionTag?: EQuestionPredictionTag | null, itemCategoryIds: Array<any>, singleChoiceOptions?: Array<{ __typename?: 'ItemQuestionOption', labelKey: string, infoKey?: string | null, categoryValues?: any | null, conditionValue?: EQuestionConditionValue | null, isDefaultValue?: boolean | null }> | null, rangeData?: { __typename?: 'ItemQuestionRangeData', minValue: number, maxValue: number, defaultValue: number, unitPrice: number, unitKey: string } | null };

export type ProductFragmentFragment = { __typename?: 'ProductLegacy', _id: any, title: string, slug: string, objectID: string, releaseDate?: any | null, maxValue?: number | null, maxLoanToValue?: number | null, itemCategoryId: any, isInactive?: boolean | null, pictureFilename?: string | null, gewicht?: number | null, karat?: number | null, material?: string | null, ean?: string | null, class?: string | null, isTaxFree?: boolean | null, itemCategory?: { __typename?: 'ItemCategory', _id: any, name: string, parentId?: any | null, createdAt: any, updatedAt: any, slug: string, visibleOnDomain: EVisibleOnDomain, availableTransportModes: Array<ETransportMode>, maximumPawnDuration: EMaximumPawnDuration, recursiveMinimumItemValue?: number | null } | null, conditionMaxValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null, contentCategories?: { __typename?: 'ContentCategories', lvl0: string, lvl1?: string | null, lvl2?: string | null, lvl3?: string | null } | null, picture?: { __typename?: 'UploadFile', _id: any, name: string, alternativeText: string, caption: string, hash: string, ext: string, mime: string, width: number, height: number, size: number, url: string, provider: string, createdAt: any, updatedAt: any, formats?: { __typename?: 'UploadFileFormats', thumbnail: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string }, small?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, medium?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, large?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, product_thumbnail?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, product_small?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null } | null } | null };

export type GetCategoryChildPagesContentQueryVariables = Exact<{
  path: Scalars['String']['input'];
  includeDrafts: Scalars['Boolean']['input'];
}>;


export type GetCategoryChildPagesContentQuery = { __typename?: 'Query', getCategoryPageContent: { __typename?: 'CategoryPageContent', availableRegions?: Array<ERegionCode> | null, page: { __typename?: 'CategoryPage', _id: any, isLeaveCategory?: boolean | null, selectorHeading: string }, childPages: Array<{ __typename?: 'CategoryPage', _id: any, path: string, isSpecialPage?: boolean | null, categoryLabel: string, categoryImage?: { __typename?: 'UploadFile', _id: any, name: string, alternativeText: string, caption: string, hash: string, ext: string, mime: string, width: number, height: number, size: number, url: string, provider: string, createdAt: any, updatedAt: any, formats?: { __typename?: 'UploadFileFormats', thumbnail: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string }, small?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, medium?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, large?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, product_thumbnail?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, product_small?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null } | null } | null }> } };

export type GetItemPageContentQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  includeDrafts: Scalars['Boolean']['input'];
  date: Scalars['DateTime']['input'];
  omitInternalQuestions?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetItemPageContentQuery = { __typename?: 'Query', getItemPageContent: { __typename?: 'ItemPageContent', product: { __typename?: 'ProductLegacy', _id: any, title: string, slug: string, objectID: string, releaseDate?: any | null, maxValue?: number | null, maxLoanToValue?: number | null, itemCategoryId: any, isInactive?: boolean | null, pictureFilename?: string | null, gewicht?: number | null, karat?: number | null, material?: string | null, ean?: string | null, class?: string | null, isTaxFree?: boolean | null, itemCategory?: { __typename?: 'ItemCategory', _id: any, name: string, parentId?: any | null, createdAt: any, updatedAt: any, slug: string, visibleOnDomain: EVisibleOnDomain, availableTransportModes: Array<ETransportMode>, maximumPawnDuration: EMaximumPawnDuration, recursiveMinimumItemValue?: number | null } | null, conditionMaxValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null, contentCategories?: { __typename?: 'ContentCategories', lvl0: string, lvl1?: string | null, lvl2?: string | null, lvl3?: string | null } | null, picture?: { __typename?: 'UploadFile', _id: any, name: string, alternativeText: string, caption: string, hash: string, ext: string, mime: string, width: number, height: number, size: number, url: string, provider: string, createdAt: any, updatedAt: any, formats?: { __typename?: 'UploadFileFormats', thumbnail: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string }, small?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, medium?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, large?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, product_thumbnail?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, product_small?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null } | null } | null }, categoryPages: { __typename?: 'CategoryPages', lvl0?: { __typename?: 'CategoryPage', _id: any, fallbackImage?: { __typename?: 'UploadFile', _id: any, name: string, alternativeText: string, caption: string, hash: string, ext: string, mime: string, width: number, height: number, size: number, url: string, provider: string, createdAt: any, updatedAt: any, formats?: { __typename?: 'UploadFileFormats', thumbnail: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string }, small?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, medium?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, large?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, product_thumbnail?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, product_small?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null } | null } | null } | null, lvl1?: { __typename?: 'CategoryPage', _id: any, fallbackImage?: { __typename?: 'UploadFile', _id: any, name: string, alternativeText: string, caption: string, hash: string, ext: string, mime: string, width: number, height: number, size: number, url: string, provider: string, createdAt: any, updatedAt: any, formats?: { __typename?: 'UploadFileFormats', thumbnail: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string }, small?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, medium?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, large?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, product_thumbnail?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, product_small?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null } | null } | null } | null, lvl2?: { __typename?: 'CategoryPage', _id: any, fallbackImage?: { __typename?: 'UploadFile', _id: any, name: string, alternativeText: string, caption: string, hash: string, ext: string, mime: string, width: number, height: number, size: number, url: string, provider: string, createdAt: any, updatedAt: any, formats?: { __typename?: 'UploadFileFormats', thumbnail: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string }, small?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, medium?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, large?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, product_thumbnail?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, product_small?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null } | null } | null } | null, lvl3?: { __typename?: 'CategoryPage', _id: any, fallbackImage?: { __typename?: 'UploadFile', _id: any, name: string, alternativeText: string, caption: string, hash: string, ext: string, mime: string, width: number, height: number, size: number, url: string, provider: string, createdAt: any, updatedAt: any, formats?: { __typename?: 'UploadFileFormats', thumbnail: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string }, small?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, medium?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, large?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, product_thumbnail?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, product_small?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null } | null } | null } | null }, itemQuestions: Array<{ __typename?: 'ItemQuestion', _id: any, order: number, questionType: EQuestionType, valueMode: EQuestionValueMode, titleKey: string, infoKey?: string | null, isInternal?: boolean | null, predictionTag?: EQuestionPredictionTag | null, itemCategoryIds: Array<any>, singleChoiceOptions?: Array<{ __typename?: 'ItemQuestionOption', labelKey: string, infoKey?: string | null, categoryValues?: any | null, conditionValue?: EQuestionConditionValue | null, isDefaultValue?: boolean | null }> | null, rangeData?: { __typename?: 'ItemQuestionRangeData', minValue: number, maxValue: number, defaultValue: number, unitPrice: number, unitKey: string } | null }> } };

export type GetItemQuestionsByCategoryQueryVariables = Exact<{
  itemCategoryId: Scalars['ObjectId']['input'];
  date: Scalars['DateTime']['input'];
  isCustomItem: Scalars['Boolean']['input'];
  omitDeactivatedQuestionsForNewProducts: Scalars['Boolean']['input'];
}>;


export type GetItemQuestionsByCategoryQuery = { __typename?: 'Query', getItemQuestionsByCategory: Array<{ __typename?: 'ItemQuestion', _id: any, order: number, questionType: EQuestionType, valueMode: EQuestionValueMode, titleKey: string, infoKey?: string | null, isInternal?: boolean | null, predictionTag?: EQuestionPredictionTag | null, itemCategoryIds: Array<any>, singleChoiceOptions?: Array<{ __typename?: 'ItemQuestionOption', labelKey: string, infoKey?: string | null, categoryValues?: any | null, conditionValue?: EQuestionConditionValue | null, isDefaultValue?: boolean | null }> | null, rangeData?: { __typename?: 'ItemQuestionRangeData', minValue: number, maxValue: number, defaultValue: number, unitPrice: number, unitKey: string } | null }> };

export type GetProductsLegacyWithPaginationQueryVariables = Exact<{
  opts: ProductLegacyOpts;
}>;


export type GetProductsLegacyWithPaginationQuery = { __typename?: 'Query', getProductsLegacyWithPagination: { __typename?: 'ProductsWithPagination', count: number, take?: number | null, skip?: number | null, products: Array<{ __typename?: 'ProductLegacy', _id: any, title: string, slug: string, objectID: string, releaseDate?: any | null, maxValue?: number | null, maxLoanToValue?: number | null, itemCategoryId: any, isInactive?: boolean | null, pictureFilename?: string | null, gewicht?: number | null, karat?: number | null, material?: string | null, ean?: string | null, class?: string | null, isTaxFree?: boolean | null, itemCategory?: { __typename?: 'ItemCategory', _id: any, name: string, parentId?: any | null, createdAt: any, updatedAt: any, slug: string, visibleOnDomain: EVisibleOnDomain, availableTransportModes: Array<ETransportMode>, maximumPawnDuration: EMaximumPawnDuration, recursiveMinimumItemValue?: number | null } | null, conditionMaxValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null, contentCategories?: { __typename?: 'ContentCategories', lvl0: string, lvl1?: string | null, lvl2?: string | null, lvl3?: string | null } | null, picture?: { __typename?: 'UploadFile', _id: any, name: string, alternativeText: string, caption: string, hash: string, ext: string, mime: string, width: number, height: number, size: number, url: string, provider: string, createdAt: any, updatedAt: any, formats?: { __typename?: 'UploadFileFormats', thumbnail: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string }, small?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, medium?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, large?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, product_thumbnail?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, product_small?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null } | null } | null }> } };

export type GetParentCategoriesQueryVariables = Exact<{
  itemCategoryId: Scalars['ObjectId']['input'];
}>;


export type GetParentCategoriesQuery = { __typename?: 'Query', getParentCategories: Array<{ __typename?: 'ItemCategory', _id: any, name: string, parentId?: any | null, createdAt: any, updatedAt: any, slug: string, visibleOnDomain: EVisibleOnDomain }> };

type AvailablePropertiesFragment_ProductAvailableBooleanProperty_Fragment = { __typename?: 'ProductAvailableBooleanProperty', propertyDefinitionId: any, propertyDefinitionType: EProductPropertyType, propertyDefinition: { __typename?: 'ProductPropertyDefinition', _id: any, type: EProductPropertyType, impactsLook: boolean, showOnWebsite: boolean, key: string, description?: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> } | null, name: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> } } };

type AvailablePropertiesFragment_ProductAvailableNumberProperty_Fragment = { __typename?: 'ProductAvailableNumberProperty', propertyDefinitionId: any, propertyDefinitionType: EProductPropertyType, propertyDefinition: { __typename?: 'ProductPropertyDefinition', _id: any, type: EProductPropertyType, impactsLook: boolean, showOnWebsite: boolean, key: string, description?: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> } | null, name: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> }, valueFormatting?: { __typename?: 'PropertyDefinitionValueFormatting', suffix?: string | null, orderBy?: EOrderBy | null } | null }, values: Array<{ __typename?: 'AvailablePropertyNumberOption', numberValue: number }> };

type AvailablePropertiesFragment_ProductAvailableTextProperty_Fragment = { __typename?: 'ProductAvailableTextProperty', propertyDefinitionId: any, propertyDefinitionType: EProductPropertyType, propertyDefinition: { __typename?: 'ProductPropertyDefinition', _id: any, type: EProductPropertyType, impactsLook: boolean, showOnWebsite: boolean, key: string, description?: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> } | null, name: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> }, valueFormatting?: { __typename?: 'PropertyDefinitionValueFormatting', suffix?: string | null, orderBy?: EOrderBy | null } | null }, values: Array<{ __typename?: 'AvailablePropertyTextOption', id: any, translation: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> } }> };

export type AvailablePropertiesFragmentFragment = AvailablePropertiesFragment_ProductAvailableBooleanProperty_Fragment | AvailablePropertiesFragment_ProductAvailableNumberProperty_Fragment | AvailablePropertiesFragment_ProductAvailableTextProperty_Fragment;

export type VariantsFragmentFragment = { __typename?: 'ProductVariant', id: any, isPriceValid: boolean, name: string, image?: { __typename?: 'ProductImage', id: string, url: string } | null, product: { __typename?: 'Product', name: string, category: { __typename?: 'ItemCategory', name: string, parentCategories: Array<{ __typename?: 'ItemCategory', name: string }> } }, propertiesValues: Array<{ __typename?: 'ProductVariantPropertyBooleanValue', propertyDefinitionId: any, propertyDefinition: { __typename?: 'ProductPropertyDefinition', _id: any, type: EProductPropertyType, impactsLook: boolean, showOnWebsite: boolean, key: string, name: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> }, valueFormatting?: { __typename?: 'PropertyDefinitionValueFormatting', suffix?: string | null } | null }, value: { __typename?: 'AvailablePropertyBooleanOption', booleanValue: boolean } } | { __typename?: 'ProductVariantPropertyNumberValue', propertyDefinitionId: any, propertyDefinition: { __typename?: 'ProductPropertyDefinition', _id: any, type: EProductPropertyType, impactsLook: boolean, showOnWebsite: boolean, key: string, name: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> }, valueFormatting?: { __typename?: 'PropertyDefinitionValueFormatting', suffix?: string | null } | null }, value: { __typename?: 'AvailablePropertyNumberOption', numberValue: number } } | { __typename?: 'ProductVariantPropertyTextValue', propertyDefinitionId: any, propertyDefinition: { __typename?: 'ProductPropertyDefinition', _id: any, type: EProductPropertyType, impactsLook: boolean, showOnWebsite: boolean, key: string, name: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> }, valueFormatting?: { __typename?: 'PropertyDefinitionValueFormatting', suffix?: string | null } | null }, value: { __typename?: 'AvailablePropertyTextOption', translation: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> } } }> };

export type GetProductBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  date: Scalars['DateTime']['input'];
}>;


export type GetProductBySlugQuery = { __typename?: 'Query', getProductBySlug: { __typename?: 'Product', _id: any, categoryId: any, slug: string, name: string, manufacturer: string, imageMode: EProductImageMode, imageId?: string | null, category: { __typename?: 'ItemCategory', _id: any, name: string, parentId?: any | null, algoliaCategorySlug?: string | null, createdAt: any, updatedAt: any, slug: string, visibleOnDomain: EVisibleOnDomain, availableTransportModes: Array<ETransportMode>, maximumPawnDuration: EMaximumPawnDuration, recursiveMinimumItemValue?: number | null, parentCategories: Array<{ __typename?: 'ItemCategory', _id: any, name: string, parentId?: any | null, slug: string }> }, image?: { __typename?: 'ProductImage', id: string, url: string } | null, itemQuestions: Array<{ __typename?: 'ItemQuestion', _id: any, order: number, questionType: EQuestionType, valueMode: EQuestionValueMode, titleKey: string, infoKey?: string | null, isInternal?: boolean | null, predictionTag?: EQuestionPredictionTag | null, itemCategoryIds: Array<any>, singleChoiceOptions?: Array<{ __typename?: 'ItemQuestionOption', labelKey: string, infoKey?: string | null, categoryValues?: any | null, conditionValue?: EQuestionConditionValue | null, isDefaultValue?: boolean | null }> | null, rangeData?: { __typename?: 'ItemQuestionRangeData', minValue: number, maxValue: number, defaultValue: number, unitPrice: number, unitKey: string } | null }>, availableProperties?: Array<{ __typename?: 'ProductAvailableBooleanProperty', propertyDefinitionId: any, propertyDefinitionType: EProductPropertyType, propertyDefinition: { __typename?: 'ProductPropertyDefinition', _id: any, type: EProductPropertyType, impactsLook: boolean, showOnWebsite: boolean, key: string, description?: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> } | null, name: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> } } } | { __typename?: 'ProductAvailableNumberProperty', propertyDefinitionId: any, propertyDefinitionType: EProductPropertyType, propertyDefinition: { __typename?: 'ProductPropertyDefinition', _id: any, type: EProductPropertyType, impactsLook: boolean, showOnWebsite: boolean, key: string, description?: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> } | null, name: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> }, valueFormatting?: { __typename?: 'PropertyDefinitionValueFormatting', suffix?: string | null, orderBy?: EOrderBy | null } | null }, values: Array<{ __typename?: 'AvailablePropertyNumberOption', numberValue: number }> } | { __typename?: 'ProductAvailableTextProperty', propertyDefinitionId: any, propertyDefinitionType: EProductPropertyType, propertyDefinition: { __typename?: 'ProductPropertyDefinition', _id: any, type: EProductPropertyType, impactsLook: boolean, showOnWebsite: boolean, key: string, description?: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> } | null, name: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> }, valueFormatting?: { __typename?: 'PropertyDefinitionValueFormatting', suffix?: string | null, orderBy?: EOrderBy | null } | null }, values: Array<{ __typename?: 'AvailablePropertyTextOption', id: any, translation: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> } }> }> | null, variants: Array<{ __typename?: 'ProductVariant', id: any, isPriceValid: boolean, name: string, image?: { __typename?: 'ProductImage', id: string, url: string } | null, product: { __typename?: 'Product', name: string, category: { __typename?: 'ItemCategory', name: string, parentCategories: Array<{ __typename?: 'ItemCategory', name: string }> } }, propertiesValues: Array<{ __typename?: 'ProductVariantPropertyBooleanValue', propertyDefinitionId: any, propertyDefinition: { __typename?: 'ProductPropertyDefinition', _id: any, type: EProductPropertyType, impactsLook: boolean, showOnWebsite: boolean, key: string, name: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> }, valueFormatting?: { __typename?: 'PropertyDefinitionValueFormatting', suffix?: string | null } | null }, value: { __typename?: 'AvailablePropertyBooleanOption', booleanValue: boolean } } | { __typename?: 'ProductVariantPropertyNumberValue', propertyDefinitionId: any, propertyDefinition: { __typename?: 'ProductPropertyDefinition', _id: any, type: EProductPropertyType, impactsLook: boolean, showOnWebsite: boolean, key: string, name: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> }, valueFormatting?: { __typename?: 'PropertyDefinitionValueFormatting', suffix?: string | null } | null }, value: { __typename?: 'AvailablePropertyNumberOption', numberValue: number } } | { __typename?: 'ProductVariantPropertyTextValue', propertyDefinitionId: any, propertyDefinition: { __typename?: 'ProductPropertyDefinition', _id: any, type: EProductPropertyType, impactsLook: boolean, showOnWebsite: boolean, key: string, name: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> }, valueFormatting?: { __typename?: 'PropertyDefinitionValueFormatting', suffix?: string | null } | null }, value: { __typename?: 'AvailablePropertyTextOption', translation: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> } } }> }>, price?: { __typename?: 'ProductPriceCrawledMode', mode: EProductPriceMode, variants: Array<{ __typename?: 'ProductVariantPrice', variantId: any, price?: number | null, createdAt?: any | null, updatedAt?: any | null, adjustment?: { __typename?: 'ProductPriceAdjustment', value: number, type: EProductPriceAdjustmentType, updatedAt?: any | null } | null }> } | { __typename?: 'ProductPriceManualPreciousMetalMode', mode: EProductPriceMode, material: EProductMaterial, isInvestmentGold: boolean, variants: Array<{ __typename?: 'ProductVariantPrice', variantId: any, price?: number | null, materialMetric?: { __typename?: 'MaterialMetric', alloy: number, weight: number } | null }> } | { __typename?: 'ProductPriceManualPropertyMode', mode: EProductPriceMode, basePrice: number, properties: Array<{ __typename?: 'ProductVariantPriceProperty', propertyDefinitionId: any, propertyValue: string, adjustment?: { __typename?: 'ProductPriceAdjustment', value: number, type: EProductPriceAdjustmentType } | null }> } | { __typename?: 'ProductPriceManualVariantMode', mode: EProductPriceMode, variants: Array<{ __typename?: 'ProductVariantPrice', variantId: any, price?: number | null, updatedAt?: any | null }> } | null } };

export type ProductFragmentV2Fragment = { __typename?: 'Product', _id: any, name: string, slug: string, isPublished: boolean };

export type SearchProductsQueryVariables = Exact<{
  args: ProductsFiltersArgs;
}>;


export type SearchProductsQuery = { __typename?: 'Query', searchProducts: { __typename?: 'PaginatedProducts', nodes: Array<{ __typename?: 'Product', _id: any, name: string, slug: string, isPublished: boolean }>, pageInfo: { __typename?: 'PageInfoSkipLimit', skip?: number | null, limit?: number | null, hasPrevPage?: boolean | null, hasNextPage?: boolean | null, total: number } } };

export type TransportDataFragmentFragment = { __typename?: 'TransportData', transportMode: ETransportMode, standardShippingData?: { __typename?: 'StandardShippingData', sentShippingLabels?: Array<{ __typename?: 'ShippingLabel', shippingPartner: EStandardShipmentType, labelFile: { __typename?: 'FileMetadata', filename?: string | null } }> | null, address: { __typename?: 'OAddress', houseNumber?: string | null, stairway?: string | null, door?: string | null, floor?: string | null, street?: string | null, city?: string | null, state?: string | null, countryCode?: ECountry | null, country?: string | null, zipCode?: string | null, queryString?: string | null, address1?: string | null, address2?: string | null, note?: string | null, name?: string | null, companyName?: string | null, coordinates?: { __typename?: 'OCoordinates', lat: number, lng: number } | null } } | null, premiumShippingData?: { __typename?: 'PremiumShippingData', toHourUTC: number, fromHourUTC: number, date: any, address: { __typename?: 'OAddress', houseNumber?: string | null, stairway?: string | null, door?: string | null, floor?: string | null, street?: string | null, city?: string | null, state?: string | null, countryCode?: ECountry | null, country?: string | null, zipCode?: string | null, queryString?: string | null, address1?: string | null, address2?: string | null, note?: string | null, name?: string | null, companyName?: string | null, coordinates?: { __typename?: 'OCoordinates', lat: number, lng: number } | null } } | null };

type AnyPaymentTypeFragment_AutomaticPaymentWrapper_Fragment = { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType };

type AnyPaymentTypeFragment_ManualPaymentWrapper_Fragment = { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType };

export type AnyPaymentTypeFragmentFragment = AnyPaymentTypeFragment_AutomaticPaymentWrapper_Fragment | AnyPaymentTypeFragment_ManualPaymentWrapper_Fragment;

type BaseEventFragment_DealBookedEvent_Fragment = { __typename: 'DealBookedEvent', createdAt: any, timestamp: any, displayName: string };

type BaseEventFragment_DealCanceledEvent_Fragment = { __typename: 'DealCanceledEvent', createdAt: any, timestamp: any, displayName: string };

type BaseEventFragment_DealClosedEvent_Fragment = { __typename: 'DealClosedEvent', createdAt: any, timestamp: any, displayName: string };

type BaseEventFragment_DealCollectedEvent_Fragment = { __typename: 'DealCollectedEvent', createdAt: any, timestamp: any, displayName: string };

type BaseEventFragment_DealCustomerInCreditEvent_Fragment = { __typename: 'DealCustomerInCreditEvent', createdAt: any, timestamp: any, displayName: string };

type BaseEventFragment_DealCustomerInDebtEvent_Fragment = { __typename: 'DealCustomerInDebtEvent', createdAt: any, timestamp: any, displayName: string };

type BaseEventFragment_DealDeclinedEvent_Fragment = { __typename: 'DealDeclinedEvent', createdAt: any, timestamp: any, displayName: string };

type BaseEventFragment_DealDerecognizedEvent_Fragment = { __typename: 'DealDerecognizedEvent', createdAt: any, timestamp: any, displayName: string };

type BaseEventFragment_DealExcessAmountPayedEvent_Fragment = { __typename: 'DealExcessAmountPayedEvent', createdAt: any, timestamp: any, displayName: string };

type BaseEventFragment_DealExtensionConfirmedEvent_Fragment = { __typename: 'DealExtensionConfirmedEvent', createdAt: any, timestamp: any, displayName: string };

type BaseEventFragment_DealItemReceivedIdMissingEvent_Fragment = { __typename: 'DealItemReceivedIdMissingEvent', createdAt: any, timestamp: any, displayName: string };

type BaseEventFragment_DealLoanDueEvent_Fragment = { __typename: 'DealLoanDueEvent', createdAt: any, timestamp: any, displayName: string };

type BaseEventFragment_DealLoanDueNotifiedEvent_Fragment = { __typename: 'DealLoanDueNotifiedEvent', createdAt: any, timestamp: any, displayName: string };

type BaseEventFragment_DealOnSellEvent_Fragment = { __typename: 'DealOnSellEvent', createdAt: any, timestamp: any, displayName: string };

type BaseEventFragment_DealPaybackConfirmedEvent_Fragment = { __typename: 'DealPaybackConfirmedEvent', createdAt: any, timestamp: any, displayName: string };

type BaseEventFragment_DealPayedAndStoredEvent_Fragment = { __typename: 'DealPayedAndStoredEvent', createdAt: any, timestamp: any, displayName: string };

type BaseEventFragment_DealPayedShipmentPendingEvent_Fragment = { __typename: 'DealPayedShipmentPendingEvent', createdAt: any, timestamp: any, displayName: string };

type BaseEventFragment_DealPickedUpEvent_Fragment = { __typename: 'DealPickedUpEvent', createdAt: any, timestamp: any, displayName: string };

type BaseEventFragment_DealPickedUpUnsuccessfulEvent_Fragment = { __typename: 'DealPickedUpUnsuccessfulEvent', createdAt: any, timestamp: any, displayName: string };

type BaseEventFragment_DealReviewingEvent_Fragment = { __typename: 'DealReviewingEvent', createdAt: any, timestamp: any, displayName: string };

type BaseEventFragment_DealSoldExternEvent_Fragment = { __typename: 'DealSoldExternEvent', createdAt: any, timestamp: any, displayName: string };

type BaseEventFragment_DealSoldInternEvent_Fragment = { __typename: 'DealSoldInternEvent', createdAt: any, timestamp: any, displayName: string };

type BaseEventFragment_DealVerifiedEvent_Fragment = { __typename: 'DealVerifiedEvent', createdAt: any, timestamp: any, displayName: string };

export type BaseEventFragmentFragment = BaseEventFragment_DealBookedEvent_Fragment | BaseEventFragment_DealCanceledEvent_Fragment | BaseEventFragment_DealClosedEvent_Fragment | BaseEventFragment_DealCollectedEvent_Fragment | BaseEventFragment_DealCustomerInCreditEvent_Fragment | BaseEventFragment_DealCustomerInDebtEvent_Fragment | BaseEventFragment_DealDeclinedEvent_Fragment | BaseEventFragment_DealDerecognizedEvent_Fragment | BaseEventFragment_DealExcessAmountPayedEvent_Fragment | BaseEventFragment_DealExtensionConfirmedEvent_Fragment | BaseEventFragment_DealItemReceivedIdMissingEvent_Fragment | BaseEventFragment_DealLoanDueEvent_Fragment | BaseEventFragment_DealLoanDueNotifiedEvent_Fragment | BaseEventFragment_DealOnSellEvent_Fragment | BaseEventFragment_DealPaybackConfirmedEvent_Fragment | BaseEventFragment_DealPayedAndStoredEvent_Fragment | BaseEventFragment_DealPayedShipmentPendingEvent_Fragment | BaseEventFragment_DealPickedUpEvent_Fragment | BaseEventFragment_DealPickedUpUnsuccessfulEvent_Fragment | BaseEventFragment_DealReviewingEvent_Fragment | BaseEventFragment_DealSoldExternEvent_Fragment | BaseEventFragment_DealSoldInternEvent_Fragment | BaseEventFragment_DealVerifiedEvent_Fragment;

export type BookedEventFragmentFragment = { __typename?: 'DealBookedEvent', dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } };

export type VerifiedEventFragmentFragment = { __typename?: 'DealVerifiedEvent', isOverwrittenFees?: boolean | null, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } };

export type ReviewingEventFragmentFragment = { __typename?: 'DealReviewingEvent', issuanceCertificate: { __typename?: 'FileMetadata', url: string, contentType?: string | null } };

export type PaybackConfirmedEventFragmentFragment = { __typename?: 'DealPaybackConfirmedEvent', paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType }, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } };

export type ExtensionConfirmedEventFragmentFragment = { __typename?: 'DealExtensionConfirmedEvent', dueAmount: number, partialRedemptionAmount: number, overwrittenPartialRedemptionAmount?: number | null, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType }, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> }, childCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> }, itemsExtensionAnswers?: Array<{ __typename?: 'ItemExtensionAnswers', storageLabel: string, answers: Array<{ __typename?: 'ItemAnswer', questionId: any, selectedOptionIndex?: number | null, rangeValue?: number | null }> }> | null };

export type OnSellEventFragmentFragment = { __typename?: 'DealOnSellEvent', valueAddedTaxRate: number, differenceTaxRate: number, valorizationFeeRate: number };

export type ClosedEventFragmentFragment = { __typename?: 'DealClosedEvent', valorizationFeeNet?: number | null, valorizationFeeGross?: number | null, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } };

type DealEventFragment_DealBookedEvent_Fragment = { __typename: 'DealBookedEvent', createdAt: any, timestamp: any, displayName: string, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } };

type DealEventFragment_DealCanceledEvent_Fragment = { __typename: 'DealCanceledEvent', createdAt: any, timestamp: any, displayName: string };

type DealEventFragment_DealClosedEvent_Fragment = { __typename: 'DealClosedEvent', createdAt: any, timestamp: any, displayName: string, valorizationFeeNet?: number | null, valorizationFeeGross?: number | null, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } };

type DealEventFragment_DealCollectedEvent_Fragment = { __typename: 'DealCollectedEvent', createdAt: any, timestamp: any, displayName: string };

type DealEventFragment_DealCustomerInCreditEvent_Fragment = { __typename: 'DealCustomerInCreditEvent', createdAt: any, timestamp: any, displayName: string };

type DealEventFragment_DealCustomerInDebtEvent_Fragment = { __typename: 'DealCustomerInDebtEvent', createdAt: any, timestamp: any, displayName: string };

type DealEventFragment_DealDeclinedEvent_Fragment = { __typename: 'DealDeclinedEvent', createdAt: any, timestamp: any, displayName: string };

type DealEventFragment_DealDerecognizedEvent_Fragment = { __typename: 'DealDerecognizedEvent', createdAt: any, timestamp: any, displayName: string };

type DealEventFragment_DealExcessAmountPayedEvent_Fragment = { __typename: 'DealExcessAmountPayedEvent', createdAt: any, timestamp: any, displayName: string };

type DealEventFragment_DealExtensionConfirmedEvent_Fragment = { __typename: 'DealExtensionConfirmedEvent', createdAt: any, timestamp: any, displayName: string, dueAmount: number, partialRedemptionAmount: number, overwrittenPartialRedemptionAmount?: number | null, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType }, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> }, childCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> }, itemsExtensionAnswers?: Array<{ __typename?: 'ItemExtensionAnswers', storageLabel: string, answers: Array<{ __typename?: 'ItemAnswer', questionId: any, selectedOptionIndex?: number | null, rangeValue?: number | null }> }> | null };

type DealEventFragment_DealItemReceivedIdMissingEvent_Fragment = { __typename: 'DealItemReceivedIdMissingEvent', createdAt: any, timestamp: any, displayName: string };

type DealEventFragment_DealLoanDueEvent_Fragment = { __typename: 'DealLoanDueEvent', createdAt: any, timestamp: any, displayName: string };

type DealEventFragment_DealLoanDueNotifiedEvent_Fragment = { __typename: 'DealLoanDueNotifiedEvent', createdAt: any, timestamp: any, displayName: string };

type DealEventFragment_DealOnSellEvent_Fragment = { __typename: 'DealOnSellEvent', createdAt: any, timestamp: any, displayName: string, valueAddedTaxRate: number, differenceTaxRate: number, valorizationFeeRate: number };

type DealEventFragment_DealPaybackConfirmedEvent_Fragment = { __typename: 'DealPaybackConfirmedEvent', createdAt: any, timestamp: any, displayName: string, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType }, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } };

type DealEventFragment_DealPayedAndStoredEvent_Fragment = { __typename: 'DealPayedAndStoredEvent', createdAt: any, timestamp: any, displayName: string };

type DealEventFragment_DealPayedShipmentPendingEvent_Fragment = { __typename: 'DealPayedShipmentPendingEvent', createdAt: any, timestamp: any, displayName: string };

type DealEventFragment_DealPickedUpEvent_Fragment = { __typename: 'DealPickedUpEvent', createdAt: any, timestamp: any, displayName: string };

type DealEventFragment_DealPickedUpUnsuccessfulEvent_Fragment = { __typename: 'DealPickedUpUnsuccessfulEvent', createdAt: any, timestamp: any, displayName: string };

type DealEventFragment_DealReviewingEvent_Fragment = { __typename: 'DealReviewingEvent', createdAt: any, timestamp: any, displayName: string, issuanceCertificate: { __typename?: 'FileMetadata', url: string, contentType?: string | null } };

type DealEventFragment_DealSoldExternEvent_Fragment = { __typename: 'DealSoldExternEvent', createdAt: any, timestamp: any, displayName: string };

type DealEventFragment_DealSoldInternEvent_Fragment = { __typename: 'DealSoldInternEvent', createdAt: any, timestamp: any, displayName: string };

type DealEventFragment_DealVerifiedEvent_Fragment = { __typename: 'DealVerifiedEvent', createdAt: any, timestamp: any, displayName: string, isOverwrittenFees?: boolean | null, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } };

export type DealEventFragmentFragment = DealEventFragment_DealBookedEvent_Fragment | DealEventFragment_DealCanceledEvent_Fragment | DealEventFragment_DealClosedEvent_Fragment | DealEventFragment_DealCollectedEvent_Fragment | DealEventFragment_DealCustomerInCreditEvent_Fragment | DealEventFragment_DealCustomerInDebtEvent_Fragment | DealEventFragment_DealDeclinedEvent_Fragment | DealEventFragment_DealDerecognizedEvent_Fragment | DealEventFragment_DealExcessAmountPayedEvent_Fragment | DealEventFragment_DealExtensionConfirmedEvent_Fragment | DealEventFragment_DealItemReceivedIdMissingEvent_Fragment | DealEventFragment_DealLoanDueEvent_Fragment | DealEventFragment_DealLoanDueNotifiedEvent_Fragment | DealEventFragment_DealOnSellEvent_Fragment | DealEventFragment_DealPaybackConfirmedEvent_Fragment | DealEventFragment_DealPayedAndStoredEvent_Fragment | DealEventFragment_DealPayedShipmentPendingEvent_Fragment | DealEventFragment_DealPickedUpEvent_Fragment | DealEventFragment_DealPickedUpUnsuccessfulEvent_Fragment | DealEventFragment_DealReviewingEvent_Fragment | DealEventFragment_DealSoldExternEvent_Fragment | DealEventFragment_DealSoldInternEvent_Fragment | DealEventFragment_DealVerifiedEvent_Fragment;

export type PawnDataFragmentFragment = { __typename?: 'PawnData', pawnNumber?: number | null, billNumber?: string | null, extensionChildId?: any | null, extensionParentId?: any | null, pawnTicketLink?: { __typename?: 'FileMetadata', url: string, contentType?: string | null } | null, billLink?: { __typename?: 'FileMetadata', url: string, contentType?: string | null } | null, paybackData?: { __typename?: 'PaymentData', iban?: string | null, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType } } | null, reservedPaybackData?: { __typename?: 'ReservedPaybackData', isExtension: boolean, date: any, paymentType: EManualPaymentType, feeAmount: number, partialRedemptionAmount: number, dueAmount: number } | null };

export type DealPreviewFragmentFragment = { __typename?: 'Deal', _id: any, createdAt: any, updatedAt: any, dealType: EDealType, bookingNumber: number, initialShopId?: any | null, shippingLabelPageId?: string | null, isPaybackPaymentOngoing: boolean, isExtensionPaymentOngoing: boolean, latestOngoingPaymentRequestedAt?: any | null, hasCompletedPayment: boolean, isInOpenAuction?: boolean | null, acceptingWithdrawalFeeTermsRequired: boolean, canDealOnSellBeExtendedOrPaidBack: boolean, dealFinalValues: { __typename?: 'DealFinalValues', dealType: EDealType, durationInDays: number, shouldOverwritePayoutAmount: boolean, payoutAmount: number, isOnlineExtensionPrevented?: boolean | null }, pawnData?: { __typename?: 'PawnData', pawnNumber?: number | null, billNumber?: string | null, extensionChildId?: any | null, extensionParentId?: any | null, pawnTicketLink?: { __typename?: 'FileMetadata', url: string, contentType?: string | null } | null, billLink?: { __typename?: 'FileMetadata', url: string, contentType?: string | null } | null, paybackData?: { __typename?: 'PaymentData', iban?: string | null, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType } } | null, reservedPaybackData?: { __typename?: 'ReservedPaybackData', isExtension: boolean, date: any, paymentType: EManualPaymentType, feeAmount: number, partialRedemptionAmount: number, dueAmount: number } | null } | null, purchaseData?: { __typename?: 'PurchaseData', receiptNumber?: string | null, receiptLink?: { __typename?: 'FileMetadata', url: string, contentType?: string | null } | null } | null, events: Array<{ __typename: 'DealBookedEvent', createdAt: any, timestamp: any, displayName: string, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | { __typename: 'DealCanceledEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealClosedEvent', createdAt: any, timestamp: any, displayName: string, valorizationFeeNet?: number | null, valorizationFeeGross?: number | null, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | { __typename: 'DealCollectedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealCustomerInCreditEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealCustomerInDebtEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealDeclinedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealDerecognizedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealExcessAmountPayedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealExtensionConfirmedEvent', createdAt: any, timestamp: any, displayName: string, dueAmount: number, partialRedemptionAmount: number, overwrittenPartialRedemptionAmount?: number | null, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType }, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> }, childCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> }, itemsExtensionAnswers?: Array<{ __typename?: 'ItemExtensionAnswers', storageLabel: string, answers: Array<{ __typename?: 'ItemAnswer', questionId: any, selectedOptionIndex?: number | null, rangeValue?: number | null }> }> | null } | { __typename: 'DealItemReceivedIdMissingEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealLoanDueEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealLoanDueNotifiedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealOnSellEvent', createdAt: any, timestamp: any, displayName: string, valueAddedTaxRate: number, differenceTaxRate: number, valorizationFeeRate: number } | { __typename: 'DealPaybackConfirmedEvent', createdAt: any, timestamp: any, displayName: string, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType }, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | { __typename: 'DealPayedAndStoredEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPayedShipmentPendingEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPickedUpEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPickedUpUnsuccessfulEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealReviewingEvent', createdAt: any, timestamp: any, displayName: string, issuanceCertificate: { __typename?: 'FileMetadata', url: string, contentType?: string | null } } | { __typename: 'DealSoldExternEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealSoldInternEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealVerifiedEvent', createdAt: any, timestamp: any, displayName: string, isOverwrittenFees?: boolean | null, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } }>, payoutData: { __typename?: 'PaymentData', iban?: string | null, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType } }, company: { __typename?: 'Company', name: string, iban?: string | null, paypalEmail?: string | null, configuration: { __typename?: 'CompanyConfiguration', minimumPawnDuration: number, gracePeriod: number }, successionCompany?: { __typename?: 'Company', _id: any, name: string } | null } };

export type DealFragmentFragment = { __typename?: 'Deal', businessUnit: EBusinessUnit, itemsIds: Array<any>, isPaybackPaymentOngoing: boolean, shippingLabelPageId?: string | null, isExtensionPaymentOngoing: boolean, _id: any, createdAt: any, updatedAt: any, dealType: EDealType, bookingNumber: number, initialShopId?: any | null, latestOngoingPaymentRequestedAt?: any | null, hasCompletedPayment: boolean, isInOpenAuction?: boolean | null, acceptingWithdrawalFeeTermsRequired: boolean, canDealOnSellBeExtendedOrPaidBack: boolean, pickupData?: { __typename?: 'TransportData', transportMode: ETransportMode, standardShippingData?: { __typename?: 'StandardShippingData', sentShippingLabels?: Array<{ __typename?: 'ShippingLabel', shippingPartner: EStandardShipmentType, labelFile: { __typename?: 'FileMetadata', filename?: string | null } }> | null, address: { __typename?: 'OAddress', houseNumber?: string | null, stairway?: string | null, door?: string | null, floor?: string | null, street?: string | null, city?: string | null, state?: string | null, countryCode?: ECountry | null, country?: string | null, zipCode?: string | null, queryString?: string | null, address1?: string | null, address2?: string | null, note?: string | null, name?: string | null, companyName?: string | null, coordinates?: { __typename?: 'OCoordinates', lat: number, lng: number } | null } } | null, premiumShippingData?: { __typename?: 'PremiumShippingData', toHourUTC: number, fromHourUTC: number, date: any, address: { __typename?: 'OAddress', houseNumber?: string | null, stairway?: string | null, door?: string | null, floor?: string | null, street?: string | null, city?: string | null, state?: string | null, countryCode?: ECountry | null, country?: string | null, zipCode?: string | null, queryString?: string | null, address1?: string | null, address2?: string | null, note?: string | null, name?: string | null, companyName?: string | null, coordinates?: { __typename?: 'OCoordinates', lat: number, lng: number } | null } } | null } | null, dropoffData?: { __typename?: 'TransportData', transportMode: ETransportMode, standardShippingData?: { __typename?: 'StandardShippingData', sentShippingLabels?: Array<{ __typename?: 'ShippingLabel', shippingPartner: EStandardShipmentType, labelFile: { __typename?: 'FileMetadata', filename?: string | null } }> | null, address: { __typename?: 'OAddress', houseNumber?: string | null, stairway?: string | null, door?: string | null, floor?: string | null, street?: string | null, city?: string | null, state?: string | null, countryCode?: ECountry | null, country?: string | null, zipCode?: string | null, queryString?: string | null, address1?: string | null, address2?: string | null, note?: string | null, name?: string | null, companyName?: string | null, coordinates?: { __typename?: 'OCoordinates', lat: number, lng: number } | null } } | null, premiumShippingData?: { __typename?: 'PremiumShippingData', toHourUTC: number, fromHourUTC: number, date: any, address: { __typename?: 'OAddress', houseNumber?: string | null, stairway?: string | null, door?: string | null, floor?: string | null, street?: string | null, city?: string | null, state?: string | null, countryCode?: ECountry | null, country?: string | null, zipCode?: string | null, queryString?: string | null, address1?: string | null, address2?: string | null, note?: string | null, name?: string | null, companyName?: string | null, coordinates?: { __typename?: 'OCoordinates', lat: number, lng: number } | null } } | null } | null, dealPartnerData?: { __typename?: 'ODealPartnerData', type: EDealPartnerType, knp?: { __typename?: 'ODealPartnerDataKnp', fileReferenceNumber: string, debtAmount: number } | null } | null, items: Array<{ __typename?: 'DealItem', _id: any, title: string, isContinueUsing: boolean, itemCategoryId: any, algoliaReference?: string | null, material?: string | null, ean?: string | null, variantId?: any | null, itemCategory: { __typename?: 'ItemCategory', _id: any, name: string, parentId?: any | null, createdAt: any, updatedAt: any, slug: string, availableTransportModes: Array<ETransportMode> }, media?: Array<{ __typename?: 'FileMetadata', url: string, contentType?: string | null }> | null, productLegacy?: { __typename?: 'ProductLegacy', title: string, picture?: { __typename?: 'UploadFile', _id: any, name: string, alternativeText: string, caption: string, hash: string, ext: string, mime: string, width: number, height: number, size: number, url: string, provider: string, createdAt: any, updatedAt: any, formats?: { __typename?: 'UploadFileFormats', thumbnail: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string }, small?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, medium?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, large?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, product_thumbnail?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, product_small?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null } | null } | null } | null, productVariant?: { __typename?: 'ProductVariant', id: any, isPriceValid: boolean, name: string, image?: { __typename?: 'ProductImage', id: string, url: string } | null, product: { __typename?: 'Product', name: string, category: { __typename?: 'ItemCategory', name: string, parentCategories: Array<{ __typename?: 'ItemCategory', name: string }> } }, propertiesValues: Array<{ __typename?: 'ProductVariantPropertyBooleanValue', propertyDefinitionId: any, propertyDefinition: { __typename?: 'ProductPropertyDefinition', _id: any, type: EProductPropertyType, impactsLook: boolean, showOnWebsite: boolean, key: string, name: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> }, valueFormatting?: { __typename?: 'PropertyDefinitionValueFormatting', suffix?: string | null } | null }, value: { __typename?: 'AvailablePropertyBooleanOption', booleanValue: boolean } } | { __typename?: 'ProductVariantPropertyNumberValue', propertyDefinitionId: any, propertyDefinition: { __typename?: 'ProductPropertyDefinition', _id: any, type: EProductPropertyType, impactsLook: boolean, showOnWebsite: boolean, key: string, name: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> }, valueFormatting?: { __typename?: 'PropertyDefinitionValueFormatting', suffix?: string | null } | null }, value: { __typename?: 'AvailablePropertyNumberOption', numberValue: number } } | { __typename?: 'ProductVariantPropertyTextValue', propertyDefinitionId: any, propertyDefinition: { __typename?: 'ProductPropertyDefinition', _id: any, type: EProductPropertyType, impactsLook: boolean, showOnWebsite: boolean, key: string, name: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> }, valueFormatting?: { __typename?: 'PropertyDefinitionValueFormatting', suffix?: string | null } | null }, value: { __typename?: 'AvailablePropertyTextOption', translation: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> } } }> } | null }>, company: { __typename?: 'Company', name: string, iban?: string | null, paypalEmail?: string | null, configuration: { __typename?: 'CompanyConfiguration', minimumPawnDuration: number, gracePeriod: number }, unzerConfiguration?: { __typename?: 'CompanyUnzerConfiguration', publicKey?: string | null } | null, successionCompany?: { __typename?: 'Company', _id: any, name: string } | null }, dealFinalValues: { __typename?: 'DealFinalValues', dealType: EDealType, durationInDays: number, shouldOverwritePayoutAmount: boolean, payoutAmount: number, isOnlineExtensionPrevented?: boolean | null }, pawnData?: { __typename?: 'PawnData', pawnNumber?: number | null, billNumber?: string | null, extensionChildId?: any | null, extensionParentId?: any | null, pawnTicketLink?: { __typename?: 'FileMetadata', url: string, contentType?: string | null } | null, billLink?: { __typename?: 'FileMetadata', url: string, contentType?: string | null } | null, paybackData?: { __typename?: 'PaymentData', iban?: string | null, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType } } | null, reservedPaybackData?: { __typename?: 'ReservedPaybackData', isExtension: boolean, date: any, paymentType: EManualPaymentType, feeAmount: number, partialRedemptionAmount: number, dueAmount: number } | null } | null, purchaseData?: { __typename?: 'PurchaseData', receiptNumber?: string | null, receiptLink?: { __typename?: 'FileMetadata', url: string, contentType?: string | null } | null } | null, events: Array<{ __typename: 'DealBookedEvent', createdAt: any, timestamp: any, displayName: string, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | { __typename: 'DealCanceledEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealClosedEvent', createdAt: any, timestamp: any, displayName: string, valorizationFeeNet?: number | null, valorizationFeeGross?: number | null, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | { __typename: 'DealCollectedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealCustomerInCreditEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealCustomerInDebtEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealDeclinedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealDerecognizedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealExcessAmountPayedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealExtensionConfirmedEvent', createdAt: any, timestamp: any, displayName: string, dueAmount: number, partialRedemptionAmount: number, overwrittenPartialRedemptionAmount?: number | null, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType }, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> }, childCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> }, itemsExtensionAnswers?: Array<{ __typename?: 'ItemExtensionAnswers', storageLabel: string, answers: Array<{ __typename?: 'ItemAnswer', questionId: any, selectedOptionIndex?: number | null, rangeValue?: number | null }> }> | null } | { __typename: 'DealItemReceivedIdMissingEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealLoanDueEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealLoanDueNotifiedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealOnSellEvent', createdAt: any, timestamp: any, displayName: string, valueAddedTaxRate: number, differenceTaxRate: number, valorizationFeeRate: number } | { __typename: 'DealPaybackConfirmedEvent', createdAt: any, timestamp: any, displayName: string, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType }, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | { __typename: 'DealPayedAndStoredEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPayedShipmentPendingEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPickedUpEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPickedUpUnsuccessfulEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealReviewingEvent', createdAt: any, timestamp: any, displayName: string, issuanceCertificate: { __typename?: 'FileMetadata', url: string, contentType?: string | null } } | { __typename: 'DealSoldExternEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealSoldInternEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealVerifiedEvent', createdAt: any, timestamp: any, displayName: string, isOverwrittenFees?: boolean | null, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } }>, payoutData: { __typename?: 'PaymentData', iban?: string | null, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType } } };

type PaymentResultFragment_FailedPayment_Fragment = { __typename?: 'FailedPayment', id: string, errors: Array<{ __typename?: 'FailedPaymentError', code: EUnzerFailedPaymentErrorCode }> };

type PaymentResultFragment_PendingPayment_Fragment = { __typename?: 'PendingPayment', redirectUrl: string, id: string };

type PaymentResultFragment_SuccessfulPayment_Fragment = { __typename?: 'SuccessfulPayment', id: string };

export type PaymentResultFragmentFragment = PaymentResultFragment_FailedPayment_Fragment | PaymentResultFragment_PendingPayment_Fragment | PaymentResultFragment_SuccessfulPayment_Fragment;

export type FileMetadataFragmentFragment = { __typename?: 'FileMetadata', url: string, contentType?: string | null, filename?: string | null, createdAt?: any | null };

export type GetCurrentCustomerWithAdressesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentCustomerWithAdressesQuery = { __typename?: 'Query', getCurrentCustomer: { __typename?: 'Customer', _id: any, firstname: string, lastname: string, email: string, phone: string, dateOfBirth?: any | null, iban?: string | null, paypalAddress?: string | null, identityType?: ECustomerIdentityType | null, identityVerifiedAt?: any | null, identityUploadLinks?: Array<{ __typename?: 'FileMetadata', url: string, contentType?: string | null, filename?: string | null, createdAt?: any | null }> | null, addresses?: Array<{ __typename?: 'OCustomerAddress', street?: string | null, countryCode?: ECountry | null, zipCode?: string | null, houseNumber?: string | null, floor?: string | null, door?: string | null, city?: string | null, state?: string | null, country?: string | null, stairway?: string | null, queryString?: string | null, note?: string | null, isDeliveryAddress?: boolean | null, isBillingAddress?: boolean | null, coordinates?: { __typename?: 'OCoordinates', lat: number, lng: number } | null }> | null } };

export type DealProfileFragmentFragment = { __typename?: 'Deal', _id: any, createdAt: any, updatedAt: any, dealType: EDealType, bookingNumber: number, isPaybackPaymentOngoing: boolean, shippingLabelPageId?: string | null, isExtensionPaymentOngoing: boolean, latestOngoingPaymentRequestedAt?: any | null, hasCompletedPayment: boolean, isInOpenAuction?: boolean | null, acceptingWithdrawalFeeTermsRequired: boolean, canDealOnSellBeExtendedOrPaidBack: boolean, dealFinalValues: { __typename?: 'DealFinalValues', dealType: EDealType, durationInDays: number, shouldOverwritePayoutAmount: boolean, payoutAmount: number, isOnlineExtensionPrevented?: boolean | null }, pawnData?: { __typename?: 'PawnData', pawnNumber?: number | null, billNumber?: string | null, extensionChildId?: any | null, extensionParentId?: any | null, pawnTicketLink?: { __typename?: 'FileMetadata', url: string, contentType?: string | null } | null, billLink?: { __typename?: 'FileMetadata', url: string, contentType?: string | null } | null, paybackData?: { __typename?: 'PaymentData', iban?: string | null, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType } } | null, reservedPaybackData?: { __typename?: 'ReservedPaybackData', isExtension: boolean, date: any, paymentType: EManualPaymentType, feeAmount: number, partialRedemptionAmount: number, dueAmount: number } | null } | null, events: Array<{ __typename: 'DealBookedEvent', createdAt: any, timestamp: any, displayName: string, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | { __typename: 'DealCanceledEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealClosedEvent', createdAt: any, timestamp: any, displayName: string, valorizationFeeNet?: number | null, valorizationFeeGross?: number | null, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | { __typename: 'DealCollectedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealCustomerInCreditEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealCustomerInDebtEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealDeclinedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealDerecognizedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealExcessAmountPayedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealExtensionConfirmedEvent', createdAt: any, timestamp: any, displayName: string, dueAmount: number, partialRedemptionAmount: number, overwrittenPartialRedemptionAmount?: number | null, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType }, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> }, childCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> }, itemsExtensionAnswers?: Array<{ __typename?: 'ItemExtensionAnswers', storageLabel: string, answers: Array<{ __typename?: 'ItemAnswer', questionId: any, selectedOptionIndex?: number | null, rangeValue?: number | null }> }> | null } | { __typename: 'DealItemReceivedIdMissingEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealLoanDueEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealLoanDueNotifiedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealOnSellEvent', createdAt: any, timestamp: any, displayName: string, valueAddedTaxRate: number, differenceTaxRate: number, valorizationFeeRate: number } | { __typename: 'DealPaybackConfirmedEvent', createdAt: any, timestamp: any, displayName: string, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType }, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | { __typename: 'DealPayedAndStoredEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPayedShipmentPendingEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPickedUpEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPickedUpUnsuccessfulEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealReviewingEvent', createdAt: any, timestamp: any, displayName: string, issuanceCertificate: { __typename?: 'FileMetadata', url: string, contentType?: string | null } } | { __typename: 'DealSoldExternEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealSoldInternEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealVerifiedEvent', createdAt: any, timestamp: any, displayName: string, isOverwrittenFees?: boolean | null, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } }> };

export type GetDealByIdQueryVariables = Exact<{
  dealId: Scalars['ObjectId']['input'];
}>;


export type GetDealByIdQuery = { __typename?: 'Query', getDealById: { __typename?: 'Deal', businessUnit: EBusinessUnit, itemsIds: Array<any>, isPaybackPaymentOngoing: boolean, shippingLabelPageId?: string | null, isExtensionPaymentOngoing: boolean, _id: any, createdAt: any, updatedAt: any, dealType: EDealType, bookingNumber: number, initialShopId?: any | null, latestOngoingPaymentRequestedAt?: any | null, hasCompletedPayment: boolean, isInOpenAuction?: boolean | null, acceptingWithdrawalFeeTermsRequired: boolean, canDealOnSellBeExtendedOrPaidBack: boolean, pickupData?: { __typename?: 'TransportData', transportMode: ETransportMode, standardShippingData?: { __typename?: 'StandardShippingData', sentShippingLabels?: Array<{ __typename?: 'ShippingLabel', shippingPartner: EStandardShipmentType, labelFile: { __typename?: 'FileMetadata', filename?: string | null } }> | null, address: { __typename?: 'OAddress', houseNumber?: string | null, stairway?: string | null, door?: string | null, floor?: string | null, street?: string | null, city?: string | null, state?: string | null, countryCode?: ECountry | null, country?: string | null, zipCode?: string | null, queryString?: string | null, address1?: string | null, address2?: string | null, note?: string | null, name?: string | null, companyName?: string | null, coordinates?: { __typename?: 'OCoordinates', lat: number, lng: number } | null } } | null, premiumShippingData?: { __typename?: 'PremiumShippingData', toHourUTC: number, fromHourUTC: number, date: any, address: { __typename?: 'OAddress', houseNumber?: string | null, stairway?: string | null, door?: string | null, floor?: string | null, street?: string | null, city?: string | null, state?: string | null, countryCode?: ECountry | null, country?: string | null, zipCode?: string | null, queryString?: string | null, address1?: string | null, address2?: string | null, note?: string | null, name?: string | null, companyName?: string | null, coordinates?: { __typename?: 'OCoordinates', lat: number, lng: number } | null } } | null } | null, dropoffData?: { __typename?: 'TransportData', transportMode: ETransportMode, standardShippingData?: { __typename?: 'StandardShippingData', sentShippingLabels?: Array<{ __typename?: 'ShippingLabel', shippingPartner: EStandardShipmentType, labelFile: { __typename?: 'FileMetadata', filename?: string | null } }> | null, address: { __typename?: 'OAddress', houseNumber?: string | null, stairway?: string | null, door?: string | null, floor?: string | null, street?: string | null, city?: string | null, state?: string | null, countryCode?: ECountry | null, country?: string | null, zipCode?: string | null, queryString?: string | null, address1?: string | null, address2?: string | null, note?: string | null, name?: string | null, companyName?: string | null, coordinates?: { __typename?: 'OCoordinates', lat: number, lng: number } | null } } | null, premiumShippingData?: { __typename?: 'PremiumShippingData', toHourUTC: number, fromHourUTC: number, date: any, address: { __typename?: 'OAddress', houseNumber?: string | null, stairway?: string | null, door?: string | null, floor?: string | null, street?: string | null, city?: string | null, state?: string | null, countryCode?: ECountry | null, country?: string | null, zipCode?: string | null, queryString?: string | null, address1?: string | null, address2?: string | null, note?: string | null, name?: string | null, companyName?: string | null, coordinates?: { __typename?: 'OCoordinates', lat: number, lng: number } | null } } | null } | null, dealPartnerData?: { __typename?: 'ODealPartnerData', type: EDealPartnerType, knp?: { __typename?: 'ODealPartnerDataKnp', fileReferenceNumber: string, debtAmount: number } | null } | null, items: Array<{ __typename?: 'DealItem', _id: any, title: string, isContinueUsing: boolean, itemCategoryId: any, algoliaReference?: string | null, material?: string | null, ean?: string | null, variantId?: any | null, itemCategory: { __typename?: 'ItemCategory', _id: any, name: string, parentId?: any | null, createdAt: any, updatedAt: any, slug: string, availableTransportModes: Array<ETransportMode> }, media?: Array<{ __typename?: 'FileMetadata', url: string, contentType?: string | null }> | null, productLegacy?: { __typename?: 'ProductLegacy', title: string, picture?: { __typename?: 'UploadFile', _id: any, name: string, alternativeText: string, caption: string, hash: string, ext: string, mime: string, width: number, height: number, size: number, url: string, provider: string, createdAt: any, updatedAt: any, formats?: { __typename?: 'UploadFileFormats', thumbnail: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string }, small?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, medium?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, large?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, product_thumbnail?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, product_small?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null } | null } | null } | null, productVariant?: { __typename?: 'ProductVariant', id: any, isPriceValid: boolean, name: string, image?: { __typename?: 'ProductImage', id: string, url: string } | null, product: { __typename?: 'Product', name: string, category: { __typename?: 'ItemCategory', name: string, parentCategories: Array<{ __typename?: 'ItemCategory', name: string }> } }, propertiesValues: Array<{ __typename?: 'ProductVariantPropertyBooleanValue', propertyDefinitionId: any, propertyDefinition: { __typename?: 'ProductPropertyDefinition', _id: any, type: EProductPropertyType, impactsLook: boolean, showOnWebsite: boolean, key: string, name: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> }, valueFormatting?: { __typename?: 'PropertyDefinitionValueFormatting', suffix?: string | null } | null }, value: { __typename?: 'AvailablePropertyBooleanOption', booleanValue: boolean } } | { __typename?: 'ProductVariantPropertyNumberValue', propertyDefinitionId: any, propertyDefinition: { __typename?: 'ProductPropertyDefinition', _id: any, type: EProductPropertyType, impactsLook: boolean, showOnWebsite: boolean, key: string, name: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> }, valueFormatting?: { __typename?: 'PropertyDefinitionValueFormatting', suffix?: string | null } | null }, value: { __typename?: 'AvailablePropertyNumberOption', numberValue: number } } | { __typename?: 'ProductVariantPropertyTextValue', propertyDefinitionId: any, propertyDefinition: { __typename?: 'ProductPropertyDefinition', _id: any, type: EProductPropertyType, impactsLook: boolean, showOnWebsite: boolean, key: string, name: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> }, valueFormatting?: { __typename?: 'PropertyDefinitionValueFormatting', suffix?: string | null } | null }, value: { __typename?: 'AvailablePropertyTextOption', translation: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> } } }> } | null }>, company: { __typename?: 'Company', name: string, iban?: string | null, paypalEmail?: string | null, configuration: { __typename?: 'CompanyConfiguration', minimumPawnDuration: number, gracePeriod: number }, unzerConfiguration?: { __typename?: 'CompanyUnzerConfiguration', publicKey?: string | null } | null, successionCompany?: { __typename?: 'Company', _id: any, name: string } | null }, dealFinalValues: { __typename?: 'DealFinalValues', dealType: EDealType, durationInDays: number, shouldOverwritePayoutAmount: boolean, payoutAmount: number, isOnlineExtensionPrevented?: boolean | null }, pawnData?: { __typename?: 'PawnData', pawnNumber?: number | null, billNumber?: string | null, extensionChildId?: any | null, extensionParentId?: any | null, pawnTicketLink?: { __typename?: 'FileMetadata', url: string, contentType?: string | null } | null, billLink?: { __typename?: 'FileMetadata', url: string, contentType?: string | null } | null, paybackData?: { __typename?: 'PaymentData', iban?: string | null, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType } } | null, reservedPaybackData?: { __typename?: 'ReservedPaybackData', isExtension: boolean, date: any, paymentType: EManualPaymentType, feeAmount: number, partialRedemptionAmount: number, dueAmount: number } | null } | null, purchaseData?: { __typename?: 'PurchaseData', receiptNumber?: string | null, receiptLink?: { __typename?: 'FileMetadata', url: string, contentType?: string | null } | null } | null, events: Array<{ __typename: 'DealBookedEvent', createdAt: any, timestamp: any, displayName: string, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | { __typename: 'DealCanceledEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealClosedEvent', createdAt: any, timestamp: any, displayName: string, valorizationFeeNet?: number | null, valorizationFeeGross?: number | null, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | { __typename: 'DealCollectedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealCustomerInCreditEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealCustomerInDebtEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealDeclinedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealDerecognizedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealExcessAmountPayedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealExtensionConfirmedEvent', createdAt: any, timestamp: any, displayName: string, dueAmount: number, partialRedemptionAmount: number, overwrittenPartialRedemptionAmount?: number | null, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType }, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> }, childCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> }, itemsExtensionAnswers?: Array<{ __typename?: 'ItemExtensionAnswers', storageLabel: string, answers: Array<{ __typename?: 'ItemAnswer', questionId: any, selectedOptionIndex?: number | null, rangeValue?: number | null }> }> | null } | { __typename: 'DealItemReceivedIdMissingEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealLoanDueEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealLoanDueNotifiedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealOnSellEvent', createdAt: any, timestamp: any, displayName: string, valueAddedTaxRate: number, differenceTaxRate: number, valorizationFeeRate: number } | { __typename: 'DealPaybackConfirmedEvent', createdAt: any, timestamp: any, displayName: string, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType }, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | { __typename: 'DealPayedAndStoredEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPayedShipmentPendingEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPickedUpEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPickedUpUnsuccessfulEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealReviewingEvent', createdAt: any, timestamp: any, displayName: string, issuanceCertificate: { __typename?: 'FileMetadata', url: string, contentType?: string | null } } | { __typename: 'DealSoldExternEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealSoldInternEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealVerifiedEvent', createdAt: any, timestamp: any, displayName: string, isOverwrittenFees?: boolean | null, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } }>, payoutData: { __typename?: 'PaymentData', iban?: string | null, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType } } } };

export type GetDealAndCalculationByIdQueryVariables = Exact<{
  dealId: Scalars['ObjectId']['input'];
  extensionCalculationArgs: DealExtensionCalculationArgs;
  paybackCalculationArgs: DealPaybackCalculationArgs;
}>;


export type GetDealAndCalculationByIdQuery = { __typename?: 'Query', getDealById: { __typename?: 'Deal', businessUnit: EBusinessUnit, itemsIds: Array<any>, isPaybackPaymentOngoing: boolean, shippingLabelPageId?: string | null, isExtensionPaymentOngoing: boolean, _id: any, createdAt: any, updatedAt: any, dealType: EDealType, bookingNumber: number, initialShopId?: any | null, latestOngoingPaymentRequestedAt?: any | null, hasCompletedPayment: boolean, isInOpenAuction?: boolean | null, acceptingWithdrawalFeeTermsRequired: boolean, canDealOnSellBeExtendedOrPaidBack: boolean, persistedExtensionCalculation?: { __typename?: 'PersistedDealExtensionCalculation', dealId: any, dueAmount: number, partialRedemptionAmount: number, overwrittenPartialRedemptionAmount?: number | null, dealExtensionCalculationId: any, itemsExtensionAnswers: Array<{ __typename?: 'ItemExtensionAnswers', storageLabel: string, answers: Array<{ __typename?: 'ItemAnswer', questionId: any, selectedOptionIndex?: number | null, rangeValue?: number | null }> }>, childDealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> }, parentDealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | null, persistedPaybackCalculation?: { __typename?: 'PersistedDealPaybackCalculation', dealId: any, dealPaybackCalculationId: any, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | null, pickupData?: { __typename?: 'TransportData', transportMode: ETransportMode, standardShippingData?: { __typename?: 'StandardShippingData', sentShippingLabels?: Array<{ __typename?: 'ShippingLabel', shippingPartner: EStandardShipmentType, labelFile: { __typename?: 'FileMetadata', filename?: string | null } }> | null, address: { __typename?: 'OAddress', houseNumber?: string | null, stairway?: string | null, door?: string | null, floor?: string | null, street?: string | null, city?: string | null, state?: string | null, countryCode?: ECountry | null, country?: string | null, zipCode?: string | null, queryString?: string | null, address1?: string | null, address2?: string | null, note?: string | null, name?: string | null, companyName?: string | null, coordinates?: { __typename?: 'OCoordinates', lat: number, lng: number } | null } } | null, premiumShippingData?: { __typename?: 'PremiumShippingData', toHourUTC: number, fromHourUTC: number, date: any, address: { __typename?: 'OAddress', houseNumber?: string | null, stairway?: string | null, door?: string | null, floor?: string | null, street?: string | null, city?: string | null, state?: string | null, countryCode?: ECountry | null, country?: string | null, zipCode?: string | null, queryString?: string | null, address1?: string | null, address2?: string | null, note?: string | null, name?: string | null, companyName?: string | null, coordinates?: { __typename?: 'OCoordinates', lat: number, lng: number } | null } } | null } | null, dropoffData?: { __typename?: 'TransportData', transportMode: ETransportMode, standardShippingData?: { __typename?: 'StandardShippingData', sentShippingLabels?: Array<{ __typename?: 'ShippingLabel', shippingPartner: EStandardShipmentType, labelFile: { __typename?: 'FileMetadata', filename?: string | null } }> | null, address: { __typename?: 'OAddress', houseNumber?: string | null, stairway?: string | null, door?: string | null, floor?: string | null, street?: string | null, city?: string | null, state?: string | null, countryCode?: ECountry | null, country?: string | null, zipCode?: string | null, queryString?: string | null, address1?: string | null, address2?: string | null, note?: string | null, name?: string | null, companyName?: string | null, coordinates?: { __typename?: 'OCoordinates', lat: number, lng: number } | null } } | null, premiumShippingData?: { __typename?: 'PremiumShippingData', toHourUTC: number, fromHourUTC: number, date: any, address: { __typename?: 'OAddress', houseNumber?: string | null, stairway?: string | null, door?: string | null, floor?: string | null, street?: string | null, city?: string | null, state?: string | null, countryCode?: ECountry | null, country?: string | null, zipCode?: string | null, queryString?: string | null, address1?: string | null, address2?: string | null, note?: string | null, name?: string | null, companyName?: string | null, coordinates?: { __typename?: 'OCoordinates', lat: number, lng: number } | null } } | null } | null, dealPartnerData?: { __typename?: 'ODealPartnerData', type: EDealPartnerType, knp?: { __typename?: 'ODealPartnerDataKnp', fileReferenceNumber: string, debtAmount: number } | null } | null, items: Array<{ __typename?: 'DealItem', _id: any, title: string, isContinueUsing: boolean, itemCategoryId: any, algoliaReference?: string | null, material?: string | null, ean?: string | null, variantId?: any | null, itemCategory: { __typename?: 'ItemCategory', _id: any, name: string, parentId?: any | null, createdAt: any, updatedAt: any, slug: string, availableTransportModes: Array<ETransportMode> }, media?: Array<{ __typename?: 'FileMetadata', url: string, contentType?: string | null }> | null, productLegacy?: { __typename?: 'ProductLegacy', title: string, picture?: { __typename?: 'UploadFile', _id: any, name: string, alternativeText: string, caption: string, hash: string, ext: string, mime: string, width: number, height: number, size: number, url: string, provider: string, createdAt: any, updatedAt: any, formats?: { __typename?: 'UploadFileFormats', thumbnail: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string }, small?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, medium?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, large?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, product_thumbnail?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, product_small?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null } | null } | null } | null, productVariant?: { __typename?: 'ProductVariant', id: any, isPriceValid: boolean, name: string, image?: { __typename?: 'ProductImage', id: string, url: string } | null, product: { __typename?: 'Product', name: string, category: { __typename?: 'ItemCategory', name: string, parentCategories: Array<{ __typename?: 'ItemCategory', name: string }> } }, propertiesValues: Array<{ __typename?: 'ProductVariantPropertyBooleanValue', propertyDefinitionId: any, propertyDefinition: { __typename?: 'ProductPropertyDefinition', _id: any, type: EProductPropertyType, impactsLook: boolean, showOnWebsite: boolean, key: string, name: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> }, valueFormatting?: { __typename?: 'PropertyDefinitionValueFormatting', suffix?: string | null } | null }, value: { __typename?: 'AvailablePropertyBooleanOption', booleanValue: boolean } } | { __typename?: 'ProductVariantPropertyNumberValue', propertyDefinitionId: any, propertyDefinition: { __typename?: 'ProductPropertyDefinition', _id: any, type: EProductPropertyType, impactsLook: boolean, showOnWebsite: boolean, key: string, name: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> }, valueFormatting?: { __typename?: 'PropertyDefinitionValueFormatting', suffix?: string | null } | null }, value: { __typename?: 'AvailablePropertyNumberOption', numberValue: number } } | { __typename?: 'ProductVariantPropertyTextValue', propertyDefinitionId: any, propertyDefinition: { __typename?: 'ProductPropertyDefinition', _id: any, type: EProductPropertyType, impactsLook: boolean, showOnWebsite: boolean, key: string, name: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> }, valueFormatting?: { __typename?: 'PropertyDefinitionValueFormatting', suffix?: string | null } | null }, value: { __typename?: 'AvailablePropertyTextOption', translation: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> } } }> } | null }>, company: { __typename?: 'Company', name: string, iban?: string | null, paypalEmail?: string | null, configuration: { __typename?: 'CompanyConfiguration', minimumPawnDuration: number, gracePeriod: number }, unzerConfiguration?: { __typename?: 'CompanyUnzerConfiguration', publicKey?: string | null } | null, successionCompany?: { __typename?: 'Company', _id: any, name: string } | null }, dealFinalValues: { __typename?: 'DealFinalValues', dealType: EDealType, durationInDays: number, shouldOverwritePayoutAmount: boolean, payoutAmount: number, isOnlineExtensionPrevented?: boolean | null }, pawnData?: { __typename?: 'PawnData', pawnNumber?: number | null, billNumber?: string | null, extensionChildId?: any | null, extensionParentId?: any | null, pawnTicketLink?: { __typename?: 'FileMetadata', url: string, contentType?: string | null } | null, billLink?: { __typename?: 'FileMetadata', url: string, contentType?: string | null } | null, paybackData?: { __typename?: 'PaymentData', iban?: string | null, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType } } | null, reservedPaybackData?: { __typename?: 'ReservedPaybackData', isExtension: boolean, date: any, paymentType: EManualPaymentType, feeAmount: number, partialRedemptionAmount: number, dueAmount: number } | null } | null, purchaseData?: { __typename?: 'PurchaseData', receiptNumber?: string | null, receiptLink?: { __typename?: 'FileMetadata', url: string, contentType?: string | null } | null } | null, events: Array<{ __typename: 'DealBookedEvent', createdAt: any, timestamp: any, displayName: string, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | { __typename: 'DealCanceledEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealClosedEvent', createdAt: any, timestamp: any, displayName: string, valorizationFeeNet?: number | null, valorizationFeeGross?: number | null, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | { __typename: 'DealCollectedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealCustomerInCreditEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealCustomerInDebtEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealDeclinedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealDerecognizedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealExcessAmountPayedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealExtensionConfirmedEvent', createdAt: any, timestamp: any, displayName: string, dueAmount: number, partialRedemptionAmount: number, overwrittenPartialRedemptionAmount?: number | null, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType }, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> }, childCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> }, itemsExtensionAnswers?: Array<{ __typename?: 'ItemExtensionAnswers', storageLabel: string, answers: Array<{ __typename?: 'ItemAnswer', questionId: any, selectedOptionIndex?: number | null, rangeValue?: number | null }> }> | null } | { __typename: 'DealItemReceivedIdMissingEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealLoanDueEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealLoanDueNotifiedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealOnSellEvent', createdAt: any, timestamp: any, displayName: string, valueAddedTaxRate: number, differenceTaxRate: number, valorizationFeeRate: number } | { __typename: 'DealPaybackConfirmedEvent', createdAt: any, timestamp: any, displayName: string, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType }, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | { __typename: 'DealPayedAndStoredEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPayedShipmentPendingEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPickedUpEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPickedUpUnsuccessfulEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealReviewingEvent', createdAt: any, timestamp: any, displayName: string, issuanceCertificate: { __typename?: 'FileMetadata', url: string, contentType?: string | null } } | { __typename: 'DealSoldExternEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealSoldInternEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealVerifiedEvent', createdAt: any, timestamp: any, displayName: string, isOverwrittenFees?: boolean | null, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } }>, payoutData: { __typename?: 'PaymentData', iban?: string | null, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType } } } };

export type GetDealByShippingLabelPageIdQueryVariables = Exact<{
  shippingLabelPageId: Scalars['String']['input'];
}>;


export type GetDealByShippingLabelPageIdQuery = { __typename?: 'Query', getDealByShippingLabelPageId: { __typename?: 'Deal', businessUnit: EBusinessUnit, itemsIds: Array<any>, isPaybackPaymentOngoing: boolean, shippingLabelPageId?: string | null, isExtensionPaymentOngoing: boolean, _id: any, createdAt: any, updatedAt: any, dealType: EDealType, bookingNumber: number, initialShopId?: any | null, latestOngoingPaymentRequestedAt?: any | null, hasCompletedPayment: boolean, isInOpenAuction?: boolean | null, acceptingWithdrawalFeeTermsRequired: boolean, canDealOnSellBeExtendedOrPaidBack: boolean, pickupData?: { __typename?: 'TransportData', transportMode: ETransportMode, standardShippingData?: { __typename?: 'StandardShippingData', sentShippingLabels?: Array<{ __typename?: 'ShippingLabel', shippingPartner: EStandardShipmentType, labelFile: { __typename?: 'FileMetadata', filename?: string | null } }> | null, address: { __typename?: 'OAddress', houseNumber?: string | null, stairway?: string | null, door?: string | null, floor?: string | null, street?: string | null, city?: string | null, state?: string | null, countryCode?: ECountry | null, country?: string | null, zipCode?: string | null, queryString?: string | null, address1?: string | null, address2?: string | null, note?: string | null, name?: string | null, companyName?: string | null, coordinates?: { __typename?: 'OCoordinates', lat: number, lng: number } | null } } | null, premiumShippingData?: { __typename?: 'PremiumShippingData', toHourUTC: number, fromHourUTC: number, date: any, address: { __typename?: 'OAddress', houseNumber?: string | null, stairway?: string | null, door?: string | null, floor?: string | null, street?: string | null, city?: string | null, state?: string | null, countryCode?: ECountry | null, country?: string | null, zipCode?: string | null, queryString?: string | null, address1?: string | null, address2?: string | null, note?: string | null, name?: string | null, companyName?: string | null, coordinates?: { __typename?: 'OCoordinates', lat: number, lng: number } | null } } | null } | null, dropoffData?: { __typename?: 'TransportData', transportMode: ETransportMode, standardShippingData?: { __typename?: 'StandardShippingData', sentShippingLabels?: Array<{ __typename?: 'ShippingLabel', shippingPartner: EStandardShipmentType, labelFile: { __typename?: 'FileMetadata', filename?: string | null } }> | null, address: { __typename?: 'OAddress', houseNumber?: string | null, stairway?: string | null, door?: string | null, floor?: string | null, street?: string | null, city?: string | null, state?: string | null, countryCode?: ECountry | null, country?: string | null, zipCode?: string | null, queryString?: string | null, address1?: string | null, address2?: string | null, note?: string | null, name?: string | null, companyName?: string | null, coordinates?: { __typename?: 'OCoordinates', lat: number, lng: number } | null } } | null, premiumShippingData?: { __typename?: 'PremiumShippingData', toHourUTC: number, fromHourUTC: number, date: any, address: { __typename?: 'OAddress', houseNumber?: string | null, stairway?: string | null, door?: string | null, floor?: string | null, street?: string | null, city?: string | null, state?: string | null, countryCode?: ECountry | null, country?: string | null, zipCode?: string | null, queryString?: string | null, address1?: string | null, address2?: string | null, note?: string | null, name?: string | null, companyName?: string | null, coordinates?: { __typename?: 'OCoordinates', lat: number, lng: number } | null } } | null } | null, dealPartnerData?: { __typename?: 'ODealPartnerData', type: EDealPartnerType, knp?: { __typename?: 'ODealPartnerDataKnp', fileReferenceNumber: string, debtAmount: number } | null } | null, items: Array<{ __typename?: 'DealItem', _id: any, title: string, isContinueUsing: boolean, itemCategoryId: any, algoliaReference?: string | null, material?: string | null, ean?: string | null, variantId?: any | null, itemCategory: { __typename?: 'ItemCategory', _id: any, name: string, parentId?: any | null, createdAt: any, updatedAt: any, slug: string, availableTransportModes: Array<ETransportMode> }, media?: Array<{ __typename?: 'FileMetadata', url: string, contentType?: string | null }> | null, productLegacy?: { __typename?: 'ProductLegacy', title: string, picture?: { __typename?: 'UploadFile', _id: any, name: string, alternativeText: string, caption: string, hash: string, ext: string, mime: string, width: number, height: number, size: number, url: string, provider: string, createdAt: any, updatedAt: any, formats?: { __typename?: 'UploadFileFormats', thumbnail: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string }, small?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, medium?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, large?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, product_thumbnail?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, product_small?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null } | null } | null } | null, productVariant?: { __typename?: 'ProductVariant', id: any, isPriceValid: boolean, name: string, image?: { __typename?: 'ProductImage', id: string, url: string } | null, product: { __typename?: 'Product', name: string, category: { __typename?: 'ItemCategory', name: string, parentCategories: Array<{ __typename?: 'ItemCategory', name: string }> } }, propertiesValues: Array<{ __typename?: 'ProductVariantPropertyBooleanValue', propertyDefinitionId: any, propertyDefinition: { __typename?: 'ProductPropertyDefinition', _id: any, type: EProductPropertyType, impactsLook: boolean, showOnWebsite: boolean, key: string, name: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> }, valueFormatting?: { __typename?: 'PropertyDefinitionValueFormatting', suffix?: string | null } | null }, value: { __typename?: 'AvailablePropertyBooleanOption', booleanValue: boolean } } | { __typename?: 'ProductVariantPropertyNumberValue', propertyDefinitionId: any, propertyDefinition: { __typename?: 'ProductPropertyDefinition', _id: any, type: EProductPropertyType, impactsLook: boolean, showOnWebsite: boolean, key: string, name: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> }, valueFormatting?: { __typename?: 'PropertyDefinitionValueFormatting', suffix?: string | null } | null }, value: { __typename?: 'AvailablePropertyNumberOption', numberValue: number } } | { __typename?: 'ProductVariantPropertyTextValue', propertyDefinitionId: any, propertyDefinition: { __typename?: 'ProductPropertyDefinition', _id: any, type: EProductPropertyType, impactsLook: boolean, showOnWebsite: boolean, key: string, name: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> }, valueFormatting?: { __typename?: 'PropertyDefinitionValueFormatting', suffix?: string | null } | null }, value: { __typename?: 'AvailablePropertyTextOption', translation: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> } } }> } | null }>, company: { __typename?: 'Company', name: string, iban?: string | null, paypalEmail?: string | null, configuration: { __typename?: 'CompanyConfiguration', minimumPawnDuration: number, gracePeriod: number }, unzerConfiguration?: { __typename?: 'CompanyUnzerConfiguration', publicKey?: string | null } | null, successionCompany?: { __typename?: 'Company', _id: any, name: string } | null }, dealFinalValues: { __typename?: 'DealFinalValues', dealType: EDealType, durationInDays: number, shouldOverwritePayoutAmount: boolean, payoutAmount: number, isOnlineExtensionPrevented?: boolean | null }, pawnData?: { __typename?: 'PawnData', pawnNumber?: number | null, billNumber?: string | null, extensionChildId?: any | null, extensionParentId?: any | null, pawnTicketLink?: { __typename?: 'FileMetadata', url: string, contentType?: string | null } | null, billLink?: { __typename?: 'FileMetadata', url: string, contentType?: string | null } | null, paybackData?: { __typename?: 'PaymentData', iban?: string | null, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType } } | null, reservedPaybackData?: { __typename?: 'ReservedPaybackData', isExtension: boolean, date: any, paymentType: EManualPaymentType, feeAmount: number, partialRedemptionAmount: number, dueAmount: number } | null } | null, purchaseData?: { __typename?: 'PurchaseData', receiptNumber?: string | null, receiptLink?: { __typename?: 'FileMetadata', url: string, contentType?: string | null } | null } | null, events: Array<{ __typename: 'DealBookedEvent', createdAt: any, timestamp: any, displayName: string, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | { __typename: 'DealCanceledEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealClosedEvent', createdAt: any, timestamp: any, displayName: string, valorizationFeeNet?: number | null, valorizationFeeGross?: number | null, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | { __typename: 'DealCollectedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealCustomerInCreditEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealCustomerInDebtEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealDeclinedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealDerecognizedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealExcessAmountPayedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealExtensionConfirmedEvent', createdAt: any, timestamp: any, displayName: string, dueAmount: number, partialRedemptionAmount: number, overwrittenPartialRedemptionAmount?: number | null, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType }, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> }, childCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> }, itemsExtensionAnswers?: Array<{ __typename?: 'ItemExtensionAnswers', storageLabel: string, answers: Array<{ __typename?: 'ItemAnswer', questionId: any, selectedOptionIndex?: number | null, rangeValue?: number | null }> }> | null } | { __typename: 'DealItemReceivedIdMissingEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealLoanDueEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealLoanDueNotifiedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealOnSellEvent', createdAt: any, timestamp: any, displayName: string, valueAddedTaxRate: number, differenceTaxRate: number, valorizationFeeRate: number } | { __typename: 'DealPaybackConfirmedEvent', createdAt: any, timestamp: any, displayName: string, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType }, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | { __typename: 'DealPayedAndStoredEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPayedShipmentPendingEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPickedUpEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPickedUpUnsuccessfulEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealReviewingEvent', createdAt: any, timestamp: any, displayName: string, issuanceCertificate: { __typename?: 'FileMetadata', url: string, contentType?: string | null } } | { __typename: 'DealSoldExternEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealSoldInternEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealVerifiedEvent', createdAt: any, timestamp: any, displayName: string, isOverwrittenFees?: boolean | null, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } }>, payoutData: { __typename?: 'PaymentData', iban?: string | null, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType } } } };

export type GetDealsForCustomerQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
}>;


export type GetDealsForCustomerQuery = { __typename?: 'Query', getCurrentCustomer: { __typename?: 'Customer', _id: any, activeDeals: Array<{ __typename?: 'Deal', events: Array<{ __typename: 'DealBookedEvent', createdAt: any, timestamp: any, displayName: string, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | { __typename: 'DealCanceledEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealClosedEvent', createdAt: any, timestamp: any, displayName: string, valorizationFeeNet?: number | null, valorizationFeeGross?: number | null, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | { __typename: 'DealCollectedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealCustomerInCreditEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealCustomerInDebtEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealDeclinedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealDerecognizedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealExcessAmountPayedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealExtensionConfirmedEvent', createdAt: any, timestamp: any, displayName: string, dueAmount: number, partialRedemptionAmount: number, overwrittenPartialRedemptionAmount?: number | null, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType }, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> }, childCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> }, itemsExtensionAnswers?: Array<{ __typename?: 'ItemExtensionAnswers', storageLabel: string, answers: Array<{ __typename?: 'ItemAnswer', questionId: any, selectedOptionIndex?: number | null, rangeValue?: number | null }> }> | null } | { __typename: 'DealItemReceivedIdMissingEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealLoanDueEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealLoanDueNotifiedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealOnSellEvent', createdAt: any, timestamp: any, displayName: string, valueAddedTaxRate: number, differenceTaxRate: number, valorizationFeeRate: number } | { __typename: 'DealPaybackConfirmedEvent', createdAt: any, timestamp: any, displayName: string, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType }, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | { __typename: 'DealPayedAndStoredEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPayedShipmentPendingEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPickedUpEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPickedUpUnsuccessfulEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealReviewingEvent', createdAt: any, timestamp: any, displayName: string, issuanceCertificate: { __typename?: 'FileMetadata', url: string, contentType?: string | null } } | { __typename: 'DealSoldExternEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealSoldInternEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealVerifiedEvent', createdAt: any, timestamp: any, displayName: string, isOverwrittenFees?: boolean | null, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } }> }> } };

export type GetDealsForCustomerAndCalculationQueryVariables = Exact<{
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  extensionCalculationArgs: DealExtensionCalculationArgs;
  paybackCalculationArgs: DealPaybackCalculationArgs;
}>;


export type GetDealsForCustomerAndCalculationQuery = { __typename?: 'Query', getCurrentCustomer: { __typename?: 'Customer', _id: any, deals: Array<{ __typename?: 'Deal', isPaybackPaymentOngoing: boolean, isExtensionPaymentOngoing: boolean, _id: any, createdAt: any, updatedAt: any, dealType: EDealType, bookingNumber: number, shippingLabelPageId?: string | null, latestOngoingPaymentRequestedAt?: any | null, hasCompletedPayment: boolean, isInOpenAuction?: boolean | null, acceptingWithdrawalFeeTermsRequired: boolean, canDealOnSellBeExtendedOrPaidBack: boolean, persistedExtensionCalculation?: { __typename?: 'PersistedDealExtensionCalculation', dealId: any, dueAmount: number, partialRedemptionAmount: number, overwrittenPartialRedemptionAmount?: number | null, dealExtensionCalculationId: any, itemsExtensionAnswers: Array<{ __typename?: 'ItemExtensionAnswers', storageLabel: string, answers: Array<{ __typename?: 'ItemAnswer', questionId: any, selectedOptionIndex?: number | null, rangeValue?: number | null }> }>, childDealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> }, parentDealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | null, persistedPaybackCalculation?: { __typename?: 'PersistedDealPaybackCalculation', dealId: any, dealPaybackCalculationId: any, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | null, items: Array<{ __typename?: 'DealItem', _id: any, title: string, itemCategoryId: any, isContinueUsing: boolean, itemCategory: { __typename?: 'ItemCategory', _id: any, name: string, parentId?: any | null, createdAt: any, updatedAt: any, slug: string, availableTransportModes: Array<ETransportMode> }, productLegacy?: { __typename?: 'ProductLegacy', title: string, picture?: { __typename?: 'UploadFile', _id: any, name: string, alternativeText: string, caption: string, hash: string, ext: string, mime: string, width: number, height: number, size: number, url: string, provider: string, createdAt: any, updatedAt: any, formats?: { __typename?: 'UploadFileFormats', thumbnail: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string }, small?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, medium?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, large?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, product_thumbnail?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null, product_small?: { __typename?: 'UploadFileFormat', hash: string, ext: string, mime: string, width: number, height: number, size: number, path?: string | null, url: string } | null } | null } | null } | null, productVariant?: { __typename?: 'ProductVariant', id: any, isPriceValid: boolean, name: string, product: { __typename?: 'Product', name: string, category: { __typename?: 'ItemCategory', name: string, parentCategories: Array<{ __typename?: 'ItemCategory', name: string }> } }, image?: { __typename?: 'ProductImage', id: string, url: string } | null, propertiesValues: Array<{ __typename?: 'ProductVariantPropertyBooleanValue', propertyDefinitionId: any, propertyDefinition: { __typename?: 'ProductPropertyDefinition', _id: any, type: EProductPropertyType, impactsLook: boolean, showOnWebsite: boolean, key: string, name: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> }, valueFormatting?: { __typename?: 'PropertyDefinitionValueFormatting', suffix?: string | null } | null }, value: { __typename?: 'AvailablePropertyBooleanOption', booleanValue: boolean } } | { __typename?: 'ProductVariantPropertyNumberValue', propertyDefinitionId: any, propertyDefinition: { __typename?: 'ProductPropertyDefinition', _id: any, type: EProductPropertyType, impactsLook: boolean, showOnWebsite: boolean, key: string, name: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> }, valueFormatting?: { __typename?: 'PropertyDefinitionValueFormatting', suffix?: string | null } | null }, value: { __typename?: 'AvailablePropertyNumberOption', numberValue: number } } | { __typename?: 'ProductVariantPropertyTextValue', propertyDefinitionId: any, propertyDefinition: { __typename?: 'ProductPropertyDefinition', _id: any, type: EProductPropertyType, impactsLook: boolean, showOnWebsite: boolean, key: string, name: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> }, valueFormatting?: { __typename?: 'PropertyDefinitionValueFormatting', suffix?: string | null } | null }, value: { __typename?: 'AvailablePropertyTextOption', translation: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> } } }> } | null }>, dealFinalValues: { __typename?: 'DealFinalValues', dealType: EDealType, durationInDays: number, shouldOverwritePayoutAmount: boolean, payoutAmount: number, isOnlineExtensionPrevented?: boolean | null }, pawnData?: { __typename?: 'PawnData', pawnNumber?: number | null, billNumber?: string | null, extensionChildId?: any | null, extensionParentId?: any | null, pawnTicketLink?: { __typename?: 'FileMetadata', url: string, contentType?: string | null } | null, billLink?: { __typename?: 'FileMetadata', url: string, contentType?: string | null } | null, paybackData?: { __typename?: 'PaymentData', iban?: string | null, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType } } | null, reservedPaybackData?: { __typename?: 'ReservedPaybackData', isExtension: boolean, date: any, paymentType: EManualPaymentType, feeAmount: number, partialRedemptionAmount: number, dueAmount: number } | null } | null, events: Array<{ __typename: 'DealBookedEvent', createdAt: any, timestamp: any, displayName: string, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | { __typename: 'DealCanceledEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealClosedEvent', createdAt: any, timestamp: any, displayName: string, valorizationFeeNet?: number | null, valorizationFeeGross?: number | null, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | { __typename: 'DealCollectedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealCustomerInCreditEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealCustomerInDebtEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealDeclinedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealDerecognizedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealExcessAmountPayedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealExtensionConfirmedEvent', createdAt: any, timestamp: any, displayName: string, dueAmount: number, partialRedemptionAmount: number, overwrittenPartialRedemptionAmount?: number | null, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType }, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> }, childCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> }, itemsExtensionAnswers?: Array<{ __typename?: 'ItemExtensionAnswers', storageLabel: string, answers: Array<{ __typename?: 'ItemAnswer', questionId: any, selectedOptionIndex?: number | null, rangeValue?: number | null }> }> | null } | { __typename: 'DealItemReceivedIdMissingEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealLoanDueEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealLoanDueNotifiedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealOnSellEvent', createdAt: any, timestamp: any, displayName: string, valueAddedTaxRate: number, differenceTaxRate: number, valorizationFeeRate: number } | { __typename: 'DealPaybackConfirmedEvent', createdAt: any, timestamp: any, displayName: string, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType }, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | { __typename: 'DealPayedAndStoredEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPayedShipmentPendingEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPickedUpEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPickedUpUnsuccessfulEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealReviewingEvent', createdAt: any, timestamp: any, displayName: string, issuanceCertificate: { __typename?: 'FileMetadata', url: string, contentType?: string | null } } | { __typename: 'DealSoldExternEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealSoldInternEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealVerifiedEvent', createdAt: any, timestamp: any, displayName: string, isOverwrittenFees?: boolean | null, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } }> }>, customDeals: Array<{ __typename?: 'CustomDeal', _id: any, customDealNumber: number, status?: ECustomDealStatusType | null, createdAt: any, updatedAt: any, durationInDays: number, isPayoutOverwritten?: boolean | null, isReversedFeeCalculation?: boolean | null, dealType: EDealType, overridePayoutAmount: number, availableTransportModes: Array<ETransportMode>, contactData: { __typename?: 'CustomDealContactData', email?: string | null, phone?: string | null }, company: { __typename?: 'Company', _id: any, configuration: { __typename?: 'CompanyConfiguration', minimumPawnDuration: number, gracePeriod: number } }, items: Array<{ __typename?: 'CustomDealItemDataEntry', itemCategoryId: any, title: string, note?: string | null, algoliaReference?: string | null, policeNumber?: string | null, pawnPayoutAmount: number, purchasePayoutAmount: number, overwrittenPawnPayoutAmount?: number | null, overwrittenPurchasePayoutAmount?: number | null, ean?: string | null, material?: string | null, counterofferPayoutAmount?: number | null, foundComparableOffers?: ECustomItemFoundComparableOffers | null, overwrittenItemValue?: number | null, foundOffersEvaluationFactor?: number | null, variantId?: any | null, productVariant?: { __typename?: 'ProductVariant', id: any, isPriceValid: boolean, name: string, image?: { __typename?: 'ProductImage', id: string, url: string } | null, product: { __typename?: 'Product', name: string, category: { __typename?: 'ItemCategory', name: string, parentCategories: Array<{ __typename?: 'ItemCategory', name: string }> } }, propertiesValues: Array<{ __typename?: 'ProductVariantPropertyBooleanValue', propertyDefinitionId: any, propertyDefinition: { __typename?: 'ProductPropertyDefinition', _id: any, type: EProductPropertyType, impactsLook: boolean, showOnWebsite: boolean, key: string, name: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> }, valueFormatting?: { __typename?: 'PropertyDefinitionValueFormatting', suffix?: string | null } | null }, value: { __typename?: 'AvailablePropertyBooleanOption', booleanValue: boolean } } | { __typename?: 'ProductVariantPropertyNumberValue', propertyDefinitionId: any, propertyDefinition: { __typename?: 'ProductPropertyDefinition', _id: any, type: EProductPropertyType, impactsLook: boolean, showOnWebsite: boolean, key: string, name: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> }, valueFormatting?: { __typename?: 'PropertyDefinitionValueFormatting', suffix?: string | null } | null }, value: { __typename?: 'AvailablePropertyNumberOption', numberValue: number } } | { __typename?: 'ProductVariantPropertyTextValue', propertyDefinitionId: any, propertyDefinition: { __typename?: 'ProductPropertyDefinition', _id: any, type: EProductPropertyType, impactsLook: boolean, showOnWebsite: boolean, key: string, name: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> }, valueFormatting?: { __typename?: 'PropertyDefinitionValueFormatting', suffix?: string | null } | null }, value: { __typename?: 'AvailablePropertyTextOption', translation: { __typename?: 'TranslatedString', allTranslations: Array<{ __typename?: 'TranslationItem', text: string, languageCode: ELanguageCode }> } } }> } | null, priceFindings?: Array<{ __typename?: 'PriceFinding', price?: number | null }> | null, media?: Array<{ __typename?: 'FileMetadata', url: string, contentType?: string | null }> | null, answers?: Array<{ __typename?: 'ItemAnswer', questionId: any, selectedOptionIndex?: number | null, rangeValue?: number | null }> | null, itemPawnValueEntry?: { __typename?: 'ItemValuesEntry', adjustedMarketValue: number, payoutAmount?: number | null } | null, itemPurchaseValueEntry?: { __typename?: 'ItemValuesEntry', adjustedMarketValue: number, payoutAmount?: number | null } | null }>, events: Array<{ __typename?: 'CustomDealEvent', event: ECustomDealStatusType, createdAt: any, timestamp: any }>, pawnCalculation?: { __typename?: 'CustomDealCalculation', payoutAmount: number } | null, purchaseCalculation?: { __typename?: 'CustomDealCalculation', payoutAmount: number } | null }> } };

export type UpdateCustomerMutationVariables = Exact<{
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  paypalAddress?: InputMaybe<Scalars['String']['input']>;
  addresses?: InputMaybe<Array<ICustomerAddress> | ICustomerAddress>;
  identityType?: InputMaybe<ECustomerIdentityType>;
  identityUploadLinks?: InputMaybe<Array<FileTusMetadataArgs> | FileTusMetadataArgs>;
}>;


export type UpdateCustomerMutation = { __typename?: 'Mutation', updateCustomer: { __typename?: 'Customer', _id: any, firstname: string, lastname: string, phone: string, iban?: string | null, paypalAddress?: string | null, addresses?: Array<{ __typename?: 'OCustomerAddress', street?: string | null, countryCode?: ECountry | null, zipCode?: string | null, houseNumber?: string | null, floor?: string | null, door?: string | null, city?: string | null, state?: string | null, country?: string | null, stairway?: string | null, queryString?: string | null, note?: string | null, isDeliveryAddress?: boolean | null, isBillingAddress?: boolean | null, coordinates?: { __typename?: 'OCoordinates', lat: number, lng: number } | null }> | null } };

export type ReserveExtensionMutationVariables = Exact<{
  args: ReserveExtensionArgs;
}>;


export type ReserveExtensionMutation = { __typename?: 'Mutation', reserveExtension: { __typename?: 'Deal', _id: any, pawnData?: { __typename?: 'PawnData', pawnNumber?: number | null, billNumber?: string | null, extensionChildId?: any | null, extensionParentId?: any | null, pawnTicketLink?: { __typename?: 'FileMetadata', url: string, contentType?: string | null } | null, billLink?: { __typename?: 'FileMetadata', url: string, contentType?: string | null } | null, paybackData?: { __typename?: 'PaymentData', iban?: string | null, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType } } | null, reservedPaybackData?: { __typename?: 'ReservedPaybackData', isExtension: boolean, date: any, paymentType: EManualPaymentType, feeAmount: number, partialRedemptionAmount: number, dueAmount: number } | null } | null } };

export type ReservePaybackMutationVariables = Exact<{
  args: ReservePaybackArgs;
}>;


export type ReservePaybackMutation = { __typename?: 'Mutation', reservePayback: { __typename?: 'Deal', _id: any, pawnData?: { __typename?: 'PawnData', pawnNumber?: number | null, billNumber?: string | null, extensionChildId?: any | null, extensionParentId?: any | null, pawnTicketLink?: { __typename?: 'FileMetadata', url: string, contentType?: string | null } | null, billLink?: { __typename?: 'FileMetadata', url: string, contentType?: string | null } | null, paybackData?: { __typename?: 'PaymentData', iban?: string | null, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType } } | null, reservedPaybackData?: { __typename?: 'ReservedPaybackData', isExtension: boolean, date: any, paymentType: EManualPaymentType, feeAmount: number, partialRedemptionAmount: number, dueAmount: number } | null } | null } };

export type GetExistingDealCalculationQueryVariables = Exact<{
  dealId: Scalars['ObjectId']['input'];
  args: GetExistingDealCalculationArgs;
}>;


export type GetExistingDealCalculationQuery = { __typename?: 'Query', getExistingDealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } };

export type UpdatePasswordMutationVariables = Exact<{
  oldPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type UpdatePasswordMutation = { __typename?: 'Mutation', updateCustomerPassword: { __typename?: 'Customer', firstname: string, lastname: string, _id: any } };

export type CancelDealMutationVariables = Exact<{
  dealId: Scalars['ObjectId']['input'];
}>;


export type CancelDealMutation = { __typename?: 'Mutation', cancelDeal: { __typename?: 'Deal', _id: any, events: Array<{ __typename: 'DealBookedEvent', createdAt: any, timestamp: any, displayName: string, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | { __typename: 'DealCanceledEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealClosedEvent', createdAt: any, timestamp: any, displayName: string, valorizationFeeNet?: number | null, valorizationFeeGross?: number | null, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | { __typename: 'DealCollectedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealCustomerInCreditEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealCustomerInDebtEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealDeclinedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealDerecognizedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealExcessAmountPayedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealExtensionConfirmedEvent', createdAt: any, timestamp: any, displayName: string, dueAmount: number, partialRedemptionAmount: number, overwrittenPartialRedemptionAmount?: number | null, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType }, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> }, childCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> }, itemsExtensionAnswers?: Array<{ __typename?: 'ItemExtensionAnswers', storageLabel: string, answers: Array<{ __typename?: 'ItemAnswer', questionId: any, selectedOptionIndex?: number | null, rangeValue?: number | null }> }> | null } | { __typename: 'DealItemReceivedIdMissingEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealLoanDueEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealLoanDueNotifiedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealOnSellEvent', createdAt: any, timestamp: any, displayName: string, valueAddedTaxRate: number, differenceTaxRate: number, valorizationFeeRate: number } | { __typename: 'DealPaybackConfirmedEvent', createdAt: any, timestamp: any, displayName: string, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType }, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | { __typename: 'DealPayedAndStoredEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPayedShipmentPendingEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPickedUpEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPickedUpUnsuccessfulEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealReviewingEvent', createdAt: any, timestamp: any, displayName: string, issuanceCertificate: { __typename?: 'FileMetadata', url: string, contentType?: string | null } } | { __typename: 'DealSoldExternEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealSoldInternEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealVerifiedEvent', createdAt: any, timestamp: any, displayName: string, isOverwrittenFees?: boolean | null, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } }> } };

export type DeleteCustomerMutationVariables = Exact<{
  customerId: Scalars['ObjectId']['input'];
}>;


export type DeleteCustomerMutation = { __typename?: 'Mutation', deleteCustomer: boolean };

export type DealExtensionCalculationQueryVariables = Exact<{
  dealId: Scalars['ObjectId']['input'];
  args: DealExtensionCalculationArgs;
}>;


export type DealExtensionCalculationQuery = { __typename?: 'Query', dealExtensionCalculation?: { __typename?: 'PersistedDealExtensionCalculation', dealId: any, dueAmount: number, partialRedemptionAmount: number, overwrittenPartialRedemptionAmount?: number | null, dealExtensionCalculationId: any, itemsExtensionAnswers: Array<{ __typename?: 'ItemExtensionAnswers', storageLabel: string, answers: Array<{ __typename?: 'ItemAnswer', questionId: any, selectedOptionIndex?: number | null, rangeValue?: number | null }> }>, childDealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> }, parentDealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | null };

export type DealPaybackCalculationQueryVariables = Exact<{
  dealId: Scalars['ObjectId']['input'];
  args: DealPaybackCalculationArgs;
}>;


export type DealPaybackCalculationQuery = { __typename?: 'Query', dealPaybackCalculation?: { __typename?: 'PersistedDealPaybackCalculation', dealId: any, dealPaybackCalculationId: any, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | null };

export type CancelPaybackExtensionMutationVariables = Exact<{
  dealId: Scalars['ObjectId']['input'];
}>;


export type CancelPaybackExtensionMutation = { __typename?: 'Mutation', cancelPaybackExtension: { __typename?: 'Deal', _id: any, events: Array<{ __typename: 'DealBookedEvent', createdAt: any, timestamp: any, displayName: string, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | { __typename: 'DealCanceledEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealClosedEvent', createdAt: any, timestamp: any, displayName: string, valorizationFeeNet?: number | null, valorizationFeeGross?: number | null, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | { __typename: 'DealCollectedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealCustomerInCreditEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealCustomerInDebtEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealDeclinedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealDerecognizedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealExcessAmountPayedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealExtensionConfirmedEvent', createdAt: any, timestamp: any, displayName: string, dueAmount: number, partialRedemptionAmount: number, overwrittenPartialRedemptionAmount?: number | null, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType }, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> }, childCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> }, itemsExtensionAnswers?: Array<{ __typename?: 'ItemExtensionAnswers', storageLabel: string, answers: Array<{ __typename?: 'ItemAnswer', questionId: any, selectedOptionIndex?: number | null, rangeValue?: number | null }> }> | null } | { __typename: 'DealItemReceivedIdMissingEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealLoanDueEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealLoanDueNotifiedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealOnSellEvent', createdAt: any, timestamp: any, displayName: string, valueAddedTaxRate: number, differenceTaxRate: number, valorizationFeeRate: number } | { __typename: 'DealPaybackConfirmedEvent', createdAt: any, timestamp: any, displayName: string, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType }, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | { __typename: 'DealPayedAndStoredEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPayedShipmentPendingEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPickedUpEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPickedUpUnsuccessfulEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealReviewingEvent', createdAt: any, timestamp: any, displayName: string, issuanceCertificate: { __typename?: 'FileMetadata', url: string, contentType?: string | null } } | { __typename: 'DealSoldExternEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealSoldInternEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealVerifiedEvent', createdAt: any, timestamp: any, displayName: string, isOverwrittenFees?: boolean | null, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } }> } };

export type DeactivateCustomerMutationVariables = Exact<{
  customerId: Scalars['ObjectId']['input'];
}>;


export type DeactivateCustomerMutation = { __typename?: 'Mutation', deactivateCustomer: boolean };

export type GetItemCategoryQueryVariables = Exact<{
  itemCategoryId: Scalars['ObjectId']['input'];
}>;


export type GetItemCategoryQuery = { __typename?: 'Query', getItemCategory: { __typename?: 'ItemCategory', _id: any, name: string, parentId?: any | null, algoliaCategorySlug?: string | null, createdAt: any, updatedAt: any, slug: string, visibleOnDomain: EVisibleOnDomain, availableTransportModes: Array<ETransportMode>, maximumPawnDuration: EMaximumPawnDuration } };

export type PayExtensionOnlineMutationVariables = Exact<{
  onlinePaymentArgs: OnlinePaymentArgs;
}>;


export type PayExtensionOnlineMutation = { __typename?: 'Mutation', payExtensionOnline: { __typename?: 'OnlinePaymentResult', deal: { __typename?: 'Deal', _id: any, bookingNumber: number }, paymentResult: { __typename?: 'FailedPayment', id: string, errors: Array<{ __typename?: 'FailedPaymentError', code: EUnzerFailedPaymentErrorCode }> } | { __typename?: 'PendingPayment', redirectUrl: string, id: string } | { __typename?: 'SuccessfulPayment', id: string } } };

export type ValidatePaybackOrExtendDealPersistanceCalculationMutationVariables = Exact<{
  args: ValidatePaybackOrExtendDealPersistanceCalculationArgs;
}>;


export type ValidatePaybackOrExtendDealPersistanceCalculationMutation = { __typename?: 'Mutation', validatePaybackOrExtendDealPersistanceCalculation: boolean };

export type DealOnlinePaymentSucceedFragmentFragment = { __typename?: 'Deal', _id: any, createdAt: any, updatedAt: any, isPaybackPaymentOngoing: boolean, isExtensionPaymentOngoing: boolean, latestOngoingPaymentRequestedAt?: any | null, hasCompletedPayment: boolean, events: Array<{ __typename: 'DealBookedEvent', createdAt: any, timestamp: any, displayName: string, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | { __typename: 'DealCanceledEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealClosedEvent', createdAt: any, timestamp: any, displayName: string, valorizationFeeNet?: number | null, valorizationFeeGross?: number | null, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | { __typename: 'DealCollectedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealCustomerInCreditEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealCustomerInDebtEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealDeclinedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealDerecognizedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealExcessAmountPayedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealExtensionConfirmedEvent', createdAt: any, timestamp: any, displayName: string, dueAmount: number, partialRedemptionAmount: number, overwrittenPartialRedemptionAmount?: number | null, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType }, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> }, childCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> }, itemsExtensionAnswers?: Array<{ __typename?: 'ItemExtensionAnswers', storageLabel: string, answers: Array<{ __typename?: 'ItemAnswer', questionId: any, selectedOptionIndex?: number | null, rangeValue?: number | null }> }> | null } | { __typename: 'DealItemReceivedIdMissingEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealLoanDueEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealLoanDueNotifiedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealOnSellEvent', createdAt: any, timestamp: any, displayName: string, valueAddedTaxRate: number, differenceTaxRate: number, valorizationFeeRate: number } | { __typename: 'DealPaybackConfirmedEvent', createdAt: any, timestamp: any, displayName: string, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType }, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | { __typename: 'DealPayedAndStoredEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPayedShipmentPendingEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPickedUpEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPickedUpUnsuccessfulEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealReviewingEvent', createdAt: any, timestamp: any, displayName: string, issuanceCertificate: { __typename?: 'FileMetadata', url: string, contentType?: string | null } } | { __typename: 'DealSoldExternEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealSoldInternEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealVerifiedEvent', createdAt: any, timestamp: any, displayName: string, isOverwrittenFees?: boolean | null, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } }> };

export type OnlinePaymentSucceededSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnlinePaymentSucceededSubscription = { __typename?: 'Subscription', onlinePaymentSucceeded: { __typename?: 'Deal', _id: any, createdAt: any, updatedAt: any, isPaybackPaymentOngoing: boolean, isExtensionPaymentOngoing: boolean, latestOngoingPaymentRequestedAt?: any | null, hasCompletedPayment: boolean, events: Array<{ __typename: 'DealBookedEvent', createdAt: any, timestamp: any, displayName: string, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | { __typename: 'DealCanceledEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealClosedEvent', createdAt: any, timestamp: any, displayName: string, valorizationFeeNet?: number | null, valorizationFeeGross?: number | null, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | { __typename: 'DealCollectedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealCustomerInCreditEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealCustomerInDebtEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealDeclinedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealDerecognizedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealExcessAmountPayedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealExtensionConfirmedEvent', createdAt: any, timestamp: any, displayName: string, dueAmount: number, partialRedemptionAmount: number, overwrittenPartialRedemptionAmount?: number | null, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType }, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> }, childCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> }, itemsExtensionAnswers?: Array<{ __typename?: 'ItemExtensionAnswers', storageLabel: string, answers: Array<{ __typename?: 'ItemAnswer', questionId: any, selectedOptionIndex?: number | null, rangeValue?: number | null }> }> | null } | { __typename: 'DealItemReceivedIdMissingEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealLoanDueEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealLoanDueNotifiedEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealOnSellEvent', createdAt: any, timestamp: any, displayName: string, valueAddedTaxRate: number, differenceTaxRate: number, valorizationFeeRate: number } | { __typename: 'DealPaybackConfirmedEvent', createdAt: any, timestamp: any, displayName: string, paymentType: { __typename?: 'AutomaticPaymentWrapper', automatic: EAutomaticPaymentType } | { __typename?: 'ManualPaymentWrapper', manual: EManualPaymentType }, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } } | { __typename: 'DealPayedAndStoredEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPayedShipmentPendingEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPickedUpEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealPickedUpUnsuccessfulEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealReviewingEvent', createdAt: any, timestamp: any, displayName: string, issuanceCertificate: { __typename?: 'FileMetadata', url: string, contentType?: string | null } } | { __typename: 'DealSoldExternEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealSoldInternEvent', createdAt: any, timestamp: any, displayName: string } | { __typename: 'DealVerifiedEvent', createdAt: any, timestamp: any, displayName: string, isOverwrittenFees?: boolean | null, dealCalculation: { __typename?: 'DealCalculation', date: any, loanToValuesEntryId: any, dealValuesEntry: { __typename?: 'DealValuesEntry', payoutAmount: number, paybackAmount: number, calculationPayoutAmount: number, calculationPaybackAmount: number, durationInDays: number, shouldOverwritePayoutAmount: boolean, overwrittenPayoutAmount: number }, itemsValuesEntries: Array<{ __typename?: 'ItemValuesEntry', maxMarketValue?: number | null, currentMarketValue?: number | null, predictedMarketValue?: number | null, adjustedMarketValue: number, durationInDays: number, loanToValue: number, date: any, payoutAmount?: number | null, conditionMaxMarketValues?: { __typename?: 'ConditionMaxMarketValues', excellent: number, good: number, poor: number } | null }>, appliedUsedFeeDefinitions: Array<{ __typename?: 'UsedFeeDefinition', itemCategoryId: any, feeWeight: number, calculatedFeeDefinitions: Array<{ __typename?: 'CalculatedFeeDefinition', appliedGrossAmount: number, appliedNetAmount: number, finalGrossAmount: number, finalNetAmount: number, ust: number, isManual: boolean, storedFeeDefinition: { __typename?: 'StoredFeeDefinition', amount: number, mode: EFeeMode, feeType: EFeeType, companyId: any, priority: number, billingPeriodType: EBillingPeriodType, level: EFeeLevel, dealTypes: Array<EDealType>, isActive: boolean, onlyWhenInAuction?: boolean | null } }> }> } }> } };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: DocumentTypeDecoration<TResult, TVariables>['__apiType'];

  constructor(private value: string, public __meta__?: Record<string, any>) {
    super(value);
  }

  toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const FeeFragmentFragmentDoc = new TypedDocumentString(`
    fragment FeeFragment on FeeDefinition {
  _id
  companyId
  company {
    name
  }
  priority
  amount
  billingPeriodType
  level
  mode
  feeType
  dealTypes
  restrictToCategories
  restrictToItemQuestion
  transportMode
  isActive
  feeIntervals {
    from
    diffAmount
    type
  }
}
    `, {"fragmentName":"FeeFragment"}) as unknown as TypedDocumentString<FeeFragmentFragment, unknown>;
export const DealValuesEntryFragmentFragmentDoc = new TypedDocumentString(`
    fragment DealValuesEntryFragment on DealValuesEntry {
  payoutAmount
  paybackAmount
  calculationPayoutAmount
  calculationPaybackAmount
  durationInDays
  shouldOverwritePayoutAmount
  overwrittenPayoutAmount
}
    `, {"fragmentName":"DealValuesEntryFragment"}) as unknown as TypedDocumentString<DealValuesEntryFragmentFragment, unknown>;
export const ItemValuesEntryFragmentFragmentDoc = new TypedDocumentString(`
    fragment ItemValuesEntryFragment on ItemValuesEntry {
  conditionMaxMarketValues {
    excellent
    good
    poor
  }
  maxMarketValue
  currentMarketValue
  predictedMarketValue
  adjustedMarketValue
  durationInDays
  loanToValue
  date
  payoutAmount
}
    `, {"fragmentName":"ItemValuesEntryFragment"}) as unknown as TypedDocumentString<ItemValuesEntryFragmentFragment, unknown>;
export const CalculatedFeeDefinitionFragmentFragmentDoc = new TypedDocumentString(`
    fragment CalculatedFeeDefinitionFragment on CalculatedFeeDefinition {
  appliedGrossAmount
  appliedNetAmount
  finalGrossAmount
  finalNetAmount
  ust
  isManual
  storedFeeDefinition {
    amount
    mode
    feeType
    companyId
    priority
    billingPeriodType
    level
    dealTypes
    isActive
    onlyWhenInAuction
  }
}
    `, {"fragmentName":"CalculatedFeeDefinitionFragment"}) as unknown as TypedDocumentString<CalculatedFeeDefinitionFragmentFragment, unknown>;
export const AppliedUsedFeeDefinitionsFragmentFragmentDoc = new TypedDocumentString(`
    fragment AppliedUsedFeeDefinitionsFragment on UsedFeeDefinition {
  itemCategoryId
  feeWeight
  calculatedFeeDefinitions {
    ...CalculatedFeeDefinitionFragment
  }
}
    fragment CalculatedFeeDefinitionFragment on CalculatedFeeDefinition {
  appliedGrossAmount
  appliedNetAmount
  finalGrossAmount
  finalNetAmount
  ust
  isManual
  storedFeeDefinition {
    amount
    mode
    feeType
    companyId
    priority
    billingPeriodType
    level
    dealTypes
    isActive
    onlyWhenInAuction
  }
}`, {"fragmentName":"AppliedUsedFeeDefinitionsFragment"}) as unknown as TypedDocumentString<AppliedUsedFeeDefinitionsFragmentFragment, unknown>;
export const DealCalculationFragmentFragmentDoc = new TypedDocumentString(`
    fragment DealCalculationFragment on DealCalculation {
  date
  loanToValuesEntryId
  dealValuesEntry {
    ...DealValuesEntryFragment
  }
  itemsValuesEntries {
    ...ItemValuesEntryFragment
  }
  appliedUsedFeeDefinitions {
    ...AppliedUsedFeeDefinitionsFragment
  }
}
    fragment DealValuesEntryFragment on DealValuesEntry {
  payoutAmount
  paybackAmount
  calculationPayoutAmount
  calculationPaybackAmount
  durationInDays
  shouldOverwritePayoutAmount
  overwrittenPayoutAmount
}
fragment ItemValuesEntryFragment on ItemValuesEntry {
  conditionMaxMarketValues {
    excellent
    good
    poor
  }
  maxMarketValue
  currentMarketValue
  predictedMarketValue
  adjustedMarketValue
  durationInDays
  loanToValue
  date
  payoutAmount
}
fragment CalculatedFeeDefinitionFragment on CalculatedFeeDefinition {
  appliedGrossAmount
  appliedNetAmount
  finalGrossAmount
  finalNetAmount
  ust
  isManual
  storedFeeDefinition {
    amount
    mode
    feeType
    companyId
    priority
    billingPeriodType
    level
    dealTypes
    isActive
    onlyWhenInAuction
  }
}
fragment AppliedUsedFeeDefinitionsFragment on UsedFeeDefinition {
  itemCategoryId
  feeWeight
  calculatedFeeDefinitions {
    ...CalculatedFeeDefinitionFragment
  }
}`, {"fragmentName":"DealCalculationFragment"}) as unknown as TypedDocumentString<DealCalculationFragmentFragment, unknown>;
export const PersistedDealExtensionCalculationFragmentFragmentDoc = new TypedDocumentString(`
    fragment PersistedDealExtensionCalculationFragment on PersistedDealExtensionCalculation {
  dealId
  dueAmount
  partialRedemptionAmount
  overwrittenPartialRedemptionAmount
  dealExtensionCalculationId
  itemsExtensionAnswers {
    storageLabel
    answers {
      questionId
      selectedOptionIndex
      rangeValue
    }
  }
  childDealCalculation {
    ...DealCalculationFragment
  }
  parentDealCalculation {
    ...DealCalculationFragment
  }
}
    fragment DealValuesEntryFragment on DealValuesEntry {
  payoutAmount
  paybackAmount
  calculationPayoutAmount
  calculationPaybackAmount
  durationInDays
  shouldOverwritePayoutAmount
  overwrittenPayoutAmount
}
fragment ItemValuesEntryFragment on ItemValuesEntry {
  conditionMaxMarketValues {
    excellent
    good
    poor
  }
  maxMarketValue
  currentMarketValue
  predictedMarketValue
  adjustedMarketValue
  durationInDays
  loanToValue
  date
  payoutAmount
}
fragment CalculatedFeeDefinitionFragment on CalculatedFeeDefinition {
  appliedGrossAmount
  appliedNetAmount
  finalGrossAmount
  finalNetAmount
  ust
  isManual
  storedFeeDefinition {
    amount
    mode
    feeType
    companyId
    priority
    billingPeriodType
    level
    dealTypes
    isActive
    onlyWhenInAuction
  }
}
fragment AppliedUsedFeeDefinitionsFragment on UsedFeeDefinition {
  itemCategoryId
  feeWeight
  calculatedFeeDefinitions {
    ...CalculatedFeeDefinitionFragment
  }
}
fragment DealCalculationFragment on DealCalculation {
  date
  loanToValuesEntryId
  dealValuesEntry {
    ...DealValuesEntryFragment
  }
  itemsValuesEntries {
    ...ItemValuesEntryFragment
  }
  appliedUsedFeeDefinitions {
    ...AppliedUsedFeeDefinitionsFragment
  }
}`, {"fragmentName":"PersistedDealExtensionCalculationFragment"}) as unknown as TypedDocumentString<PersistedDealExtensionCalculationFragmentFragment, unknown>;
export const PersistedDealPaybackCalculationFragmentFragmentDoc = new TypedDocumentString(`
    fragment PersistedDealPaybackCalculationFragment on PersistedDealPaybackCalculation {
  dealId
  dealPaybackCalculationId
  dealCalculation {
    ...DealCalculationFragment
  }
}
    fragment DealValuesEntryFragment on DealValuesEntry {
  payoutAmount
  paybackAmount
  calculationPayoutAmount
  calculationPaybackAmount
  durationInDays
  shouldOverwritePayoutAmount
  overwrittenPayoutAmount
}
fragment ItemValuesEntryFragment on ItemValuesEntry {
  conditionMaxMarketValues {
    excellent
    good
    poor
  }
  maxMarketValue
  currentMarketValue
  predictedMarketValue
  adjustedMarketValue
  durationInDays
  loanToValue
  date
  payoutAmount
}
fragment CalculatedFeeDefinitionFragment on CalculatedFeeDefinition {
  appliedGrossAmount
  appliedNetAmount
  finalGrossAmount
  finalNetAmount
  ust
  isManual
  storedFeeDefinition {
    amount
    mode
    feeType
    companyId
    priority
    billingPeriodType
    level
    dealTypes
    isActive
    onlyWhenInAuction
  }
}
fragment AppliedUsedFeeDefinitionsFragment on UsedFeeDefinition {
  itemCategoryId
  feeWeight
  calculatedFeeDefinitions {
    ...CalculatedFeeDefinitionFragment
  }
}
fragment DealCalculationFragment on DealCalculation {
  date
  loanToValuesEntryId
  dealValuesEntry {
    ...DealValuesEntryFragment
  }
  itemsValuesEntries {
    ...ItemValuesEntryFragment
  }
  appliedUsedFeeDefinitions {
    ...AppliedUsedFeeDefinitionsFragment
  }
}`, {"fragmentName":"PersistedDealPaybackCalculationFragment"}) as unknown as TypedDocumentString<PersistedDealPaybackCalculationFragmentFragment, unknown>;
export const CarDealCalculationFragmentFragmentDoc = new TypedDocumentString(`
    fragment CarDealCalculationFragment on CarDealCalculation {
  dealCalculationId
  date
  noValuation
  loanToValuesEntryId
  competitiveVehiclesForSale
  dealValuesEntry {
    ...DealValuesEntryFragment
  }
  itemsValuesEntries {
    ...ItemValuesEntryFragment
  }
  appliedUsedFeeDefinitions {
    ...AppliedUsedFeeDefinitionsFragment
  }
}
    fragment DealValuesEntryFragment on DealValuesEntry {
  payoutAmount
  paybackAmount
  calculationPayoutAmount
  calculationPaybackAmount
  durationInDays
  shouldOverwritePayoutAmount
  overwrittenPayoutAmount
}
fragment ItemValuesEntryFragment on ItemValuesEntry {
  conditionMaxMarketValues {
    excellent
    good
    poor
  }
  maxMarketValue
  currentMarketValue
  predictedMarketValue
  adjustedMarketValue
  durationInDays
  loanToValue
  date
  payoutAmount
}
fragment CalculatedFeeDefinitionFragment on CalculatedFeeDefinition {
  appliedGrossAmount
  appliedNetAmount
  finalGrossAmount
  finalNetAmount
  ust
  isManual
  storedFeeDefinition {
    amount
    mode
    feeType
    companyId
    priority
    billingPeriodType
    level
    dealTypes
    isActive
    onlyWhenInAuction
  }
}
fragment AppliedUsedFeeDefinitionsFragment on UsedFeeDefinition {
  itemCategoryId
  feeWeight
  calculatedFeeDefinitions {
    ...CalculatedFeeDefinitionFragment
  }
}`, {"fragmentName":"CarDealCalculationFragment"}) as unknown as TypedDocumentString<CarDealCalculationFragmentFragment, unknown>;
export const VariantsFragmentFragmentDoc = new TypedDocumentString(`
    fragment VariantsFragment on ProductVariant {
  id
  isPriceValid
  image {
    id
    url
  }
  name
  product {
    name
    category {
      name
      parentCategories {
        name
      }
    }
  }
  propertiesValues {
    ... on ProductVariantPropertyTextValue {
      propertyDefinitionId
      propertyDefinition {
        _id
        type
        impactsLook
        showOnWebsite
        name {
          allTranslations {
            text
            languageCode
          }
        }
        key
        valueFormatting {
          suffix
        }
      }
      value {
        translation {
          allTranslations {
            text
            languageCode
          }
        }
      }
    }
    ... on ProductVariantPropertyNumberValue {
      propertyDefinitionId
      propertyDefinition {
        _id
        type
        impactsLook
        showOnWebsite
        name {
          allTranslations {
            text
            languageCode
          }
        }
        key
        valueFormatting {
          suffix
        }
      }
      value {
        numberValue
      }
    }
    ... on ProductVariantPropertyBooleanValue {
      propertyDefinitionId
      propertyDefinition {
        _id
        type
        impactsLook
        showOnWebsite
        name {
          allTranslations {
            text
            languageCode
          }
        }
        key
        valueFormatting {
          suffix
        }
      }
      value {
        booleanValue
      }
    }
  }
}
    `, {"fragmentName":"VariantsFragment"}) as unknown as TypedDocumentString<VariantsFragmentFragment, unknown>;
export const CustomDealFragmentFragmentDoc = new TypedDocumentString(`
    fragment CustomDealFragment on CustomDeal {
  _id
  customDealNumber
  status
  createdAt
  updatedAt
  durationInDays
  isPayoutOverwritten
  isReversedFeeCalculation
  contactData {
    email
    phone
  }
  dealType
  company {
    _id
    configuration {
      minimumPawnDuration
      gracePeriod
    }
  }
  items {
    itemCategoryId
    title
    note
    algoliaReference
    policeNumber
    pawnPayoutAmount
    purchasePayoutAmount
    overwrittenPawnPayoutAmount
    overwrittenPurchasePayoutAmount
    ean
    material
    counterofferPayoutAmount
    foundComparableOffers
    overwrittenItemValue
    foundOffersEvaluationFactor
    variantId
    productVariant {
      ...VariantsFragment
    }
    priceFindings {
      price
    }
    media {
      url
      contentType
    }
    note
    answers {
      questionId
      selectedOptionIndex
      rangeValue
    }
    itemPawnValueEntry {
      adjustedMarketValue
      payoutAmount
    }
    itemPurchaseValueEntry {
      adjustedMarketValue
      payoutAmount
    }
  }
  overridePayoutAmount
  availableTransportModes
  events {
    event
    createdAt
    timestamp
  }
  pawnCalculation {
    payoutAmount
  }
  purchaseCalculation {
    payoutAmount
  }
}
    fragment VariantsFragment on ProductVariant {
  id
  isPriceValid
  image {
    id
    url
  }
  name
  product {
    name
    category {
      name
      parentCategories {
        name
      }
    }
  }
  propertiesValues {
    ... on ProductVariantPropertyTextValue {
      propertyDefinitionId
      propertyDefinition {
        _id
        type
        impactsLook
        showOnWebsite
        name {
          allTranslations {
            text
            languageCode
          }
        }
        key
        valueFormatting {
          suffix
        }
      }
      value {
        translation {
          allTranslations {
            text
            languageCode
          }
        }
      }
    }
    ... on ProductVariantPropertyNumberValue {
      propertyDefinitionId
      propertyDefinition {
        _id
        type
        impactsLook
        showOnWebsite
        name {
          allTranslations {
            text
            languageCode
          }
        }
        key
        valueFormatting {
          suffix
        }
      }
      value {
        numberValue
      }
    }
    ... on ProductVariantPropertyBooleanValue {
      propertyDefinitionId
      propertyDefinition {
        _id
        type
        impactsLook
        showOnWebsite
        name {
          allTranslations {
            text
            languageCode
          }
        }
        key
        valueFormatting {
          suffix
        }
      }
      value {
        booleanValue
      }
    }
  }
}`, {"fragmentName":"CustomDealFragment"}) as unknown as TypedDocumentString<CustomDealFragmentFragment, unknown>;
export const CustomRequestFragmentFragmentDoc = new TypedDocumentString(`
    fragment CustomRequestFragment on CustomRequest {
  _id
  createdAt
  updatedAt
  events {
    createdAt
    event
    timestamp
  }
  dealData {
    selected {
      durationInDays
      payoutAmount
    }
    verified {
      durationInDays
      payoutAmount
    }
  }
  itemsData {
    selected {
      title
      itemCategoryId
      itemCategory {
        _id
        name
        parentId
      }
      condition
      note
      media {
        url
        contentType
      }
      itemValuesEntry {
        adjustedMarketValue
        loanToValue
        durationInDays
        date
      }
    }
    verified {
      title
      itemCategoryId
      itemCategory {
        _id
        name
        parentId
      }
      condition
      note
      media {
        url
        contentType
      }
      itemValuesEntry {
        adjustedMarketValue
        loanToValue
        durationInDays
        date
      }
    }
  }
}
    `, {"fragmentName":"CustomRequestFragment"}) as unknown as TypedDocumentString<CustomRequestFragmentFragment, unknown>;
export const RegionFragmentFragmentDoc = new TypedDocumentString(`
    fragment RegionFragment on Region {
  name
  code
  domain
}
    `, {"fragmentName":"RegionFragment"}) as unknown as TypedDocumentString<RegionFragmentFragment, unknown>;
export const ShopFragmentFragmentDoc = new TypedDocumentString(`
    fragment ShopFragment on Shop {
  _id
  name
  phone
  email
  googleMapsLink
  shopPagePath
  address {
    coordinates {
      lat
      lng
    }
    houseNumber
    stairway
    door
    floor
    street
    city
    state
    countryCode
    country
    zipCode
    queryString
    address1
    address2
  }
  openingHours
}
    `, {"fragmentName":"ShopFragment"}) as unknown as TypedDocumentString<ShopFragmentFragment, unknown>;
export const SearchPageProductFragmentFragmentDoc = new TypedDocumentString(`
    fragment SearchPageProductFragment on Product {
  _id
  name
  slug
  isPublished
}
    `, {"fragmentName":"SearchPageProductFragment"}) as unknown as TypedDocumentString<SearchPageProductFragmentFragment, unknown>;
export const SearchPageItemCategoryFragmentFragmentDoc = new TypedDocumentString(`
    fragment SearchPageItemCategoryFragment on ItemCategorySearchResult {
  text {
    text(languageCode: $languageCode)
  }
  icon
  matchedKeyword
  fullSlug
}
    `, {"fragmentName":"SearchPageItemCategoryFragment"}) as unknown as TypedDocumentString<SearchPageItemCategoryFragmentFragment, unknown>;
export const ProductSelectorProducts_ProductsFragmentFragmentDoc = new TypedDocumentString(`
    fragment ProductSelectorProducts_ProductsFragment on Product {
  _id
  slug
  name
  overviewImage {
    url
  }
  image {
    url
  }
}
    `, {"fragmentName":"ProductSelectorProducts_ProductsFragment"}) as unknown as TypedDocumentString<ProductSelectorProducts_ProductsFragmentFragment, unknown>;
export const UploadFileFormatFragmentFragmentDoc = new TypedDocumentString(`
    fragment UploadFileFormatFragment on UploadFileFormat {
  hash
  ext
  mime
  width
  height
  size
  path
  url
}
    `, {"fragmentName":"UploadFileFormatFragment"}) as unknown as TypedDocumentString<UploadFileFormatFragmentFragment, unknown>;
export const UploadFileFragmentFragmentDoc = new TypedDocumentString(`
    fragment UploadFileFragment on UploadFile {
  _id
  name
  alternativeText
  caption
  hash
  ext
  mime
  width
  height
  size
  url
  provider
  createdAt
  updatedAt
  formats {
    thumbnail {
      ...UploadFileFormatFragment
    }
    small {
      ...UploadFileFormatFragment
    }
    medium {
      ...UploadFileFormatFragment
    }
    large {
      ...UploadFileFormatFragment
    }
    product_thumbnail {
      ...UploadFileFormatFragment
    }
    product_small {
      ...UploadFileFormatFragment
    }
  }
}
    fragment UploadFileFormatFragment on UploadFileFormat {
  hash
  ext
  mime
  width
  height
  size
  path
  url
}`, {"fragmentName":"UploadFileFragment"}) as unknown as TypedDocumentString<UploadFileFragmentFragment, unknown>;
export const CategoryPageFragmentFragmentDoc = new TypedDocumentString(`
    fragment CategoryPageFragment on CategoryPage {
  _id
  fallbackImage {
    ...UploadFileFragment
  }
}
    fragment UploadFileFormatFragment on UploadFileFormat {
  hash
  ext
  mime
  width
  height
  size
  path
  url
}
fragment UploadFileFragment on UploadFile {
  _id
  name
  alternativeText
  caption
  hash
  ext
  mime
  width
  height
  size
  url
  provider
  createdAt
  updatedAt
  formats {
    thumbnail {
      ...UploadFileFormatFragment
    }
    small {
      ...UploadFileFormatFragment
    }
    medium {
      ...UploadFileFormatFragment
    }
    large {
      ...UploadFileFormatFragment
    }
    product_thumbnail {
      ...UploadFileFormatFragment
    }
    product_small {
      ...UploadFileFormatFragment
    }
  }
}`, {"fragmentName":"CategoryPageFragment"}) as unknown as TypedDocumentString<CategoryPageFragmentFragment, unknown>;
export const ItemQuestionFragmentFragmentDoc = new TypedDocumentString(`
    fragment ItemQuestionFragment on ItemQuestion {
  _id
  order
  questionType
  valueMode
  titleKey
  infoKey
  isInternal
  predictionTag
  singleChoiceOptions {
    labelKey
    infoKey
    categoryValues
    conditionValue
    isDefaultValue
  }
  rangeData {
    minValue
    maxValue
    defaultValue
    unitPrice
    unitKey
  }
  itemCategoryIds
}
    `, {"fragmentName":"ItemQuestionFragment"}) as unknown as TypedDocumentString<ItemQuestionFragmentFragment, unknown>;
export const ProductFragmentFragmentDoc = new TypedDocumentString(`
    fragment ProductFragment on ProductLegacy {
  _id
  title
  slug
  objectID
  releaseDate
  maxValue
  maxLoanToValue
  itemCategoryId
  itemCategory {
    _id
    name
    parentId
    createdAt
    updatedAt
    slug
    visibleOnDomain
    availableTransportModes
    maximumPawnDuration
    recursiveMinimumItemValue
  }
  isInactive
  conditionMaxValues {
    excellent
    good
    poor
  }
  contentCategories {
    lvl0
    lvl1
    lvl2
    lvl3
  }
  pictureFilename
  gewicht
  karat
  material
  ean
  class
  picture {
    ...UploadFileFragment
  }
  isTaxFree
}
    fragment UploadFileFormatFragment on UploadFileFormat {
  hash
  ext
  mime
  width
  height
  size
  path
  url
}
fragment UploadFileFragment on UploadFile {
  _id
  name
  alternativeText
  caption
  hash
  ext
  mime
  width
  height
  size
  url
  provider
  createdAt
  updatedAt
  formats {
    thumbnail {
      ...UploadFileFormatFragment
    }
    small {
      ...UploadFileFormatFragment
    }
    medium {
      ...UploadFileFormatFragment
    }
    large {
      ...UploadFileFormatFragment
    }
    product_thumbnail {
      ...UploadFileFormatFragment
    }
    product_small {
      ...UploadFileFormatFragment
    }
  }
}`, {"fragmentName":"ProductFragment"}) as unknown as TypedDocumentString<ProductFragmentFragment, unknown>;
export const AvailablePropertiesFragmentFragmentDoc = new TypedDocumentString(`
    fragment AvailablePropertiesFragment on ProductAvailableProperty {
  ... on ProductAvailableTextProperty {
    propertyDefinitionId
    propertyDefinitionType
    propertyDefinition {
      _id
      type
      impactsLook
      showOnWebsite
      description {
        allTranslations {
          text
          languageCode
        }
      }
      name {
        allTranslations {
          text
          languageCode
        }
      }
      key
      valueFormatting {
        suffix
        orderBy
      }
    }
    values {
      id
      translation {
        allTranslations {
          text
          languageCode
        }
      }
    }
  }
  ... on ProductAvailableNumberProperty {
    propertyDefinitionId
    propertyDefinitionType
    propertyDefinition {
      _id
      type
      impactsLook
      showOnWebsite
      description {
        allTranslations {
          text
          languageCode
        }
      }
      name {
        allTranslations {
          text
          languageCode
        }
      }
      key
      valueFormatting {
        suffix
        orderBy
      }
    }
    values {
      numberValue
    }
  }
  ... on ProductAvailableBooleanProperty {
    propertyDefinitionId
    propertyDefinitionType
    propertyDefinition {
      _id
      type
      impactsLook
      showOnWebsite
      description {
        allTranslations {
          text
          languageCode
        }
      }
      name {
        allTranslations {
          text
          languageCode
        }
      }
      key
    }
  }
}
    `, {"fragmentName":"AvailablePropertiesFragment"}) as unknown as TypedDocumentString<AvailablePropertiesFragmentFragment, unknown>;
export const ProductFragmentV2FragmentDoc = new TypedDocumentString(`
    fragment ProductFragmentV2 on Product {
  _id
  name
  slug
  isPublished
}
    `, {"fragmentName":"ProductFragmentV2"}) as unknown as TypedDocumentString<ProductFragmentV2Fragment, unknown>;
export const PaymentDataFragmentFragmentDoc = new TypedDocumentString(`
    fragment PaymentDataFragment on PaymentData {
  paymentType {
    ... on ManualPaymentWrapper {
      manual: value
    }
    ... on AutomaticPaymentWrapper {
      automatic: value
    }
  }
}
    `, {"fragmentName":"PaymentDataFragment"}) as unknown as TypedDocumentString<PaymentDataFragmentFragment, unknown>;
export const PawnDataFragmentFragmentDoc = new TypedDocumentString(`
    fragment PawnDataFragment on PawnData {
  pawnNumber
  pawnTicketLink {
    url
    contentType
  }
  billNumber
  billLink {
    url
    contentType
  }
  paybackData {
    ...PaymentDataFragment
    iban
  }
  extensionChildId
  extensionParentId
  reservedPaybackData {
    isExtension
    date
    paymentType
    feeAmount
    partialRedemptionAmount
    dueAmount
  }
}
    fragment PaymentDataFragment on PaymentData {
  paymentType {
    ... on ManualPaymentWrapper {
      manual: value
    }
    ... on AutomaticPaymentWrapper {
      automatic: value
    }
  }
}`, {"fragmentName":"PawnDataFragment"}) as unknown as TypedDocumentString<PawnDataFragmentFragment, unknown>;
export const BaseEventFragmentFragmentDoc = new TypedDocumentString(`
    fragment BaseEventFragment on BaseDealEvent {
  __typename
  createdAt
  createdAt
  timestamp
  displayName
}
    `, {"fragmentName":"BaseEventFragment"}) as unknown as TypedDocumentString<BaseEventFragmentFragment, unknown>;
export const BookedEventFragmentFragmentDoc = new TypedDocumentString(`
    fragment BookedEventFragment on DealBookedEvent {
  dealCalculation {
    ...DealCalculationFragment
  }
}
    fragment DealValuesEntryFragment on DealValuesEntry {
  payoutAmount
  paybackAmount
  calculationPayoutAmount
  calculationPaybackAmount
  durationInDays
  shouldOverwritePayoutAmount
  overwrittenPayoutAmount
}
fragment ItemValuesEntryFragment on ItemValuesEntry {
  conditionMaxMarketValues {
    excellent
    good
    poor
  }
  maxMarketValue
  currentMarketValue
  predictedMarketValue
  adjustedMarketValue
  durationInDays
  loanToValue
  date
  payoutAmount
}
fragment CalculatedFeeDefinitionFragment on CalculatedFeeDefinition {
  appliedGrossAmount
  appliedNetAmount
  finalGrossAmount
  finalNetAmount
  ust
  isManual
  storedFeeDefinition {
    amount
    mode
    feeType
    companyId
    priority
    billingPeriodType
    level
    dealTypes
    isActive
    onlyWhenInAuction
  }
}
fragment AppliedUsedFeeDefinitionsFragment on UsedFeeDefinition {
  itemCategoryId
  feeWeight
  calculatedFeeDefinitions {
    ...CalculatedFeeDefinitionFragment
  }
}
fragment DealCalculationFragment on DealCalculation {
  date
  loanToValuesEntryId
  dealValuesEntry {
    ...DealValuesEntryFragment
  }
  itemsValuesEntries {
    ...ItemValuesEntryFragment
  }
  appliedUsedFeeDefinitions {
    ...AppliedUsedFeeDefinitionsFragment
  }
}`, {"fragmentName":"BookedEventFragment"}) as unknown as TypedDocumentString<BookedEventFragmentFragment, unknown>;
export const VerifiedEventFragmentFragmentDoc = new TypedDocumentString(`
    fragment VerifiedEventFragment on DealVerifiedEvent {
  isOverwrittenFees
  dealCalculation {
    ...DealCalculationFragment
  }
}
    fragment DealValuesEntryFragment on DealValuesEntry {
  payoutAmount
  paybackAmount
  calculationPayoutAmount
  calculationPaybackAmount
  durationInDays
  shouldOverwritePayoutAmount
  overwrittenPayoutAmount
}
fragment ItemValuesEntryFragment on ItemValuesEntry {
  conditionMaxMarketValues {
    excellent
    good
    poor
  }
  maxMarketValue
  currentMarketValue
  predictedMarketValue
  adjustedMarketValue
  durationInDays
  loanToValue
  date
  payoutAmount
}
fragment CalculatedFeeDefinitionFragment on CalculatedFeeDefinition {
  appliedGrossAmount
  appliedNetAmount
  finalGrossAmount
  finalNetAmount
  ust
  isManual
  storedFeeDefinition {
    amount
    mode
    feeType
    companyId
    priority
    billingPeriodType
    level
    dealTypes
    isActive
    onlyWhenInAuction
  }
}
fragment AppliedUsedFeeDefinitionsFragment on UsedFeeDefinition {
  itemCategoryId
  feeWeight
  calculatedFeeDefinitions {
    ...CalculatedFeeDefinitionFragment
  }
}
fragment DealCalculationFragment on DealCalculation {
  date
  loanToValuesEntryId
  dealValuesEntry {
    ...DealValuesEntryFragment
  }
  itemsValuesEntries {
    ...ItemValuesEntryFragment
  }
  appliedUsedFeeDefinitions {
    ...AppliedUsedFeeDefinitionsFragment
  }
}`, {"fragmentName":"VerifiedEventFragment"}) as unknown as TypedDocumentString<VerifiedEventFragmentFragment, unknown>;
export const ReviewingEventFragmentFragmentDoc = new TypedDocumentString(`
    fragment ReviewingEventFragment on DealReviewingEvent {
  issuanceCertificate {
    url
    contentType
  }
}
    `, {"fragmentName":"ReviewingEventFragment"}) as unknown as TypedDocumentString<ReviewingEventFragmentFragment, unknown>;
export const AnyPaymentTypeFragmentFragmentDoc = new TypedDocumentString(`
    fragment AnyPaymentTypeFragment on AnyPaymentType {
  ... on ManualPaymentWrapper {
    manual: value
  }
  ... on AutomaticPaymentWrapper {
    automatic: value
  }
}
    `, {"fragmentName":"AnyPaymentTypeFragment"}) as unknown as TypedDocumentString<AnyPaymentTypeFragmentFragment, unknown>;
export const PaybackConfirmedEventFragmentFragmentDoc = new TypedDocumentString(`
    fragment PaybackConfirmedEventFragment on DealPaybackConfirmedEvent {
  paymentType {
    ...AnyPaymentTypeFragment
  }
  dealCalculation {
    ...DealCalculationFragment
  }
}
    fragment DealValuesEntryFragment on DealValuesEntry {
  payoutAmount
  paybackAmount
  calculationPayoutAmount
  calculationPaybackAmount
  durationInDays
  shouldOverwritePayoutAmount
  overwrittenPayoutAmount
}
fragment ItemValuesEntryFragment on ItemValuesEntry {
  conditionMaxMarketValues {
    excellent
    good
    poor
  }
  maxMarketValue
  currentMarketValue
  predictedMarketValue
  adjustedMarketValue
  durationInDays
  loanToValue
  date
  payoutAmount
}
fragment CalculatedFeeDefinitionFragment on CalculatedFeeDefinition {
  appliedGrossAmount
  appliedNetAmount
  finalGrossAmount
  finalNetAmount
  ust
  isManual
  storedFeeDefinition {
    amount
    mode
    feeType
    companyId
    priority
    billingPeriodType
    level
    dealTypes
    isActive
    onlyWhenInAuction
  }
}
fragment AppliedUsedFeeDefinitionsFragment on UsedFeeDefinition {
  itemCategoryId
  feeWeight
  calculatedFeeDefinitions {
    ...CalculatedFeeDefinitionFragment
  }
}
fragment DealCalculationFragment on DealCalculation {
  date
  loanToValuesEntryId
  dealValuesEntry {
    ...DealValuesEntryFragment
  }
  itemsValuesEntries {
    ...ItemValuesEntryFragment
  }
  appliedUsedFeeDefinitions {
    ...AppliedUsedFeeDefinitionsFragment
  }
}
fragment AnyPaymentTypeFragment on AnyPaymentType {
  ... on ManualPaymentWrapper {
    manual: value
  }
  ... on AutomaticPaymentWrapper {
    automatic: value
  }
}`, {"fragmentName":"PaybackConfirmedEventFragment"}) as unknown as TypedDocumentString<PaybackConfirmedEventFragmentFragment, unknown>;
export const ExtensionConfirmedEventFragmentFragmentDoc = new TypedDocumentString(`
    fragment ExtensionConfirmedEventFragment on DealExtensionConfirmedEvent {
  paymentType {
    ...AnyPaymentTypeFragment
  }
  dealCalculation {
    ...DealCalculationFragment
  }
  childCalculation {
    ...DealCalculationFragment
  }
  dueAmount
  partialRedemptionAmount
  overwrittenPartialRedemptionAmount
  itemsExtensionAnswers {
    storageLabel
    answers {
      questionId
      selectedOptionIndex
      rangeValue
    }
  }
}
    fragment DealValuesEntryFragment on DealValuesEntry {
  payoutAmount
  paybackAmount
  calculationPayoutAmount
  calculationPaybackAmount
  durationInDays
  shouldOverwritePayoutAmount
  overwrittenPayoutAmount
}
fragment ItemValuesEntryFragment on ItemValuesEntry {
  conditionMaxMarketValues {
    excellent
    good
    poor
  }
  maxMarketValue
  currentMarketValue
  predictedMarketValue
  adjustedMarketValue
  durationInDays
  loanToValue
  date
  payoutAmount
}
fragment CalculatedFeeDefinitionFragment on CalculatedFeeDefinition {
  appliedGrossAmount
  appliedNetAmount
  finalGrossAmount
  finalNetAmount
  ust
  isManual
  storedFeeDefinition {
    amount
    mode
    feeType
    companyId
    priority
    billingPeriodType
    level
    dealTypes
    isActive
    onlyWhenInAuction
  }
}
fragment AppliedUsedFeeDefinitionsFragment on UsedFeeDefinition {
  itemCategoryId
  feeWeight
  calculatedFeeDefinitions {
    ...CalculatedFeeDefinitionFragment
  }
}
fragment DealCalculationFragment on DealCalculation {
  date
  loanToValuesEntryId
  dealValuesEntry {
    ...DealValuesEntryFragment
  }
  itemsValuesEntries {
    ...ItemValuesEntryFragment
  }
  appliedUsedFeeDefinitions {
    ...AppliedUsedFeeDefinitionsFragment
  }
}
fragment AnyPaymentTypeFragment on AnyPaymentType {
  ... on ManualPaymentWrapper {
    manual: value
  }
  ... on AutomaticPaymentWrapper {
    automatic: value
  }
}`, {"fragmentName":"ExtensionConfirmedEventFragment"}) as unknown as TypedDocumentString<ExtensionConfirmedEventFragmentFragment, unknown>;
export const OnSellEventFragmentFragmentDoc = new TypedDocumentString(`
    fragment OnSellEventFragment on DealOnSellEvent {
  valueAddedTaxRate
  differenceTaxRate
  valorizationFeeRate
}
    `, {"fragmentName":"OnSellEventFragment"}) as unknown as TypedDocumentString<OnSellEventFragmentFragment, unknown>;
export const ClosedEventFragmentFragmentDoc = new TypedDocumentString(`
    fragment ClosedEventFragment on DealClosedEvent {
  dealCalculation {
    ...DealCalculationFragment
  }
  valorizationFeeNet
  valorizationFeeGross
}
    fragment DealValuesEntryFragment on DealValuesEntry {
  payoutAmount
  paybackAmount
  calculationPayoutAmount
  calculationPaybackAmount
  durationInDays
  shouldOverwritePayoutAmount
  overwrittenPayoutAmount
}
fragment ItemValuesEntryFragment on ItemValuesEntry {
  conditionMaxMarketValues {
    excellent
    good
    poor
  }
  maxMarketValue
  currentMarketValue
  predictedMarketValue
  adjustedMarketValue
  durationInDays
  loanToValue
  date
  payoutAmount
}
fragment CalculatedFeeDefinitionFragment on CalculatedFeeDefinition {
  appliedGrossAmount
  appliedNetAmount
  finalGrossAmount
  finalNetAmount
  ust
  isManual
  storedFeeDefinition {
    amount
    mode
    feeType
    companyId
    priority
    billingPeriodType
    level
    dealTypes
    isActive
    onlyWhenInAuction
  }
}
fragment AppliedUsedFeeDefinitionsFragment on UsedFeeDefinition {
  itemCategoryId
  feeWeight
  calculatedFeeDefinitions {
    ...CalculatedFeeDefinitionFragment
  }
}
fragment DealCalculationFragment on DealCalculation {
  date
  loanToValuesEntryId
  dealValuesEntry {
    ...DealValuesEntryFragment
  }
  itemsValuesEntries {
    ...ItemValuesEntryFragment
  }
  appliedUsedFeeDefinitions {
    ...AppliedUsedFeeDefinitionsFragment
  }
}`, {"fragmentName":"ClosedEventFragment"}) as unknown as TypedDocumentString<ClosedEventFragmentFragment, unknown>;
export const DealEventFragmentFragmentDoc = new TypedDocumentString(`
    fragment DealEventFragment on DealEvent {
  ...BaseEventFragment
  ...BookedEventFragment
  ...VerifiedEventFragment
  ...ReviewingEventFragment
  ...PaybackConfirmedEventFragment
  ...ExtensionConfirmedEventFragment
  ...OnSellEventFragment
  ...ClosedEventFragment
}
    fragment DealValuesEntryFragment on DealValuesEntry {
  payoutAmount
  paybackAmount
  calculationPayoutAmount
  calculationPaybackAmount
  durationInDays
  shouldOverwritePayoutAmount
  overwrittenPayoutAmount
}
fragment ItemValuesEntryFragment on ItemValuesEntry {
  conditionMaxMarketValues {
    excellent
    good
    poor
  }
  maxMarketValue
  currentMarketValue
  predictedMarketValue
  adjustedMarketValue
  durationInDays
  loanToValue
  date
  payoutAmount
}
fragment CalculatedFeeDefinitionFragment on CalculatedFeeDefinition {
  appliedGrossAmount
  appliedNetAmount
  finalGrossAmount
  finalNetAmount
  ust
  isManual
  storedFeeDefinition {
    amount
    mode
    feeType
    companyId
    priority
    billingPeriodType
    level
    dealTypes
    isActive
    onlyWhenInAuction
  }
}
fragment AppliedUsedFeeDefinitionsFragment on UsedFeeDefinition {
  itemCategoryId
  feeWeight
  calculatedFeeDefinitions {
    ...CalculatedFeeDefinitionFragment
  }
}
fragment DealCalculationFragment on DealCalculation {
  date
  loanToValuesEntryId
  dealValuesEntry {
    ...DealValuesEntryFragment
  }
  itemsValuesEntries {
    ...ItemValuesEntryFragment
  }
  appliedUsedFeeDefinitions {
    ...AppliedUsedFeeDefinitionsFragment
  }
}
fragment AnyPaymentTypeFragment on AnyPaymentType {
  ... on ManualPaymentWrapper {
    manual: value
  }
  ... on AutomaticPaymentWrapper {
    automatic: value
  }
}
fragment BaseEventFragment on BaseDealEvent {
  __typename
  createdAt
  createdAt
  timestamp
  displayName
}
fragment BookedEventFragment on DealBookedEvent {
  dealCalculation {
    ...DealCalculationFragment
  }
}
fragment VerifiedEventFragment on DealVerifiedEvent {
  isOverwrittenFees
  dealCalculation {
    ...DealCalculationFragment
  }
}
fragment ReviewingEventFragment on DealReviewingEvent {
  issuanceCertificate {
    url
    contentType
  }
}
fragment PaybackConfirmedEventFragment on DealPaybackConfirmedEvent {
  paymentType {
    ...AnyPaymentTypeFragment
  }
  dealCalculation {
    ...DealCalculationFragment
  }
}
fragment ExtensionConfirmedEventFragment on DealExtensionConfirmedEvent {
  paymentType {
    ...AnyPaymentTypeFragment
  }
  dealCalculation {
    ...DealCalculationFragment
  }
  childCalculation {
    ...DealCalculationFragment
  }
  dueAmount
  partialRedemptionAmount
  overwrittenPartialRedemptionAmount
  itemsExtensionAnswers {
    storageLabel
    answers {
      questionId
      selectedOptionIndex
      rangeValue
    }
  }
}
fragment OnSellEventFragment on DealOnSellEvent {
  valueAddedTaxRate
  differenceTaxRate
  valorizationFeeRate
}
fragment ClosedEventFragment on DealClosedEvent {
  dealCalculation {
    ...DealCalculationFragment
  }
  valorizationFeeNet
  valorizationFeeGross
}`, {"fragmentName":"DealEventFragment"}) as unknown as TypedDocumentString<DealEventFragmentFragment, unknown>;
export const DealPreviewFragmentFragmentDoc = new TypedDocumentString(`
    fragment DealPreviewFragment on Deal {
  _id
  createdAt
  updatedAt
  dealType
  bookingNumber
  dealFinalValues {
    dealType
    durationInDays
    shouldOverwritePayoutAmount
    payoutAmount
    isOnlineExtensionPrevented
  }
  pawnData {
    ...PawnDataFragment
  }
  purchaseData {
    receiptNumber
    receiptLink {
      url
      contentType
    }
  }
  events {
    ...DealEventFragment
  }
  payoutData {
    ...PaymentDataFragment
    iban
  }
  initialShopId
  company {
    configuration {
      minimumPawnDuration
      gracePeriod
    }
    name
    iban
    paypalEmail
    successionCompany {
      _id
      name
    }
  }
  shippingLabelPageId
  isPaybackPaymentOngoing
  isExtensionPaymentOngoing
  latestOngoingPaymentRequestedAt
  hasCompletedPayment
  isInOpenAuction
  acceptingWithdrawalFeeTermsRequired
  canDealOnSellBeExtendedOrPaidBack
}
    fragment DealValuesEntryFragment on DealValuesEntry {
  payoutAmount
  paybackAmount
  calculationPayoutAmount
  calculationPaybackAmount
  durationInDays
  shouldOverwritePayoutAmount
  overwrittenPayoutAmount
}
fragment ItemValuesEntryFragment on ItemValuesEntry {
  conditionMaxMarketValues {
    excellent
    good
    poor
  }
  maxMarketValue
  currentMarketValue
  predictedMarketValue
  adjustedMarketValue
  durationInDays
  loanToValue
  date
  payoutAmount
}
fragment CalculatedFeeDefinitionFragment on CalculatedFeeDefinition {
  appliedGrossAmount
  appliedNetAmount
  finalGrossAmount
  finalNetAmount
  ust
  isManual
  storedFeeDefinition {
    amount
    mode
    feeType
    companyId
    priority
    billingPeriodType
    level
    dealTypes
    isActive
    onlyWhenInAuction
  }
}
fragment AppliedUsedFeeDefinitionsFragment on UsedFeeDefinition {
  itemCategoryId
  feeWeight
  calculatedFeeDefinitions {
    ...CalculatedFeeDefinitionFragment
  }
}
fragment DealCalculationFragment on DealCalculation {
  date
  loanToValuesEntryId
  dealValuesEntry {
    ...DealValuesEntryFragment
  }
  itemsValuesEntries {
    ...ItemValuesEntryFragment
  }
  appliedUsedFeeDefinitions {
    ...AppliedUsedFeeDefinitionsFragment
  }
}
fragment PaymentDataFragment on PaymentData {
  paymentType {
    ... on ManualPaymentWrapper {
      manual: value
    }
    ... on AutomaticPaymentWrapper {
      automatic: value
    }
  }
}
fragment AnyPaymentTypeFragment on AnyPaymentType {
  ... on ManualPaymentWrapper {
    manual: value
  }
  ... on AutomaticPaymentWrapper {
    automatic: value
  }
}
fragment BaseEventFragment on BaseDealEvent {
  __typename
  createdAt
  createdAt
  timestamp
  displayName
}
fragment BookedEventFragment on DealBookedEvent {
  dealCalculation {
    ...DealCalculationFragment
  }
}
fragment VerifiedEventFragment on DealVerifiedEvent {
  isOverwrittenFees
  dealCalculation {
    ...DealCalculationFragment
  }
}
fragment ReviewingEventFragment on DealReviewingEvent {
  issuanceCertificate {
    url
    contentType
  }
}
fragment PaybackConfirmedEventFragment on DealPaybackConfirmedEvent {
  paymentType {
    ...AnyPaymentTypeFragment
  }
  dealCalculation {
    ...DealCalculationFragment
  }
}
fragment ExtensionConfirmedEventFragment on DealExtensionConfirmedEvent {
  paymentType {
    ...AnyPaymentTypeFragment
  }
  dealCalculation {
    ...DealCalculationFragment
  }
  childCalculation {
    ...DealCalculationFragment
  }
  dueAmount
  partialRedemptionAmount
  overwrittenPartialRedemptionAmount
  itemsExtensionAnswers {
    storageLabel
    answers {
      questionId
      selectedOptionIndex
      rangeValue
    }
  }
}
fragment OnSellEventFragment on DealOnSellEvent {
  valueAddedTaxRate
  differenceTaxRate
  valorizationFeeRate
}
fragment ClosedEventFragment on DealClosedEvent {
  dealCalculation {
    ...DealCalculationFragment
  }
  valorizationFeeNet
  valorizationFeeGross
}
fragment DealEventFragment on DealEvent {
  ...BaseEventFragment
  ...BookedEventFragment
  ...VerifiedEventFragment
  ...ReviewingEventFragment
  ...PaybackConfirmedEventFragment
  ...ExtensionConfirmedEventFragment
  ...OnSellEventFragment
  ...ClosedEventFragment
}
fragment PawnDataFragment on PawnData {
  pawnNumber
  pawnTicketLink {
    url
    contentType
  }
  billNumber
  billLink {
    url
    contentType
  }
  paybackData {
    ...PaymentDataFragment
    iban
  }
  extensionChildId
  extensionParentId
  reservedPaybackData {
    isExtension
    date
    paymentType
    feeAmount
    partialRedemptionAmount
    dueAmount
  }
}`, {"fragmentName":"DealPreviewFragment"}) as unknown as TypedDocumentString<DealPreviewFragmentFragment, unknown>;
export const AddressFragmentFragmentDoc = new TypedDocumentString(`
    fragment AddressFragment on OAddress {
  coordinates {
    lat
    lng
  }
  houseNumber
  stairway
  door
  floor
  street
  city
  state
  countryCode
  country
  zipCode
  queryString
  address1
  address2
  note
  name
  companyName
}
    `, {"fragmentName":"AddressFragment"}) as unknown as TypedDocumentString<AddressFragmentFragment, unknown>;
export const TransportDataFragmentFragmentDoc = new TypedDocumentString(`
    fragment TransportDataFragment on TransportData {
  transportMode
  standardShippingData {
    sentShippingLabels {
      labelFile {
        filename
      }
      shippingPartner
    }
    address {
      ...AddressFragment
    }
  }
  premiumShippingData {
    address {
      ...AddressFragment
    }
    toHourUTC
    fromHourUTC
    date
  }
}
    fragment AddressFragment on OAddress {
  coordinates {
    lat
    lng
  }
  houseNumber
  stairway
  door
  floor
  street
  city
  state
  countryCode
  country
  zipCode
  queryString
  address1
  address2
  note
  name
  companyName
}`, {"fragmentName":"TransportDataFragment"}) as unknown as TypedDocumentString<TransportDataFragmentFragment, unknown>;
export const DealFragmentFragmentDoc = new TypedDocumentString(`
    fragment DealFragment on Deal {
  ...DealPreviewFragment
  pickupData {
    ...TransportDataFragment
  }
  dropoffData {
    ...TransportDataFragment
  }
  dealPartnerData {
    type
    knp {
      fileReferenceNumber
      debtAmount
    }
  }
  businessUnit
  itemsIds
  items(omitItemQuestions: true, omitItemValorizationCalculation: true) {
    _id
    title
    isContinueUsing
    itemCategoryId
    itemCategory {
      _id
      name
      parentId
      createdAt
      updatedAt
      slug
      availableTransportModes
    }
    algoliaReference
    material
    ean
    media {
      url
      contentType
    }
    productLegacy {
      picture {
        ...UploadFileFragment
      }
      title
    }
    variantId
    productVariant {
      ...VariantsFragment
    }
  }
  company {
    configuration {
      minimumPawnDuration
      gracePeriod
    }
    name
    iban
    paypalEmail
    unzerConfiguration {
      publicKey
    }
    successionCompany {
      _id
      name
    }
  }
  isPaybackPaymentOngoing
  shippingLabelPageId
  isExtensionPaymentOngoing
}
    fragment UploadFileFormatFragment on UploadFileFormat {
  hash
  ext
  mime
  width
  height
  size
  path
  url
}
fragment UploadFileFragment on UploadFile {
  _id
  name
  alternativeText
  caption
  hash
  ext
  mime
  width
  height
  size
  url
  provider
  createdAt
  updatedAt
  formats {
    thumbnail {
      ...UploadFileFormatFragment
    }
    small {
      ...UploadFileFormatFragment
    }
    medium {
      ...UploadFileFormatFragment
    }
    large {
      ...UploadFileFormatFragment
    }
    product_thumbnail {
      ...UploadFileFormatFragment
    }
    product_small {
      ...UploadFileFormatFragment
    }
  }
}
fragment DealValuesEntryFragment on DealValuesEntry {
  payoutAmount
  paybackAmount
  calculationPayoutAmount
  calculationPaybackAmount
  durationInDays
  shouldOverwritePayoutAmount
  overwrittenPayoutAmount
}
fragment ItemValuesEntryFragment on ItemValuesEntry {
  conditionMaxMarketValues {
    excellent
    good
    poor
  }
  maxMarketValue
  currentMarketValue
  predictedMarketValue
  adjustedMarketValue
  durationInDays
  loanToValue
  date
  payoutAmount
}
fragment CalculatedFeeDefinitionFragment on CalculatedFeeDefinition {
  appliedGrossAmount
  appliedNetAmount
  finalGrossAmount
  finalNetAmount
  ust
  isManual
  storedFeeDefinition {
    amount
    mode
    feeType
    companyId
    priority
    billingPeriodType
    level
    dealTypes
    isActive
    onlyWhenInAuction
  }
}
fragment AppliedUsedFeeDefinitionsFragment on UsedFeeDefinition {
  itemCategoryId
  feeWeight
  calculatedFeeDefinitions {
    ...CalculatedFeeDefinitionFragment
  }
}
fragment DealCalculationFragment on DealCalculation {
  date
  loanToValuesEntryId
  dealValuesEntry {
    ...DealValuesEntryFragment
  }
  itemsValuesEntries {
    ...ItemValuesEntryFragment
  }
  appliedUsedFeeDefinitions {
    ...AppliedUsedFeeDefinitionsFragment
  }
}
fragment AddressFragment on OAddress {
  coordinates {
    lat
    lng
  }
  houseNumber
  stairway
  door
  floor
  street
  city
  state
  countryCode
  country
  zipCode
  queryString
  address1
  address2
  note
  name
  companyName
}
fragment PaymentDataFragment on PaymentData {
  paymentType {
    ... on ManualPaymentWrapper {
      manual: value
    }
    ... on AutomaticPaymentWrapper {
      automatic: value
    }
  }
}
fragment VariantsFragment on ProductVariant {
  id
  isPriceValid
  image {
    id
    url
  }
  name
  product {
    name
    category {
      name
      parentCategories {
        name
      }
    }
  }
  propertiesValues {
    ... on ProductVariantPropertyTextValue {
      propertyDefinitionId
      propertyDefinition {
        _id
        type
        impactsLook
        showOnWebsite
        name {
          allTranslations {
            text
            languageCode
          }
        }
        key
        valueFormatting {
          suffix
        }
      }
      value {
        translation {
          allTranslations {
            text
            languageCode
          }
        }
      }
    }
    ... on ProductVariantPropertyNumberValue {
      propertyDefinitionId
      propertyDefinition {
        _id
        type
        impactsLook
        showOnWebsite
        name {
          allTranslations {
            text
            languageCode
          }
        }
        key
        valueFormatting {
          suffix
        }
      }
      value {
        numberValue
      }
    }
    ... on ProductVariantPropertyBooleanValue {
      propertyDefinitionId
      propertyDefinition {
        _id
        type
        impactsLook
        showOnWebsite
        name {
          allTranslations {
            text
            languageCode
          }
        }
        key
        valueFormatting {
          suffix
        }
      }
      value {
        booleanValue
      }
    }
  }
}
fragment TransportDataFragment on TransportData {
  transportMode
  standardShippingData {
    sentShippingLabels {
      labelFile {
        filename
      }
      shippingPartner
    }
    address {
      ...AddressFragment
    }
  }
  premiumShippingData {
    address {
      ...AddressFragment
    }
    toHourUTC
    fromHourUTC
    date
  }
}
fragment AnyPaymentTypeFragment on AnyPaymentType {
  ... on ManualPaymentWrapper {
    manual: value
  }
  ... on AutomaticPaymentWrapper {
    automatic: value
  }
}
fragment BaseEventFragment on BaseDealEvent {
  __typename
  createdAt
  createdAt
  timestamp
  displayName
}
fragment BookedEventFragment on DealBookedEvent {
  dealCalculation {
    ...DealCalculationFragment
  }
}
fragment VerifiedEventFragment on DealVerifiedEvent {
  isOverwrittenFees
  dealCalculation {
    ...DealCalculationFragment
  }
}
fragment ReviewingEventFragment on DealReviewingEvent {
  issuanceCertificate {
    url
    contentType
  }
}
fragment PaybackConfirmedEventFragment on DealPaybackConfirmedEvent {
  paymentType {
    ...AnyPaymentTypeFragment
  }
  dealCalculation {
    ...DealCalculationFragment
  }
}
fragment ExtensionConfirmedEventFragment on DealExtensionConfirmedEvent {
  paymentType {
    ...AnyPaymentTypeFragment
  }
  dealCalculation {
    ...DealCalculationFragment
  }
  childCalculation {
    ...DealCalculationFragment
  }
  dueAmount
  partialRedemptionAmount
  overwrittenPartialRedemptionAmount
  itemsExtensionAnswers {
    storageLabel
    answers {
      questionId
      selectedOptionIndex
      rangeValue
    }
  }
}
fragment OnSellEventFragment on DealOnSellEvent {
  valueAddedTaxRate
  differenceTaxRate
  valorizationFeeRate
}
fragment ClosedEventFragment on DealClosedEvent {
  dealCalculation {
    ...DealCalculationFragment
  }
  valorizationFeeNet
  valorizationFeeGross
}
fragment DealEventFragment on DealEvent {
  ...BaseEventFragment
  ...BookedEventFragment
  ...VerifiedEventFragment
  ...ReviewingEventFragment
  ...PaybackConfirmedEventFragment
  ...ExtensionConfirmedEventFragment
  ...OnSellEventFragment
  ...ClosedEventFragment
}
fragment PawnDataFragment on PawnData {
  pawnNumber
  pawnTicketLink {
    url
    contentType
  }
  billNumber
  billLink {
    url
    contentType
  }
  paybackData {
    ...PaymentDataFragment
    iban
  }
  extensionChildId
  extensionParentId
  reservedPaybackData {
    isExtension
    date
    paymentType
    feeAmount
    partialRedemptionAmount
    dueAmount
  }
}
fragment DealPreviewFragment on Deal {
  _id
  createdAt
  updatedAt
  dealType
  bookingNumber
  dealFinalValues {
    dealType
    durationInDays
    shouldOverwritePayoutAmount
    payoutAmount
    isOnlineExtensionPrevented
  }
  pawnData {
    ...PawnDataFragment
  }
  purchaseData {
    receiptNumber
    receiptLink {
      url
      contentType
    }
  }
  events {
    ...DealEventFragment
  }
  payoutData {
    ...PaymentDataFragment
    iban
  }
  initialShopId
  company {
    configuration {
      minimumPawnDuration
      gracePeriod
    }
    name
    iban
    paypalEmail
    successionCompany {
      _id
      name
    }
  }
  shippingLabelPageId
  isPaybackPaymentOngoing
  isExtensionPaymentOngoing
  latestOngoingPaymentRequestedAt
  hasCompletedPayment
  isInOpenAuction
  acceptingWithdrawalFeeTermsRequired
  canDealOnSellBeExtendedOrPaidBack
}`, {"fragmentName":"DealFragment"}) as unknown as TypedDocumentString<DealFragmentFragment, unknown>;
export const PaymentResultFragmentFragmentDoc = new TypedDocumentString(`
    fragment PaymentResultFragment on PaymentResult {
  ... on SuccessfulPayment {
    id
  }
  ... on PendingPayment {
    redirectUrl
    id
  }
  ... on FailedPayment {
    id
    errors {
      code
    }
  }
}
    `, {"fragmentName":"PaymentResultFragment"}) as unknown as TypedDocumentString<PaymentResultFragmentFragment, unknown>;
export const FileMetadataFragmentFragmentDoc = new TypedDocumentString(`
    fragment FileMetadataFragment on FileMetadata {
  url
  contentType
  filename
  createdAt
}
    `, {"fragmentName":"FileMetadataFragment"}) as unknown as TypedDocumentString<FileMetadataFragmentFragment, unknown>;
export const DealProfileFragmentFragmentDoc = new TypedDocumentString(`
    fragment DealProfileFragment on Deal {
  _id
  createdAt
  updatedAt
  dealType
  bookingNumber
  dealFinalValues {
    dealType
    durationInDays
    shouldOverwritePayoutAmount
    payoutAmount
    isOnlineExtensionPrevented
  }
  pawnData {
    ...PawnDataFragment
  }
  events {
    ...DealEventFragment
  }
  isPaybackPaymentOngoing
  shippingLabelPageId
  isExtensionPaymentOngoing
  latestOngoingPaymentRequestedAt
  hasCompletedPayment
  isInOpenAuction
  acceptingWithdrawalFeeTermsRequired
  canDealOnSellBeExtendedOrPaidBack
}
    fragment DealValuesEntryFragment on DealValuesEntry {
  payoutAmount
  paybackAmount
  calculationPayoutAmount
  calculationPaybackAmount
  durationInDays
  shouldOverwritePayoutAmount
  overwrittenPayoutAmount
}
fragment ItemValuesEntryFragment on ItemValuesEntry {
  conditionMaxMarketValues {
    excellent
    good
    poor
  }
  maxMarketValue
  currentMarketValue
  predictedMarketValue
  adjustedMarketValue
  durationInDays
  loanToValue
  date
  payoutAmount
}
fragment CalculatedFeeDefinitionFragment on CalculatedFeeDefinition {
  appliedGrossAmount
  appliedNetAmount
  finalGrossAmount
  finalNetAmount
  ust
  isManual
  storedFeeDefinition {
    amount
    mode
    feeType
    companyId
    priority
    billingPeriodType
    level
    dealTypes
    isActive
    onlyWhenInAuction
  }
}
fragment AppliedUsedFeeDefinitionsFragment on UsedFeeDefinition {
  itemCategoryId
  feeWeight
  calculatedFeeDefinitions {
    ...CalculatedFeeDefinitionFragment
  }
}
fragment DealCalculationFragment on DealCalculation {
  date
  loanToValuesEntryId
  dealValuesEntry {
    ...DealValuesEntryFragment
  }
  itemsValuesEntries {
    ...ItemValuesEntryFragment
  }
  appliedUsedFeeDefinitions {
    ...AppliedUsedFeeDefinitionsFragment
  }
}
fragment PaymentDataFragment on PaymentData {
  paymentType {
    ... on ManualPaymentWrapper {
      manual: value
    }
    ... on AutomaticPaymentWrapper {
      automatic: value
    }
  }
}
fragment AnyPaymentTypeFragment on AnyPaymentType {
  ... on ManualPaymentWrapper {
    manual: value
  }
  ... on AutomaticPaymentWrapper {
    automatic: value
  }
}
fragment BaseEventFragment on BaseDealEvent {
  __typename
  createdAt
  createdAt
  timestamp
  displayName
}
fragment BookedEventFragment on DealBookedEvent {
  dealCalculation {
    ...DealCalculationFragment
  }
}
fragment VerifiedEventFragment on DealVerifiedEvent {
  isOverwrittenFees
  dealCalculation {
    ...DealCalculationFragment
  }
}
fragment ReviewingEventFragment on DealReviewingEvent {
  issuanceCertificate {
    url
    contentType
  }
}
fragment PaybackConfirmedEventFragment on DealPaybackConfirmedEvent {
  paymentType {
    ...AnyPaymentTypeFragment
  }
  dealCalculation {
    ...DealCalculationFragment
  }
}
fragment ExtensionConfirmedEventFragment on DealExtensionConfirmedEvent {
  paymentType {
    ...AnyPaymentTypeFragment
  }
  dealCalculation {
    ...DealCalculationFragment
  }
  childCalculation {
    ...DealCalculationFragment
  }
  dueAmount
  partialRedemptionAmount
  overwrittenPartialRedemptionAmount
  itemsExtensionAnswers {
    storageLabel
    answers {
      questionId
      selectedOptionIndex
      rangeValue
    }
  }
}
fragment OnSellEventFragment on DealOnSellEvent {
  valueAddedTaxRate
  differenceTaxRate
  valorizationFeeRate
}
fragment ClosedEventFragment on DealClosedEvent {
  dealCalculation {
    ...DealCalculationFragment
  }
  valorizationFeeNet
  valorizationFeeGross
}
fragment DealEventFragment on DealEvent {
  ...BaseEventFragment
  ...BookedEventFragment
  ...VerifiedEventFragment
  ...ReviewingEventFragment
  ...PaybackConfirmedEventFragment
  ...ExtensionConfirmedEventFragment
  ...OnSellEventFragment
  ...ClosedEventFragment
}
fragment PawnDataFragment on PawnData {
  pawnNumber
  pawnTicketLink {
    url
    contentType
  }
  billNumber
  billLink {
    url
    contentType
  }
  paybackData {
    ...PaymentDataFragment
    iban
  }
  extensionChildId
  extensionParentId
  reservedPaybackData {
    isExtension
    date
    paymentType
    feeAmount
    partialRedemptionAmount
    dueAmount
  }
}`, {"fragmentName":"DealProfileFragment"}) as unknown as TypedDocumentString<DealProfileFragmentFragment, unknown>;
export const DealOnlinePaymentSucceedFragmentFragmentDoc = new TypedDocumentString(`
    fragment DealOnlinePaymentSucceedFragment on Deal {
  _id
  createdAt
  updatedAt
  events {
    ...DealEventFragment
  }
  isPaybackPaymentOngoing
  isExtensionPaymentOngoing
  latestOngoingPaymentRequestedAt
  hasCompletedPayment
}
    fragment DealValuesEntryFragment on DealValuesEntry {
  payoutAmount
  paybackAmount
  calculationPayoutAmount
  calculationPaybackAmount
  durationInDays
  shouldOverwritePayoutAmount
  overwrittenPayoutAmount
}
fragment ItemValuesEntryFragment on ItemValuesEntry {
  conditionMaxMarketValues {
    excellent
    good
    poor
  }
  maxMarketValue
  currentMarketValue
  predictedMarketValue
  adjustedMarketValue
  durationInDays
  loanToValue
  date
  payoutAmount
}
fragment CalculatedFeeDefinitionFragment on CalculatedFeeDefinition {
  appliedGrossAmount
  appliedNetAmount
  finalGrossAmount
  finalNetAmount
  ust
  isManual
  storedFeeDefinition {
    amount
    mode
    feeType
    companyId
    priority
    billingPeriodType
    level
    dealTypes
    isActive
    onlyWhenInAuction
  }
}
fragment AppliedUsedFeeDefinitionsFragment on UsedFeeDefinition {
  itemCategoryId
  feeWeight
  calculatedFeeDefinitions {
    ...CalculatedFeeDefinitionFragment
  }
}
fragment DealCalculationFragment on DealCalculation {
  date
  loanToValuesEntryId
  dealValuesEntry {
    ...DealValuesEntryFragment
  }
  itemsValuesEntries {
    ...ItemValuesEntryFragment
  }
  appliedUsedFeeDefinitions {
    ...AppliedUsedFeeDefinitionsFragment
  }
}
fragment AnyPaymentTypeFragment on AnyPaymentType {
  ... on ManualPaymentWrapper {
    manual: value
  }
  ... on AutomaticPaymentWrapper {
    automatic: value
  }
}
fragment BaseEventFragment on BaseDealEvent {
  __typename
  createdAt
  createdAt
  timestamp
  displayName
}
fragment BookedEventFragment on DealBookedEvent {
  dealCalculation {
    ...DealCalculationFragment
  }
}
fragment VerifiedEventFragment on DealVerifiedEvent {
  isOverwrittenFees
  dealCalculation {
    ...DealCalculationFragment
  }
}
fragment ReviewingEventFragment on DealReviewingEvent {
  issuanceCertificate {
    url
    contentType
  }
}
fragment PaybackConfirmedEventFragment on DealPaybackConfirmedEvent {
  paymentType {
    ...AnyPaymentTypeFragment
  }
  dealCalculation {
    ...DealCalculationFragment
  }
}
fragment ExtensionConfirmedEventFragment on DealExtensionConfirmedEvent {
  paymentType {
    ...AnyPaymentTypeFragment
  }
  dealCalculation {
    ...DealCalculationFragment
  }
  childCalculation {
    ...DealCalculationFragment
  }
  dueAmount
  partialRedemptionAmount
  overwrittenPartialRedemptionAmount
  itemsExtensionAnswers {
    storageLabel
    answers {
      questionId
      selectedOptionIndex
      rangeValue
    }
  }
}
fragment OnSellEventFragment on DealOnSellEvent {
  valueAddedTaxRate
  differenceTaxRate
  valorizationFeeRate
}
fragment ClosedEventFragment on DealClosedEvent {
  dealCalculation {
    ...DealCalculationFragment
  }
  valorizationFeeNet
  valorizationFeeGross
}
fragment DealEventFragment on DealEvent {
  ...BaseEventFragment
  ...BookedEventFragment
  ...VerifiedEventFragment
  ...ReviewingEventFragment
  ...PaybackConfirmedEventFragment
  ...ExtensionConfirmedEventFragment
  ...OnSellEventFragment
  ...ClosedEventFragment
}`, {"fragmentName":"DealOnlinePaymentSucceedFragment"}) as unknown as TypedDocumentString<DealOnlinePaymentSucceedFragmentFragment, unknown>;
export const GetCurrentCustomerDocument = new TypedDocumentString(`
    query getCurrentCustomer {
  getCurrentCustomer {
    _id
    firstname
    lastname
    email
    phone
    dateOfBirth
    phone
    iban
    paypalAddress
    hasAlreadyDeals
    addresses {
      countryCode
      street
      zipCode
    }
  }
}
    `) as unknown as TypedDocumentString<GetCurrentCustomerQuery, GetCurrentCustomerQueryVariables>;
export const LoginCustomerDocument = new TypedDocumentString(`
    mutation loginCustomer($username: String!, $password: String!) {
  loginCustomer(username: $username, password: $password) {
    token
    _id
    firstname
    lastname
    email
    phone
    dateOfBirth
    phone
    iban
    paypalAddress
    deals {
      _id
    }
    addresses {
      countryCode
      street
      zipCode
    }
  }
}
    `) as unknown as TypedDocumentString<LoginCustomerMutation, LoginCustomerMutationVariables>;
export const RegisterCustomerDocument = new TypedDocumentString(`
    mutation registerCustomer($email: String!, $firstname: String!, $lastname: String!, $password: String!, $dateOfBirth: DateTime!, $phone: String!, $acquiredBy: String, $registrationId: String) {
  registerCustomer(
    email: $email
    firstname: $firstname
    lastname: $lastname
    password: $password
    dateOfBirth: $dateOfBirth
    phone: $phone
    acquiredBy: $acquiredBy
    registrationId: $registrationId
  ) {
    token
    _id
    firstname
    lastname
    email
    phone
    dateOfBirth
    phone
    iban
    paypalAddress
  }
}
    `) as unknown as TypedDocumentString<RegisterCustomerMutation, RegisterCustomerMutationVariables>;
export const ResetCustomerPasswordMailDocument = new TypedDocumentString(`
    mutation resetCustomerPasswordMail($email: String!) {
  resetCustomerPasswordMail(email: $email)
}
    `) as unknown as TypedDocumentString<ResetCustomerPasswordMailMutation, ResetCustomerPasswordMailMutationVariables>;
export const ChangeCustomerPasswordFromTokenDocument = new TypedDocumentString(`
    mutation changeCustomerPasswordFromToken($password: String!, $token: String!) {
  changeCustomerPasswordFromToken(password: $password, token: $token) {
    token
    _id
    firstname
    lastname
    email
    phone
    dateOfBirth
    phone
    iban
    paypalAddress
  }
}
    `) as unknown as TypedDocumentString<ChangeCustomerPasswordFromTokenMutation, ChangeCustomerPasswordFromTokenMutationVariables>;
export const ValidateInitialPasswordLinkDocument = new TypedDocumentString(`
    query validateInitialPasswordLink($token: String!) {
  validateInitialPasswordLink(token: $token)
}
    `) as unknown as TypedDocumentString<ValidateInitialPasswordLinkQuery, ValidateInitialPasswordLinkQueryVariables>;
export const IsGuestCheckoutRegistrationTokenValidDocument = new TypedDocumentString(`
    query isGuestCheckoutRegistrationTokenValid($token: String!) {
  isGuestCheckoutRegistrationTokenValid(token: $token)
}
    `) as unknown as TypedDocumentString<IsGuestCheckoutRegistrationTokenValidQuery, IsGuestCheckoutRegistrationTokenValidQueryVariables>;
export const GetCompanyByRegionDocument = new TypedDocumentString(`
    query getCompanyByRegion($region: ERegionCode!) {
  getCompanyByRegion(region: $region) {
    _id
    name
    uid
    fibuNumber
    paypalEmail
    email
    supportEmail
    phoneNumber
    whatsappNumber
    website
    jurisdiction
    headquarter {
      houseNumber
      stairway
      floor
      door
      street
      address1
      address2
      city
      zipCode
      state
      country
      countryCode
    }
    configuration {
      minimumPawnDuration
      gracePeriod
    }
  }
}
    `) as unknown as TypedDocumentString<GetCompanyByRegionQuery, GetCompanyByRegionQueryVariables>;
export const GetAvailableAndCurrentUserRegionsDocument = new TypedDocumentString(`
    query getAvailableAndCurrentUserRegions {
  getAvailableRegions {
    currentRegion {
      ...RegionFragment
    }
    availableRegions {
      ...RegionFragment
    }
  }
}
    fragment RegionFragment on Region {
  name
  code
  domain
}`) as unknown as TypedDocumentString<GetAvailableAndCurrentUserRegionsQuery, GetAvailableAndCurrentUserRegionsQueryVariables>;
export const GetMaintenanceWindowDocument = new TypedDocumentString(`
    query getMaintenanceWindow {
  getMaintenanceWindow {
    scheduledStartTime
    duration
  }
}
    `) as unknown as TypedDocumentString<GetMaintenanceWindowQuery, GetMaintenanceWindowQueryVariables>;
export const CreateShippingLabelByPageIdDocument = new TypedDocumentString(`
    mutation createShippingLabelByPageId($shippingLabelPageId: String!) {
  createShippingLabelByPageId(shippingLabelPageId: $shippingLabelPageId) {
    pickupData {
      transportMode
      standardShippingData {
        sentShippingLabels {
          labelFile {
            filename
          }
          shippingPartner
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CreateShippingLabelByPageIdMutation, CreateShippingLabelByPageIdMutationVariables>;
export const SearchPageQueryDocument = new TypedDocumentString(`
    query SearchPageQuery($searchProductArgs: ProductsFiltersArgs!, $searchItemCategoryArgs: ItemCategoryFiltersArgs!, $languageCode: ELanguageCode!) {
  searchProducts(args: $searchProductArgs) {
    nodes {
      ...SearchPageProductFragment
    }
  }
  searchItemCategories(args: $searchItemCategoryArgs) {
    ...SearchPageItemCategoryFragment
  }
}
    fragment SearchPageProductFragment on Product {
  _id
  name
  slug
  isPublished
}
fragment SearchPageItemCategoryFragment on ItemCategorySearchResult {
  text {
    text(languageCode: $languageCode)
  }
  icon
  matchedKeyword
  fullSlug
}`) as unknown as TypedDocumentString<SearchPageQueryQuery, SearchPageQueryQueryVariables>;
export const ProductSelectorMainProductsQueryDocument = new TypedDocumentString(`
    query ProductSelectorMainProductsQuery($productIds: [ObjectId!]!, $categoryIds: [ObjectId!]!) {
  products: getProducts(opts: {filter: {ids: $productIds, isPublished: true}}) {
    ...ProductSelectorProducts_ProductsFragment
  }
  otherProducts: getProducts(
    opts: {take: 1, filter: {excludeIds: $productIds, categoryIds: $categoryIds, isPublished: true}}
  ) {
    _id
  }
}
    fragment ProductSelectorProducts_ProductsFragment on Product {
  _id
  slug
  name
  overviewImage {
    url
  }
  image {
    url
  }
}`) as unknown as TypedDocumentString<ProductSelectorMainProductsQueryQuery, ProductSelectorMainProductsQueryQueryVariables>;
export const ProductSelectorOtherProductsQueryDocument = new TypedDocumentString(`
    query ProductSelectorOtherProductsQuery($opts: ProductOpts!) {
  products: getProducts(opts: $opts) {
    ...ProductSelectorProducts_ProductsFragment
  }
}
    fragment ProductSelectorProducts_ProductsFragment on Product {
  _id
  slug
  name
  overviewImage {
    url
  }
  image {
    url
  }
}`) as unknown as TypedDocumentString<ProductSelectorOtherProductsQueryQuery, ProductSelectorOtherProductsQueryQueryVariables>;
export const GetViviEntryPointDocument = new TypedDocumentString(`
    query getViviEntryPoint {
  getViviEntryPoint {
    nextStep {
      summary
      name
      description {
        value
        label
      }
      href
      type
      rel
      templated
    }
  }
}
    `) as unknown as TypedDocumentString<GetViviEntryPointQuery, GetViviEntryPointQueryVariables>;
export const CallViviEndpointDocument = new TypedDocumentString(`
    query callViviEndpoint($args: ViviRequestArgs!) {
  callViviEndpoint(args: $args) {
    nextStep {
      summary
      name
      description {
        value
        label
      }
      href
      type
      rel
      templated
    }
    lastStepHref
  }
}
    `) as unknown as TypedDocumentString<CallViviEndpointQuery, CallViviEndpointQueryVariables>;
export const CarDealCalculationDocument = new TypedDocumentString(`
    query carDealCalculation($args: CarDealCalculationArgs!) {
  carDealCalculation(args: $args) {
    ...CarDealCalculationFragment
  }
}
    fragment DealValuesEntryFragment on DealValuesEntry {
  payoutAmount
  paybackAmount
  calculationPayoutAmount
  calculationPaybackAmount
  durationInDays
  shouldOverwritePayoutAmount
  overwrittenPayoutAmount
}
fragment ItemValuesEntryFragment on ItemValuesEntry {
  conditionMaxMarketValues {
    excellent
    good
    poor
  }
  maxMarketValue
  currentMarketValue
  predictedMarketValue
  adjustedMarketValue
  durationInDays
  loanToValue
  date
  payoutAmount
}
fragment CalculatedFeeDefinitionFragment on CalculatedFeeDefinition {
  appliedGrossAmount
  appliedNetAmount
  finalGrossAmount
  finalNetAmount
  ust
  isManual
  storedFeeDefinition {
    amount
    mode
    feeType
    companyId
    priority
    billingPeriodType
    level
    dealTypes
    isActive
    onlyWhenInAuction
  }
}
fragment AppliedUsedFeeDefinitionsFragment on UsedFeeDefinition {
  itemCategoryId
  feeWeight
  calculatedFeeDefinitions {
    ...CalculatedFeeDefinitionFragment
  }
}
fragment CarDealCalculationFragment on CarDealCalculation {
  dealCalculationId
  date
  noValuation
  loanToValuesEntryId
  competitiveVehiclesForSale
  dealValuesEntry {
    ...DealValuesEntryFragment
  }
  itemsValuesEntries {
    ...ItemValuesEntryFragment
  }
  appliedUsedFeeDefinitions {
    ...AppliedUsedFeeDefinitionsFragment
  }
}`) as unknown as TypedDocumentString<CarDealCalculationQuery, CarDealCalculationQueryVariables>;
export const CreateCustomerCallRequestDocument = new TypedDocumentString(`
    mutation createCustomerCallRequest($args: CustomerCallRequestArgs!) {
  createCustomerCallRequest(args: $args)
}
    `) as unknown as TypedDocumentString<CreateCustomerCallRequestMutation, CreateCustomerCallRequestMutationVariables>;
export const CreateCarDealDocument = new TypedDocumentString(`
    mutation createCarDeal($dealCalculationId: ObjectId!, $companyId: ObjectId!, $payoutType: EManualPaymentType!, $iban: String, $paypalAddress: String, $dealItemsCreateArgs: [DealItemCreateArgs!]!, $pickupData: TransportDataArgs, $dealPartnerData: DealPartnerDataArgs, $initialShopId: ObjectId, $registeredCustomerId: ObjectId, $guestCustomerDataArgs: GuestCustomerDataArgs) {
  createCarDeal(
    dealCalculationId: $dealCalculationId
    companyId: $companyId
    payoutType: $payoutType
    iban: $iban
    paypalAddress: $paypalAddress
    dealItemsCreateArgs: $dealItemsCreateArgs
    pickupData: $pickupData
    dealPartnerData: $dealPartnerData
    initialShopId: $initialShopId
    registeredCustomerId: $registeredCustomerId
    guestCustomerDataArgs: $guestCustomerDataArgs
  ) {
    _id
    createdAt
    updatedAt
    dealType
    bookingNumber
    dealFinalValues {
      dealType
      durationInDays
      shouldOverwritePayoutAmount
      payoutAmount
      isOnlineExtensionPrevented
    }
    pawnData {
      pawnNumber
      pawnTicketLink {
        url
        contentType
      }
      billNumber
      billLink {
        url
        contentType
      }
      paybackData {
        ...PaymentDataFragment
        iban
      }
      extensionChildId
      extensionParentId
    }
    purchaseData {
      receiptNumber
      receiptLink {
        url
        contentType
      }
    }
    events {
      ...BaseEventFragment
      ...BookedEventFragment
    }
    payoutData {
      ...PaymentDataFragment
      iban
    }
    initialShopId
    pickupData {
      transportMode
    }
    dropoffData {
      transportMode
    }
    dealPartnerData {
      type
      knp {
        fileReferenceNumber
        debtAmount
      }
    }
    itemsIds
    items(omitItemQuestions: true, omitItemValorizationCalculation: true) {
      _id
      title
      itemCategoryId
      itemCategory {
        _id
        name
        parentId
        createdAt
        updatedAt
        slug
        parentCategories {
          _id
        }
      }
      algoliaReference
      material
      ean
      media {
        url
        contentType
      }
      note
      values {
        verified {
          maxMarketValue
          loanToValue
          payoutAmount
        }
      }
    }
  }
}
    fragment DealValuesEntryFragment on DealValuesEntry {
  payoutAmount
  paybackAmount
  calculationPayoutAmount
  calculationPaybackAmount
  durationInDays
  shouldOverwritePayoutAmount
  overwrittenPayoutAmount
}
fragment ItemValuesEntryFragment on ItemValuesEntry {
  conditionMaxMarketValues {
    excellent
    good
    poor
  }
  maxMarketValue
  currentMarketValue
  predictedMarketValue
  adjustedMarketValue
  durationInDays
  loanToValue
  date
  payoutAmount
}
fragment CalculatedFeeDefinitionFragment on CalculatedFeeDefinition {
  appliedGrossAmount
  appliedNetAmount
  finalGrossAmount
  finalNetAmount
  ust
  isManual
  storedFeeDefinition {
    amount
    mode
    feeType
    companyId
    priority
    billingPeriodType
    level
    dealTypes
    isActive
    onlyWhenInAuction
  }
}
fragment AppliedUsedFeeDefinitionsFragment on UsedFeeDefinition {
  itemCategoryId
  feeWeight
  calculatedFeeDefinitions {
    ...CalculatedFeeDefinitionFragment
  }
}
fragment DealCalculationFragment on DealCalculation {
  date
  loanToValuesEntryId
  dealValuesEntry {
    ...DealValuesEntryFragment
  }
  itemsValuesEntries {
    ...ItemValuesEntryFragment
  }
  appliedUsedFeeDefinitions {
    ...AppliedUsedFeeDefinitionsFragment
  }
}
fragment PaymentDataFragment on PaymentData {
  paymentType {
    ... on ManualPaymentWrapper {
      manual: value
    }
    ... on AutomaticPaymentWrapper {
      automatic: value
    }
  }
}
fragment BaseEventFragment on BaseDealEvent {
  __typename
  createdAt
  createdAt
  timestamp
  displayName
}
fragment BookedEventFragment on DealBookedEvent {
  dealCalculation {
    ...DealCalculationFragment
  }
}`) as unknown as TypedDocumentString<CreateCarDealMutation, CreateCarDealMutationVariables>;
export const GetCarMakeModelsDocument = new TypedDocumentString(`
    query getCarMakeModels($args: CarMakeModelsArgs!) {
  carMakeModels(args: $args)
}
    `) as unknown as TypedDocumentString<GetCarMakeModelsQuery, GetCarMakeModelsQueryVariables>;
export const GetShopsActiveOnWebsiteDocument = new TypedDocumentString(`
    query getShopsActiveOnWebsite($opts: ShopOpts) {
  getShopsActiveOnWebsite(opts: $opts) {
    ...ShopFragment
  }
}
    fragment ShopFragment on Shop {
  _id
  name
  phone
  email
  googleMapsLink
  shopPagePath
  address {
    coordinates {
      lat
      lng
    }
    houseNumber
    stairway
    door
    floor
    street
    city
    state
    countryCode
    country
    zipCode
    queryString
    address1
    address2
  }
  openingHours
}`) as unknown as TypedDocumentString<GetShopsActiveOnWebsiteQuery, GetShopsActiveOnWebsiteQueryVariables>;
export const GetShopsForCategoriesDocument = new TypedDocumentString(`
    query getShopsForCategories($opts: ShopOpts, $itemCategoryIds: [ObjectId!]!) {
  getShopsForCategories(opts: $opts, itemCategoryIds: $itemCategoryIds) {
    ...ShopFragment
  }
}
    fragment ShopFragment on Shop {
  _id
  name
  phone
  email
  googleMapsLink
  shopPagePath
  address {
    coordinates {
      lat
      lng
    }
    houseNumber
    stairway
    door
    floor
    street
    city
    state
    countryCode
    country
    zipCode
    queryString
    address1
    address2
  }
  openingHours
}`) as unknown as TypedDocumentString<GetShopsForCategoriesQuery, GetShopsForCategoriesQueryVariables>;
export const AddDealRatingDocument = new TypedDocumentString(`
    mutation addDealRating($rating: Int!, $message: String, $dealId: ObjectId!) {
  addDealRating(rating: $rating, message: $message, dealId: $dealId)
}
    `) as unknown as TypedDocumentString<AddDealRatingMutation, AddDealRatingMutationVariables>;
export const DealCalculationDocument = new TypedDocumentString(`
    query dealCalculation($companyId: ObjectId!, $durationInDays: Int!, $date: DateTime, $dealType: EDealType!, $dealItemsCalculationArgs: [DealItemCalculationArgs!]!, $pickupTransportMode: ETransportMode!, $dropoffTransportMode: ETransportMode!, $shouldOverwritePayoutAmount: Boolean!, $overwrittenPayoutAmount: Float!, $shouldOverwriteManualFees: Boolean!, $manualFeeDefinitionsArgs: [ManualFeeDefinitionArgs!]!, $customDealId: ObjectId, $isReversedCalculation: Boolean!) {
  dealCalculation(
    companyId: $companyId
    durationInDays: $durationInDays
    date: $date
    dealType: $dealType
    dealItemsCalculationArgs: $dealItemsCalculationArgs
    pickupTransportMode: $pickupTransportMode
    dropoffTransportMode: $dropoffTransportMode
    shouldOverwritePayoutAmount: $shouldOverwritePayoutAmount
    overwrittenPayoutAmount: $overwrittenPayoutAmount
    shouldOverwriteManualFees: $shouldOverwriteManualFees
    manualFeeDefinitionsArgs: $manualFeeDefinitionsArgs
    customDealId: $customDealId
    isReversedCalculation: $isReversedCalculation
  ) {
    dealCalculationId
    date
    loanToValuesEntryId
    dealValuesEntry {
      ...DealValuesEntryFragment
    }
    itemsValuesEntries {
      ...ItemValuesEntryFragment
    }
    appliedUsedFeeDefinitions {
      ...AppliedUsedFeeDefinitionsFragment
    }
  }
}
    fragment DealValuesEntryFragment on DealValuesEntry {
  payoutAmount
  paybackAmount
  calculationPayoutAmount
  calculationPaybackAmount
  durationInDays
  shouldOverwritePayoutAmount
  overwrittenPayoutAmount
}
fragment ItemValuesEntryFragment on ItemValuesEntry {
  conditionMaxMarketValues {
    excellent
    good
    poor
  }
  maxMarketValue
  currentMarketValue
  predictedMarketValue
  adjustedMarketValue
  durationInDays
  loanToValue
  date
  payoutAmount
}
fragment CalculatedFeeDefinitionFragment on CalculatedFeeDefinition {
  appliedGrossAmount
  appliedNetAmount
  finalGrossAmount
  finalNetAmount
  ust
  isManual
  storedFeeDefinition {
    amount
    mode
    feeType
    companyId
    priority
    billingPeriodType
    level
    dealTypes
    isActive
    onlyWhenInAuction
  }
}
fragment AppliedUsedFeeDefinitionsFragment on UsedFeeDefinition {
  itemCategoryId
  feeWeight
  calculatedFeeDefinitions {
    ...CalculatedFeeDefinitionFragment
  }
}`) as unknown as TypedDocumentString<DealCalculationQuery, DealCalculationQueryVariables>;
export const CreateDealDocument = new TypedDocumentString(`
    mutation createDeal($dealCalculationId: ObjectId!, $companyId: ObjectId!, $payoutType: EManualPaymentType!, $iban: String, $paypalAddress: String, $dealItemsCreateArgs: [DealItemCreateArgs!]!, $pickupData: TransportDataArgs, $dealPartnerData: DealPartnerDataArgs, $customDealId: ObjectId, $initialShopId: ObjectId, $registeredCustomerId: ObjectId, $guestCustomerDataArgs: GuestCustomerDataArgs) {
  createDeal(
    dealCalculationId: $dealCalculationId
    companyId: $companyId
    payoutType: $payoutType
    iban: $iban
    paypalAddress: $paypalAddress
    dealItemsCreateArgs: $dealItemsCreateArgs
    pickupData: $pickupData
    dealPartnerData: $dealPartnerData
    customDealId: $customDealId
    initialShopId: $initialShopId
    registeredCustomerId: $registeredCustomerId
    guestCustomerDataArgs: $guestCustomerDataArgs
  ) {
    _id
    createdAt
    updatedAt
    dealType
    bookingNumber
    dealFinalValues {
      dealType
      durationInDays
      shouldOverwritePayoutAmount
      payoutAmount
    }
    pawnData {
      pawnNumber
      pawnTicketLink {
        url
        contentType
      }
      billNumber
      billLink {
        url
        contentType
      }
      paybackData {
        ...PaymentDataFragment
        iban
      }
      extensionChildId
      extensionParentId
    }
    purchaseData {
      receiptNumber
      receiptLink {
        url
        contentType
      }
    }
    events {
      ...BaseEventFragment
      ...BookedEventFragment
    }
    payoutData {
      ...PaymentDataFragment
      iban
    }
    initialShopId
    pickupData {
      transportMode
    }
    dropoffData {
      transportMode
    }
    dealPartnerData {
      type
      knp {
        fileReferenceNumber
        debtAmount
      }
    }
    itemsIds
    items(omitItemQuestions: true, omitItemValorizationCalculation: true) {
      _id
      title
      itemCategoryId
      itemCategory {
        _id
        name
        parentId
        createdAt
        updatedAt
        slug
        parentCategories {
          _id
        }
      }
      algoliaReference
      material
      ean
      media {
        url
        contentType
      }
      note
      values {
        verified {
          maxMarketValue
          loanToValue
          payoutAmount
        }
      }
    }
  }
}
    fragment DealValuesEntryFragment on DealValuesEntry {
  payoutAmount
  paybackAmount
  calculationPayoutAmount
  calculationPaybackAmount
  durationInDays
  shouldOverwritePayoutAmount
  overwrittenPayoutAmount
}
fragment ItemValuesEntryFragment on ItemValuesEntry {
  conditionMaxMarketValues {
    excellent
    good
    poor
  }
  maxMarketValue
  currentMarketValue
  predictedMarketValue
  adjustedMarketValue
  durationInDays
  loanToValue
  date
  payoutAmount
}
fragment CalculatedFeeDefinitionFragment on CalculatedFeeDefinition {
  appliedGrossAmount
  appliedNetAmount
  finalGrossAmount
  finalNetAmount
  ust
  isManual
  storedFeeDefinition {
    amount
    mode
    feeType
    companyId
    priority
    billingPeriodType
    level
    dealTypes
    isActive
    onlyWhenInAuction
  }
}
fragment AppliedUsedFeeDefinitionsFragment on UsedFeeDefinition {
  itemCategoryId
  feeWeight
  calculatedFeeDefinitions {
    ...CalculatedFeeDefinitionFragment
  }
}
fragment DealCalculationFragment on DealCalculation {
  date
  loanToValuesEntryId
  dealValuesEntry {
    ...DealValuesEntryFragment
  }
  itemsValuesEntries {
    ...ItemValuesEntryFragment
  }
  appliedUsedFeeDefinitions {
    ...AppliedUsedFeeDefinitionsFragment
  }
}
fragment PaymentDataFragment on PaymentData {
  paymentType {
    ... on ManualPaymentWrapper {
      manual: value
    }
    ... on AutomaticPaymentWrapper {
      automatic: value
    }
  }
}
fragment BaseEventFragment on BaseDealEvent {
  __typename
  createdAt
  createdAt
  timestamp
  displayName
}
fragment BookedEventFragment on DealBookedEvent {
  dealCalculation {
    ...DealCalculationFragment
  }
}`) as unknown as TypedDocumentString<CreateDealMutation, CreateDealMutationVariables>;
export const CreateDealForCustomerDocument = new TypedDocumentString(`
    mutation createDealForCustomer($dealCreateArgs: DealCreateArgs!, $customerEmail: String!) {
  createDealForCustomer(
    dealCreateArgs: $dealCreateArgs
    customerEmail: $customerEmail
  ) {
    _id
    createdAt
    updatedAt
    dealType
    bookingNumber
    dealFinalValues {
      dealType
      durationInDays
      shouldOverwritePayoutAmount
      payoutAmount
    }
    pawnData {
      pawnNumber
      pawnTicketLink {
        url
        contentType
      }
      billNumber
      billLink {
        url
        contentType
      }
      paybackData {
        ...PaymentDataFragment
        iban
      }
      extensionChildId
      extensionParentId
    }
    purchaseData {
      receiptNumber
      receiptLink {
        url
        contentType
      }
    }
    events {
      ...BaseEventFragment
      ...BookedEventFragment
    }
    payoutData {
      ...PaymentDataFragment
      iban
    }
    initialShopId
    pickupData {
      transportMode
    }
    dropoffData {
      transportMode
    }
    dealPartnerData {
      type
      knp {
        fileReferenceNumber
        debtAmount
      }
    }
    itemsIds
    items(omitItemQuestions: true, omitItemValorizationCalculation: true) {
      _id
      title
      itemCategoryId
      itemCategory {
        _id
        name
        parentId
        createdAt
        updatedAt
        slug
      }
      algoliaReference
      material
      ean
      media {
        url
        contentType
      }
      note
      values {
        verified {
          maxMarketValue
          loanToValue
        }
      }
    }
  }
}
    fragment DealValuesEntryFragment on DealValuesEntry {
  payoutAmount
  paybackAmount
  calculationPayoutAmount
  calculationPaybackAmount
  durationInDays
  shouldOverwritePayoutAmount
  overwrittenPayoutAmount
}
fragment ItemValuesEntryFragment on ItemValuesEntry {
  conditionMaxMarketValues {
    excellent
    good
    poor
  }
  maxMarketValue
  currentMarketValue
  predictedMarketValue
  adjustedMarketValue
  durationInDays
  loanToValue
  date
  payoutAmount
}
fragment CalculatedFeeDefinitionFragment on CalculatedFeeDefinition {
  appliedGrossAmount
  appliedNetAmount
  finalGrossAmount
  finalNetAmount
  ust
  isManual
  storedFeeDefinition {
    amount
    mode
    feeType
    companyId
    priority
    billingPeriodType
    level
    dealTypes
    isActive
    onlyWhenInAuction
  }
}
fragment AppliedUsedFeeDefinitionsFragment on UsedFeeDefinition {
  itemCategoryId
  feeWeight
  calculatedFeeDefinitions {
    ...CalculatedFeeDefinitionFragment
  }
}
fragment DealCalculationFragment on DealCalculation {
  date
  loanToValuesEntryId
  dealValuesEntry {
    ...DealValuesEntryFragment
  }
  itemsValuesEntries {
    ...ItemValuesEntryFragment
  }
  appliedUsedFeeDefinitions {
    ...AppliedUsedFeeDefinitionsFragment
  }
}
fragment PaymentDataFragment on PaymentData {
  paymentType {
    ... on ManualPaymentWrapper {
      manual: value
    }
    ... on AutomaticPaymentWrapper {
      automatic: value
    }
  }
}
fragment BaseEventFragment on BaseDealEvent {
  __typename
  createdAt
  createdAt
  timestamp
  displayName
}
fragment BookedEventFragment on DealBookedEvent {
  dealCalculation {
    ...DealCalculationFragment
  }
}`) as unknown as TypedDocumentString<CreateDealForCustomerMutation, CreateDealForCustomerMutationVariables>;
export const GetCurrentCustomerAddressesDocument = new TypedDocumentString(`
    query getCurrentCustomerAddresses {
  getCurrentCustomer {
    addresses {
      street
      countryCode
      zipCode
      coordinates {
        lat
        lng
      }
      houseNumber
      floor
      door
      city
      state
      country
      stairway
      queryString
      note
      isDeliveryAddress
      isBillingAddress
    }
  }
}
    `) as unknown as TypedDocumentString<GetCurrentCustomerAddressesQuery, GetCurrentCustomerAddressesQueryVariables>;
export const GetUpcomingPickupSlotsDocument = new TypedDocumentString(`
    query getUpcomingPickupSlots($args: StoreboxUpcomingPickupSlotsArgs!) {
  getUpcomingPickupSlots(args: $args) {
    start
    end
  }
}
    `) as unknown as TypedDocumentString<GetUpcomingPickupSlotsQuery, GetUpcomingPickupSlotsQueryVariables>;
export const StoreboxAvailableForZipCodeDocument = new TypedDocumentString(`
    query storeboxAvailableForZipCode($zipCode: String!, $companyId: ObjectId!) {
  storeboxAvailableForZipCode(zipCode: $zipCode, companyId: $companyId)
}
    `) as unknown as TypedDocumentString<StoreboxAvailableForZipCodeQuery, StoreboxAvailableForZipCodeQueryVariables>;
export const CreateCustomDealDocument = new TypedDocumentString(`
    mutation createCustomDeal($customDealCreateArgs: CustomDealCreateArgs!) {
  createCustomDeal(customDealCreateArgs: $customDealCreateArgs) {
    _id
    items {
      itemCategory {
        parentCategories {
          _id
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CreateCustomDealMutation, CreateCustomDealMutationVariables>;
export const RejectCustomDealCounterofferDocument = new TypedDocumentString(`
    mutation rejectCustomDealCounteroffer($rejectCustomDealCounterofferArgs: RejectCustomDealCounterofferArgs!) {
  rejectCustomDealCounteroffer(
    rejectCustomDealCounterofferArgs: $rejectCustomDealCounterofferArgs
  ) {
    _id
  }
}
    `) as unknown as TypedDocumentString<RejectCustomDealCounterofferMutation, RejectCustomDealCounterofferMutationVariables>;
export const GetCustomDealByIdDocument = new TypedDocumentString(`
    query getCustomDealById($customDealId: ObjectId!) {
  getCustomDealById(customDealId: $customDealId) {
    ...CustomDealFragment
  }
}
    fragment CustomDealFragment on CustomDeal {
  _id
  customDealNumber
  status
  createdAt
  updatedAt
  durationInDays
  isPayoutOverwritten
  isReversedFeeCalculation
  contactData {
    email
    phone
  }
  dealType
  company {
    _id
    configuration {
      minimumPawnDuration
      gracePeriod
    }
  }
  items {
    itemCategoryId
    title
    note
    algoliaReference
    policeNumber
    pawnPayoutAmount
    purchasePayoutAmount
    overwrittenPawnPayoutAmount
    overwrittenPurchasePayoutAmount
    ean
    material
    counterofferPayoutAmount
    foundComparableOffers
    overwrittenItemValue
    foundOffersEvaluationFactor
    variantId
    productVariant {
      ...VariantsFragment
    }
    priceFindings {
      price
    }
    media {
      url
      contentType
    }
    note
    answers {
      questionId
      selectedOptionIndex
      rangeValue
    }
    itemPawnValueEntry {
      adjustedMarketValue
      payoutAmount
    }
    itemPurchaseValueEntry {
      adjustedMarketValue
      payoutAmount
    }
  }
  overridePayoutAmount
  availableTransportModes
  events {
    event
    createdAt
    timestamp
  }
  pawnCalculation {
    payoutAmount
  }
  purchaseCalculation {
    payoutAmount
  }
}
fragment VariantsFragment on ProductVariant {
  id
  isPriceValid
  image {
    id
    url
  }
  name
  product {
    name
    category {
      name
      parentCategories {
        name
      }
    }
  }
  propertiesValues {
    ... on ProductVariantPropertyTextValue {
      propertyDefinitionId
      propertyDefinition {
        _id
        type
        impactsLook
        showOnWebsite
        name {
          allTranslations {
            text
            languageCode
          }
        }
        key
        valueFormatting {
          suffix
        }
      }
      value {
        translation {
          allTranslations {
            text
            languageCode
          }
        }
      }
    }
    ... on ProductVariantPropertyNumberValue {
      propertyDefinitionId
      propertyDefinition {
        _id
        type
        impactsLook
        showOnWebsite
        name {
          allTranslations {
            text
            languageCode
          }
        }
        key
        valueFormatting {
          suffix
        }
      }
      value {
        numberValue
      }
    }
    ... on ProductVariantPropertyBooleanValue {
      propertyDefinitionId
      propertyDefinition {
        _id
        type
        impactsLook
        showOnWebsite
        name {
          allTranslations {
            text
            languageCode
          }
        }
        key
        valueFormatting {
          suffix
        }
      }
      value {
        booleanValue
      }
    }
  }
}`) as unknown as TypedDocumentString<GetCustomDealByIdQuery, GetCustomDealByIdQueryVariables>;
export const DealPawnDurationsDocument = new TypedDocumentString(`
    query dealPawnDurations($args: DealPawnDurationsArgs!) {
  dealPawnDurations(args: $args)
}
    `) as unknown as TypedDocumentString<DealPawnDurationsQuery, DealPawnDurationsQueryVariables>;
export const CustomDealCalculationDocument = new TypedDocumentString(`
    query customDealCalculation($customDealCalculationArgs: CustomDealCalculationArgs!) {
  customDealCalculation(customDealCalculationArgs: $customDealCalculationArgs) {
    payoutAmount
    dealType
    token
    date
    dealValuesEntry {
      ...DealValuesEntryFragment
    }
    itemsValuesEntries {
      ...ItemValuesEntryFragment
    }
    appliedUsedFeeDefinitions {
      ...AppliedUsedFeeDefinitionsFragment
    }
  }
}
    fragment DealValuesEntryFragment on DealValuesEntry {
  payoutAmount
  paybackAmount
  calculationPayoutAmount
  calculationPaybackAmount
  durationInDays
  shouldOverwritePayoutAmount
  overwrittenPayoutAmount
}
fragment ItemValuesEntryFragment on ItemValuesEntry {
  conditionMaxMarketValues {
    excellent
    good
    poor
  }
  maxMarketValue
  currentMarketValue
  predictedMarketValue
  adjustedMarketValue
  durationInDays
  loanToValue
  date
  payoutAmount
}
fragment CalculatedFeeDefinitionFragment on CalculatedFeeDefinition {
  appliedGrossAmount
  appliedNetAmount
  finalGrossAmount
  finalNetAmount
  ust
  isManual
  storedFeeDefinition {
    amount
    mode
    feeType
    companyId
    priority
    billingPeriodType
    level
    dealTypes
    isActive
    onlyWhenInAuction
  }
}
fragment AppliedUsedFeeDefinitionsFragment on UsedFeeDefinition {
  itemCategoryId
  feeWeight
  calculatedFeeDefinitions {
    ...CalculatedFeeDefinitionFragment
  }
}`) as unknown as TypedDocumentString<CustomDealCalculationQuery, CustomDealCalculationQueryVariables>;
export const GetCustomDealFormByCategoryDocument = new TypedDocumentString(`
    query getCustomDealFormByCategory($categoryId: ObjectId!, $languageCode: ELanguageCode!) {
  getCustomDealFormByCategory(categoryId: $categoryId) {
    isAllowedPurchase
    isUsedForCommissionSale
    questions {
      __typename
      ... on BaseCustomDealFormQuestion {
        _id
        __typename
        type
        label {
          allTranslations {
            languageCode
            text
          }
          text(languageCode: $languageCode)
        }
        info {
          allTranslations {
            languageCode
            text
          }
          text(languageCode: $languageCode)
        }
        titleKey
        optional
        showOnIssuanceCertificate
        showOnSalesBill
      }
      ... on NumberDefaultCustomDealFormQuestion {
        initialNumberAnswer
      }
      ... on TextMultilineCustomDealFormQuestion {
        initialMultilineTextAnswer
      }
      ... on TextDefaultCustomDealFormQuestion {
        initialTextAnswer
      }
      ... on BooleanCustomDealFormQuestion {
        initialBooleanAnswer
      }
      ... on TextOptionsCustomDealFormQuestion {
        initialOptionTextAnswer
        options {
          default
          description {
            allTranslations {
              languageCode
              text
            }
            text(languageCode: $languageCode)
          }
          label {
            allTranslations {
              languageCode
              text
            }
            text(languageCode: $languageCode)
          }
        }
        allowEnterAnswer
      }
      ... on NumberOptionsCustomDealFormQuestion {
        initialOptionNumberAnswer
        options {
          default
          label {
            allTranslations {
              languageCode
              text
            }
            text(languageCode: $languageCode)
          }
        }
        allowEnterAnswer
        restrictions(categoryId: $categoryId) {
          conditionOperator
          conditionValue
          errorMessage {
            text(languageCode: $languageCode)
          }
        }
      }
      ... on FileUploadCustomDealFormQuestion {
        initialFileUploadAnswer
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetCustomDealFormByCategoryQuery, GetCustomDealFormByCategoryQueryVariables>;
export const GetItemCategoriesDocument = new TypedDocumentString(`
    query getItemCategories($opts: ItemCategoryOpts) {
  getItemCategories(opts: $opts) {
    _id
    name
    parentId
    createdAt
    updatedAt
    slug
    categoryPageIds
    visibleOnDomain
  }
}
    `) as unknown as TypedDocumentString<GetItemCategoriesQuery, GetItemCategoriesQueryVariables>;
export const GetCategoryChildPagesContentDocument = new TypedDocumentString(`
    query getCategoryChildPagesContent($path: String!, $includeDrafts: Boolean!) {
  getCategoryPageContent(path: $path, includeDrafts: $includeDrafts) {
    availableRegions
    page {
      _id
      isLeaveCategory
      selectorHeading
    }
    childPages(includeDrafts: $includeDrafts) {
      _id
      path
      isSpecialPage
      categoryLabel
      categoryImage {
        ...UploadFileFragment
      }
    }
  }
}
    fragment UploadFileFormatFragment on UploadFileFormat {
  hash
  ext
  mime
  width
  height
  size
  path
  url
}
fragment UploadFileFragment on UploadFile {
  _id
  name
  alternativeText
  caption
  hash
  ext
  mime
  width
  height
  size
  url
  provider
  createdAt
  updatedAt
  formats {
    thumbnail {
      ...UploadFileFormatFragment
    }
    small {
      ...UploadFileFormatFragment
    }
    medium {
      ...UploadFileFormatFragment
    }
    large {
      ...UploadFileFormatFragment
    }
    product_thumbnail {
      ...UploadFileFormatFragment
    }
    product_small {
      ...UploadFileFormatFragment
    }
  }
}`) as unknown as TypedDocumentString<GetCategoryChildPagesContentQuery, GetCategoryChildPagesContentQueryVariables>;
export const GetItemPageContentDocument = new TypedDocumentString(`
    query getItemPageContent($slug: String!, $includeDrafts: Boolean!, $date: DateTime!, $omitInternalQuestions: Boolean) {
  getItemPageContent(slug: $slug) {
    product {
      ...ProductFragment
    }
    categoryPages(includeDrafts: $includeDrafts, language: "de") {
      lvl0 {
        ...CategoryPageFragment
      }
      lvl1 {
        ...CategoryPageFragment
      }
      lvl2 {
        ...CategoryPageFragment
      }
      lvl3 {
        ...CategoryPageFragment
      }
    }
    itemQuestions(date: $date, omitInternalQuestions: $omitInternalQuestions) {
      ...ItemQuestionFragment
    }
  }
}
    fragment UploadFileFormatFragment on UploadFileFormat {
  hash
  ext
  mime
  width
  height
  size
  path
  url
}
fragment UploadFileFragment on UploadFile {
  _id
  name
  alternativeText
  caption
  hash
  ext
  mime
  width
  height
  size
  url
  provider
  createdAt
  updatedAt
  formats {
    thumbnail {
      ...UploadFileFormatFragment
    }
    small {
      ...UploadFileFormatFragment
    }
    medium {
      ...UploadFileFormatFragment
    }
    large {
      ...UploadFileFormatFragment
    }
    product_thumbnail {
      ...UploadFileFormatFragment
    }
    product_small {
      ...UploadFileFormatFragment
    }
  }
}
fragment CategoryPageFragment on CategoryPage {
  _id
  fallbackImage {
    ...UploadFileFragment
  }
}
fragment ItemQuestionFragment on ItemQuestion {
  _id
  order
  questionType
  valueMode
  titleKey
  infoKey
  isInternal
  predictionTag
  singleChoiceOptions {
    labelKey
    infoKey
    categoryValues
    conditionValue
    isDefaultValue
  }
  rangeData {
    minValue
    maxValue
    defaultValue
    unitPrice
    unitKey
  }
  itemCategoryIds
}
fragment ProductFragment on ProductLegacy {
  _id
  title
  slug
  objectID
  releaseDate
  maxValue
  maxLoanToValue
  itemCategoryId
  itemCategory {
    _id
    name
    parentId
    createdAt
    updatedAt
    slug
    visibleOnDomain
    availableTransportModes
    maximumPawnDuration
    recursiveMinimumItemValue
  }
  isInactive
  conditionMaxValues {
    excellent
    good
    poor
  }
  contentCategories {
    lvl0
    lvl1
    lvl2
    lvl3
  }
  pictureFilename
  gewicht
  karat
  material
  ean
  class
  picture {
    ...UploadFileFragment
  }
  isTaxFree
}`) as unknown as TypedDocumentString<GetItemPageContentQuery, GetItemPageContentQueryVariables>;
export const GetItemQuestionsByCategoryDocument = new TypedDocumentString(`
    query getItemQuestionsByCategory($itemCategoryId: ObjectId!, $date: DateTime!, $isCustomItem: Boolean!, $omitDeactivatedQuestionsForNewProducts: Boolean!) {
  getItemQuestionsByCategory(
    itemCategoryId: $itemCategoryId
    date: $date
    isCustomItem: $isCustomItem
    omitDeactivatedQuestionsForNewProducts: $omitDeactivatedQuestionsForNewProducts
  ) {
    ...ItemQuestionFragment
  }
}
    fragment ItemQuestionFragment on ItemQuestion {
  _id
  order
  questionType
  valueMode
  titleKey
  infoKey
  isInternal
  predictionTag
  singleChoiceOptions {
    labelKey
    infoKey
    categoryValues
    conditionValue
    isDefaultValue
  }
  rangeData {
    minValue
    maxValue
    defaultValue
    unitPrice
    unitKey
  }
  itemCategoryIds
}`) as unknown as TypedDocumentString<GetItemQuestionsByCategoryQuery, GetItemQuestionsByCategoryQueryVariables>;
export const GetProductsLegacyWithPaginationDocument = new TypedDocumentString(`
    query getProductsLegacyWithPagination($opts: ProductLegacyOpts!) {
  getProductsLegacyWithPagination(opts: $opts) {
    products {
      ...ProductFragment
    }
    count
    take
    skip
  }
}
    fragment UploadFileFormatFragment on UploadFileFormat {
  hash
  ext
  mime
  width
  height
  size
  path
  url
}
fragment UploadFileFragment on UploadFile {
  _id
  name
  alternativeText
  caption
  hash
  ext
  mime
  width
  height
  size
  url
  provider
  createdAt
  updatedAt
  formats {
    thumbnail {
      ...UploadFileFormatFragment
    }
    small {
      ...UploadFileFormatFragment
    }
    medium {
      ...UploadFileFormatFragment
    }
    large {
      ...UploadFileFormatFragment
    }
    product_thumbnail {
      ...UploadFileFormatFragment
    }
    product_small {
      ...UploadFileFormatFragment
    }
  }
}
fragment ProductFragment on ProductLegacy {
  _id
  title
  slug
  objectID
  releaseDate
  maxValue
  maxLoanToValue
  itemCategoryId
  itemCategory {
    _id
    name
    parentId
    createdAt
    updatedAt
    slug
    visibleOnDomain
    availableTransportModes
    maximumPawnDuration
    recursiveMinimumItemValue
  }
  isInactive
  conditionMaxValues {
    excellent
    good
    poor
  }
  contentCategories {
    lvl0
    lvl1
    lvl2
    lvl3
  }
  pictureFilename
  gewicht
  karat
  material
  ean
  class
  picture {
    ...UploadFileFragment
  }
  isTaxFree
}`) as unknown as TypedDocumentString<GetProductsLegacyWithPaginationQuery, GetProductsLegacyWithPaginationQueryVariables>;
export const GetParentCategoriesDocument = new TypedDocumentString(`
    query getParentCategories($itemCategoryId: ObjectId!) {
  getParentCategories(itemCategoryId: $itemCategoryId) {
    _id
    name
    parentId
    createdAt
    updatedAt
    slug
    visibleOnDomain
  }
}
    `) as unknown as TypedDocumentString<GetParentCategoriesQuery, GetParentCategoriesQueryVariables>;
export const GetProductBySlugDocument = new TypedDocumentString(`
    query getProductBySlug($slug: String!, $date: DateTime!) {
  getProductBySlug(slug: $slug) {
    _id
    categoryId
    slug
    category {
      _id
      name
      parentId
      algoliaCategorySlug
      createdAt
      updatedAt
      slug
      visibleOnDomain
      availableTransportModes
      maximumPawnDuration
      recursiveMinimumItemValue
      parentCategories {
        _id
        name
        parentId
        slug
      }
    }
    name
    manufacturer
    imageMode
    imageId
    image {
      id
      url
    }
    itemQuestions(
      date: $date
      omitInternalQuestions: true
      omitDeactivatedQuestionsForNewProducts: true
    ) {
      ...ItemQuestionFragment
    }
    availableProperties {
      ...AvailablePropertiesFragment
    }
    variants {
      ...VariantsFragment
    }
    price {
      ... on ProductPriceCrawledMode {
        mode
        variants {
          variantId
          price
          createdAt
          updatedAt
          adjustment {
            value
            type
            updatedAt
          }
        }
      }
      ... on ProductPriceManualVariantMode {
        mode
        variants {
          variantId
          price
          updatedAt
        }
      }
      ... on ProductPriceManualPropertyMode {
        mode
        basePrice
        properties {
          propertyDefinitionId
          propertyValue
          adjustment {
            value
            type
          }
        }
      }
      ... on ProductPriceManualPreciousMetalMode {
        mode
        material
        isInvestmentGold
        variants {
          variantId
          price
          materialMetric {
            alloy
            weight
          }
        }
      }
    }
  }
}
    fragment ItemQuestionFragment on ItemQuestion {
  _id
  order
  questionType
  valueMode
  titleKey
  infoKey
  isInternal
  predictionTag
  singleChoiceOptions {
    labelKey
    infoKey
    categoryValues
    conditionValue
    isDefaultValue
  }
  rangeData {
    minValue
    maxValue
    defaultValue
    unitPrice
    unitKey
  }
  itemCategoryIds
}
fragment AvailablePropertiesFragment on ProductAvailableProperty {
  ... on ProductAvailableTextProperty {
    propertyDefinitionId
    propertyDefinitionType
    propertyDefinition {
      _id
      type
      impactsLook
      showOnWebsite
      description {
        allTranslations {
          text
          languageCode
        }
      }
      name {
        allTranslations {
          text
          languageCode
        }
      }
      key
      valueFormatting {
        suffix
        orderBy
      }
    }
    values {
      id
      translation {
        allTranslations {
          text
          languageCode
        }
      }
    }
  }
  ... on ProductAvailableNumberProperty {
    propertyDefinitionId
    propertyDefinitionType
    propertyDefinition {
      _id
      type
      impactsLook
      showOnWebsite
      description {
        allTranslations {
          text
          languageCode
        }
      }
      name {
        allTranslations {
          text
          languageCode
        }
      }
      key
      valueFormatting {
        suffix
        orderBy
      }
    }
    values {
      numberValue
    }
  }
  ... on ProductAvailableBooleanProperty {
    propertyDefinitionId
    propertyDefinitionType
    propertyDefinition {
      _id
      type
      impactsLook
      showOnWebsite
      description {
        allTranslations {
          text
          languageCode
        }
      }
      name {
        allTranslations {
          text
          languageCode
        }
      }
      key
    }
  }
}
fragment VariantsFragment on ProductVariant {
  id
  isPriceValid
  image {
    id
    url
  }
  name
  product {
    name
    category {
      name
      parentCategories {
        name
      }
    }
  }
  propertiesValues {
    ... on ProductVariantPropertyTextValue {
      propertyDefinitionId
      propertyDefinition {
        _id
        type
        impactsLook
        showOnWebsite
        name {
          allTranslations {
            text
            languageCode
          }
        }
        key
        valueFormatting {
          suffix
        }
      }
      value {
        translation {
          allTranslations {
            text
            languageCode
          }
        }
      }
    }
    ... on ProductVariantPropertyNumberValue {
      propertyDefinitionId
      propertyDefinition {
        _id
        type
        impactsLook
        showOnWebsite
        name {
          allTranslations {
            text
            languageCode
          }
        }
        key
        valueFormatting {
          suffix
        }
      }
      value {
        numberValue
      }
    }
    ... on ProductVariantPropertyBooleanValue {
      propertyDefinitionId
      propertyDefinition {
        _id
        type
        impactsLook
        showOnWebsite
        name {
          allTranslations {
            text
            languageCode
          }
        }
        key
        valueFormatting {
          suffix
        }
      }
      value {
        booleanValue
      }
    }
  }
}`) as unknown as TypedDocumentString<GetProductBySlugQuery, GetProductBySlugQueryVariables>;
export const SearchProductsDocument = new TypedDocumentString(`
    query searchProducts($args: ProductsFiltersArgs!) {
  searchProducts(args: $args) {
    nodes {
      ...ProductFragmentV2
    }
    pageInfo {
      skip
      limit
      hasPrevPage
      hasNextPage
      total
    }
  }
}
    fragment ProductFragmentV2 on Product {
  _id
  name
  slug
  isPublished
}`) as unknown as TypedDocumentString<SearchProductsQuery, SearchProductsQueryVariables>;
export const GetCurrentCustomerWithAdressesDocument = new TypedDocumentString(`
    query getCurrentCustomerWithAdresses {
  getCurrentCustomer {
    _id
    firstname
    lastname
    email
    phone
    dateOfBirth
    phone
    iban
    paypalAddress
    identityType
    identityUploadLinks {
      ...FileMetadataFragment
    }
    identityVerifiedAt
    addresses {
      street
      countryCode
      zipCode
      coordinates {
        lat
        lng
      }
      houseNumber
      floor
      door
      city
      state
      country
      stairway
      queryString
      note
      isDeliveryAddress
      isBillingAddress
    }
  }
}
    fragment FileMetadataFragment on FileMetadata {
  url
  contentType
  filename
  createdAt
}`) as unknown as TypedDocumentString<GetCurrentCustomerWithAdressesQuery, GetCurrentCustomerWithAdressesQueryVariables>;
export const GetDealByIdDocument = new TypedDocumentString(`
    query getDealById($dealId: ObjectId!) {
  getDealById(dealId: $dealId) {
    ...DealFragment
  }
}
    fragment UploadFileFormatFragment on UploadFileFormat {
  hash
  ext
  mime
  width
  height
  size
  path
  url
}
fragment UploadFileFragment on UploadFile {
  _id
  name
  alternativeText
  caption
  hash
  ext
  mime
  width
  height
  size
  url
  provider
  createdAt
  updatedAt
  formats {
    thumbnail {
      ...UploadFileFormatFragment
    }
    small {
      ...UploadFileFormatFragment
    }
    medium {
      ...UploadFileFormatFragment
    }
    large {
      ...UploadFileFormatFragment
    }
    product_thumbnail {
      ...UploadFileFormatFragment
    }
    product_small {
      ...UploadFileFormatFragment
    }
  }
}
fragment DealValuesEntryFragment on DealValuesEntry {
  payoutAmount
  paybackAmount
  calculationPayoutAmount
  calculationPaybackAmount
  durationInDays
  shouldOverwritePayoutAmount
  overwrittenPayoutAmount
}
fragment ItemValuesEntryFragment on ItemValuesEntry {
  conditionMaxMarketValues {
    excellent
    good
    poor
  }
  maxMarketValue
  currentMarketValue
  predictedMarketValue
  adjustedMarketValue
  durationInDays
  loanToValue
  date
  payoutAmount
}
fragment CalculatedFeeDefinitionFragment on CalculatedFeeDefinition {
  appliedGrossAmount
  appliedNetAmount
  finalGrossAmount
  finalNetAmount
  ust
  isManual
  storedFeeDefinition {
    amount
    mode
    feeType
    companyId
    priority
    billingPeriodType
    level
    dealTypes
    isActive
    onlyWhenInAuction
  }
}
fragment AppliedUsedFeeDefinitionsFragment on UsedFeeDefinition {
  itemCategoryId
  feeWeight
  calculatedFeeDefinitions {
    ...CalculatedFeeDefinitionFragment
  }
}
fragment DealCalculationFragment on DealCalculation {
  date
  loanToValuesEntryId
  dealValuesEntry {
    ...DealValuesEntryFragment
  }
  itemsValuesEntries {
    ...ItemValuesEntryFragment
  }
  appliedUsedFeeDefinitions {
    ...AppliedUsedFeeDefinitionsFragment
  }
}
fragment AddressFragment on OAddress {
  coordinates {
    lat
    lng
  }
  houseNumber
  stairway
  door
  floor
  street
  city
  state
  countryCode
  country
  zipCode
  queryString
  address1
  address2
  note
  name
  companyName
}
fragment PaymentDataFragment on PaymentData {
  paymentType {
    ... on ManualPaymentWrapper {
      manual: value
    }
    ... on AutomaticPaymentWrapper {
      automatic: value
    }
  }
}
fragment VariantsFragment on ProductVariant {
  id
  isPriceValid
  image {
    id
    url
  }
  name
  product {
    name
    category {
      name
      parentCategories {
        name
      }
    }
  }
  propertiesValues {
    ... on ProductVariantPropertyTextValue {
      propertyDefinitionId
      propertyDefinition {
        _id
        type
        impactsLook
        showOnWebsite
        name {
          allTranslations {
            text
            languageCode
          }
        }
        key
        valueFormatting {
          suffix
        }
      }
      value {
        translation {
          allTranslations {
            text
            languageCode
          }
        }
      }
    }
    ... on ProductVariantPropertyNumberValue {
      propertyDefinitionId
      propertyDefinition {
        _id
        type
        impactsLook
        showOnWebsite
        name {
          allTranslations {
            text
            languageCode
          }
        }
        key
        valueFormatting {
          suffix
        }
      }
      value {
        numberValue
      }
    }
    ... on ProductVariantPropertyBooleanValue {
      propertyDefinitionId
      propertyDefinition {
        _id
        type
        impactsLook
        showOnWebsite
        name {
          allTranslations {
            text
            languageCode
          }
        }
        key
        valueFormatting {
          suffix
        }
      }
      value {
        booleanValue
      }
    }
  }
}
fragment TransportDataFragment on TransportData {
  transportMode
  standardShippingData {
    sentShippingLabels {
      labelFile {
        filename
      }
      shippingPartner
    }
    address {
      ...AddressFragment
    }
  }
  premiumShippingData {
    address {
      ...AddressFragment
    }
    toHourUTC
    fromHourUTC
    date
  }
}
fragment AnyPaymentTypeFragment on AnyPaymentType {
  ... on ManualPaymentWrapper {
    manual: value
  }
  ... on AutomaticPaymentWrapper {
    automatic: value
  }
}
fragment BaseEventFragment on BaseDealEvent {
  __typename
  createdAt
  createdAt
  timestamp
  displayName
}
fragment BookedEventFragment on DealBookedEvent {
  dealCalculation {
    ...DealCalculationFragment
  }
}
fragment VerifiedEventFragment on DealVerifiedEvent {
  isOverwrittenFees
  dealCalculation {
    ...DealCalculationFragment
  }
}
fragment ReviewingEventFragment on DealReviewingEvent {
  issuanceCertificate {
    url
    contentType
  }
}
fragment PaybackConfirmedEventFragment on DealPaybackConfirmedEvent {
  paymentType {
    ...AnyPaymentTypeFragment
  }
  dealCalculation {
    ...DealCalculationFragment
  }
}
fragment ExtensionConfirmedEventFragment on DealExtensionConfirmedEvent {
  paymentType {
    ...AnyPaymentTypeFragment
  }
  dealCalculation {
    ...DealCalculationFragment
  }
  childCalculation {
    ...DealCalculationFragment
  }
  dueAmount
  partialRedemptionAmount
  overwrittenPartialRedemptionAmount
  itemsExtensionAnswers {
    storageLabel
    answers {
      questionId
      selectedOptionIndex
      rangeValue
    }
  }
}
fragment OnSellEventFragment on DealOnSellEvent {
  valueAddedTaxRate
  differenceTaxRate
  valorizationFeeRate
}
fragment ClosedEventFragment on DealClosedEvent {
  dealCalculation {
    ...DealCalculationFragment
  }
  valorizationFeeNet
  valorizationFeeGross
}
fragment DealEventFragment on DealEvent {
  ...BaseEventFragment
  ...BookedEventFragment
  ...VerifiedEventFragment
  ...ReviewingEventFragment
  ...PaybackConfirmedEventFragment
  ...ExtensionConfirmedEventFragment
  ...OnSellEventFragment
  ...ClosedEventFragment
}
fragment PawnDataFragment on PawnData {
  pawnNumber
  pawnTicketLink {
    url
    contentType
  }
  billNumber
  billLink {
    url
    contentType
  }
  paybackData {
    ...PaymentDataFragment
    iban
  }
  extensionChildId
  extensionParentId
  reservedPaybackData {
    isExtension
    date
    paymentType
    feeAmount
    partialRedemptionAmount
    dueAmount
  }
}
fragment DealPreviewFragment on Deal {
  _id
  createdAt
  updatedAt
  dealType
  bookingNumber
  dealFinalValues {
    dealType
    durationInDays
    shouldOverwritePayoutAmount
    payoutAmount
    isOnlineExtensionPrevented
  }
  pawnData {
    ...PawnDataFragment
  }
  purchaseData {
    receiptNumber
    receiptLink {
      url
      contentType
    }
  }
  events {
    ...DealEventFragment
  }
  payoutData {
    ...PaymentDataFragment
    iban
  }
  initialShopId
  company {
    configuration {
      minimumPawnDuration
      gracePeriod
    }
    name
    iban
    paypalEmail
    successionCompany {
      _id
      name
    }
  }
  shippingLabelPageId
  isPaybackPaymentOngoing
  isExtensionPaymentOngoing
  latestOngoingPaymentRequestedAt
  hasCompletedPayment
  isInOpenAuction
  acceptingWithdrawalFeeTermsRequired
  canDealOnSellBeExtendedOrPaidBack
}
fragment DealFragment on Deal {
  ...DealPreviewFragment
  pickupData {
    ...TransportDataFragment
  }
  dropoffData {
    ...TransportDataFragment
  }
  dealPartnerData {
    type
    knp {
      fileReferenceNumber
      debtAmount
    }
  }
  businessUnit
  itemsIds
  items(omitItemQuestions: true, omitItemValorizationCalculation: true) {
    _id
    title
    isContinueUsing
    itemCategoryId
    itemCategory {
      _id
      name
      parentId
      createdAt
      updatedAt
      slug
      availableTransportModes
    }
    algoliaReference
    material
    ean
    media {
      url
      contentType
    }
    productLegacy {
      picture {
        ...UploadFileFragment
      }
      title
    }
    variantId
    productVariant {
      ...VariantsFragment
    }
  }
  company {
    configuration {
      minimumPawnDuration
      gracePeriod
    }
    name
    iban
    paypalEmail
    unzerConfiguration {
      publicKey
    }
    successionCompany {
      _id
      name
    }
  }
  isPaybackPaymentOngoing
  shippingLabelPageId
  isExtensionPaymentOngoing
}`) as unknown as TypedDocumentString<GetDealByIdQuery, GetDealByIdQueryVariables>;
export const GetDealAndCalculationByIdDocument = new TypedDocumentString(`
    query getDealAndCalculationById($dealId: ObjectId!, $extensionCalculationArgs: DealExtensionCalculationArgs!, $paybackCalculationArgs: DealPaybackCalculationArgs!) {
  getDealById(dealId: $dealId) {
    ...DealFragment
    persistedExtensionCalculation(args: $extensionCalculationArgs) {
      ...PersistedDealExtensionCalculationFragment
    }
    persistedPaybackCalculation(args: $paybackCalculationArgs) {
      ...PersistedDealPaybackCalculationFragment
    }
  }
}
    fragment UploadFileFormatFragment on UploadFileFormat {
  hash
  ext
  mime
  width
  height
  size
  path
  url
}
fragment UploadFileFragment on UploadFile {
  _id
  name
  alternativeText
  caption
  hash
  ext
  mime
  width
  height
  size
  url
  provider
  createdAt
  updatedAt
  formats {
    thumbnail {
      ...UploadFileFormatFragment
    }
    small {
      ...UploadFileFormatFragment
    }
    medium {
      ...UploadFileFormatFragment
    }
    large {
      ...UploadFileFormatFragment
    }
    product_thumbnail {
      ...UploadFileFormatFragment
    }
    product_small {
      ...UploadFileFormatFragment
    }
  }
}
fragment DealValuesEntryFragment on DealValuesEntry {
  payoutAmount
  paybackAmount
  calculationPayoutAmount
  calculationPaybackAmount
  durationInDays
  shouldOverwritePayoutAmount
  overwrittenPayoutAmount
}
fragment ItemValuesEntryFragment on ItemValuesEntry {
  conditionMaxMarketValues {
    excellent
    good
    poor
  }
  maxMarketValue
  currentMarketValue
  predictedMarketValue
  adjustedMarketValue
  durationInDays
  loanToValue
  date
  payoutAmount
}
fragment CalculatedFeeDefinitionFragment on CalculatedFeeDefinition {
  appliedGrossAmount
  appliedNetAmount
  finalGrossAmount
  finalNetAmount
  ust
  isManual
  storedFeeDefinition {
    amount
    mode
    feeType
    companyId
    priority
    billingPeriodType
    level
    dealTypes
    isActive
    onlyWhenInAuction
  }
}
fragment AppliedUsedFeeDefinitionsFragment on UsedFeeDefinition {
  itemCategoryId
  feeWeight
  calculatedFeeDefinitions {
    ...CalculatedFeeDefinitionFragment
  }
}
fragment DealCalculationFragment on DealCalculation {
  date
  loanToValuesEntryId
  dealValuesEntry {
    ...DealValuesEntryFragment
  }
  itemsValuesEntries {
    ...ItemValuesEntryFragment
  }
  appliedUsedFeeDefinitions {
    ...AppliedUsedFeeDefinitionsFragment
  }
}
fragment PersistedDealExtensionCalculationFragment on PersistedDealExtensionCalculation {
  dealId
  dueAmount
  partialRedemptionAmount
  overwrittenPartialRedemptionAmount
  dealExtensionCalculationId
  itemsExtensionAnswers {
    storageLabel
    answers {
      questionId
      selectedOptionIndex
      rangeValue
    }
  }
  childDealCalculation {
    ...DealCalculationFragment
  }
  parentDealCalculation {
    ...DealCalculationFragment
  }
}
fragment PersistedDealPaybackCalculationFragment on PersistedDealPaybackCalculation {
  dealId
  dealPaybackCalculationId
  dealCalculation {
    ...DealCalculationFragment
  }
}
fragment AddressFragment on OAddress {
  coordinates {
    lat
    lng
  }
  houseNumber
  stairway
  door
  floor
  street
  city
  state
  countryCode
  country
  zipCode
  queryString
  address1
  address2
  note
  name
  companyName
}
fragment PaymentDataFragment on PaymentData {
  paymentType {
    ... on ManualPaymentWrapper {
      manual: value
    }
    ... on AutomaticPaymentWrapper {
      automatic: value
    }
  }
}
fragment VariantsFragment on ProductVariant {
  id
  isPriceValid
  image {
    id
    url
  }
  name
  product {
    name
    category {
      name
      parentCategories {
        name
      }
    }
  }
  propertiesValues {
    ... on ProductVariantPropertyTextValue {
      propertyDefinitionId
      propertyDefinition {
        _id
        type
        impactsLook
        showOnWebsite
        name {
          allTranslations {
            text
            languageCode
          }
        }
        key
        valueFormatting {
          suffix
        }
      }
      value {
        translation {
          allTranslations {
            text
            languageCode
          }
        }
      }
    }
    ... on ProductVariantPropertyNumberValue {
      propertyDefinitionId
      propertyDefinition {
        _id
        type
        impactsLook
        showOnWebsite
        name {
          allTranslations {
            text
            languageCode
          }
        }
        key
        valueFormatting {
          suffix
        }
      }
      value {
        numberValue
      }
    }
    ... on ProductVariantPropertyBooleanValue {
      propertyDefinitionId
      propertyDefinition {
        _id
        type
        impactsLook
        showOnWebsite
        name {
          allTranslations {
            text
            languageCode
          }
        }
        key
        valueFormatting {
          suffix
        }
      }
      value {
        booleanValue
      }
    }
  }
}
fragment TransportDataFragment on TransportData {
  transportMode
  standardShippingData {
    sentShippingLabels {
      labelFile {
        filename
      }
      shippingPartner
    }
    address {
      ...AddressFragment
    }
  }
  premiumShippingData {
    address {
      ...AddressFragment
    }
    toHourUTC
    fromHourUTC
    date
  }
}
fragment AnyPaymentTypeFragment on AnyPaymentType {
  ... on ManualPaymentWrapper {
    manual: value
  }
  ... on AutomaticPaymentWrapper {
    automatic: value
  }
}
fragment BaseEventFragment on BaseDealEvent {
  __typename
  createdAt
  createdAt
  timestamp
  displayName
}
fragment BookedEventFragment on DealBookedEvent {
  dealCalculation {
    ...DealCalculationFragment
  }
}
fragment VerifiedEventFragment on DealVerifiedEvent {
  isOverwrittenFees
  dealCalculation {
    ...DealCalculationFragment
  }
}
fragment ReviewingEventFragment on DealReviewingEvent {
  issuanceCertificate {
    url
    contentType
  }
}
fragment PaybackConfirmedEventFragment on DealPaybackConfirmedEvent {
  paymentType {
    ...AnyPaymentTypeFragment
  }
  dealCalculation {
    ...DealCalculationFragment
  }
}
fragment ExtensionConfirmedEventFragment on DealExtensionConfirmedEvent {
  paymentType {
    ...AnyPaymentTypeFragment
  }
  dealCalculation {
    ...DealCalculationFragment
  }
  childCalculation {
    ...DealCalculationFragment
  }
  dueAmount
  partialRedemptionAmount
  overwrittenPartialRedemptionAmount
  itemsExtensionAnswers {
    storageLabel
    answers {
      questionId
      selectedOptionIndex
      rangeValue
    }
  }
}
fragment OnSellEventFragment on DealOnSellEvent {
  valueAddedTaxRate
  differenceTaxRate
  valorizationFeeRate
}
fragment ClosedEventFragment on DealClosedEvent {
  dealCalculation {
    ...DealCalculationFragment
  }
  valorizationFeeNet
  valorizationFeeGross
}
fragment DealEventFragment on DealEvent {
  ...BaseEventFragment
  ...BookedEventFragment
  ...VerifiedEventFragment
  ...ReviewingEventFragment
  ...PaybackConfirmedEventFragment
  ...ExtensionConfirmedEventFragment
  ...OnSellEventFragment
  ...ClosedEventFragment
}
fragment PawnDataFragment on PawnData {
  pawnNumber
  pawnTicketLink {
    url
    contentType
  }
  billNumber
  billLink {
    url
    contentType
  }
  paybackData {
    ...PaymentDataFragment
    iban
  }
  extensionChildId
  extensionParentId
  reservedPaybackData {
    isExtension
    date
    paymentType
    feeAmount
    partialRedemptionAmount
    dueAmount
  }
}
fragment DealPreviewFragment on Deal {
  _id
  createdAt
  updatedAt
  dealType
  bookingNumber
  dealFinalValues {
    dealType
    durationInDays
    shouldOverwritePayoutAmount
    payoutAmount
    isOnlineExtensionPrevented
  }
  pawnData {
    ...PawnDataFragment
  }
  purchaseData {
    receiptNumber
    receiptLink {
      url
      contentType
    }
  }
  events {
    ...DealEventFragment
  }
  payoutData {
    ...PaymentDataFragment
    iban
  }
  initialShopId
  company {
    configuration {
      minimumPawnDuration
      gracePeriod
    }
    name
    iban
    paypalEmail
    successionCompany {
      _id
      name
    }
  }
  shippingLabelPageId
  isPaybackPaymentOngoing
  isExtensionPaymentOngoing
  latestOngoingPaymentRequestedAt
  hasCompletedPayment
  isInOpenAuction
  acceptingWithdrawalFeeTermsRequired
  canDealOnSellBeExtendedOrPaidBack
}
fragment DealFragment on Deal {
  ...DealPreviewFragment
  pickupData {
    ...TransportDataFragment
  }
  dropoffData {
    ...TransportDataFragment
  }
  dealPartnerData {
    type
    knp {
      fileReferenceNumber
      debtAmount
    }
  }
  businessUnit
  itemsIds
  items(omitItemQuestions: true, omitItemValorizationCalculation: true) {
    _id
    title
    isContinueUsing
    itemCategoryId
    itemCategory {
      _id
      name
      parentId
      createdAt
      updatedAt
      slug
      availableTransportModes
    }
    algoliaReference
    material
    ean
    media {
      url
      contentType
    }
    productLegacy {
      picture {
        ...UploadFileFragment
      }
      title
    }
    variantId
    productVariant {
      ...VariantsFragment
    }
  }
  company {
    configuration {
      minimumPawnDuration
      gracePeriod
    }
    name
    iban
    paypalEmail
    unzerConfiguration {
      publicKey
    }
    successionCompany {
      _id
      name
    }
  }
  isPaybackPaymentOngoing
  shippingLabelPageId
  isExtensionPaymentOngoing
}`) as unknown as TypedDocumentString<GetDealAndCalculationByIdQuery, GetDealAndCalculationByIdQueryVariables>;
export const GetDealByShippingLabelPageIdDocument = new TypedDocumentString(`
    query getDealByShippingLabelPageId($shippingLabelPageId: String!) {
  getDealByShippingLabelPageId(shippingLabelPageId: $shippingLabelPageId) {
    ...DealFragment
  }
}
    fragment UploadFileFormatFragment on UploadFileFormat {
  hash
  ext
  mime
  width
  height
  size
  path
  url
}
fragment UploadFileFragment on UploadFile {
  _id
  name
  alternativeText
  caption
  hash
  ext
  mime
  width
  height
  size
  url
  provider
  createdAt
  updatedAt
  formats {
    thumbnail {
      ...UploadFileFormatFragment
    }
    small {
      ...UploadFileFormatFragment
    }
    medium {
      ...UploadFileFormatFragment
    }
    large {
      ...UploadFileFormatFragment
    }
    product_thumbnail {
      ...UploadFileFormatFragment
    }
    product_small {
      ...UploadFileFormatFragment
    }
  }
}
fragment DealValuesEntryFragment on DealValuesEntry {
  payoutAmount
  paybackAmount
  calculationPayoutAmount
  calculationPaybackAmount
  durationInDays
  shouldOverwritePayoutAmount
  overwrittenPayoutAmount
}
fragment ItemValuesEntryFragment on ItemValuesEntry {
  conditionMaxMarketValues {
    excellent
    good
    poor
  }
  maxMarketValue
  currentMarketValue
  predictedMarketValue
  adjustedMarketValue
  durationInDays
  loanToValue
  date
  payoutAmount
}
fragment CalculatedFeeDefinitionFragment on CalculatedFeeDefinition {
  appliedGrossAmount
  appliedNetAmount
  finalGrossAmount
  finalNetAmount
  ust
  isManual
  storedFeeDefinition {
    amount
    mode
    feeType
    companyId
    priority
    billingPeriodType
    level
    dealTypes
    isActive
    onlyWhenInAuction
  }
}
fragment AppliedUsedFeeDefinitionsFragment on UsedFeeDefinition {
  itemCategoryId
  feeWeight
  calculatedFeeDefinitions {
    ...CalculatedFeeDefinitionFragment
  }
}
fragment DealCalculationFragment on DealCalculation {
  date
  loanToValuesEntryId
  dealValuesEntry {
    ...DealValuesEntryFragment
  }
  itemsValuesEntries {
    ...ItemValuesEntryFragment
  }
  appliedUsedFeeDefinitions {
    ...AppliedUsedFeeDefinitionsFragment
  }
}
fragment AddressFragment on OAddress {
  coordinates {
    lat
    lng
  }
  houseNumber
  stairway
  door
  floor
  street
  city
  state
  countryCode
  country
  zipCode
  queryString
  address1
  address2
  note
  name
  companyName
}
fragment PaymentDataFragment on PaymentData {
  paymentType {
    ... on ManualPaymentWrapper {
      manual: value
    }
    ... on AutomaticPaymentWrapper {
      automatic: value
    }
  }
}
fragment VariantsFragment on ProductVariant {
  id
  isPriceValid
  image {
    id
    url
  }
  name
  product {
    name
    category {
      name
      parentCategories {
        name
      }
    }
  }
  propertiesValues {
    ... on ProductVariantPropertyTextValue {
      propertyDefinitionId
      propertyDefinition {
        _id
        type
        impactsLook
        showOnWebsite
        name {
          allTranslations {
            text
            languageCode
          }
        }
        key
        valueFormatting {
          suffix
        }
      }
      value {
        translation {
          allTranslations {
            text
            languageCode
          }
        }
      }
    }
    ... on ProductVariantPropertyNumberValue {
      propertyDefinitionId
      propertyDefinition {
        _id
        type
        impactsLook
        showOnWebsite
        name {
          allTranslations {
            text
            languageCode
          }
        }
        key
        valueFormatting {
          suffix
        }
      }
      value {
        numberValue
      }
    }
    ... on ProductVariantPropertyBooleanValue {
      propertyDefinitionId
      propertyDefinition {
        _id
        type
        impactsLook
        showOnWebsite
        name {
          allTranslations {
            text
            languageCode
          }
        }
        key
        valueFormatting {
          suffix
        }
      }
      value {
        booleanValue
      }
    }
  }
}
fragment TransportDataFragment on TransportData {
  transportMode
  standardShippingData {
    sentShippingLabels {
      labelFile {
        filename
      }
      shippingPartner
    }
    address {
      ...AddressFragment
    }
  }
  premiumShippingData {
    address {
      ...AddressFragment
    }
    toHourUTC
    fromHourUTC
    date
  }
}
fragment AnyPaymentTypeFragment on AnyPaymentType {
  ... on ManualPaymentWrapper {
    manual: value
  }
  ... on AutomaticPaymentWrapper {
    automatic: value
  }
}
fragment BaseEventFragment on BaseDealEvent {
  __typename
  createdAt
  createdAt
  timestamp
  displayName
}
fragment BookedEventFragment on DealBookedEvent {
  dealCalculation {
    ...DealCalculationFragment
  }
}
fragment VerifiedEventFragment on DealVerifiedEvent {
  isOverwrittenFees
  dealCalculation {
    ...DealCalculationFragment
  }
}
fragment ReviewingEventFragment on DealReviewingEvent {
  issuanceCertificate {
    url
    contentType
  }
}
fragment PaybackConfirmedEventFragment on DealPaybackConfirmedEvent {
  paymentType {
    ...AnyPaymentTypeFragment
  }
  dealCalculation {
    ...DealCalculationFragment
  }
}
fragment ExtensionConfirmedEventFragment on DealExtensionConfirmedEvent {
  paymentType {
    ...AnyPaymentTypeFragment
  }
  dealCalculation {
    ...DealCalculationFragment
  }
  childCalculation {
    ...DealCalculationFragment
  }
  dueAmount
  partialRedemptionAmount
  overwrittenPartialRedemptionAmount
  itemsExtensionAnswers {
    storageLabel
    answers {
      questionId
      selectedOptionIndex
      rangeValue
    }
  }
}
fragment OnSellEventFragment on DealOnSellEvent {
  valueAddedTaxRate
  differenceTaxRate
  valorizationFeeRate
}
fragment ClosedEventFragment on DealClosedEvent {
  dealCalculation {
    ...DealCalculationFragment
  }
  valorizationFeeNet
  valorizationFeeGross
}
fragment DealEventFragment on DealEvent {
  ...BaseEventFragment
  ...BookedEventFragment
  ...VerifiedEventFragment
  ...ReviewingEventFragment
  ...PaybackConfirmedEventFragment
  ...ExtensionConfirmedEventFragment
  ...OnSellEventFragment
  ...ClosedEventFragment
}
fragment PawnDataFragment on PawnData {
  pawnNumber
  pawnTicketLink {
    url
    contentType
  }
  billNumber
  billLink {
    url
    contentType
  }
  paybackData {
    ...PaymentDataFragment
    iban
  }
  extensionChildId
  extensionParentId
  reservedPaybackData {
    isExtension
    date
    paymentType
    feeAmount
    partialRedemptionAmount
    dueAmount
  }
}
fragment DealPreviewFragment on Deal {
  _id
  createdAt
  updatedAt
  dealType
  bookingNumber
  dealFinalValues {
    dealType
    durationInDays
    shouldOverwritePayoutAmount
    payoutAmount
    isOnlineExtensionPrevented
  }
  pawnData {
    ...PawnDataFragment
  }
  purchaseData {
    receiptNumber
    receiptLink {
      url
      contentType
    }
  }
  events {
    ...DealEventFragment
  }
  payoutData {
    ...PaymentDataFragment
    iban
  }
  initialShopId
  company {
    configuration {
      minimumPawnDuration
      gracePeriod
    }
    name
    iban
    paypalEmail
    successionCompany {
      _id
      name
    }
  }
  shippingLabelPageId
  isPaybackPaymentOngoing
  isExtensionPaymentOngoing
  latestOngoingPaymentRequestedAt
  hasCompletedPayment
  isInOpenAuction
  acceptingWithdrawalFeeTermsRequired
  canDealOnSellBeExtendedOrPaidBack
}
fragment DealFragment on Deal {
  ...DealPreviewFragment
  pickupData {
    ...TransportDataFragment
  }
  dropoffData {
    ...TransportDataFragment
  }
  dealPartnerData {
    type
    knp {
      fileReferenceNumber
      debtAmount
    }
  }
  businessUnit
  itemsIds
  items(omitItemQuestions: true, omitItemValorizationCalculation: true) {
    _id
    title
    isContinueUsing
    itemCategoryId
    itemCategory {
      _id
      name
      parentId
      createdAt
      updatedAt
      slug
      availableTransportModes
    }
    algoliaReference
    material
    ean
    media {
      url
      contentType
    }
    productLegacy {
      picture {
        ...UploadFileFragment
      }
      title
    }
    variantId
    productVariant {
      ...VariantsFragment
    }
  }
  company {
    configuration {
      minimumPawnDuration
      gracePeriod
    }
    name
    iban
    paypalEmail
    unzerConfiguration {
      publicKey
    }
    successionCompany {
      _id
      name
    }
  }
  isPaybackPaymentOngoing
  shippingLabelPageId
  isExtensionPaymentOngoing
}`) as unknown as TypedDocumentString<GetDealByShippingLabelPageIdQuery, GetDealByShippingLabelPageIdQueryVariables>;
export const GetDealsForCustomerDocument = new TypedDocumentString(`
    query getDealsForCustomer($skip: Float, $take: Float) {
  getCurrentCustomer {
    _id
    activeDeals(skip: $skip, take: $take) {
      events {
        ...DealEventFragment
      }
    }
  }
}
    fragment DealValuesEntryFragment on DealValuesEntry {
  payoutAmount
  paybackAmount
  calculationPayoutAmount
  calculationPaybackAmount
  durationInDays
  shouldOverwritePayoutAmount
  overwrittenPayoutAmount
}
fragment ItemValuesEntryFragment on ItemValuesEntry {
  conditionMaxMarketValues {
    excellent
    good
    poor
  }
  maxMarketValue
  currentMarketValue
  predictedMarketValue
  adjustedMarketValue
  durationInDays
  loanToValue
  date
  payoutAmount
}
fragment CalculatedFeeDefinitionFragment on CalculatedFeeDefinition {
  appliedGrossAmount
  appliedNetAmount
  finalGrossAmount
  finalNetAmount
  ust
  isManual
  storedFeeDefinition {
    amount
    mode
    feeType
    companyId
    priority
    billingPeriodType
    level
    dealTypes
    isActive
    onlyWhenInAuction
  }
}
fragment AppliedUsedFeeDefinitionsFragment on UsedFeeDefinition {
  itemCategoryId
  feeWeight
  calculatedFeeDefinitions {
    ...CalculatedFeeDefinitionFragment
  }
}
fragment DealCalculationFragment on DealCalculation {
  date
  loanToValuesEntryId
  dealValuesEntry {
    ...DealValuesEntryFragment
  }
  itemsValuesEntries {
    ...ItemValuesEntryFragment
  }
  appliedUsedFeeDefinitions {
    ...AppliedUsedFeeDefinitionsFragment
  }
}
fragment AnyPaymentTypeFragment on AnyPaymentType {
  ... on ManualPaymentWrapper {
    manual: value
  }
  ... on AutomaticPaymentWrapper {
    automatic: value
  }
}
fragment BaseEventFragment on BaseDealEvent {
  __typename
  createdAt
  createdAt
  timestamp
  displayName
}
fragment BookedEventFragment on DealBookedEvent {
  dealCalculation {
    ...DealCalculationFragment
  }
}
fragment VerifiedEventFragment on DealVerifiedEvent {
  isOverwrittenFees
  dealCalculation {
    ...DealCalculationFragment
  }
}
fragment ReviewingEventFragment on DealReviewingEvent {
  issuanceCertificate {
    url
    contentType
  }
}
fragment PaybackConfirmedEventFragment on DealPaybackConfirmedEvent {
  paymentType {
    ...AnyPaymentTypeFragment
  }
  dealCalculation {
    ...DealCalculationFragment
  }
}
fragment ExtensionConfirmedEventFragment on DealExtensionConfirmedEvent {
  paymentType {
    ...AnyPaymentTypeFragment
  }
  dealCalculation {
    ...DealCalculationFragment
  }
  childCalculation {
    ...DealCalculationFragment
  }
  dueAmount
  partialRedemptionAmount
  overwrittenPartialRedemptionAmount
  itemsExtensionAnswers {
    storageLabel
    answers {
      questionId
      selectedOptionIndex
      rangeValue
    }
  }
}
fragment OnSellEventFragment on DealOnSellEvent {
  valueAddedTaxRate
  differenceTaxRate
  valorizationFeeRate
}
fragment ClosedEventFragment on DealClosedEvent {
  dealCalculation {
    ...DealCalculationFragment
  }
  valorizationFeeNet
  valorizationFeeGross
}
fragment DealEventFragment on DealEvent {
  ...BaseEventFragment
  ...BookedEventFragment
  ...VerifiedEventFragment
  ...ReviewingEventFragment
  ...PaybackConfirmedEventFragment
  ...ExtensionConfirmedEventFragment
  ...OnSellEventFragment
  ...ClosedEventFragment
}`) as unknown as TypedDocumentString<GetDealsForCustomerQuery, GetDealsForCustomerQueryVariables>;
export const GetDealsForCustomerAndCalculationDocument = new TypedDocumentString(`
    query getDealsForCustomerAndCalculation($isActive: Boolean, $skip: Float, $take: Float, $extensionCalculationArgs: DealExtensionCalculationArgs!, $paybackCalculationArgs: DealPaybackCalculationArgs!) {
  getCurrentCustomer {
    _id
    deals(isActive: $isActive, skip: $skip, take: $take) {
      ...DealProfileFragment
      persistedExtensionCalculation(args: $extensionCalculationArgs) {
        ...PersistedDealExtensionCalculationFragment
      }
      persistedPaybackCalculation(args: $paybackCalculationArgs) {
        ...PersistedDealPaybackCalculationFragment
      }
      isPaybackPaymentOngoing
      isExtensionPaymentOngoing
      items(omitItemQuestions: true, omitItemValorizationCalculation: true) {
        _id
        title
        itemCategoryId
        isContinueUsing
        itemCategory {
          _id
          name
          parentId
          createdAt
          updatedAt
          slug
          availableTransportModes
        }
        productLegacy {
          picture {
            ...UploadFileFragment
          }
          title
        }
        productVariant {
          product {
            name
          }
          image {
            id
            url
          }
          ...VariantsFragment
        }
      }
    }
    customDeals {
      ...CustomDealFragment
    }
  }
}
    fragment UploadFileFormatFragment on UploadFileFormat {
  hash
  ext
  mime
  width
  height
  size
  path
  url
}
fragment UploadFileFragment on UploadFile {
  _id
  name
  alternativeText
  caption
  hash
  ext
  mime
  width
  height
  size
  url
  provider
  createdAt
  updatedAt
  formats {
    thumbnail {
      ...UploadFileFormatFragment
    }
    small {
      ...UploadFileFormatFragment
    }
    medium {
      ...UploadFileFormatFragment
    }
    large {
      ...UploadFileFormatFragment
    }
    product_thumbnail {
      ...UploadFileFormatFragment
    }
    product_small {
      ...UploadFileFormatFragment
    }
  }
}
fragment DealValuesEntryFragment on DealValuesEntry {
  payoutAmount
  paybackAmount
  calculationPayoutAmount
  calculationPaybackAmount
  durationInDays
  shouldOverwritePayoutAmount
  overwrittenPayoutAmount
}
fragment ItemValuesEntryFragment on ItemValuesEntry {
  conditionMaxMarketValues {
    excellent
    good
    poor
  }
  maxMarketValue
  currentMarketValue
  predictedMarketValue
  adjustedMarketValue
  durationInDays
  loanToValue
  date
  payoutAmount
}
fragment CalculatedFeeDefinitionFragment on CalculatedFeeDefinition {
  appliedGrossAmount
  appliedNetAmount
  finalGrossAmount
  finalNetAmount
  ust
  isManual
  storedFeeDefinition {
    amount
    mode
    feeType
    companyId
    priority
    billingPeriodType
    level
    dealTypes
    isActive
    onlyWhenInAuction
  }
}
fragment AppliedUsedFeeDefinitionsFragment on UsedFeeDefinition {
  itemCategoryId
  feeWeight
  calculatedFeeDefinitions {
    ...CalculatedFeeDefinitionFragment
  }
}
fragment DealCalculationFragment on DealCalculation {
  date
  loanToValuesEntryId
  dealValuesEntry {
    ...DealValuesEntryFragment
  }
  itemsValuesEntries {
    ...ItemValuesEntryFragment
  }
  appliedUsedFeeDefinitions {
    ...AppliedUsedFeeDefinitionsFragment
  }
}
fragment PersistedDealExtensionCalculationFragment on PersistedDealExtensionCalculation {
  dealId
  dueAmount
  partialRedemptionAmount
  overwrittenPartialRedemptionAmount
  dealExtensionCalculationId
  itemsExtensionAnswers {
    storageLabel
    answers {
      questionId
      selectedOptionIndex
      rangeValue
    }
  }
  childDealCalculation {
    ...DealCalculationFragment
  }
  parentDealCalculation {
    ...DealCalculationFragment
  }
}
fragment PersistedDealPaybackCalculationFragment on PersistedDealPaybackCalculation {
  dealId
  dealPaybackCalculationId
  dealCalculation {
    ...DealCalculationFragment
  }
}
fragment CustomDealFragment on CustomDeal {
  _id
  customDealNumber
  status
  createdAt
  updatedAt
  durationInDays
  isPayoutOverwritten
  isReversedFeeCalculation
  contactData {
    email
    phone
  }
  dealType
  company {
    _id
    configuration {
      minimumPawnDuration
      gracePeriod
    }
  }
  items {
    itemCategoryId
    title
    note
    algoliaReference
    policeNumber
    pawnPayoutAmount
    purchasePayoutAmount
    overwrittenPawnPayoutAmount
    overwrittenPurchasePayoutAmount
    ean
    material
    counterofferPayoutAmount
    foundComparableOffers
    overwrittenItemValue
    foundOffersEvaluationFactor
    variantId
    productVariant {
      ...VariantsFragment
    }
    priceFindings {
      price
    }
    media {
      url
      contentType
    }
    note
    answers {
      questionId
      selectedOptionIndex
      rangeValue
    }
    itemPawnValueEntry {
      adjustedMarketValue
      payoutAmount
    }
    itemPurchaseValueEntry {
      adjustedMarketValue
      payoutAmount
    }
  }
  overridePayoutAmount
  availableTransportModes
  events {
    event
    createdAt
    timestamp
  }
  pawnCalculation {
    payoutAmount
  }
  purchaseCalculation {
    payoutAmount
  }
}
fragment PaymentDataFragment on PaymentData {
  paymentType {
    ... on ManualPaymentWrapper {
      manual: value
    }
    ... on AutomaticPaymentWrapper {
      automatic: value
    }
  }
}
fragment VariantsFragment on ProductVariant {
  id
  isPriceValid
  image {
    id
    url
  }
  name
  product {
    name
    category {
      name
      parentCategories {
        name
      }
    }
  }
  propertiesValues {
    ... on ProductVariantPropertyTextValue {
      propertyDefinitionId
      propertyDefinition {
        _id
        type
        impactsLook
        showOnWebsite
        name {
          allTranslations {
            text
            languageCode
          }
        }
        key
        valueFormatting {
          suffix
        }
      }
      value {
        translation {
          allTranslations {
            text
            languageCode
          }
        }
      }
    }
    ... on ProductVariantPropertyNumberValue {
      propertyDefinitionId
      propertyDefinition {
        _id
        type
        impactsLook
        showOnWebsite
        name {
          allTranslations {
            text
            languageCode
          }
        }
        key
        valueFormatting {
          suffix
        }
      }
      value {
        numberValue
      }
    }
    ... on ProductVariantPropertyBooleanValue {
      propertyDefinitionId
      propertyDefinition {
        _id
        type
        impactsLook
        showOnWebsite
        name {
          allTranslations {
            text
            languageCode
          }
        }
        key
        valueFormatting {
          suffix
        }
      }
      value {
        booleanValue
      }
    }
  }
}
fragment AnyPaymentTypeFragment on AnyPaymentType {
  ... on ManualPaymentWrapper {
    manual: value
  }
  ... on AutomaticPaymentWrapper {
    automatic: value
  }
}
fragment BaseEventFragment on BaseDealEvent {
  __typename
  createdAt
  createdAt
  timestamp
  displayName
}
fragment BookedEventFragment on DealBookedEvent {
  dealCalculation {
    ...DealCalculationFragment
  }
}
fragment VerifiedEventFragment on DealVerifiedEvent {
  isOverwrittenFees
  dealCalculation {
    ...DealCalculationFragment
  }
}
fragment ReviewingEventFragment on DealReviewingEvent {
  issuanceCertificate {
    url
    contentType
  }
}
fragment PaybackConfirmedEventFragment on DealPaybackConfirmedEvent {
  paymentType {
    ...AnyPaymentTypeFragment
  }
  dealCalculation {
    ...DealCalculationFragment
  }
}
fragment ExtensionConfirmedEventFragment on DealExtensionConfirmedEvent {
  paymentType {
    ...AnyPaymentTypeFragment
  }
  dealCalculation {
    ...DealCalculationFragment
  }
  childCalculation {
    ...DealCalculationFragment
  }
  dueAmount
  partialRedemptionAmount
  overwrittenPartialRedemptionAmount
  itemsExtensionAnswers {
    storageLabel
    answers {
      questionId
      selectedOptionIndex
      rangeValue
    }
  }
}
fragment OnSellEventFragment on DealOnSellEvent {
  valueAddedTaxRate
  differenceTaxRate
  valorizationFeeRate
}
fragment ClosedEventFragment on DealClosedEvent {
  dealCalculation {
    ...DealCalculationFragment
  }
  valorizationFeeNet
  valorizationFeeGross
}
fragment DealEventFragment on DealEvent {
  ...BaseEventFragment
  ...BookedEventFragment
  ...VerifiedEventFragment
  ...ReviewingEventFragment
  ...PaybackConfirmedEventFragment
  ...ExtensionConfirmedEventFragment
  ...OnSellEventFragment
  ...ClosedEventFragment
}
fragment PawnDataFragment on PawnData {
  pawnNumber
  pawnTicketLink {
    url
    contentType
  }
  billNumber
  billLink {
    url
    contentType
  }
  paybackData {
    ...PaymentDataFragment
    iban
  }
  extensionChildId
  extensionParentId
  reservedPaybackData {
    isExtension
    date
    paymentType
    feeAmount
    partialRedemptionAmount
    dueAmount
  }
}
fragment DealProfileFragment on Deal {
  _id
  createdAt
  updatedAt
  dealType
  bookingNumber
  dealFinalValues {
    dealType
    durationInDays
    shouldOverwritePayoutAmount
    payoutAmount
    isOnlineExtensionPrevented
  }
  pawnData {
    ...PawnDataFragment
  }
  events {
    ...DealEventFragment
  }
  isPaybackPaymentOngoing
  shippingLabelPageId
  isExtensionPaymentOngoing
  latestOngoingPaymentRequestedAt
  hasCompletedPayment
  isInOpenAuction
  acceptingWithdrawalFeeTermsRequired
  canDealOnSellBeExtendedOrPaidBack
}`) as unknown as TypedDocumentString<GetDealsForCustomerAndCalculationQuery, GetDealsForCustomerAndCalculationQueryVariables>;
export const UpdateCustomerDocument = new TypedDocumentString(`
    mutation updateCustomer($firstname: String, $lastname: String, $phone: String, $iban: String, $paypalAddress: String, $addresses: [ICustomerAddress!], $identityType: ECustomerIdentityType, $identityUploadLinks: [FileTusMetadataArgs!]) {
  updateCustomer(
    firstname: $firstname
    lastname: $lastname
    phone: $phone
    iban: $iban
    paypalAddress: $paypalAddress
    addresses: $addresses
    identityType: $identityType
    identityUploadLinks: $identityUploadLinks
  ) {
    _id
    firstname
    lastname
    phone
    iban
    paypalAddress
    addresses {
      street
      countryCode
      zipCode
      coordinates {
        lat
        lng
      }
      houseNumber
      floor
      door
      city
      state
      country
      stairway
      queryString
      note
      isDeliveryAddress
      isBillingAddress
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateCustomerMutation, UpdateCustomerMutationVariables>;
export const ReserveExtensionDocument = new TypedDocumentString(`
    mutation reserveExtension($args: ReserveExtensionArgs!) {
  reserveExtension(args: $args) {
    _id
    pawnData {
      ...PawnDataFragment
    }
  }
}
    fragment PaymentDataFragment on PaymentData {
  paymentType {
    ... on ManualPaymentWrapper {
      manual: value
    }
    ... on AutomaticPaymentWrapper {
      automatic: value
    }
  }
}
fragment PawnDataFragment on PawnData {
  pawnNumber
  pawnTicketLink {
    url
    contentType
  }
  billNumber
  billLink {
    url
    contentType
  }
  paybackData {
    ...PaymentDataFragment
    iban
  }
  extensionChildId
  extensionParentId
  reservedPaybackData {
    isExtension
    date
    paymentType
    feeAmount
    partialRedemptionAmount
    dueAmount
  }
}`) as unknown as TypedDocumentString<ReserveExtensionMutation, ReserveExtensionMutationVariables>;
export const ReservePaybackDocument = new TypedDocumentString(`
    mutation reservePayback($args: ReservePaybackArgs!) {
  reservePayback(args: $args) {
    _id
    pawnData {
      ...PawnDataFragment
    }
  }
}
    fragment PaymentDataFragment on PaymentData {
  paymentType {
    ... on ManualPaymentWrapper {
      manual: value
    }
    ... on AutomaticPaymentWrapper {
      automatic: value
    }
  }
}
fragment PawnDataFragment on PawnData {
  pawnNumber
  pawnTicketLink {
    url
    contentType
  }
  billNumber
  billLink {
    url
    contentType
  }
  paybackData {
    ...PaymentDataFragment
    iban
  }
  extensionChildId
  extensionParentId
  reservedPaybackData {
    isExtension
    date
    paymentType
    feeAmount
    partialRedemptionAmount
    dueAmount
  }
}`) as unknown as TypedDocumentString<ReservePaybackMutation, ReservePaybackMutationVariables>;
export const GetExistingDealCalculationDocument = new TypedDocumentString(`
    query getExistingDealCalculation($dealId: ObjectId!, $args: GetExistingDealCalculationArgs!) {
  getExistingDealCalculation(dealId: $dealId, args: $args) {
    ...DealCalculationFragment
  }
}
    fragment DealValuesEntryFragment on DealValuesEntry {
  payoutAmount
  paybackAmount
  calculationPayoutAmount
  calculationPaybackAmount
  durationInDays
  shouldOverwritePayoutAmount
  overwrittenPayoutAmount
}
fragment ItemValuesEntryFragment on ItemValuesEntry {
  conditionMaxMarketValues {
    excellent
    good
    poor
  }
  maxMarketValue
  currentMarketValue
  predictedMarketValue
  adjustedMarketValue
  durationInDays
  loanToValue
  date
  payoutAmount
}
fragment CalculatedFeeDefinitionFragment on CalculatedFeeDefinition {
  appliedGrossAmount
  appliedNetAmount
  finalGrossAmount
  finalNetAmount
  ust
  isManual
  storedFeeDefinition {
    amount
    mode
    feeType
    companyId
    priority
    billingPeriodType
    level
    dealTypes
    isActive
    onlyWhenInAuction
  }
}
fragment AppliedUsedFeeDefinitionsFragment on UsedFeeDefinition {
  itemCategoryId
  feeWeight
  calculatedFeeDefinitions {
    ...CalculatedFeeDefinitionFragment
  }
}
fragment DealCalculationFragment on DealCalculation {
  date
  loanToValuesEntryId
  dealValuesEntry {
    ...DealValuesEntryFragment
  }
  itemsValuesEntries {
    ...ItemValuesEntryFragment
  }
  appliedUsedFeeDefinitions {
    ...AppliedUsedFeeDefinitionsFragment
  }
}`) as unknown as TypedDocumentString<GetExistingDealCalculationQuery, GetExistingDealCalculationQueryVariables>;
export const UpdatePasswordDocument = new TypedDocumentString(`
    mutation updatePassword($oldPassword: String!, $newPassword: String!) {
  updateCustomerPassword(oldPassword: $oldPassword, newPassword: $newPassword) {
    firstname
    lastname
    _id
  }
}
    `) as unknown as TypedDocumentString<UpdatePasswordMutation, UpdatePasswordMutationVariables>;
export const CancelDealDocument = new TypedDocumentString(`
    mutation cancelDeal($dealId: ObjectId!) {
  cancelDeal(dealId: $dealId) {
    _id
    events {
      ...DealEventFragment
    }
  }
}
    fragment DealValuesEntryFragment on DealValuesEntry {
  payoutAmount
  paybackAmount
  calculationPayoutAmount
  calculationPaybackAmount
  durationInDays
  shouldOverwritePayoutAmount
  overwrittenPayoutAmount
}
fragment ItemValuesEntryFragment on ItemValuesEntry {
  conditionMaxMarketValues {
    excellent
    good
    poor
  }
  maxMarketValue
  currentMarketValue
  predictedMarketValue
  adjustedMarketValue
  durationInDays
  loanToValue
  date
  payoutAmount
}
fragment CalculatedFeeDefinitionFragment on CalculatedFeeDefinition {
  appliedGrossAmount
  appliedNetAmount
  finalGrossAmount
  finalNetAmount
  ust
  isManual
  storedFeeDefinition {
    amount
    mode
    feeType
    companyId
    priority
    billingPeriodType
    level
    dealTypes
    isActive
    onlyWhenInAuction
  }
}
fragment AppliedUsedFeeDefinitionsFragment on UsedFeeDefinition {
  itemCategoryId
  feeWeight
  calculatedFeeDefinitions {
    ...CalculatedFeeDefinitionFragment
  }
}
fragment DealCalculationFragment on DealCalculation {
  date
  loanToValuesEntryId
  dealValuesEntry {
    ...DealValuesEntryFragment
  }
  itemsValuesEntries {
    ...ItemValuesEntryFragment
  }
  appliedUsedFeeDefinitions {
    ...AppliedUsedFeeDefinitionsFragment
  }
}
fragment AnyPaymentTypeFragment on AnyPaymentType {
  ... on ManualPaymentWrapper {
    manual: value
  }
  ... on AutomaticPaymentWrapper {
    automatic: value
  }
}
fragment BaseEventFragment on BaseDealEvent {
  __typename
  createdAt
  createdAt
  timestamp
  displayName
}
fragment BookedEventFragment on DealBookedEvent {
  dealCalculation {
    ...DealCalculationFragment
  }
}
fragment VerifiedEventFragment on DealVerifiedEvent {
  isOverwrittenFees
  dealCalculation {
    ...DealCalculationFragment
  }
}
fragment ReviewingEventFragment on DealReviewingEvent {
  issuanceCertificate {
    url
    contentType
  }
}
fragment PaybackConfirmedEventFragment on DealPaybackConfirmedEvent {
  paymentType {
    ...AnyPaymentTypeFragment
  }
  dealCalculation {
    ...DealCalculationFragment
  }
}
fragment ExtensionConfirmedEventFragment on DealExtensionConfirmedEvent {
  paymentType {
    ...AnyPaymentTypeFragment
  }
  dealCalculation {
    ...DealCalculationFragment
  }
  childCalculation {
    ...DealCalculationFragment
  }
  dueAmount
  partialRedemptionAmount
  overwrittenPartialRedemptionAmount
  itemsExtensionAnswers {
    storageLabel
    answers {
      questionId
      selectedOptionIndex
      rangeValue
    }
  }
}
fragment OnSellEventFragment on DealOnSellEvent {
  valueAddedTaxRate
  differenceTaxRate
  valorizationFeeRate
}
fragment ClosedEventFragment on DealClosedEvent {
  dealCalculation {
    ...DealCalculationFragment
  }
  valorizationFeeNet
  valorizationFeeGross
}
fragment DealEventFragment on DealEvent {
  ...BaseEventFragment
  ...BookedEventFragment
  ...VerifiedEventFragment
  ...ReviewingEventFragment
  ...PaybackConfirmedEventFragment
  ...ExtensionConfirmedEventFragment
  ...OnSellEventFragment
  ...ClosedEventFragment
}`) as unknown as TypedDocumentString<CancelDealMutation, CancelDealMutationVariables>;
export const DeleteCustomerDocument = new TypedDocumentString(`
    mutation deleteCustomer($customerId: ObjectId!) {
  deleteCustomer(customerId: $customerId)
}
    `) as unknown as TypedDocumentString<DeleteCustomerMutation, DeleteCustomerMutationVariables>;
export const DealExtensionCalculationDocument = new TypedDocumentString(`
    query dealExtensionCalculation($dealId: ObjectId!, $args: DealExtensionCalculationArgs!) {
  dealExtensionCalculation(dealId: $dealId, args: $args) {
    ...PersistedDealExtensionCalculationFragment
  }
}
    fragment DealValuesEntryFragment on DealValuesEntry {
  payoutAmount
  paybackAmount
  calculationPayoutAmount
  calculationPaybackAmount
  durationInDays
  shouldOverwritePayoutAmount
  overwrittenPayoutAmount
}
fragment ItemValuesEntryFragment on ItemValuesEntry {
  conditionMaxMarketValues {
    excellent
    good
    poor
  }
  maxMarketValue
  currentMarketValue
  predictedMarketValue
  adjustedMarketValue
  durationInDays
  loanToValue
  date
  payoutAmount
}
fragment CalculatedFeeDefinitionFragment on CalculatedFeeDefinition {
  appliedGrossAmount
  appliedNetAmount
  finalGrossAmount
  finalNetAmount
  ust
  isManual
  storedFeeDefinition {
    amount
    mode
    feeType
    companyId
    priority
    billingPeriodType
    level
    dealTypes
    isActive
    onlyWhenInAuction
  }
}
fragment AppliedUsedFeeDefinitionsFragment on UsedFeeDefinition {
  itemCategoryId
  feeWeight
  calculatedFeeDefinitions {
    ...CalculatedFeeDefinitionFragment
  }
}
fragment DealCalculationFragment on DealCalculation {
  date
  loanToValuesEntryId
  dealValuesEntry {
    ...DealValuesEntryFragment
  }
  itemsValuesEntries {
    ...ItemValuesEntryFragment
  }
  appliedUsedFeeDefinitions {
    ...AppliedUsedFeeDefinitionsFragment
  }
}
fragment PersistedDealExtensionCalculationFragment on PersistedDealExtensionCalculation {
  dealId
  dueAmount
  partialRedemptionAmount
  overwrittenPartialRedemptionAmount
  dealExtensionCalculationId
  itemsExtensionAnswers {
    storageLabel
    answers {
      questionId
      selectedOptionIndex
      rangeValue
    }
  }
  childDealCalculation {
    ...DealCalculationFragment
  }
  parentDealCalculation {
    ...DealCalculationFragment
  }
}`) as unknown as TypedDocumentString<DealExtensionCalculationQuery, DealExtensionCalculationQueryVariables>;
export const DealPaybackCalculationDocument = new TypedDocumentString(`
    query dealPaybackCalculation($dealId: ObjectId!, $args: DealPaybackCalculationArgs!) {
  dealPaybackCalculation(dealId: $dealId, args: $args) {
    ...PersistedDealPaybackCalculationFragment
  }
}
    fragment DealValuesEntryFragment on DealValuesEntry {
  payoutAmount
  paybackAmount
  calculationPayoutAmount
  calculationPaybackAmount
  durationInDays
  shouldOverwritePayoutAmount
  overwrittenPayoutAmount
}
fragment ItemValuesEntryFragment on ItemValuesEntry {
  conditionMaxMarketValues {
    excellent
    good
    poor
  }
  maxMarketValue
  currentMarketValue
  predictedMarketValue
  adjustedMarketValue
  durationInDays
  loanToValue
  date
  payoutAmount
}
fragment CalculatedFeeDefinitionFragment on CalculatedFeeDefinition {
  appliedGrossAmount
  appliedNetAmount
  finalGrossAmount
  finalNetAmount
  ust
  isManual
  storedFeeDefinition {
    amount
    mode
    feeType
    companyId
    priority
    billingPeriodType
    level
    dealTypes
    isActive
    onlyWhenInAuction
  }
}
fragment AppliedUsedFeeDefinitionsFragment on UsedFeeDefinition {
  itemCategoryId
  feeWeight
  calculatedFeeDefinitions {
    ...CalculatedFeeDefinitionFragment
  }
}
fragment DealCalculationFragment on DealCalculation {
  date
  loanToValuesEntryId
  dealValuesEntry {
    ...DealValuesEntryFragment
  }
  itemsValuesEntries {
    ...ItemValuesEntryFragment
  }
  appliedUsedFeeDefinitions {
    ...AppliedUsedFeeDefinitionsFragment
  }
}
fragment PersistedDealPaybackCalculationFragment on PersistedDealPaybackCalculation {
  dealId
  dealPaybackCalculationId
  dealCalculation {
    ...DealCalculationFragment
  }
}`) as unknown as TypedDocumentString<DealPaybackCalculationQuery, DealPaybackCalculationQueryVariables>;
export const CancelPaybackExtensionDocument = new TypedDocumentString(`
    mutation cancelPaybackExtension($dealId: ObjectId!) {
  cancelPaybackExtension(dealId: $dealId) {
    _id
    events {
      ...DealEventFragment
    }
  }
}
    fragment DealValuesEntryFragment on DealValuesEntry {
  payoutAmount
  paybackAmount
  calculationPayoutAmount
  calculationPaybackAmount
  durationInDays
  shouldOverwritePayoutAmount
  overwrittenPayoutAmount
}
fragment ItemValuesEntryFragment on ItemValuesEntry {
  conditionMaxMarketValues {
    excellent
    good
    poor
  }
  maxMarketValue
  currentMarketValue
  predictedMarketValue
  adjustedMarketValue
  durationInDays
  loanToValue
  date
  payoutAmount
}
fragment CalculatedFeeDefinitionFragment on CalculatedFeeDefinition {
  appliedGrossAmount
  appliedNetAmount
  finalGrossAmount
  finalNetAmount
  ust
  isManual
  storedFeeDefinition {
    amount
    mode
    feeType
    companyId
    priority
    billingPeriodType
    level
    dealTypes
    isActive
    onlyWhenInAuction
  }
}
fragment AppliedUsedFeeDefinitionsFragment on UsedFeeDefinition {
  itemCategoryId
  feeWeight
  calculatedFeeDefinitions {
    ...CalculatedFeeDefinitionFragment
  }
}
fragment DealCalculationFragment on DealCalculation {
  date
  loanToValuesEntryId
  dealValuesEntry {
    ...DealValuesEntryFragment
  }
  itemsValuesEntries {
    ...ItemValuesEntryFragment
  }
  appliedUsedFeeDefinitions {
    ...AppliedUsedFeeDefinitionsFragment
  }
}
fragment AnyPaymentTypeFragment on AnyPaymentType {
  ... on ManualPaymentWrapper {
    manual: value
  }
  ... on AutomaticPaymentWrapper {
    automatic: value
  }
}
fragment BaseEventFragment on BaseDealEvent {
  __typename
  createdAt
  createdAt
  timestamp
  displayName
}
fragment BookedEventFragment on DealBookedEvent {
  dealCalculation {
    ...DealCalculationFragment
  }
}
fragment VerifiedEventFragment on DealVerifiedEvent {
  isOverwrittenFees
  dealCalculation {
    ...DealCalculationFragment
  }
}
fragment ReviewingEventFragment on DealReviewingEvent {
  issuanceCertificate {
    url
    contentType
  }
}
fragment PaybackConfirmedEventFragment on DealPaybackConfirmedEvent {
  paymentType {
    ...AnyPaymentTypeFragment
  }
  dealCalculation {
    ...DealCalculationFragment
  }
}
fragment ExtensionConfirmedEventFragment on DealExtensionConfirmedEvent {
  paymentType {
    ...AnyPaymentTypeFragment
  }
  dealCalculation {
    ...DealCalculationFragment
  }
  childCalculation {
    ...DealCalculationFragment
  }
  dueAmount
  partialRedemptionAmount
  overwrittenPartialRedemptionAmount
  itemsExtensionAnswers {
    storageLabel
    answers {
      questionId
      selectedOptionIndex
      rangeValue
    }
  }
}
fragment OnSellEventFragment on DealOnSellEvent {
  valueAddedTaxRate
  differenceTaxRate
  valorizationFeeRate
}
fragment ClosedEventFragment on DealClosedEvent {
  dealCalculation {
    ...DealCalculationFragment
  }
  valorizationFeeNet
  valorizationFeeGross
}
fragment DealEventFragment on DealEvent {
  ...BaseEventFragment
  ...BookedEventFragment
  ...VerifiedEventFragment
  ...ReviewingEventFragment
  ...PaybackConfirmedEventFragment
  ...ExtensionConfirmedEventFragment
  ...OnSellEventFragment
  ...ClosedEventFragment
}`) as unknown as TypedDocumentString<CancelPaybackExtensionMutation, CancelPaybackExtensionMutationVariables>;
export const DeactivateCustomerDocument = new TypedDocumentString(`
    mutation deactivateCustomer($customerId: ObjectId!) {
  deactivateCustomer(customerId: $customerId)
}
    `) as unknown as TypedDocumentString<DeactivateCustomerMutation, DeactivateCustomerMutationVariables>;
export const GetItemCategoryDocument = new TypedDocumentString(`
    query getItemCategory($itemCategoryId: ObjectId!) {
  getItemCategory(itemCategoryId: $itemCategoryId) {
    _id
    name
    parentId
    algoliaCategorySlug
    createdAt
    updatedAt
    slug
    visibleOnDomain
    availableTransportModes
    maximumPawnDuration
  }
}
    `) as unknown as TypedDocumentString<GetItemCategoryQuery, GetItemCategoryQueryVariables>;
export const PayExtensionOnlineDocument = new TypedDocumentString(`
    mutation payExtensionOnline($onlinePaymentArgs: OnlinePaymentArgs!) {
  payExtensionOnline(onlinePaymentArgs: $onlinePaymentArgs) {
    deal {
      _id
      bookingNumber
    }
    paymentResult {
      ...PaymentResultFragment
    }
  }
}
    fragment PaymentResultFragment on PaymentResult {
  ... on SuccessfulPayment {
    id
  }
  ... on PendingPayment {
    redirectUrl
    id
  }
  ... on FailedPayment {
    id
    errors {
      code
    }
  }
}`) as unknown as TypedDocumentString<PayExtensionOnlineMutation, PayExtensionOnlineMutationVariables>;
export const ValidatePaybackOrExtendDealPersistanceCalculationDocument = new TypedDocumentString(`
    mutation validatePaybackOrExtendDealPersistanceCalculation($args: ValidatePaybackOrExtendDealPersistanceCalculationArgs!) {
  validatePaybackOrExtendDealPersistanceCalculation(args: $args)
}
    `) as unknown as TypedDocumentString<ValidatePaybackOrExtendDealPersistanceCalculationMutation, ValidatePaybackOrExtendDealPersistanceCalculationMutationVariables>;
export const OnlinePaymentSucceededDocument = new TypedDocumentString(`
    subscription onlinePaymentSucceeded {
  onlinePaymentSucceeded {
    ...DealOnlinePaymentSucceedFragment
  }
}
    fragment DealValuesEntryFragment on DealValuesEntry {
  payoutAmount
  paybackAmount
  calculationPayoutAmount
  calculationPaybackAmount
  durationInDays
  shouldOverwritePayoutAmount
  overwrittenPayoutAmount
}
fragment ItemValuesEntryFragment on ItemValuesEntry {
  conditionMaxMarketValues {
    excellent
    good
    poor
  }
  maxMarketValue
  currentMarketValue
  predictedMarketValue
  adjustedMarketValue
  durationInDays
  loanToValue
  date
  payoutAmount
}
fragment CalculatedFeeDefinitionFragment on CalculatedFeeDefinition {
  appliedGrossAmount
  appliedNetAmount
  finalGrossAmount
  finalNetAmount
  ust
  isManual
  storedFeeDefinition {
    amount
    mode
    feeType
    companyId
    priority
    billingPeriodType
    level
    dealTypes
    isActive
    onlyWhenInAuction
  }
}
fragment AppliedUsedFeeDefinitionsFragment on UsedFeeDefinition {
  itemCategoryId
  feeWeight
  calculatedFeeDefinitions {
    ...CalculatedFeeDefinitionFragment
  }
}
fragment DealCalculationFragment on DealCalculation {
  date
  loanToValuesEntryId
  dealValuesEntry {
    ...DealValuesEntryFragment
  }
  itemsValuesEntries {
    ...ItemValuesEntryFragment
  }
  appliedUsedFeeDefinitions {
    ...AppliedUsedFeeDefinitionsFragment
  }
}
fragment AnyPaymentTypeFragment on AnyPaymentType {
  ... on ManualPaymentWrapper {
    manual: value
  }
  ... on AutomaticPaymentWrapper {
    automatic: value
  }
}
fragment BaseEventFragment on BaseDealEvent {
  __typename
  createdAt
  createdAt
  timestamp
  displayName
}
fragment BookedEventFragment on DealBookedEvent {
  dealCalculation {
    ...DealCalculationFragment
  }
}
fragment VerifiedEventFragment on DealVerifiedEvent {
  isOverwrittenFees
  dealCalculation {
    ...DealCalculationFragment
  }
}
fragment ReviewingEventFragment on DealReviewingEvent {
  issuanceCertificate {
    url
    contentType
  }
}
fragment PaybackConfirmedEventFragment on DealPaybackConfirmedEvent {
  paymentType {
    ...AnyPaymentTypeFragment
  }
  dealCalculation {
    ...DealCalculationFragment
  }
}
fragment ExtensionConfirmedEventFragment on DealExtensionConfirmedEvent {
  paymentType {
    ...AnyPaymentTypeFragment
  }
  dealCalculation {
    ...DealCalculationFragment
  }
  childCalculation {
    ...DealCalculationFragment
  }
  dueAmount
  partialRedemptionAmount
  overwrittenPartialRedemptionAmount
  itemsExtensionAnswers {
    storageLabel
    answers {
      questionId
      selectedOptionIndex
      rangeValue
    }
  }
}
fragment OnSellEventFragment on DealOnSellEvent {
  valueAddedTaxRate
  differenceTaxRate
  valorizationFeeRate
}
fragment ClosedEventFragment on DealClosedEvent {
  dealCalculation {
    ...DealCalculationFragment
  }
  valorizationFeeNet
  valorizationFeeGross
}
fragment DealEventFragment on DealEvent {
  ...BaseEventFragment
  ...BookedEventFragment
  ...VerifiedEventFragment
  ...ReviewingEventFragment
  ...PaybackConfirmedEventFragment
  ...ExtensionConfirmedEventFragment
  ...OnSellEventFragment
  ...ClosedEventFragment
}
fragment DealOnlinePaymentSucceedFragment on Deal {
  _id
  createdAt
  updatedAt
  events {
    ...DealEventFragment
  }
  isPaybackPaymentOngoing
  isExtensionPaymentOngoing
  latestOngoingPaymentRequestedAt
  hasCompletedPayment
}`) as unknown as TypedDocumentString<OnlinePaymentSucceededSubscription, OnlinePaymentSucceededSubscriptionVariables>;